// Simple Translation System - 3 Languages
// HeveaTalent - Complete Translation File

export const translations = {
  pt: {
    // ========== HEADER & NAVIGATION ==========
    login: "Entrar",
    register: "Cadastrar-se",
    logout: "Sair",
    welcome: "Bem-vindo",
    profile: "Perfil",
    settings: "Configurações",
    
    // ========== LANDING PAGE ==========
    // Hero Section
    heroTitle: "Conectando Talentos na",
    heroSubtitle: "Heveicultura",
    heroDescription: "A plataforma especializada que conecta proprietários rurais com profissionais qualificados do setor da heveicultura. Encontre os melhores sangradores, gerentes, fiscais e engenheiros agrônomos.",
    startFree: "Começar Grátis",
    learnMore: "Saiba Mais",
    
    // Landing Features
    manageHeveiculture: "Gerencie sua heveicultura",
    findBestProfessionals: "e encontre os melhores profissionais",
    completePlatform: "A plataforma completa para produtores e trabalhadores da heveicultura",
    jobBoard: "Balcão de Emprego",
    community: "Comunidade",
    bleedingCalendar: "Calendário de Sangria",
    teamManagement: "Gestão de Equipe",
    workerCertification: "Certificação de Trabalhadores",
    seeHowItWorks: "Ver como funciona",
    
    // Landing Cards
    simplicity: "Simplicidade",
    simplicityDesc: "Interface intuitiva desenvolvida para o campo. Fácil de usar em qualquer dispositivo.",
    security: "Segurança",
    securityDesc: "Seus dados protegidos com LGPD. Perfis verificados e avaliações autênticas.",
    fairness: "Transparência",
    fairnessDesc: "Sistema de avaliação transparente. Reconhecimento por mérito e experiência.",
    
    forEmployers: "Para Empregadores",
    forEmployersDesc: "Publique vagas e encontre profissionais qualificados com sistema de certificação",
    forProfessionals: "Para Profissionais",
    forProfessionalsDesc: "Ofereça seus serviços e construa sua reputação com nosso sistema de selos",
    marketplaceDesc: "Compre e venda propriedades, ferramentas, insumos e maquinaria",
    communityDesc: "Comunidade ativa para compartilhar dicas e conhecimentos",
    
    findIdealProfessional: "Como Encontrar o Profissional Ideal",
    
    // ========== MAIN SECTIONS ==========
    jobCenter: "Central de Empregos",
    marketplace: "Marketplace",
    certifiedProfessionals: "Profissionais Certificados",
    agriculturalMarketplace: "Marketplace Agrícola",
    jobs: "Empregos",
    evaluations: "Avaliações",
    plans: "Planos",
    calendar: "Calendário",
    reports: "Relatórios",
    performance: "Desempenho",
    marketAnalysisTab: "Cotações",
    marketAnalysisDesc: "Cotações, calculadora e análise de preços da borracha",
    professionals: "Profissionais",
    communityTips: "Dicas da Comunidade",
    
    // ========== MARKETPLACE ==========
    properties: "Propriedades",
    tools: "Ferramentas",
    supplies: "Insumos",
    pesticides: "Defensivos",
    machinery: "Maquinaria",
    others: "Outros",
    sellProduct: "Vender Produto",
    myAds: "Meus Anúncios",
    browseProducts: "Navegar Produtos",
    announceProduct: "Anunciar Produto",
    publishAd: "Publicar Anúncio",
    productTitle: "Título do Produto",
    category: "Categoria",
    selectCategory: "Selecione a categoria",
    price: "Preço (R$)",
    condition: "Condição",
    location: "Localização",
    productDescription: "Descrição do Produto",
    contactInfo: "Informações de Contato",
    productImages: "Imagens do Produto (URLs)",
    new: "Novo",
    seminew: "Seminovo",
    used: "Usado",
    feature: "Destacar",
    featureAd: "🔥 Destacar - R$ 9,90",
    remove: "Remover",
    removeAd: "Remover Anúncio",
    productPublished: "Produto anunciado com sucesso!",
    errorPublishing: "Erro ao criar anúncio",
    adRemoved: "Anúncio removido com sucesso!",
    errorRemoving: "Erro ao remover anúncio",
    
    // ========== JOBS ==========
    publishJob: "Publicar Vaga",
    searchJobs: "Buscar Vagas",
    myJobs: "Minhas Vagas",
    jobTitle: "Título da Vaga",
    jobDescription: "Descrição da Vaga",
    salary: "Salário",
    requirements: "Requisitos",
    benefits: "Benefícios",
    applyNow: "Candidatar-se",
    applications: "Candidaturas",
    
    // ========== FORMS ==========
    fullName: "Nome Completo",
    email: "Email",
    password: "Senha",
    userType: "Tipo de Usuário",
    selectType: "Selecione o tipo",
    employer: "Empregador/Proprietário",
    professional: "Profissional",
    phone: "Telefone",
    company: "Empresa/Propriedade",
    experienceYears: "Anos de Experiência",
    specialization: "Especialização",
    save: "Salvar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    delete: "Excluir",
    edit: "Editar",
    update: "Atualizar",
    create: "Criar",
    record: "Registro",
    search: "Buscar",
    filter: "Filtrar",
    clear: "Limpar",
    
    // ========== SPECIALIZATIONS ==========
    tapper: "Sangrador",
    generalManager: "Gerente Geral",
    inspector: "Fiscal",
    agronomist: "Engenheiro Agrônomo",
    
    // ========== TECHNICAL QUALIFICATION (EVALUATION SYSTEM) ==========
    technicalQualification: "Qualificação Técnica",
    technicalQualificationDesc: "Sua qualificação determina o peso das avaliações que você faz",
    qualificationEngineer: "Engenheiro Agrônomo",
    qualificationTechnician: "Técnico Agrícola",
    qualificationLeader: "Líder de Equipe",
    qualificationOwner: "Proprietário",
    qualificationOther: "Outro",
    selectQualification: "Selecione sua qualificação",
    
    // Evaluation Types
    evaluationTypeTechnical: "Avaliação Técnica",
    evaluationTypeEmployer: "Avaliação de Empregador",
    technicalSeal: "Selo Técnico",
    technicalSealDesc: "Baseado em avaliações de profissionais técnicos certificados (peso 3x)",
    employerEvaluations: "Avaliações de Empregadores",
    employerEvaluationsDesc: "Histórico de avaliações de proprietários (peso 1x)",
    weightedScore: "Pontuação Ponderada",
    weightedScoreDesc: "Média ponderada: avaliações técnicas (3x) + avaliações de empregadores (1x)",
    noTechnicalEvaluations: "Ainda sem avaliações técnicas",
    noEmployerEvaluations: "Ainda sem avaliações de empregadores",
    
    // ========== EVOLUTION CHART ==========
    performanceEvolution: "Evolução do Desempenho",
    last12Months: "Últimos 12 meses",
    currentSeal: "Selo Atual",
    trend: "Tendência",
    lastThreeMonths: "Últimos 3 meses",
    technicalEvaluations: "Avaliações Técnicas",
    employerEvaluationsShort: "Empregadores",
    weight3x: "Peso 3x",
    weight1x: "Peso 1x",
    noEvaluationsYet: "Ainda sem avaliações",
    firstEvaluationMessage: "Os dados aparecerão após a primeira avaliação",
    sealGold: "Ouro",
    sealSilver: "Prata",
    sealBronze: "Bronze",
    sealNone: "Sem selo",
    
    // ========== ACHIEVEMENT SYSTEM ==========
    achievementSystem: "Sistema de Conquistas",
    allProfessionalsWelcome: "Todos os profissionais são bem-vindos! Conquiste badges conforme cresce na plataforma.",
    firstAccess: "Primeiro acesso",
    firstRating: "Primeira Avaliação",
    positiveFeedback: "Feedback positivo",
    activeProfessional: "Profissional Ativo",
    completedJobs: "5+ trabalhos concluídos",
    experienced: "Experiente",
    oneYearPlatform: "1 ano na plataforma",
    
    // ========== TIME ==========
    immediate: "Imediata",
    oneMonth: "1 mês",
    twoMonths: "2 meses",
    threeMonths: "3 meses",
    days: "dias",
    hours: "horas",
    minutes: "minutos",
    today: "Hoje",
    yesterday: "Ontem",
    
    // ========== PLANS ==========
    plansForEmployers: "Planos para Proprietários",
    plansForProfessionals: "Planos para Profissionais",
    currentPlan: "Plano Atual",
    recommended: "Recomendado",
    selectPlan: "Selecionar Plano",
    startTrial: "Iniciar Teste Grátis",
    freeTrial: "dias grátis para testar",
    monthly: "mês",
    yearly: "ano",
    free: "Gratuito",
    unlimited: "Ilimitado",
    
    // Plan Features
    propertiesLimit: "propriedades",
    jobPostings: "anúncios no balcão de emprego",
    marketplaceAds: "anúncios no marketplace",
    teamManagement: "Gestão de equipe",
    fullCalendar: "Calendário completo",
    basicReports: "Relatórios básicos",
    fullReports: "Relatórios completos",
    freeHighlights: "destaques grátis/mês",
    
    // Trial Messages
    trialExpired: "Período de Teste Expirado",
    trialExpiredMessage: "Seu período de teste terminou. Faça upgrade para continuar.",
    trialRemaining: "dias restantes no período de teste",
    dataPreserved: "Seus dados estão salvos e serão recuperados após o upgrade.",
    
    // ========== AVULSO ITEMS ==========
    avulsoItems: "Itens Avulsos",
    avulsoDescription: "Compre recursos extras sem precisar trocar de plano",
    highlight: "Destaque de Anúncio",
    highlightDesc: "Seu anúncio aparece no topo das listagens por 7 dias",
    extraAdJob: "Anúncio Extra - Balcão",
    extraAdJobDesc: "1 vaga adicional no Balcão de Emprego por 30 dias",
    extraAdMarketplace: "Anúncio Extra - Marketplace",
    extraAdMarketplaceDesc: "1 anúncio adicional no Marketplace por 30 dias",
    buyHighlight: "Comprar Destaque",
    buyAd: "Comprar Anúncio",
    paymentViaPix: "Pagamento via PIX • Ativação imediata após confirmação",
    
    // ========== BANNER ==========
    growWithHeveaTalent: "Cresça com a HeveaTalent",
    discoverPlansAndResources: "Conheça os planos disponíveis e recursos",
    
    // ========== CALENDAR ==========
    bleedingCalendarTitle: "Calendário de Sangria - Heveicultura",
    newProperty: "Nova Propriedade",
    propertySelection: "Seleção de Propriedade",
    noPropertiesRegistered: "Nenhuma propriedade cadastrada",
    createFirstProperty: "Crie sua primeira propriedade para começar a usar o calendário de sangria",
    createProperty: "Criar Primeira Propriedade",
    selectProperty: "Selecione uma propriedade",
    monthlyProduction: "Produção Mensal",
    totalProduction: "Produção Total",
    averageDaily: "Média Diária",
    activeDays: "Dias Ativos",
    workingDays: "Dias Trabalhados",
    
    // Calendar Tips
    calendarTipTitle: "Como usar o Calendário de Sangria:",
    calendarTip1: "Registre a produção diária de cada sangrador",
    calendarTip2: "Acompanhe o desempenho mensal e anual",
    calendarTip3: "Compare produtividade entre trabalhadores",
    
    // ========== EVALUATIONS ==========
    evaluationSystem: "Sistema de Avaliação",
    giveEvaluation: "Dar Avaliação",
    receiveEvaluation: "Receber Avaliação",
    internalEvaluation: "Avaliação Interna",
    privateControl: "Controle Interno (Privado)",
    evaluationSent: "Avaliação enviada com sucesso!",
    errorSendingEvaluation: "Erro ao enviar avaliação",
    
    // ========== COMMUNITY ==========
    communityTipsTitle: "Dicas da Comunidade",
    shareTip: "Compartilhar Dica",
    shareYourTip: "Conte sua dica ou experiência:",
    tipCategory: "Categoria (sangria, ferramentas, saude, clima, outros):",
    tipShared: "Dica compartilhada com sucesso!",
    errorSharingTip: "Erro ao compartilhar dica. Tente novamente.",
    writeComment: "Digite seu comentário aqui...",
    leaveComment: "Deixe um comentário (opcional)",
    send: "Enviar",
    like: "Curtir",
    comment: "Comentar",
    comments: "comentários",
    likes: "curtidas",
    
    // ========== MESSAGES ==========
    loading: "Carregando...",
    searching: "Buscando...",
    saving: "Salvando...",
    creating: "Criando...",
    sending: "Enviando...",
    registering: "Cadastrando...",
    loggingIn: "Entrando...",
    success: "Sucesso!",
    error: "Erro",
    warning: "Aviso",
    info: "Informação",
    
    // Error Messages
    errorLogin: "Erro no login. Verifique suas credenciais.",
    forgotPassword: "Esqueci minha senha",
    forgotPasswordTitle: "Recuperar senha",
    forgotPasswordDesc: "Digite seu e-mail e enviaremos um código e um link para redefinir sua senha.",
    sendCode: "Enviar código",
    sending: "Enviando...",
    alreadyHaveCode: "Já tenho um código",
    codeSentInfo: "Se o e-mail estiver cadastrado, você receberá o código de verificação. Confira também a caixa de spam.",
    verificationCode: "Código de verificação",
    newPasswordLabel: "Nova senha",
    confirmPasswordLabel: "Confirmar nova senha",
    resetPasswordBtn: "Redefinir senha",
    resetting: "Redefinindo...",
    passwordsDontMatch: "As senhas não coincidem",
    passwordMinLength: "A senha deve ter pelo menos 6 caracteres",
    passwordResetSuccess: "Senha redefinida com sucesso! Faça login com sua nova senha.",
    invalidResetLink: "Link inválido ou expirado. Solicite um novo e-mail de recuperação.",
    backToLogin: "Voltar ao início",
    requestNewEmail: "Solicitar novo e-mail",
    freeHighlightAvailablePrefix: "Você tem",
    freeHighlightAvailableSuffix: "destaque(s) grátis este mês!",
    useFreeHighlight: "Usar destaque grátis",
    freeHighlightUsed: "Destaque grátis do mês já usado",
    renewsOn: "Renova em",
    chooseAdToHighlight: "Escolha um anúncio seu para ficar em destaque por 7 dias, sem pagar nada.",
    applyFreeHighlight: "Aplicar destaque grátis",
    applying: "Aplicando...",
    noAdsToHighlight: "Você não tem anúncios ativos para destacar. Crie um anúncio no Balcão de Emprego ou Marketplace primeiro.",
    freeHighlightSuccess: "Destaque grátis aplicado!",
    freeHighlightError: "Não foi possível aplicar o destaque",
    jobBoardLabel: "Balcão",
    marketplaceLabel: "Marketplace",
    errorRegister: "Erro no cadastro",
    errorLoading: "Erro ao carregar dados",
    errorSaving: "Erro ao salvar",
    errorDeleting: "Erro ao excluir",
    errorUnknown: "Erro desconhecido",
    
    // ========== MISC ==========
    all: "Todos",
    active: "Ativo",
    inactive: "Inativo",
    pending: "Pendente",
    completed: "Concluído",
    yes: "Sim",
    no: "Não",
    or: "ou",
    and: "e",
    of: "de",
    in: "em",
    for: "para",
    with: "com",
    without: "sem",
    more: "mais",
    less: "menos",
    seeMore: "Ver mais",
    seeLess: "Ver menos",
    viewAll: "Ver todos",
    close: "Fechar",
    back: "Voltar",
    next: "Próximo",
    previous: "Anterior",
    finish: "Finalizar",
    sendComment: "Enviar Comentário",
    sending: "Enviando...",
    generating: "Gerando...",
    generate: "Gerar",
    generateReport: "Gerar Relatório",
    generateTeamReport: "Gerar Relatório da Equipe",
    teamButton: "Equipe",
    monthlyReport: "Relatório Mensal",
    teamReport: "Relatório da Equipe",
    reportPeriod: "Período do Relatório",
    reportMonth: "Mês Relatório",
    closeReport: "Fechar Relatório",
    closeDatabase: "Fechar Banco de Dados",
    savePdfPrint: "Salvar PDF / Imprimir",
    printReport: "Imprimir Relatório",
    consultData: "Consultar Dados",
    editRecord: "Editar registro",
    deleteRecord: "Deletar registro",
    addDataForDay: "Adicionar dados para este dia",
    newRecord: "Novo Registro",
    editProduct: "Editar Produto",
    saveChanges: "Salvar Alterações",
    addByUrl: "Ou Adicionar por URL",
    uploading: "Carregando",
    add: "Adicionar",
    generatePix: "Gerar PIX",
    verifiedIdentity: "Identidade Verificada",
    bleedingPerformed: "Sangria Realizada",
    openChat: "Abrir Chat",
    mobileFriendlyTip: "Clique no botão para abrir o formulário completo.",
    useEditToModify: "Use Editar para modificar registros existentes.",
    
    // Tooltips - Como usar
    tooltipJobPosting: "💡 Vagas de Emprego: Publique uma vaga para encontrar profissionais certificados com selo Bronze, Prata ou Ouro. Inclua título, descrição, local, salário e requisitos.",
    tooltipWorkOffer: "💡 Oferta de Serviço: Cadastre seus serviços para que empregadores encontrem você na busca de profissionais. Descreva suas habilidades, experiência e disponibilidade.",
    tooltipSearchJobs: "💡 Buscar Vagas: Navegue pelas vagas publicadas por proprietários. Clique em uma vaga para ver detalhes e use o chat HeveaTalent para entrar em contato.",
    tooltipMyOffers: "💡 Minhas Ofertas e Recomendações: Gerencie suas ofertas de serviço. Abaixo, veja suas recomendações recebidas e convide ex-empregadores para recomendá-lo — mesmo quem não tem conta na plataforma. Quanto mais recomendações, maior sua visibilidade. HeveaTalent cresce junto com você!",
    tooltipMarketplace: "💡 Marketplace: Compre e venda produtos, equipamentos e insumos relacionados à heveicultura.",
    tooltipCalendar: "💡 Calendário de Sangria: Registre sangrias, produção em kg, chuva e aplicações. Seus registros alimentam o Desempenho Contextual, que contribui para 50% do seu Selo profissional. Cada corte conta — construa sua reputação!",
    tooltipCommunity: "💡 Comunidade: Compartilhe dicas com fotos 📷, tire dúvidas e conecte-se com outros profissionais. Você pode anexar até 3 imagens em suas dicas e comentários!",
    tooltipEvaluations: "💡 Avaliações: Avalie e seja avaliado. Construa sua reputação na plataforma.",
    tooltipPlans: "💡 Planos: Seu plano define o que você pode usar — calendário, marketplace, gestão de equipe e relatórios. Planos maiores liberam mais propriedades, anúncios e destaques. Quanto mais você participa, mais a heveicultura reconhece seu valor!",
    tooltipProfessionals: "💡 Buscar Profissionais: Encontre trabalhadores certificados com selos Bronze, Prata ou Ouro. Veja recomendações, avaliações e perfil completo. Você pode recomendar profissionais que já trabalharam com você — sua recomendação aparece no perfil público dele. Use o chat HeveaTalent para contato direto.",
    tooltipReports: "💡 Relatórios: Visualize estatísticas e relatórios de produção da sua propriedade.",
    tooltipPerformance: "💡 Desempenho: Acompanhe seu desempenho contextual baseado nas condições locais.",
    seeExample: "Ver Exemplo",
    howToUse: "Como usar",
    exampleJobPostings: "Exemplos de Vagas",
    exampleJobPostingsDesc: "Veja abaixo exemplos de como as vagas de emprego são exibidas na plataforma. Use como referência ao buscar oportunidades.",
    example: "Exemplo",
    chatWithEmployer: "Conversar com Empregador",
    requirements: "Requisitos",
    
    // Example Modal - Service Offer (Professional)
    exampleServiceOfferTitle: "Exemplo de Oferta de Serviço Bem Feita",
    exampleServiceOfferName: "Sangrador Experiente - Disponível para Trabalho",
    exampleServiceOfferLocation: "Votuporanga, SP e região",
    exampleServiceOfferDesc: "Profissional com 5 anos de experiência em sangria de seringueiras. Especializado em técnicas descendente e ascendente. Disponibilidade imediata para trabalho em fazendas de pequeno a grande porte.",
    exampleServiceOfferTip1: "✅ Título com sua especialização e disponibilidade",
    exampleServiceOfferTip2: "✅ Experiência detalhada (anos, técnicas dominadas)",
    exampleServiceOfferTip3: "✅ Regiões onde pode trabalhar",
    exampleServiceOfferTip4: "✅ Percentual desejado ou salário 'a combinar'",
    exampleServiceOfferTip5: "✅ Disponibilidade (imediata, em 30 dias, etc.)",
    exampleServiceOfferButton: "Entendi, vou criar minha oferta!",
    bestPractices: "Boas Práticas:",
    
    // Marketplace Tooltips
    tooltipMarketplaceBrowse: "💡 Navegue pelos produtos à venda. Use os filtros para encontrar equipamentos, insumos e materiais para heveicultura. Clique em um produto para ver detalhes e entrar em contato com o vendedor.",
    tooltipMarketplaceSell: "💡 Anuncie seus produtos. Adicione fotos, descrição detalhada, preço e localização para atrair compradores interessados.",
    tooltipMarketplaceMyItems: "💡 Gerencie seus anúncios. Edite, destaque ou remova produtos que você colocou à venda.",
    
    // Record Form Tooltips
    tooltipSangria: "Dia em que realizou sangria nas árvores",
    tooltipTalhao: "Setor ou área onde foi feita a atividade",
    tooltipReposicao: "Recuperação de dias sem sangria (compensação)",
    tooltipSangriaPerdida: "Árvores não sangradas (chuva, TPD, etc)",
    tooltipFungicida: "Aplicação de tratamento contra fungos",
    tooltipChuva: "Volume de chuva do dia",
    tooltipProducao: "Peso de látex/coágulo coletado",
    tooltipWorkersDb: "Histórico privado de avaliações dos trabalhadores",
    tooltipKgPlanta: "Produção média por árvore",
    tooltipTrendUp: "Avaliações em alta",
    tooltipTrendDown: "Avaliações em queda",
    tooltipTrendStable: "Desempenho consistente",
    tooltipMultiWorkers: "trabalhadores neste dia",
    tooltipAddRecord: "Adicionar registro",
    
    // Multiple Workers Tip - Banner do calendário
    multiWorkerTipTitle: "Múltiplos Colaboradores por Dia",
    multiWorkerTipDesc: "Registre a produção de cada trabalhador individualmente no mesmo dia.",
    multiWorkerTipToggle: "Ver como fazer",
    multiWorkerTipHide: "Ocultar instruções",
    multiWorkerTipStep1: "Clique no dia desejado no calendário",
    multiWorkerTipStep2: "Preencha os dados do",
    multiWorkerTipStep2Bold: "primeiro trabalhador",
    multiWorkerTipStep2End: "(nome, produção, talhão)",
    multiWorkerTipStep3: "Clique em",
    multiWorkerTipStep3Bold: "Salvar",
    multiWorkerTipStep4: "Após salvar, aparecerá a opção",
    multiWorkerTipStep4Bold: "Adicionar Outro Trabalhador",
    multiWorkerTipStep5: "Repita o processo para cada colaborador do dia",
    multiWorkerTipNote: "Dias com múltiplos trabalhadores mostram um número no canto",
    multiWorkerTipTooltip: "Você pode registrar a produção de cada trabalhador separadamente no mesmo dia. Isso permite acompanhar o desempenho individual de cada membro da equipe.",
    multiWorkerTipReshow: "Ver dica: Múltiplos trabalhadores",

    // Calendar Events (Faltas e Feriados)
    legendBleeding: "Sangria realizada",
    legendLost: "Sangria perdida (chuva)",
    legendAbsence: "Falta do trabalhador",
    legendHoliday: "Feriado",
    legendHint: "Clique num dia para registrar sangria. Para marcar falta ou feriado, clique no pequeno ícone de calendário no canto da célula.",
    celTitle: "Falta ou Feriado",
    celExplain: "Faltas e feriados são apenas etiquetas informativas — não alteram a contagem de sangrias do sistema. Servem para dar contexto nos relatórios.",
    celExistingTitle: "Eventos deste dia:",
    celAbsence: "Falta",
    celHoliday: "Feriado",
    celCompensated: "compensada",
    celWorker: "Trabalhador",
    celWorkerPlaceholder: "Nome do trabalhador",
    celWorkerRequired: "Selecione ou digite o nome do trabalhador.",
    celFaltaWorkerRequired: "Selecione ou digite o nome do trabalhador.",
    celReason: "Motivo",
    celReasonPlaceholder: "Ex: Atestado médico, Particular",
    celHolidayName: "Nome do feriado",
    celHolidayPlaceholder: "Ex: Carnaval, Natal, Aniversário da cidade",
    celAbsenceHint: "Se este trabalhador depois compensar a falta em outra data (trabalhando num sábado, por exemplo), você poderá vincular essa sangria a esta falta no formulário de registro.",
    celHolidayHint: "O feriado é apenas uma etiqueta no calendário. Se algum trabalhador escolher trabalhar neste dia (parceria), a sangria registrada conta normalmente.",
    celMarkEvent: "Marcar falta ou feriado",
    celSaveError: "Erro ao salvar evento.",
    celDeleteError: "Erro ao remover evento.",
    celConfirmDelete: "Remover este evento?",
    // Compensação de falta (RecordFormDialog)
    rfCompensateAbsenceTitle: "Esta sangria compensa uma falta",
    rfCompensateAbsenceSelect: "Qual falta está sendo compensada?",
    rfCompensateAbsenceHint: "Ao marcar, a falta selecionada será registrada como compensada nos relatórios.",
    // Relatório mensal - Nova seção por trabalhador
    rptWorkerSectionTitle: "Por trabalhador",
    rptWorkerName: "Trabalhador",
    rptWorkerBleedings: "Sangrias",
    rptWorkerLost: "Perdidas",
    rptWorkerAbsences: "Faltas",
    rptWorkerCompensated: "Compensadas",
    rptWorkerProduction: "Produção",
    rptAbsencesTitle: "Ausências do período",
    rptHolidaysTitle: "Feriados",
    rptNoAbsences: "Nenhuma falta registrada no período.",
    rptNoHolidays: "Nenhum feriado registrado no período.",
    rptAbsencePattern: "Padrão de faltas (últimos 3 meses)",
    saving: "Salvando...",
    
    // Evaluation System Tooltips - Explicativo baseado no Tripé
    tooltipEvaluationOverview: "🏆 **Sistema de Certificação HeveaTalent**\n\n⚖️ **JUSTIÇA**: Avaliação baseada em 14 critérios técnicos oficiais (INCAPER, CATI/SP).\n\n📊 **DOIS TIPOS DE AVALIAÇÃO**:\n• **Avaliação Técnica** (peso 3x): Feita por Engenheiros Agrônomos ou Técnicos Agrícolas certificados. Maior credibilidade.\n• **Avaliação de Empregador** (peso 1x): Feita por proprietários. Reflete a experiência de trabalho.\n\n🏅 **SISTEMA DE SELOS**: A pontuação final é uma média ponderada. Selos: Bronze (60-74), Prata (75-89), Ouro (90+).\n\n📈 **EVOLUÇÃO**: Acompanhe seu progresso na aba 'Evolução do Desempenho' com gráficos e tendências.\n\n🔒 **SEGURANÇA**: Avaliações privadas, conformidade LGPD.",
    tooltipEvaluationProfile: "📊 **Seu Perfil de Certificação**\n\n🏅 **Selos de Qualidade**: Bronze (60-74 pts), Prata (75-89 pts), Ouro (90-100 pts).\n\n⚖️ **COMO FUNCIONA O CÁLCULO**:\n• Avaliações Qualificadas têm peso 3x (Engenheiros Agrônomos e Técnicos Agrícolas)\n• Avaliações Padrão têm peso 1x (Proprietários, Líderes de Equipe, Outros)\n• O peso é determinado pela qualificação do avaliador, não pelo tipo de conta\n• Seu selo é baseado na média ponderada\n\n📈 **Gráfico Evolutivo**: Veja sua evolução ao longo do tempo.\n\n🎯 **Feedback Educacional**: Receba orientações personalizadas baseadas nos 14 critérios para melhorar suas técnicas.",
    tooltipEvaluationCreate: "✍️ **Criar Avaliação Técnica**\n\n🎓 **TIPO DE AVALIAÇÃO**: Sua avaliação será classificada de acordo com sua qualificação:\n• **Engenheiro Agrônomo/Técnico Agrícola**: Avaliação Técnica (peso 3x)\n• **Proprietário/Líder de Equipe**: Avaliação de Empregador (peso 1x)\n\n👤 **Quem avaliar**: Profissionais que trabalharam em sua propriedade.\n\n📋 **14 Critérios**: Técnica de Sangria (45%), Preparação de Safra (20%), Manutenção Diária (15%), Aplicações Químicas (20%).\n\n⚖️ **Impacto**: Avaliações técnicas têm maior peso no selo final do profissional.",
    tooltipEvaluationEvolution: "📈 **Evolução do Desempenho**\n\n📊 **GRÁFICO EVOLUTIVO**: Visualize sua evolução ao longo dos últimos 12 meses com:\n• **Linha Verde**: Pontuação ponderada (média geral)\n• **Linha Azul**: Avaliações Qualificadas (peso 3x) — Engenheiros e Técnicos\n• **Linha Roxa**: Avaliações Padrão (peso 1x) — Proprietários e outros\n\n⚖️ **PESO**: O peso é determinado pela qualificação técnica do avaliador, não pelo tipo de conta. Um proprietário que é Engenheiro Agrônomo recebe peso 3x.\n\n🏅 **LINHAS DE REFERÊNCIA**: As linhas tracejadas mostram os limites dos selos:\n• 🥇 Ouro: ≥90 pontos\n• 🥈 Prata: ≥75 pontos\n• 🥉 Bronze: ≥60 pontos\n\n📈 **TENDÊNCIA**: O indicador mostra se você está melhorando (+) ou piorando (-) nos últimos 3 meses.\n\n💡 **DICA**: Busque avaliações de profissionais qualificados (Engenheiros/Técnicos) para aumentar a credibilidade do seu selo!",
    
    // Seal Levels
    bronzeSeal: "Selo Bronze",
    silverSeal: "Selo Prata",
    goldSeal: "Selo Ouro",
    platinumSeal: "Selo removido",
    qualitySeal: "Selo de Qualidade",
    
    // Professional Profile
    yearsExperience: "anos de experiência",
    evaluationsReceived: "avaliações recebidas",
    jobsCompleted: "trabalhos concluídos",
    memberSince: "Membro desde",
    contactProfessional: "Entrar em Contato",
    viewProfile: "Ver Perfil",
    
    // Employer/Property
    propertyName: "Nome da Propriedade",
    propertyLocation: "Localização da Propriedade",
    numberOfTrees: "Número de Árvores",
    cultureAge: "Idade da Cultura (anos)",
    
    // Footer
    allRightsReserved: "Todos os direitos reservados",
    termsOfUse: "Termos de Uso",
    privacyPolicy: "Política de Privacidade",
    contact: "Contato",
    help: "Ajuda",
    understood: "Entendi",
    
    // ========== PERMISSIONS GUIDE ==========
    permGuideTitle: "Guia de Permissões",
    permGuideOverview: "Visão Geral",
    permGuideRoles: "Papéis",
    permGuideTransfer: "Transferência",
    permGuidePlans: "Planos",
    permGuideHowWorks: "Como funciona?",
    permGuideHowWorksDesc: "Cada propriedade pode ter diferentes pessoas com diferentes níveis de acesso. Isso permite que consultores, gerentes e funcionários trabalhem juntos sem confusão sobre quem pode fazer o quê.",
    permGuidePracticalExample: "Exemplo prático:",
    permGuideOwnerExample: "é a dona da Fazenda Conquista",
    permGuideManagerExample: "(consultor) gerencia os dados",
    permGuideOperatorExample: "(sangrador) registra produção diária",
    permGuideImportantPlans: "Importante sobre Planos:",
    permGuideImportantPlansDesc: "Após o período de teste, cada usuário terá acesso conforme o plano escolhido (Profissional ou Proprietário). Se você é consultor/administrador que gerencia propriedades de terceiros, escolha o plano que melhor atende suas necessidades.",
    permGuideManagersOperators: "Responsáveis e Operadores:",
    permGuideManagersOperatorsDesc: "Quando o proprietário/arrendatário cadastra um consultor, operador ou responsável técnico em sua propriedade, estes acessam conforme as limitações do plano do proprietário. O proprietário define quem pode acessar sua propriedade.",
    permGuideLimitsByPlan: "Limites por Plano:",
    permGuideLimitsByPlanDesc: "Cada plano tem suas limitações (quantidade de propriedades, equipe, funcionalidades). Não é possível usar um único plano para gerenciar múltiplas propriedades de diferentes donos - cada proprietário/arrendatário deve ter seu próprio plano ativo.",
    permGuideSummary: "Resumo:",
    permGuideSummaryDesc: "O plano do dono da propriedade (proprietário ou arrendatário) define os limites. Consultores e operadores vinculados usam as permissões desse plano para aquela propriedade específica.",
    permGuideOwner: "Proprietário",
    permGuideOwnerDesc: "Dono legal da propriedade no sistema.",
    permGuideOwnerCan: "Pode:",
    permGuideOwnerCanList: "Transferir/vender a propriedade|Definir responsável e operadores|Ver e editar todos os dados|Desativar a propriedade (dados históricos preservados)",
    permGuideOwnerPlanNote: "O plano do proprietário define os limites de funcionalidades",
    permGuideOwnerDataNote: "Os dados históricos são sempre preservados para análises e estatísticas",
    permGuideManager: "Responsável",
    permGuideManagerDesc: "Gerencia a propriedade no dia a dia.",
    permGuideManagerCan: "Pode:",
    permGuideManagerCanList: "Inserir, editar e deletar registros|Ver todos os relatórios|Gerenciar equipe de seringueiros",
    permGuideManagerCannot: "Não pode:",
    permGuideManagerCannotList: "Transferir a propriedade|Adicionar outros responsáveis",
    permGuideOperator: "Operador",
    permGuideOperatorDesc: "Insere registros diários de produção.",
    permGuideOperatorCan: "Pode:",
    permGuideOperatorCanList: "Inserir novos registros|Editar/deletar seus próprios registros|Ver resumos da propriedade",
    permGuideOperatorCannot: "Não pode:",
    permGuideOperatorCannotList: "Editar registros de outros|Ver relatórios detalhados de equipe",
    permGuideTransferTitle: "Transferência de Propriedade",
    permGuideTransferDesc: "Transferir uma propriedade significa mudar quem é o dono oficial dela na plataforma. Essa ação impacta diretamente quem paga pelo plano e quem autoriza o acesso dos colaboradores.",
    permGuideTransferWhatChanges: "O que muda na transferência?",
    permGuideTransferChangeOwner: "O proprietário muda — o novo dono passa a ser o responsável legal pela propriedade na plataforma.",
    permGuideTransferChangePlan: "O plano do novo proprietário passa a valer — todos os colaboradores (responsável e operadores) passam a operar sob o plano do NOVO dono. Se o novo dono tem um plano inferior, as funcionalidades disponíveis para a equipe podem ser reduzidas.",
    permGuideTransferChangeAuth: "A autorização de acesso muda — é o novo proprietário que decide quem pode acessar, gerenciar ou operar na propriedade.",
    permGuideTransferWhatStays: "O que NÃO muda?",
    permGuideTransferStayData: "Todos os dados permanecem intactos — registros de sangria, configurações de contexto, histórico de produção, nada é perdido.",
    permGuideTransferStayTeam: "A equipe continua vinculada — responsável e operadores permanecem com seus papéis, mas agora sob a gestão do novo proprietário.",
    permGuideTransferStayConfig: "Configurações da propriedade permanecem — clone, sistema de sangria, densidade de árvores, tudo continua igual.",
    permGuideTransferPlanWarningTitle: "Atenção sobre o Plano",
    permGuideTransferPlanWarning: "Na HeveaTalent, o plano do PROPRIETÁRIO é o que define os limites de acesso de TODOS que trabalham naquela propriedade. Quando você transfere a propriedade, o plano do novo dono é que passa a valer. Exemplo: se o dono atual tem plano Completo e transfere para alguém com plano Gratuito, a equipe perde acesso às funcionalidades avançadas.",
    permGuideTransferSteps: "Como funciona o processo:",
    permGuideTransferStep1: "A transferência é solicitada pelo administrador da plataforma",
    permGuideTransferStep2: "O email do novo proprietário é informado — se ele não tiver conta, uma é criada automaticamente",
    permGuideTransferStep3: "A propriedade passa imediatamente para o novo dono com todos os dados preservados",
    permGuideTransferStep4: "O plano do novo proprietário passa a governar o acesso de toda a equipe vinculada",
    permGuideTransferWhoCanTitle: "Quem pode transferir?",
    permGuideTransferWhoCan: "Atualmente, apenas o administrador da plataforma pode realizar a transferência. Entre em contato para solicitar.",
    permGuideTransferNote: "Resumo: transferir = mudar quem é o dono + quem banca o plano para a equipe. Dados e equipe permanecem.",
    permGuidePlansTitle: "Planos e Funcionalidades",
    permGuideFree: "Gratuito",
    permGuideFreeDesc: "90 dias de calendário|1 propriedade|1 vaga de emprego|Sem gestão de equipe",
    permGuideProfessional: "Básico - R$ 30/mês",
    permGuideProfessionalDesc: "1 propriedade|Equipe até 5 pessoas|Calendário completo|45 dias grátis",
    permGuideEnterprise: "Essencial - R$ 60/mês",
    permGuideEnterpriseDesc: "3 propriedades|Equipe até 10 pessoas|Relatórios completos|45 dias grátis",
    permGuideComplete: "Completo - R$ 120/mês",
    permGuideCompleteDesc: "Propriedades ilimitadas|Equipe ilimitada|Tudo ilimitado|45 dias grátis",
    
    // ========== CALENDAR USER GUIDE ==========
    calGuideTitle: "Guia do Calendário de Sangria",
    calGuideQuickStart: "Início Rápido",
    calGuideProperty: "Propriedade",
    calGuideRecords: "Registros",
    calGuideTeam: "Equipe",
    calGuideEthrel: "Ethrel",
    calGuideReports: "Relatórios",
    calGuideTips: "Dicas",
    calGuideQuickStartTitle: "Início Rápido",
    calGuideQuickStartDesc: "O Calendário de Sangria ajuda você a controlar toda a produção de látex da sua propriedade.",
    calGuideFirstSteps: "Primeiros Passos:",
    calGuideStep1: "Selecione a propriedade no menu suspenso",
    calGuideStep2: "Escolha o mês/ano que deseja visualizar",
    calGuideStep3: "Clique em um dia no calendário para adicionar registro",
    calGuideStep4: "Preencha os dados de produção do dia",
    calGuideStep5: "Salve e repita para outros dias",
    calGuideViews: "Visualizações Disponíveis:",
    calGuideViewCalendar: "Calendário - Visão mensal com indicadores visuais",
    calGuideViewTable: "Tabela - Lista detalhada dia a dia",
    calGuidePropertyTitle: "Configurando a Propriedade",
    calGuideHarvestMonth: "Importante: Mês de Início da Safra",
    calGuideHarvestMonthDesc: "A safra da seringueira normalmente vai de Setembro a Agosto. Ao cadastrar sua propriedade, defina corretamente o mês de início para que os relatórios acumulados reflitam sua safra real.",
    calGuidePropertyData: "Dados da Propriedade:",
    calGuidePropertyName: "Nome - Identificação da fazenda",
    calGuidePropertyLocation: "Localização - Cidade/Estado",
    calGuidePropertyAge: "Idade da Cultura - Anos das seringueiras",
    calGuidePropertyArea: "Área Total - Hectares (opcional)",
    calGuidePropertyStartMonth: "Mês de Início da Safra - Geralmente Setembro",
    
    // ========== PERMISSIONS MANAGEMENT UI ==========
    permMgmtTitle: "Gerenciar Acesso",
    permMgmtSubtitle: "Defina quem pode acessar esta propriedade",
    permMgmtOwner: "Proprietário",
    permMgmtOwnerYou: "(você)",
    permMgmtOwnerDesc: "Dono legal. Pode transferir e definir permissões.",
    permMgmtManager: "Responsável",
    permMgmtManagerDesc: "Gerencia dia a dia, edita registros e vê relatórios.",
    permMgmtOperators: "Operadores",
    permMgmtOperatorsDesc: "Inserem registros diários de produção.",
    permMgmtNoManager: "Nenhum responsável definido",
    permMgmtNoOperators: "Nenhum operador cadastrado",
    permMgmtAddManager: "Definir Responsável",
    permMgmtAddOperator: "Adicionar Operador",
    permMgmtRemove: "Remover",
    permMgmtPromote: "Promover a Responsável",
    permMgmtDemote: "Rebaixar a Operador",
    permMgmtEmailPlaceholder: "Digite o email da pessoa",
    permMgmtNamePlaceholder: "Nome (opcional)",
    permMgmtConfirmRemove: "Remover acesso de",
    permMgmtConfirmRemoveDesc: "Esta pessoa perderá acesso à propriedade.",
    permMgmtSuccessAdded: "Pessoa adicionada com sucesso",
    permMgmtSuccessRemoved: "Acesso removido com sucesso",
    permMgmtSuccessUpdated: "Permissões atualizadas",
    permMgmtErrorInvalidEmail: "Email inválido",
    permMgmtErrorSameUser: "Não é possível adicionar você mesmo",
    permMgmtErrorAlreadyAdded: "Esta pessoa já tem acesso",
    permMgmtNewAccountCreated: "Conta criada automaticamente",
    permMgmtTempPassword: "Senha temporária",
    permMgmtShareCredentials: "Compartilhe estas credenciais com a pessoa",
    permMgmtOnlyOwnerCanEdit: "Apenas o proprietário pode editar permissões",
    permMgmtLoading: "Carregando permissões...",
    permMgmtError: "Erro ao carregar permissões",
    permMgmtRetry: "Tentar novamente",
    
    // ========== LOGIN & REGISTER DIALOGS ==========
    doLogin: "Fazer Login",
    enterCredentials: "Entre com suas credenciais",
    createAccount: "Criar Conta",
    registerOnPlatform: "Cadastre-se na plataforma",
    selectSpecialization: "Selecione a especialização",
    other: "Outros",
    
    // ========== LANDING PAGE EXTENDED ==========
    professionalsCadastrados: "+500 profissionais cadastrados",
    connectingProducersWorkers: "Conectando produtores e trabalhadores em todo o Brasil",
    whyUseHeveaTalent: "Por que usar o HeveaTalent?",
    everythingYouNeed: "Tudo que você precisa para gerenciar sua produção e equipe em um só lugar",
    dailyControl: "Controle Diário",
    dailyControlDesc: "Registre sangrias, chuva, fungicidas e veja resumos mensais automáticos",
    evaluateTeam: "Avalie sua Equipe",
    evaluateTeamDesc: "Acompanhe o desempenho dos trabalhadores com avaliações privadas",
    certifyTeam: "Certifique sua Equipe",
    certifyTeamDesc: "Selos de qualidade Bronze, Prata e Ouro baseados em avaliação técnica",
    buyAndSell: "Compre e Venda",
    buyAndSellDesc: "Marketplace de insumos, ferramentas e equipamentos agrícolas",
    findWork: "Encontre Trabalho",
    findWorkDesc: "Publique vagas ou encontre oportunidades na heveicultura",
    shareExperiences: "Troque Experiências",
    shareExperiencesDesc: "Comunidade ativa para compartilhar dicas e conhecimentos",
    startIn3Steps: "Comece em 3 passos simples",
    freeToStart: "É grátis para começar e você pode testar todos os recursos",
    createFreeAccount: "Crie sua conta grátis",
    quickSignup: "Cadastro rápido como produtor ou profissional",
    registerProperty: "Cadastre sua propriedade",
    addFarms: "Adicione suas fazendas e comece a organizar",
    startUsing: "Comece a usar",
    registerBleedings: "Registre sangrias, avalie equipe, use o marketplace",
    freeToStartBullet: "Gratuito para começar",
    noCreditCard: "Sem cartão de crédito",
    cancelAnytime: "Cancele quando quiser",
    footerText: "A plataforma da heveicultura brasileira",
    tripeBased: "Baseado no Tripé: Justiça • Segurança • Simplicidade",
    
    // ========== DASHBOARD NAVIGATION ==========
    newAd: "Novo Anúncio",
    searchProfessionals: "Buscar Profissionais",
    quickActions: "Ações Rápidas",
    bleedingToday: "Sangria Hoje",
    publishJobBtn: "Publicar Vaga",
    myJobsPublished: "Minhas Vagas",
    myPublishedJobs: "Minhas Vagas Publicadas",
    seeExample: "Ver Exemplo",
    seeExampleTip: "Ver Exemplo de Dica",
    publishing: "Publicando...",
    findQualifiedProfessionals: "Encontre profissionais qualificados para suas necessidades",
    noProfessionalsAvailable: "Nenhuma oferta de profissional disponível no momento",
    noJobsPublished: "Você ainda não publicou nenhuma vaga",
    searchJobsBtn: "Buscar Vagas",
    offerServices: "Oferecer Serviços",
    myOffers: "Minhas Ofertas",
    availableJobs: "Vagas Disponíveis",
    findOpportunities: "Encontre oportunidades de trabalho na heveicultura",
    noJobsAvailable: "Nenhuma vaga disponível no momento",
    myServiceOffers: "Minhas Ofertas de Serviço",
    noOffersYet: "Você ainda não publicou nenhuma oferta de serviço",
    
    // ========== PLANS SECTION ==========
    loadingPlans: "Carregando planos...",
    plansDescProfessional: "Planos acessíveis para profissionais da heveicultura. Recursos completos no plano gratuito!",
    plansDescEmployer: "Planos robustos para proprietários e empresas. Gerencie suas propriedades, equipes e operações.",
    activateFree: "Ativar Gratuito",
    choosePlan: "Escolher Plano",
    savingsPercent: "Economia de",
    perMonth: "/mês",
    perYear: "Anual",
    individualItems: "Itens Avulsos",
    buyExtrasWithoutChangingPlan: "Compre recursos extras sem precisar trocar de plano",
    adHighlight: "Destaque de Anúncio",
    adHighlightDesc: "Seu anúncio aparece no topo das listagens por 7 dias",
    moreVisibility: "Maior visibilidade",
    highlightBadge: "Badge de destaque",
    validFor7Days: "Válido por 7 dias",
    buyHighlightBtn: "Comprar Destaque",
    extraAdJobBoard: "Anúncio Extra - Balcão",
    extraAdJobBoardDesc: "1 vaga adicional no Balcão de Emprego por 30 dias",
    validFor30Days: "Válido por 30 dias",
    noChangeToPlan: "Sem alterar seu plano",
    immediateUse: "Uso imediato",
    buyAdBtn: "Comprar Anúncio",
    extraAdMarketplace: "Anúncio Extra - Marketplace",
    extraAdMarketplaceDesc: "1 anúncio adicional no Marketplace por 30 dias",
    paymentViaPix: "Pagamento via PIX • Ativação imediata após confirmação",
    tipAnnualSavings: "Dica: Economia no plano anual",
    comingSoon: "Em breve! Integração de pagamento pendente.",
    
    // ========== COMMUNITY SECTION ==========
    loadingCommunityTips: "Carregando dicas da comunidade...",
    communityTipsTitle: "Dicas da Comunidade",
    communityTipsSubtitle: "Compartilhe conhecimento e aprenda com outros profissionais",
    filterByCategory: "Filtrar por categoria",
    allCategories: "Todas as categorias",
    categoryBleeding: "Sangria",
    categoryDiseases: "Doenças",
    categoryIdeas: "Ideias",
    categoryMarket: "Mercado da Borracha",
    categoryNews: "Notícias",
    categoryWeather: "Clima",
    categoryOthers: "Outros",
    exampleBadge: "Exemplo",
    likes: "curtidas",
    comments: "comentários",
    by: "Por",
    errorLikeTip: "Erro ao curtir a dica",
    commentPrompt: "Comentar sobre",
    errorCommentTip: "Erro ao comentar",
    shareATip: "Compartilhar uma dica",
    noTipsFound: "Nenhuma dica encontrada para esta categoria",
    
    // ========== MARKETPLACE SECTION ==========
    browseProducts: "Navegar Produtos",
    sellProduct: "Vender Produto",
    myAds: "Meus Anúncios",
    myAdvertisedProducts: "Meus Produtos Anunciados",
    noProductsYet: "Você ainda não tem produtos anunciados",
    allProducts: "Todos os Produtos",
    properties: "Propriedades",
    equipment: "Equipamentos",
    supplies: "Insumos",
    services: "Serviços",
    searchInMarketplace: "Buscar no marketplace...",
    noProductsFound: "Nenhum produto encontrado",
    
    // ========== CALENDAR SECTION ==========
    trialExpiredTitle: "Período de Teste Expirado",
    trialExpiredDataSaved: "Seus dados estão salvos e serão recuperados após o upgrade.",
    viewPlansFrom: "Ver Planos - A partir de",
    month: "mês",
    lastDayOfTrial: "ÚLTIMO DIA DE TESTE!",
    lastDayTrialMsg: "Seu acesso ao Calendário expira amanhã. Faça upgrade agora para não perder o acesso.",
    upgradeNow: "Fazer Upgrade Agora",
    trialEndingSoon: "Teste terminando em breve!",
    daysRemaining: "dias restantes",
    trialExpiresIn: "Seu período de teste expira em",
    days: "dias",
    seeUpgradeOptions: "Ver opções de upgrade",
    trialEnding30Days: "Período de teste ativo",
    trialEnding30DaysMsg: "Você ainda tem",
    daysToExplore: "dias para explorar todos os recursos.",
    bleedingCalendar: "Calendário de Sangria",
    calendarSubtitle: "Registre e acompanhe suas sangrias diariamente",
    selectProperty: "Selecionar Propriedade",
    addProperty: "Adicionar Propriedade",
    newProperty: "Nova Propriedade",
    propertyName: "Nome da Propriedade",
    propertyNamePlaceholder: "Ex: Fazenda São João",
    numberOfTrees: "Número de Árvores",
    createProperty: "Criar Propriedade",
    loading: "Carregando...",
    monthlySummary: "Resumo Mensal",
    bleedingDays: "Dias de Sangria",
    rainDays: "Dias de Chuva",
    fungicideDays: "Aplicações de Fungicida",
    viewCalendar: "Ver Calendário",
    viewTable: "Ver Tabela",
    addFirstProperty: "Adicione uma Propriedade",
    noPropertyMsg: "Cadastre sua primeira propriedade para começar a usar o calendário de sangria.",
    addPropertyBtn: "Adicionar Propriedade",
    startFreeTrial: "Começar Trial Gratuito",
    contentBlocked: "Conteúdo bloqueado. Faça upgrade para continuar.",
    property: "Propriedade",
    years: "anos",
    monthYear: "Mês/Ano",
    previousMonth: "Mês anterior",
    nextMonth: "Próximo mês",
    location: "Localização",
    totalRain: "Total Chuva",
    totalProduction: "Total Produção",
    totalReplacements: "Total Reposições",
    
    // ========== TODAYS HABITS ==========
    todaysActivities: "Atividades de hoje",
    manageActivitiesDesc: "Gerencie suas atividades diárias de heveicultura",
    bleeding: "Sangria",
    bleedingDesc: "Sangria realizada hoje",
    production: "Produção",
    productionCollection: "Coleta de Produção",
    productionCollectionDesc: "Látex coletado/pesado hoje",
    generalApplications: "Aplicações Gerais",
    generalApplicationsDesc: "Produtos aplicados hoje (fungicidas, ethrel, coagulante, herbicidas, adubos)",
    management: "Manejo",
    daily: "Diária",
    periodic: "Periódica",
    sporadic: "Esporádica",
    completed: "Concluído!",
    pending: "Pendente",
    notNeededToday: "Não necessário hoje",
    dailyGoal: "Meta diária",
    whenNeeded: "Quando necessário",
    noActivitiesYet: "Nenhuma atividade ainda. Crie sua primeira atividade de sangria!",
    addActivity: "Adicionar Atividade",
    dayProgress: "Progresso do dia:",
    essentials: "essenciais",
    extra: "extra",
    extras: "extras",
    of: "de",
    
    // ========== FORMS ==========
    publishNewJob: "Publicar Nova Vaga",
    registerNewJobOpp: "Cadastre uma nova oportunidade de emprego",
    jobTitle: "Título da Vaga",
    salaryRange: "Faixa Salarial",
    salaryRangePlaceholder: "Ex: R$ 2.000 - R$ 3.000",
    jobType: "Tipo de Trabalho",
    fullTime: "Tempo Integral",
    partTime: "Meio Período",
    contract: "Contrato",
    seasonal: "Sazonal",
    jobDescription: "Descrição da Vaga",
    requirements: "Requisitos",
    publishJob: "Publicar Vaga",
    jobPublishedSuccess: "Vaga publicada com sucesso!",
    errorPublishingJob: "Erro ao publicar vaga",
    needLoginToPublish: "Você precisa fazer login para publicar vagas",
    considerUpgrade: "Considere fazer upgrade do seu plano na aba Planos.",
    
    // ========== WORK OFFER FORM ==========
    createWorkOffer: "Criar Oferta de Trabalho",
    offerServicesToEmployers: "Ofereça seus serviços para empregadores",
    offerTitle: "Título da Oferta",
    availableLocations: "Locais Disponíveis",
    expectedSalary: "Salário Esperado",
    expectedSalaryPlaceholder: "Ex: R$ 2.500",
    availability: "Disponibilidade",
    immediate: "Imediata",
    oneMonth: "1 mês",
    twoMonths: "2 meses",
    threeMonths: "3 meses",
    serviceDescription: "Descrição dos Serviços",
    skillsAndExperience: "Habilidades e Experiência",
    createOffer: "Criar Oferta",
    creating: "Criando...",
    workOfferCreatedSuccess: "Oferta de trabalho criada com sucesso!",
    errorCreatingOffer: "Erro ao criar oferta",
    needLoginToOffer: "Você precisa fazer login para ofertar trabalho",
    
    // ========== MARKETPLACE FORM ==========
    advertiseProduct: "Anunciar Produto",
    registerProductForSale: "Cadastre um produto ou serviço para venda",
    productName: "Nome do Produto",
    category: "Categoria",
    price: "Preço",
    pricePlaceholder: "Ex: R$ 150,00",
    condition: "Condição",
    conditionNew: "Novo",
    conditionUsed: "Usado",
    conditionRefurbished: "Recondicionado",
    productDescription: "Descrição do Produto",
    contactInfo: "Informações de Contato",
    advertise: "Anunciar",
    productRegisteredSuccess: "Produto cadastrado com sucesso!",
    errorRegisteringProduct: "Erro ao cadastrar produto",
    needLoginToSell: "Você precisa fazer login para vender produtos",
    selectCategory: "Selecione a categoria",
    pesticides: "Defensivos Agrícolas",
    machinery: "Maquinaria",
    semiNew: "Seminovo",
    fullLocation: "Localização Completa",
    locationPlaceholder: "Ex: Fazenda Santa Rita, Km 15, Zona Rural",
    
    // ========== EVALUATIONS DASHBOARD ==========
    technicalEvaluationSystem: "Sistema de Avaliação Técnica",
    heveaTalentCertification: "Certificação HeveaTalent baseada em literatura técnica oficial",
    overview: "Visão Geral",
    myProfile: "Meu Perfil",
    inviteEmployer: "Convidar",
    createEvaluation: "Criar Avaliação",
    myProfessionalProfile: "Meu Perfil Profissional",
    viewCertificationSeals: "Ver certificação e selos",
    accessDashboard: "Acessar Dashboard",
    aboutTheSystem: "Sobre o Sistema",
    howEvaluationWorks: "Como funciona a avaliação",
    bronze: "Bronze",
    silver: "Prata",
    gold: "Ouro",
    points: "pontos",
    technicalCriteria: "Critérios Técnicos",
    senarEmbrapaIncaperStandards: "Padrões técnicos oficiais (INCAPER/CATI)",
    bleedingTechnique: "Técnica de Sangria",
    harvestPreparation: "Preparação de Safra",
    dailyMaintenance: "Manutenção Diária",
    chemicalApplications: "Aplicações Químicas",
    educationalFeedback: "Feedback Educativo",
    improveContinuously: "Melhore continuamente",
    personalizedRecommendations: "Consulte os tooltips (ⓘ) em cada critério para dicas práticas baseadas em documentos oficiais.",
    viewTechnicalReferences: "Ver Referências Técnicas",
    viewFullProfile: "Visualize seu Perfil Completo",
    accessDashboardToSee: "Acesse seu dashboard para ver certificação, pontuação e feedback detalhado",
    openMyDashboard: "Abrir Meu Dashboard",
    createNewEvaluation: "Criar Nova Avaliação",
    selectWorkerToEvaluate: "Selecione um trabalhador da sua equipe para avaliar",
    startEvaluation: "Iniciar Avaliação",
    
    // ========== PERFORMANCE DASHBOARD ==========
    contextualPerformance: "Desempenho Contextual",
    contextualPerformanceSubtitle: "Avaliação justa baseada no contexto da propriedade",
    selectPropertyToView: "Selecione uma propriedade para visualizar o desempenho",
    performanceHistory: "Histórico de Desempenho",
    monthlyPerformance: "Desempenho Mensal",
    currentPerformance: "Desempenho Atual",
    qualitySeals: "Selos de Qualidade",
    configureContext: "Configurar Contexto",
    referenceData: "Dados de Referência",
    cloneTypes: "Tipos de Clone",
    tappingSystems: "Sistemas de Sangria",
    seasonalCoefficients: "Coeficientes Sazonais",
    noDataAvailable: "Nenhum dado disponível",
    errorLoadingData: "Erro ao carregar dados",
    
    // ========== COMMON ACTIONS & MESSAGES ==========
    saving: "Salvando...",
    save: "Salvar",
    update: "Atualizar",
    edit: "Editar",
    delete: "Deletar",
    remove: "Remover",
    add: "Adicionar",
    send: "Enviar",
    sending: "Enviando...",
    cancel: "Cancelar",
    close: "Fechar",
    confirm: "Confirmar",
    back: "Voltar",
    next: "Próximo",
    previous: "Anterior",
    search: "Buscar",
    filter: "Filtrar",
    clear: "Limpar",
    reset: "Resetar",
    submit: "Enviar",
    saveChanges: "Salvar Alterações",
    
    // ========== ERROR MESSAGES ==========
    errorSendingEvaluation: "Erro ao enviar avaliação",
    errorPublishingJob: "Erro ao publicar vaga",
    errorCreatingOffer: "Erro ao criar oferta",
    errorDeletingJob: "Erro ao excluir vaga",
    errorDeactivatingJob: "Erro ao desativar vaga",
    errorDeletingOffer: "Erro ao excluir oferta",
    errorDeactivatingOffer: "Erro ao desativar oferta",
    errorAddingComment: "Erro ao adicionar comentário",
    errorSharingTip: "Erro ao compartilhar dica. Tente novamente.",
    errorProcessingSubscription: "Erro ao processar assinatura",
    errorSearchingProfessionals: "Erro ao buscar profissionais",
    errorRemovingAd: "Erro ao remover anúncio",
    errorCreatingPixPayment: "Erro ao criar pagamento PIX",
    errorCheckingPaymentStatus: "Erro ao verificar status do pagamento",
    errorSavingRecord: "Erro ao salvar registro",
    errorAddingImage: "Erro ao adicionar imagem",
    errorLoadingFile: "Erro ao carregar arquivo",
    errorUpdatingProduct: "Erro ao atualizar produto",
    errorDeletingRecord: "Erro ao deletar registro",
    
    // ========== CALENDAR SPECIFIC ==========
    newRecord: "Novo Registro",
    editRecord: "Editar Registro",
    day: "Dia",
    addDataForThisDay: "Adicionar dados para este dia",
    editRecordTitle: "Editar registro",
    deleteRecordTitle: "Deletar registro",
    onlyNumbers: "Apenas números",
    additionalInfo: "Informações adicionais sobre a propriedade",
    mobileFriendlyTip: "Mobile-Friendly",
    clickAddButton: "Clique no botão",
    toOpenFullForm: "para abrir o formulário completo",
    useEditButton: "Use",
    toModifyRecords: "para modificar registros existentes",
    uploadingFiles: "Carregando",
    addByUrl: "Ou Adicionar por URL",
    previousImage: "Imagem anterior",
    nextImage: "Próxima imagem",
    
    // ========== YEARLY SUMMARY & ETHREL ==========
    yearlyAccumulatedSummary: "Resumo Acumulado",
    totalReplacement: "Total Reposição",
    ethrelApplications: "Aplicações de Ethrel",
    fungicideApplications: "Aplicações de Fungicida",
    totalLosses: "Total Perdas",
    totalRecords: "Total Registros",
    monthlyBreakdown: "Detalhamento Mensal",
    ethrelControl: "Controle de Ethrel",
    configureInterval: "Configure o intervalo de aplicação",
    ethrelConfiguration: "Configuração de Ethrel",
    intervalBetweenApplications: "Intervalo entre aplicações (dias)",
    alertDaysBefore: "Alertar com antecedência de (dias)",
    lastApplication: "Última aplicação",
    daysSinceLastApplication: "dias desde a última aplicação",
    nextApplicationIn: "Próxima aplicação em",
    ethrelExpired: "VENCIDO! Ethrel deveria ter sido aplicado",
    ethrelUpToDate: "Ethrel em dia",
    ethrelHistory: "Histórico de aplicações",
    ethrelProportion: "Proporção/Concentração",
    
    // ========== MARKETPLACE SPECIFIC ==========
    noProductsAvailableNow: "Nenhum produto disponível no momento",
    noProductsInCategory: "Nenhum produto nesta categoria",
    publishAd: "Publicar Anúncio",
    editProduct: "Editar Produto",
    sendEvaluation: "Enviar Avaliação",
    
    // ========== PROFESSIONAL RUBBER CULTIVATION ==========
    professionalRubberCultivation: "Heveicultura profissional",
    
    // ========== CURRENT PLAN BANNER ==========
    growWithHeveaTalent: "Cresça com a HeveaTalent",
    discoverPlansAndResources: "Conheça os planos disponíveis e recursos",
    personalCalendarHistory: "Calendário pessoal, histórico de produção",
    advancedFeaturesUnlocked: "Recursos avançados desbloqueados",
    
    // ========== HEADER & AUTH ==========
    logout: "Sair",
    heveicultureProfessional: "Heveicultura Profissional",
    of: "de",
    
    // ========== MARKET MODULE ==========
    // Navigation & Headers
    marketModule: "Mercado",
    marketAnalysis: "Análise de Mercado",
    quotations: "Cotações",
    calculator: "Calculadora",
    sources: "Fontes",
    dataStatus: "Status",
    glossary: "Glossário",
    
    // Main Headers
    marketSummary: "Resumo do Mercado",
    priceReferences: "Cotações de Referência",
    scenarioSimulator: "Simulador de Cenários",
    valueComparison: "Comparativo de Valores",
    implicitParticipationRate: "Taxa de Participação Implícita",
    
    // References
    geb10Apabor: "GEB-10 APABOR",
    geb10MarketSP: "GEB-10 Mercado SP",
    importPriceIEA: "Preço Importação (IEA)",
    coagulum: "Coágulo",
    coagulumProducer: "Coágulo (Produtor)",
    productionCost: "Custo Produção",
    exchangeRate: "Câmbio",
    dollar: "Dólar",
    international: "Internacional",
    
    // Labels & Tags
    reference: "REFERÊNCIA",
    realPrice: "PREÇO REAL",
    adoptedByMills: "ADOTADO PELAS USINAS",
    importParity: "PARIDADE IMPORTAÇÃO",
    spotPrice: "PREÇO SPOT",
    currentMarket: "Mercado",
    
    // Units
    perKg: "por kg",
    drc: "DRC",
    participationRate: "Taxa de Participação",
    
    // Tooltips & Help
    understand: "Entenda",
    howItWorks: "Como Funciona",
    howDataWorks: "Como Funcionam os Dados desta Página",
    mainData: "Os 2 dados principais",
    contextData: "Dados de Contexto",
    howToUpdate: "Como os dados são atualizados",
    
    // Data Descriptions
    geb10Description: "Preço de referência bimestral calculado a partir do preço internacional + câmbio + custos de importação.",
    importPriceDescription: "Custo TOTAL para importar borracha beneficiada. Inclui: preço internacional + câmbio + frete + seguro + impostos (~10,8%) + custos portuários.",
    geb10MarketDescription: "Preço real praticado nas transações do mercado físico paulista.",
    coagulumDescription: "Preço real pago ao produtor no mercado.",
    
    // Update Frequencies
    bimonthly: "Bimestral",
    monthly: "Mensal",
    daily: "Diário",
    annual: "Anual",
    automatic: "Automático",
    manual: "Manual",
    impliedParticipationRate: "Taxa de Participação Implícita",
    timesPerYear: "vezes/ano",
    
    // Status
    current: "Vigente",
    previousPeriod: "Período anterior",
    checkNewPeriod: "Verificar novo período",
    
    // Actions
    update: "Atualizar",
    updateData: "Atualizar Dados",
    updateExchangeRate: "Atualizar Câmbio",
    save: "Salvar",
    calculate: "Calcular",
    reset: "Limpar",
    expand: "Expandir",
    collapse: "Recolher",
    
    // Calculator
    officialFormula: "Fórmula Oficial (CNA/FAESP/IEA)",
    producerPrice: "Preço Produtor",
    preview: "Preview",
    calculatePrice: "Calcular Preço",
    calculatedResult: "Resultado do Cálculo",
    
    // Margin Analysis
    marginAnalysis: "Análise de Margem",
    marginOnProductionCost: "Margem sobre Custo de Produção",
    profit: "Lucro",
    loss: "Prejuízo",
    
    // References Comparison
    referencesComparison: "Comparativo de Referências e Taxas",
    minCNA: "Mín CNA",
    refIEA: "Ref IEA",
    
    // Guide Steps
    welcomeToGuide: "Bem-vindo ao Guia de Preços",
    priceChain: "A Cadeia de Formação",
    priceReference: "O Preço de Referência",
    whatIsDRC: "O que é DRC?",
    participationRateExplained: "A Taxa de Participação",
    completeFormula: "A Fórmula Completa",
    productionCostAnalysis: "Custo de Produção",
    negotiationTips: "Dicas para Negociar",
    summary: "Resumo",
    
    // Guide Content
    guideWelcomeText: "Este guia vai te ajudar a entender como o preço do coágulo é formado e como negociar melhor.",
    
    // Price Chain
    internationalPrice: "Preço Internacional (SGX)",
    conversionAndCosts: "Conversão + Custos de Importação",
    nationalReferencePrice: "Preço de Referência Nacional",
    producerFormula: "Fórmula do Produtor",
    yourPrice: "Seu Preço",
    
    // Disclaimers
    officialSourcesDisclaimer: "Referências de fontes oficiais (IEA, APABOR, CONAB). Para negociações, consulte sua cooperativa.",
    dataFromOfficialSources: "Os dados vêm de fontes oficiais: IEA, APABOR, CONAB, BCB",
    
    // Footer
    tripodJustice: "JUSTIÇA: Cálculos transparentes",
    tripodSecurity: "SEGURANÇA: Fontes oficiais",
    tripodSimplicity: "SIMPLICIDADE: Informação clara",
    developedBasedOn: "Conteúdo desenvolvido com base em estudos da CNA, FAESP, IEA/SAA-SP e CONAB.",
    lastUpdate: "Última atualização",
    
    // Publication Calendar
    publicationCalendar: "Calendário de Publicações",
    nextPublication: "Próxima publicação",
    verify: "Verificar",
    
    // Mandatory/Optional
    mandatoryUpdates: "Atualizações OBRIGATÓRIAS (para cálculos)",
    automaticUpdates: "Atualização AUTOMÁTICA",
    optionalUpdates: "Opcionais (contexto)",
    
    // Analysis
    relationBetweenReferences: "Relação entre as referências",
    maxCost: "Custo máximo (se a indústria importasse)",
    negotiationReference: "Referência para negociação entre usinas e produtores",
    realTransactionPrice: "Preço real das transações",
    
    // Why different values
    whyDifferentValues: "Por que os valores são diferentes?",
    sameFormulaDifferentRef: "A mesma fórmula gera valores diferentes dependendo da referência usada.",
    
    // ========== MARKET MODULE INDEX ==========
    understandRubberMarket: "Entenda o Mercado da Borracha",
    marketInfoForDecision: "Informações de mercado para tomada de decisão.",
    viewCompleteGuide: "Ver Guia Completo",
    new: "NOVO",
    yourDataPrivateProtected: "Seus dados são privados e protegidos",
    importantWarning: "Aviso Importante",
    educationalContentDisclaimer: "Este conteúdo é educativo, baseado em fontes oficiais (IEA, APABOR, CNA, CONAB). Os preços e metodologias apresentados são referências - consulte sempre sua cooperativa ou usina para negociações específicas.",
    viewUserGuide: "Ver Guia de Uso",
    december: "Dezembro",
    
    // Glossary terms
    glossaryGEB10: "Granulado Escuro Brasileiro - Borracha natural beneficiada, classificação 10",
    glossaryDRC: "Dry Rubber Content - Teor de borracha seca no coágulo",
    glossaryCoagulum: "Látex coagulado antes do beneficiamento",
    glossaryParticipationRate: "Percentual do preço de referência repassado ao produtor",
    
    // ========== OFFICIAL SOURCES ==========
    heveaTalentQuotations: "Cotações HeveaTalent",
    howPriceIsFormed: "Como o Preço é Formado",
    understandWhereDataComesFrom: "Entenda de onde vem cada número. Clique para verificar nas fontes oficiais.",
    verifySource: "Verificar fonte",
    priceFormulaProducer: "Fórmula do Preço ao Produtor",
    priceFormulaExample: "Exemplo (ago/26): R$ 16,37 × 53% × 70% = R$ 6,07/kg",
    lastVerification: "Última verificação",
    importPrice: "Preço Importação",
    geb10Label: "GEB-10",
    coaguloLabel: "Coágulo",
    internationalLabel: "Internacional",
    geb10ApabarMainRef: "GEB-10 APABOR - Referência Principal",
    geb10ApabarDesc: "Preço internalizado (Internacional + Câmbio + Custos). Publicação bimestral.",
    coaguloIeaProducerPrice: "Coágulo IEA - Preço ao Produtor",
    coaguloIeaDesc: "Valor real transacionado na origem. Base DRC 53%.",
    productionCostConab: "Custo Produção - CONAB",
    productionCostConabDesc: "Custo de produção para calcular margem do produtor.",
    dataVerifiableOfficial: "Dados de fontes oficiais verificáveis",
    youCheckBeforeUsing: "Você confere antes de usar",
    onlyWhatMatters: "Apenas o que importa",
    
    // ========== USER GUIDE ==========
    welcomeGuideTitle: "Bem-vindo ao Guia de Preços",
    guideIntroText: "Este guia vai te ensinar como funciona a formação de preços da borracha natural e como usar a calculadora para negociar melhor.",
    officialDataSources: "Dados de fontes oficiais (IEA, CNA, APABOR)",
    dataNotShared: "Seus dados não são compartilhados",
    easyToUnderstandUse: "Fácil de entender e usar",
    priceFormationChain: "A Cadeia de Formação de Preços",
    pricePassesThroughSteps: "O preço que você recebe passa por várias etapas desde a cotação internacional:",
    internationalPriceSGX: "Preço Internacional (SGX)",
    sgxQuotation: "Cotação em Singapura",
    conversionImportCosts: "Conversão + Custos de Importação",
    exchangeFreightTaxes: "Câmbio + frete + impostos + custos",
    nationalRefPrice: "Preço de Referência Nacional",
    producerFormula: "Fórmula do Produtor",
    yourPriceCoagulum: "Seu Preco (Coágulo)",
    valueYouReceive: "O valor que você recebe",
    priceReferenceTitle: "O Preço de Referência",
    officialReferencesCalc: "O preço do coágulo é calculado com base em uma referência oficial.",
    mainMarketReferences: "As principais referências do mercado:",
    adoptedByMills: "ADOTADO PELAS USINAS",
    internalizedPrice: "Preço internalizado (Internacional + Câmbio + Custos)",
    mostUsedReference: "Referência mais usada (NB Borracha, São Manoel, Hevea-Tec, etc.)",
    bimonthlyPublication: "Publicação: Bimestral (Dez/Jan, Fev/Mar...)",
    importParity: "PARIDADE IMPORTAÇÃO",
    totalCostImport: "Custo TOTAL para importar borracha beneficiada (GEB-10)",
    includesFreightTaxes: "Inclui: preço internacional + câmbio + frete + impostos (~10,8%) + custos",
    monthlyPublicationDays: "Publicação: Mensal (dias 15-20)",
    spotPrice: "PREÇO SPOT",
    spMarketPracticed: "Preço praticado no mercado paulista",
    monthlyPublication: "Publicação: Mensal",
    whyGeb10Reference: "Por que o GEB-10 APABOR é a referência do mercado?",
    geb10MarketExplanation: "É a referência adotada pelas principais usinas beneficiadoras (NB Borracha, São Manoel, Hevea-Tec, etc.). Permite comparar seu preço diretamente com o que o mercado pratica.",
    whatIsDrcTitle: "DRC - Teor de Borracha Seca",
    whatIsDrcExplanation: "É a porcentagem de borracha seca no seu coágulo. Quanto MAIS seco, MAIOR o DRC e MELHOR o preço.",
    howItWorksLabel: "Como funciona:",
    coagulumMuchWater: "Coágulo com muita água",
    lowDrc: "DRC baixo",
    wellDriedCoagulum: "Coágulo bem seco",
    highDrc: "DRC alto",
    mayBeRejected: "Pode ser rejeitado",
    minimumAccepted: "Mínimo aceito",
    goodExcellent: "Bom / Ótimo",
    excellent: "Excelente",
    drcTip: "Cada 1% a mais no DRC pode significar R$ 0,10-0,15/kg a mais no seu bolso!",
    participationRateTitle: "Taxa de Participação",
    participationRateExplanation: "É o percentual do valor de referência que você recebe. Quanto MAIOR a taxa, MAIS dinheiro no seu bolso.",
    rateBands: "Faixas de Taxa:",
    veryLow: "Muito baixa",
    minCna: "Mínimo CNA",
    good: "Boa",
    ieaReference: "Referência IEA",
    excellentRate: "Excelente",
    minRecommendedCna: "A taxa de 52% é o MÍNIMO recomendado pela CNA. O IEA usa 80% em seus cálculos oficiais!",
    howToGetBetterRates: "Como conseguir taxas melhores:",
    deliverLargerVolume: "Entregar volume maior",
    maintainRegularFrequency: "Manter frequência regular",
    guaranteeQuality: "Garantir qualidade (DRC alto)",
    longTermContracts: "Fazer contratos de longo prazo",
    negotiateInGroup: "Negociar em grupo/cooperativa",
    completeFormulaTitle: "A Fórmula Completa",
    coagulumPriceFormula: "Preço Coágulo = Referência × (DRC/100) × (Taxa/100)",
    comparativeWithReferences: "Comparativo com as 3 referências do mercado (DRC 53%):",
    bimonthlyRefPrice: "Preço de referência bimestral calculado a partir do preço internacional + câmbio + custos de importação.",
    totalCostImportGeb: "Custo total para importar borracha beneficiada (GEB-10). Inclui frete, impostos e todos os custos.",
    realTransactionPriceSP: "Preço real praticado nas transações do mercado físico de São Paulo.",
    relationBetweenRef: "Relação entre as referências:",
    maxCostIfImported: "Custo máximo (se a indústria importasse)",
    refNegotiationMills: "Referência para negociação entre usinas e produtores",
    realTransactionPriceLabel: "Preço real das transações",
    understandDifference: "Entenda a diferença",
    millsAdoptGeb10: "As usinas adotam o GEB-10 APABOR para negociar com produtores. O Preço Importação IEA serve como referência de \"paridade\" - quanto o coágulo nacional valeria se competisse diretamente com o importado.",
    productionCostTitle: "Custo de Produção",
    priceCoversCoststQuestion: "Seu preço cobre os custos?",
    profitNeedsHigherPrice: "Para ter lucro, o preço que você recebe precisa ser MAIOR que seu custo de produção.",
    operationalEffectiveCost: "Custo Operacional Efetivo",
    directCostsCOE: "Gastos diretos (COE)",
    totalOperationalCost: "Custo Operacional Total",
    includesProLabore: "Inclui pró-labore (COT)",
    marginAnalysisGeb10: "Análise de Margem (GEB-10 APABOR R$ 11,31):",
    scenario: "Cenário",
    marginVsCOT: "Margem (vs COT)",
    marketAnalysis: "Análise",
    currentMarketAnalysis: "Compare o preço do coágulo com as referências e o custo de produção nas abas Cotações e Análise — os valores são atualizados diariamente.",
    officialSourcesTitle: "Fontes Oficiais",
    verifiableData: "Dados verificáveis",
    allDataFromOfficialSources: "Todos os dados desta calculadora vêm de fontes oficiais que você pode consultar.",
    dailyQuotes: "diário",
    searchOnSite: "Buscar por \"borracha natural\" no site",
    technicalBulletins: "Boletins técnicos e notícias do setor",
    someContentForMembers: "Alguns conteúdos para associados",
    dailyCoagulumQuotation: "Cotação do coágulo (diária)",
    internationalPriceSGXRealTime: "Preço internacional SGX (tempo real)",
    negotiationTipsTitle: "Dicas para Negociar",
    knowledgeIsPower: "Conhecimento é poder!",
    useKnowledgeToNegotiate: "Agora que você entende como o preço é formado, use esse conhecimento para negociar melhor.",
    confirmMillReference: "Confirme qual referência a usina usa",
    mostUseMills: "A maioria usa GEB-10 APABOR. Compare com os valores desta calculadora.",
    askCalculationInWriting: "Peça o cálculo por escrito",
    demandTransparency: "Exija transparência: GEB-10 × DRC × Taxa = seu preço",
    improveYourDRC: "Melhore seu DRC",
    avoidMoisture: "Evite umidade no coágulo. Cada 1% vale R$ 0,10-0,15/kg",
    negotiateRate: "Negocie a taxa de participação",
    minIdealRate: "Mínimo 52%, ideal 70-80%. Volume e qualidade justificam taxas melhores",
    useThisCalculator: "Use esta calculadora",
    checkPriceFormula: "Confira se o preço oferecido bate com a fórmula oficial",
    congratulations: "Parabéns!",
    readyToNegotiate: "Agora você está pronto para negociar de forma justa e informada!",
    stepOf: "Passo {current} de {total}",
    previous: "Anterior",
    next: "Próximo",
    startUsing: "Começar a usar!",
    
    // ========== GLOSSARY ==========
    rubberMarketGlossary: "Glossário do Mercado da Borracha",
    understandTechnicalTerms: "Entenda os termos técnicos utilizados no mercado da borracha natural.",
    starTermsImportant: "Os termos com ⭐ são os mais importantes para entender a formação de preço.",
    searchTermPlaceholder: "Buscar termo... (ex: geb 10, drc, preço)",
    termsFound: "{count} termo(s) encontrado(s)",
    forSearch: "para \"{term}\"",
    noTermsFound: "Nenhum termo encontrado para \"{term}\"",
    tryOtherWord: "Tente buscar por outra palavra ou limpe o filtro",
    glossaryTip: "Os termos com ⭐ são essenciais para entender como o preço é formado.",
    startWithTerms: "Comece por eles:",
    categoryProduct: "Produto",
    categoryQuality: "Qualidade",
    categoryProduction: "Produção",
    categoryChain: "Cadeia",
    categoryPrice: "Preço",
    categoryInstitution: "Instituição",
    categoryTax: "Imposto",
    allCategories: "Todos",
    tip: "Dica",
    
    // ========== ADMIN PANEL ==========
    updateQuotationsTitle: "Atualizar Cotações",
    updateValuesFromSources: "Atualize os valores consultando as fontes oficiais. Os dados serão salvos no sistema.",
    importPriceIEA: "Preço Importação (IEA)",
    geb10Apabor: "GEB-10 APABOR",
    coaguloDRC53: "Coágulo DRC 53%",
    smr20International: "SMR20 Internacional",
    dollarExchange: "Dólar (Câmbio)",
    valueLabel: "Valor",
    referenceDateLabel: "Data Referência",
    referenceDatePlaceholder: "Ex: Dez/2025",
    savingLabel: "Salvando...",
    saveLabel: "Salvar",
    updatedSuccessfully: "atualizado com sucesso!",
    errorSavingTryAgain: "Erro ao salvar. Tente novamente.",
    connectionErrorTryAgain: "Erro de conexão. Tente novamente.",
    consultSourcesLabel: "Consultar Fontes:",
    loadingLabel: "Carregando...",
    
    // ========== SUPPLY CHAIN ==========
    supplyChainTitle: "A Cadeia Produtiva da Borracha Natural",
    supplyChainDescription: "Entenda como a borracha sai da seringueira até chegar ao consumidor final. Cada elo da cadeia adiciona valor ao produto.",
    detailsOfEachStep: "Detalhes de Cada Etapa",
    importantData: "Dados Importantes",
    referenceLabel: "Referência",
    tapperHeveicultor: "Seringueiro/Heveicultor",
    tapperDescription: "Extrai o látex da seringueira através da sangria",
    tapperProduct: "Látex / Coágulo",
    tapperDetail1: "Realiza a sangria das árvores",
    tapperDetail2: "Coleta o látex",
    tapperDetail3: "Coagula o látex (adiciona ácido)",
    tapperDetail4: "Vende o coágulo para a beneficiadora",
    coagulumPriceRef: "Preço do Coágulo (R$/kg)",
    processorMill: "Beneficiadora/Usina",
    processorDescription: "Processa o coágulo e transforma em borracha beneficiada",
    processorProduct: "GEB-10 (Granulado Escuro Brasileiro)",
    processorDetail1: "Compra coágulo dos produtores",
    processorDetail2: "Processa e limpa o material",
    processorDetail3: "Seca e granula a borracha",
    processorDetail4: "Produz o GEB-10 (100% borracha)",
    geb10PriceRef: "Preço GEB-10 (R$/kg)",
    tireIndustry: "Indústria Pneumática",
    tireIndustryDescription: "Fabrica pneus e produtos de borracha",
    tireIndustryProduct: "Pneus e derivados",
    tireIndustryDetail1: "Compra GEB-10 das beneficiadoras",
    tireIndustryDetail2: "Mistura com outros componentes",
    tireIndustryDetail3: "Fabrica pneus e produtos",
    tireIndustryDetail4: "Consome ~70% da borracha nacional",
    industrialPriceRef: "Preço Industrial",
    finalConsumer: "Consumidor Final",
    finalConsumerDescription: "Utiliza os produtos finais",
    finalConsumerProduct: "Veículos, equipamentos",
    finalConsumerDetail1: "Compra veículos com pneus",
    finalConsumerDetail2: "Troca pneus periodicamente",
    finalConsumerDetail3: "Usa produtos de borracha",
    consumerPriceRef: "Preço ao Consumidor",
    nationalProductionConsumed: "da produção nacional é consumida pela indústria pneumática",
    saoPauloConcentrates: "concentra ~70% da produção nacional de coágulo",
    domesticConsumptionImported: "do consumo interno é suprido por importação",
    sourceLabel: "Fonte",
    
    // ========== WHAT IS TBS ==========
    whatIsTbsTitle: "O que é TBS (Teor de Borracha Seca)?",
    tbsExplanation: "é a porcentagem de borracha seca presente no coágulo ou látex.",
    tbsExplanation2: "Em outras palavras: quanto do material que você está vendendo é realmente borracha (e não água ou impurezas).",
    practicalExample: "Exemplo Prático",
    practicalExampleText: "Se você tem 100 kg de coágulo com TBS de 53%:",
    dryRubberValue: "é borracha seca (o que vale)",
    waterMoisture: "é água/umidade",
    whyItMatters: "Por que isso importa?",
    whyItMattersText: "O preço que você recebe é calculado com base no TBS. Quanto maior o TBS, maior o valor do seu produto.",
    standardReference: "Referência padrão",
    howTbsAffectsPayment: "Como o TBS Afeta Seu Pagamento",
    priceAdjustedByTbs: "O preço do coágulo é ajustado proporcionalmente ao TBS, usando 53% como referência:",
    adjustedPrice: "Preço Ajustado",
    basePrice: "Preço Base",
    yourTbs: "Seu TBS",
    factor: "Fator",
    situation: "Situação",
    aboveReference: "Acima da referência",
    standardReferenceLabel: "Referência padrão",
    belowReference: "Abaixo da referência",
    tbsTip: "Quanto mais seco o coágulo antes de vender, maior será seu TBS e melhor seu preço. Evite excesso de umidade!",
    tbsCalculator: "Calculadora de TBS",
    tbsCalculatorDesc: "Calcule o TBS do seu coágulo. Você precisa pesar uma amostra antes e depois de secar.",
    wetWeight: "Peso Úmido (kg)",
    wetWeightHint: "Peso da amostra antes de secar",
    dryWeight: "Peso Seco (kg)",
    dryWeightHint: "Peso após secagem completa",
    calculateTbs: "Calcular TBS",
    clear: "Limpar",
    yourCalculatedTbs: "Seu TBS calculado:",
    aboveOrEqualReference: "Acima ou igual à referência (53%)",
    belowReferenceWarning: "Abaixo da referência (53%)",
    tbsNote: "Esta é uma estimativa. O TBS oficial é determinado em laboratório pela usina/beneficiadora no momento da compra.",
    
    // ========== USER GUIDE ==========
    welcomeToPriceGuide: "Bem-vindo ao Guia de Preços",
    guideIntro: "Este guia vai te ensinar como funciona a formação de preços da borracha natural e como usar a calculadora para negociar melhor.",
    priceFormationChainTitle: "A Cadeia de Formação de Preços",
    priceChainIntro: "O preço que você recebe passa por várias etapas desde a cotação internacional:",
    internationalPriceStep: "Preço Internacional (SGX)",
    sgxQuotationLabel: "Cotação em Singapura",
    conversionImportCostsStep: "Conversão + Custos de Importação",
    exchangeFreightTaxesLabel: "Câmbio + frete + impostos + custos",
    nationalReferencePriceStep: "Preço de Referência Nacional",
    producerFormulaStep: "Fórmula do Produtor",
    yourPriceCoagulumStep: "Seu Preço (Coágulo)",
    valueYouReceiveLabel: "O valor que você recebe",
    priceReferenceGuideTitle: "O Preço de Referência",
    officialReferencesTitle: "Referências Oficiais",
    officialReferencesDesc: "O preço do coágulo é calculado com base em uma referência oficial. Conheça as principais fontes usadas no mercado brasileiro.",
    mainMarketReferencesTitle: "As principais referências do mercado:",
    adoptedByMillsLabel: "ADOTADO PELAS USINAS",
    internalizedPriceLabel: "Preço internalizado (Internacional + Câmbio + Custos)",
    mostUsedReferenceLabel: "Referência mais usada (NB Borracha, São Manoel, Hevea-Tec, etc.)",
    bimonthlyPublicationLabel: "Publicação: Bimestral (Dez/Jan, Fev/Mar...)",
    importParityLabel: "PARIDADE IMPORTAÇÃO",
    totalCostToImportLabel: "Custo TOTAL para importar borracha beneficiada (GEB-10)",
    includesFreightTaxesLabel: "Inclui: preço internacional + câmbio + frete + impostos (~10,8%) + custos",
    monthlyPublicationLabel: "Publicação: Mensal (dias 15-20)",
    spotPriceLabel: "PREÇO SPOT",
    spMarketPracticedLabel: "Preço praticado no mercado paulista",
    monthlyPublicationSimpleLabel: "Publicação: Mensal",
    whyGeb10ReferenceTitle: "Por que o GEB-10 APABOR é a referência do mercado?",
    whyGeb10ReferenceExplanation: "É a referência adotada pelas principais usinas beneficiadoras (NB Borracha, São Manoel, Hevea-Tec, etc.). Permite comparar seu preço diretamente com o que o mercado pratica.",
    drcGuideTitle: "DRC - Teor de Borracha Seca",
    whatIsDrcGuide: "O que é DRC?",
    whatIsDrcExplanation: "É a porcentagem de borracha seca no seu coágulo. Quanto MAIS seco, MAIOR o DRC e MELHOR o preço.",
    howItWorks: "Como funciona:",
    coagulumMuchWaterLabel: "Coágulo com muita água",
    drcLowLabel: "DRC baixo (40-50%)",
    wellDriedCoagulumLabel: "Coágulo bem seco",
    drcHighLabel: "DRC alto (60-70%)",
    mayBeRejectedLabel: "Pode ser rejeitado",
    minimumAcceptedLabel: "Mínimo aceito",
    goodExcellentLabel: "Bom / Ótimo",
    excellentLabel: "Excelente",
    drcTipText: "Cada 1% a mais no DRC pode significar R$ 0,10-0,15/kg a mais no seu bolso!",
    participationRateGuideTitle: "Taxa de Participação",
    whatIsParticipationRate: "O que é a Taxa de Participação?",
    participationRateExplanationGuide: "É o percentual do valor de referência que você recebe. Quanto MAIOR a taxa, MAIS dinheiro no seu bolso.",
    rateBandsTitle: "Faixas de Taxa:",
    veryLowLabel: "Muito baixa",
    cnaMinimumLabel: "Mínimo CNA",
    goodLabel: "Boa",
    ieaReferenceLabel: "Referência IEA",
    excellentRateLabel: "Excelente",
    importantWarningRate: "A taxa de 52% é o MÍNIMO recomendado pela CNA. O IEA usa 80% em seus cálculos oficiais!",
    howToGetBetterRatesTitle: "Como conseguir taxas melhores:",
    deliverLargerVolumeLabel: "Entregar volume maior",
    maintainRegularFrequencyLabel: "Manter frequência regular",
    guaranteeQualityLabel: "Garantir qualidade (DRC alto)",
    longTermContractsLabel: "Fazer contratos de longo prazo",
    negotiateInGroupLabel: "Negociar em grupo/cooperativa",
    completeFormulaGuideTitle: "A Fórmula Completa",
    coagulumPriceFormulaLabel: "Preço Coágulo = Referência × (DRC/100) × (Taxa/100)",
    comparativeWithReferencesTitle: "Comparativo com as 3 referências do mercado (DRC 53%):",
    bimonthlyRefPriceDesc: "Preço de referência bimestral calculado a partir do preço internacional + câmbio + custos de importação.",
    totalCostToImportDesc: "Custo total para importar borracha beneficiada (GEB-10). Inclui frete, impostos e todos os custos.",
    realTransactionPriceDesc: "Preço real praticado nas transações do mercado físico de São Paulo.",
    relationBetweenReferencesTitle: "Relação entre as referências:",
    maxCostIfImportedLabel: "Custo máximo (se a indústria importasse)",
    refForNegotiationLabel: "Referência para negociação entre usinas e produtores",
    realTransactionPriceLabel: "Preço real das transações",
    understandDifferenceTitle: "Entenda a diferença",
    understandDifferenceExplanation: "As usinas adotam o GEB-10 APABOR para negociar com produtores. O Preço Importação IEA serve como referência de \"paridade\" - quanto o coágulo nacional valeria se competisse diretamente com o importado.",
    productionCostGuideTitle: "Custo de Produção",
    priceCoversQuestion: "Seu preço cobre os custos?",
    profitNeedsHigherPriceText: "Para ter lucro, o preço que você recebe precisa ser MAIOR que seu custo de produção.",
    effectiveOperationalCost: "Custo Operacional Efetivo",
    directCostsCOE: "Gastos diretos (COE)",
    totalOperationalCost: "Custo Operacional Total",
    includesProLabore: "Inclui pró-labore (COT)",
    marginAnalysisTitle: "Análise de Margem (GEB-10 APABOR R$ 11,31):",
    scenarioLabel: "Cenário",
    priceLabel: "Preço",
    marginVsCotLabel: "Margem (vs COT)",
    currentMarketLabel: "mercado",
    marketAnalysisText: "Com os preços atuais do mercado (GEB-10 R$ 11,31 e taxa ~72%), o preço do coágulo (R$ 4,30) está abaixo do custo de produção (R$ 6,07). Esta é uma realidade do mercado atual.",
    officialSourcesGuideTitle: "Fontes Oficiais",
    verifiableDataTitle: "Dados verificáveis",
    verifiableDataDesc: "Todos os dados desta calculadora vêm de fontes oficiais que você pode consultar.",
    naturalRubberPortal: "Borracha Natural (Portal Lateks)",
    dailyLabel: "diário",
    mainSourceLabel: "Cotações na página inicial - Fonte principal",
    ieaInstitute: "IEA - Instituto de Economia Agrícola",
    studiesAndAnalyses: "Preço de Importação, estudos e análises",
    searchRubberOnSite: "Buscar por \"borracha natural\" no site",
    technicalBulletinsNews: "Boletins técnicos e notícias do setor",
    someContentForMembers: "Alguns conteúdos para associados",
    dailyCoagulumQuotation: "Cotação do coágulo",
    internationalPriceSgxRealTime: "Preço internacional SGX (tempo real)",
    negotiationTipsGuideTitle: "Dicas para Negociar",
    knowledgeIsPowerTitle: "Conhecimento é poder!",
    knowledgeIsPowerDesc: "Agora que você entende como o preço é formado, use esse conhecimento para negociar melhor.",
    confirmMillReference: "Confirme qual referência a usina usa",
    confirmMillReferenceDesc: "A maioria usa GEB-10 APABOR. Compare com os valores desta calculadora.",
    askCalculationWritten: "Peça o cálculo por escrito",
    askCalculationWrittenDesc: "Exija transparência: GEB-10 × DRC × Taxa = seu preço",
    improveYourDrc: "Melhore seu DRC",
    improveYourDrcDesc: "Evite umidade no coágulo. Cada 1% vale R$ 0,10-0,15/kg",
    negotiateParticipationRate: "Negocie a taxa de participação",
    negotiateParticipationRateDesc: "Mínimo 52%, ideal 70-80%. Volume e qualidade justificam taxas melhores",
    useThisCalculator: "Use esta calculadora",
    useThisCalculatorDesc: "Confira se o preço oferecido bate com a fórmula oficial",
    congratulationsTitle: "Parabéns!",
    congratulationsDesc: "Agora você está pronto para negociar de forma justa e informada!",
    stepOfTotal: "Passo {current} de {total}",
    previousBtn: "Anterior",
    nextBtn: "Próximo",
    startUsingBtn: "Começar a usar!",

    // ========== PHASE 1 - SMALL COMPONENTS ==========
    // AchievementBadge
    noAchievementsYet: "Nenhuma conquista ainda",
    showMore: "mais",
    showLess: "Mostrar menos",

    // CertificationNav
    navHome: "Início",
    navCertification: "Certificação",
    navEvaluation: "Avaliação",
    navDocuments: "Documentos",
    joinProgram: "Aderir ao programa",
    technicalCriteria: "14 critérios técnicos",
    officialDocs: "INCAPER, CATI/SP",

    // FeedbackCard
    yourStrengths: "Seus Pontos Fortes",
    improvementOpportunities: "Oportunidades de Melhoria",
    nextObjective: "Próximo Objetivo",
    recommendedCourses: "Cursos Recomendados",
    potentialGain: "Ganho potencial",
    pointsFromNextLevel: "pontos do próximo nível",
    youAreOnly: "Você está a apenas",
    seal: "Selo",

    // ScoreBreakdown
    outOf100Points: "de 100 pontos",
    privateScore: "Privado",
    tappingTechnique: "Técnica de Sangria",
    harvestPreparation: "Preparação de Safra",
    dailyMaintenance: "Manutenção Diária",
    chemicalApplications: "Aplicações Químicas",
    maintenanceAndCare: "Manutenção e Cuidados",
    productivity: "Produtividade",

    // SealBadge
    sealExpert: "Sangrador Expert",
    sealProfessional: "Sangrador Profissional",
    sealCertified: "Sangrador Certificado",
    sealInDevelopment: "Em Desenvolvimento",
    sealExpired: "Selo Expirado",

    // ========== PHASE 2 - DASHBOARDS ==========
    // SimpleDashboard
    hello: "Olá",
    exit: "Sair",
    welcomeUser: "Bem-vindo",
    manageEmployeesProperties: "Gerencie seus funcionários e propriedades",
    findWorkOpportunities: "Encontre oportunidades de trabalho",
    quickActions: "Ações Rápidas",
    tappingToday: "Sangria Hoje",
    newAd: "Novo Anúncio",
    viewReports: "Ver Relatórios",
    viewPlans: "Ver Planos",
    jobs: "Empregos",
    calendar: "Calendário",
    plans: "Planos",
    mainDashboard: "Dashboard Principal",
    welcomeToHeveaTalent: "Bem-vindo ao HeveaTalent! Use as abas acima para navegar.",
    jobCenter: "Central de Empregos",
    postJobsOrFindWork: "Publique vagas ou encontre trabalho",
    buyAndSellProducts: "Compre e venda produtos",
    manageBleedingActivities: "Gerencie atividades de sangria",
    jobCenterTitle: "Central de Empregos",
    publishJobsFindProfessionals: "Publique vagas e encontre profissionais qualificados",
    findHeveicultureOpportunities: "Encontre oportunidades de trabalho na área de heveicultura",
    featureInDevelopment: "Funcionalidade em desenvolvimento",
    marketplaceBuyAndSell: "Compre e venda produtos relacionados à heveicultura",
    bleedingCalendar: "Calendário de Sangria",
    manageDailyActivities: "Gerencie suas atividades diárias de heveicultura",
    plansAndSubscriptions: "Planos e Assinaturas",
    choosePlanForNeeds: "Escolha o plano ideal para suas necessidades",
    basic: "Básico",
    free: "Grátis",
    publish1Ad: "Publicar 1 anúncio",
    basicCalendar: "Calendário básico",
    featuredAds: "Anúncios destacados",
    popular: "Popular",
    professional: "Profissional",
    unlimitedAds: "Anúncios ilimitados",
    advancedCalendar: "Calendário avançado",
    threeFeaturedAds: "3 anúncios destacados",
    premium: "Premium",
    allFromProfessional: "Tudo do Profissional",
    advancedReports: "Relatórios avançados",
    prioritySupport: "Suporte prioritário",
    perMonth: "/mês",

    // ReportsDashboard
    reportsAndManagement: "Relatórios e Gestão",
    trackTeamPerformance: "Acompanhe o desempenho da sua equipe",
    howToUse: "Como usar",
    reportsViewStats: "Relatórios: Visualize estatísticas e relatórios de produção da sua propriedade.",
    property: "Propriedade",
    month: "Mês",
    year: "Ano",
    update: "Atualizar",
    loading: "Carregando...",
    teamSummary: "Resumo da Equipe",
    anonymousRanking: "Ranking Anônimo",
    history: "Histórico",
    workers: "Trabalhadores",
    totalProduction: "Produção Total",
    withSeal: "Com Selo",
    averageScore: "Score Médio",
    periodDetails: "Detalhes do Período",
    workDays: "Dias de Trabalho",
    dailyAverage: "Média Diária",
    certified: "Certificados",
    productionRanking: "Ranking de Produção",
    anonymousComparisonProtected: "Comparação anônima - nomes reais protegidos",
    daysWorked: "dias trabalhados",
    average: "Média",
    noProductionDataPeriod: "Nenhum dado de produção para este período",
    dataAppearsWhenWorkersRegister: "Os dados aparecem quando trabalhadores registram produção no Calendário de Sangria",
    privacyNotice: "Privacidade:",
    realNamesProtected: "Os nomes reais dos trabalhadores são substituídos por letras (A, B, C...) para proteger sua identidade.",
    productionHistory: "Histórico de Produção",
    lastMonthsAnalyzed: "Últimos {months} meses",
    period: "Período",
    production: "Produção",
    days: "Dias",
    noHistoryAvailable: "Nenhum histórico disponível",
    noPropertiesYet: "Você ainda não tem propriedades cadastradas",
    registerPropertyToSeeReports: "Cadastre uma propriedade no Calendário de Sangria para ver relatórios",
    january: "Janeiro",
    february: "Fevereiro",
    march: "Março",
    april: "Abril",
    may: "Maio",
    june: "Junho",
    july: "Julho",
    august: "Agosto",
    september: "Setembro",
    october: "Outubro",
    november: "Novembro",
    december: "Dezembro",

    // ========== PHASE 3 - PRICE FORMATION ==========
    // Section 1 - Transparency Warning
    pf_transparencyTitle: "Transparência sobre o Sistema Atual",
    pf_transparencyText: "Existe discussão no setor sobre as metodologias de cálculo de preço. Apresentamos aqui como funciona o sistema, incluindo suas limitações reconhecidas por entidades oficiais como CNA e FAESP.",
    
    // Section 2 - How Price is Formed
    pf_howPriceFormedTitle: "Como é Formado o Preço da Borracha",
    pf_howPriceFormedIntro: "O preço pago ao produtor brasileiro pelo coágulo é derivado do preço internacional da borracha, ajustado por diversos fatores. Veja o fluxo:",
    pf_step1Title: "Preço Internacional (Singapura)",
    pf_step1Desc: "Cotação da bolsa de Singapura - referência mundial",
    pf_step2Title: "Conversão + Custos de Importação",
    pf_step2Desc: "Câmbio (dólar) + frete + seguro + impostos + desembaraço",
    pf_step3Title: "Preço de Referência GEB-10",
    pf_step3Desc: "Valor da borracha beneficiada no mercado interno",
    pf_step4Title: "Ajuste pelo TBS e Taxa de Participação",
    pf_step4Desc: "Preço GEB-10 × TBS × Taxa de Participação (~52%)",
    pf_negotiation: "Negociação",
    pf_finalPriceTitle: "Preço ao Produtor (Coágulo)",
    pf_finalPriceDesc: "Valor final pago pela usina ao heveicultor",
    
    // Section 3 - Participation Rate
    pf_participationRateTitle: "O que é a Taxa de Participação?",
    pf_participationRateIntro: "A Taxa de Participação é a relação entre o preço pago ao produtor e o preço de referência internacional. Segundo estudos da CNA/FAESP:",
    pf_minRecommendedRate: "Taxa de Participação Mínima Recomendada",
    pf_rateRelation: "Relação entre preço produtor e preço de Singapura",
    pf_factorsTitle: "Fatores que influenciam a taxa:",
    pf_factorVolume: "Maior quantidade pode garantir melhor negociação",
    pf_factorFrequency: "Entregas regulares podem ter melhores condições",
    pf_factorQuality: "Maior TBS = melhor preço",
    pf_factorDistance: "Proximidade da usina pode reduzir custos",
    pf_volume: "Volume",
    pf_frequency: "Frequência",
    pf_qualityTbs: "Qualidade/TBS",
    pf_distance: "Distância",
    
    // Section 4 - The Problem
    pf_problemTitle: "O Problema Reconhecido",
    pf_problemSource: "Segundo estudo oficial da CNA/FAESP:",
    pf_problemQuote: "A insegurança dos produtores de borracha em relação ao mecanismo de formação dos preços internos deve ser superada [...] somente se dá com a adoção e divulgação de metodologias reconhecidas por instituições independentes.",
    pf_problemsIdentified: "Problemas Identificados:",
    pf_problem1: "Falta de transparência na metodologia",
    pf_problem2: "Ausência de contratos formais",
    pf_problem3: "Preços frequentemente abaixo do custo",
    pf_problem4: "Produtor sem poder de negociação",
    pf_problem5: "Discussão sobre itens do valor aduaneiro",
    pf_initiativesTitle: "Iniciativas em Andamento:",
    pf_initiative1: "Índice IEA/CNA (metodologia alternativa)",
    pf_initiative2: "Câmara Setorial da Borracha",
    pf_initiative3: "Estudos para políticas públicas",
    pf_initiative4: "Proposta de elevação de alíquota",
    
    // Section 5 - Price vs Cost
    pf_priceVsCostTitle: "Preço vs Custo de Produção",
    pf_priceVsCostIntro: "Dados históricos mostram que, na maioria dos anos, o preço pago ao produtor não cobre o custo de produção:",
    pf_tablePeriod: "Período",
    pf_tableProducerPrice: "Preço Produtor",
    pf_tableProductionCost: "Custo Produção",
    pf_tableSituation: "Situação",
    pf_loss: "Prejuízo",
    pf_margin: "Margem",
    pf_sourceNote: "Os valores são médias e podem variar por região e condições específicas de cada propriedade.",
    
    // Section 6 - How to Protect
    pf_protectTitle: "Como se Proteger",
    pf_beforeSellingTitle: "Antes de Vender:",
    pf_beforeSelling1: "Consulte as cotações do IEA e APABOR",
    pf_beforeSelling2: "Calcule seu TBS real",
    pf_beforeSelling3: "Compare preços entre usinas",
    pf_beforeSelling4: "Conheça seu custo de produção",
    pf_negotiationTitle: "Negociação:",
    pf_negotiation1: "Peça clareza na metodologia de cálculo",
    pf_negotiation2: "Questione a taxa de participação aplicada",
    pf_negotiation3: "Considere associar-se a cooperativas",
    pf_negotiation4: "Documente todas as transações",

    // ========== USER GUIDE STEPS ==========
    // Step 1 - Welcome
    ug_step1_title: "Bem-vindo ao Guia de Preços",
    ug_step1_intro: "Este guia vai te ensinar como funciona a formação de preços da borracha natural e como usar a calculadora para negociar melhor.",
    ug_step1_tripod1: "Dados de fontes oficiais (IEA, CNA, APABOR)",
    ug_step1_tripod2: "Seus dados não são compartilhados",
    ug_step1_tripod3: "Fácil de entender e usar",
    
    // Step 2 - Price Chain
    ug_step2_title: "A Cadeia de Formação de Preços",
    ug_step2_intro: "O preço que você recebe passa por várias etapas desde a cotação internacional:",
    ug_step2_1_title: "1. Preço Internacional (SGX)",
    ug_step2_1_desc: "Cotação em Singapura",
    ug_step2_2_title: "2. Conversão + Custos de Importação",
    ug_step2_2_desc: "Câmbio PTAX + frete + impostos (10,8%) + custos",
    ug_step2_3_title: "3. Preço de Referência Nacional",
    ug_step2_3_desc: "GEB-10 APABOR e Preço Importação IEA",
    ug_step2_4_title: "4. Fórmula do Produtor",
    ug_step2_4_desc: "Referência × DRC × Taxa de Participação",
    ug_step2_5_title: "5. Seu Preço (Coágulo)",
    ug_step2_5_desc: "O valor que você recebe pelo coágulo",
    
    // Step 3 - Reference Price
    ug_step3_title: "O Preço de Referência",
    ug_step3_tripod: "O preço do coágulo é calculado com base em uma referência oficial. Conheça as principais fontes usadas no mercado brasileiro.",
    ug_step3_mainRefs: "As principais referências do mercado:",
    ug_step3_adoptedByMills: "ADOTADO PELAS USINAS",
    ug_step3_geb10Desc: "Preço internalizado (Internacional + Câmbio + Custos)",
    ug_step3_geb10Note: "Referência mais usada (NB Borracha, São Manoel, Hevea-Tec, etc.)",
    ug_step3_bimonthly: "Publicação: Bimestral (Dez/Jan, Fev/Mar...)",
    ug_step3_importParity: "PARIDADE IMPORTAÇÃO",
    ug_step3_ieaDesc: "Custo TOTAL para importar borracha beneficiada (GEB-10)",
    ug_step3_ieaIncl: "Inclui: preço internacional + câmbio + frete + impostos (~10,8%) + custos",
    ug_step3_monthly: "Publicação: Mensal (dias 15-20)",
    ug_step3_spotPrice: "PREÇO SPOT",
    ug_step3_spDesc: "Preço praticado no mercado paulista",
    ug_step3_monthlySimple: "Publicação: Mensal",
    ug_step3_whyGeb10: "Por que o GEB-10 APABOR é a referência do mercado?",
    ug_step3_whyGeb10Desc: "É a referência adotada pelas principais usinas beneficiadoras (NB Borracha, São Manoel, Hevea-Tec, etc.). Permite comparar seu preço diretamente com o que o mercado pratica.",
    
    // Step 4 - DRC
    ug_step4_title: "DRC - Teor de Borracha Seca",
    ug_step4_tripod: "É a porcentagem de borracha seca no seu coágulo. Quanto MAIS seco, MAIOR o DRC e MELHOR o preço.",
    ug_step4_howWorks: "Como funciona:",
    ug_step4_muchWater: "Coágulo com muita água",
    ug_step4_lowDrc: "DRC baixo (40-50%)",
    ug_step4_wellDried: "Coágulo bem seco",
    ug_step4_highDrc: "DRC alto (60-70%)",
    ug_step4_mayReject: "Pode ser rejeitado",
    ug_step4_minAccepted: "Mínimo aceito",
    ug_step4_goodExcellent: "Bom / Ótimo",
    ug_step4_excellent: "Excelente",
    ug_step4_tip: "Cada 1% a mais no DRC pode significar R$ 0,10-0,15/kg a mais no seu bolso!",
    
    // Step 5 - Participation Rate
    ug_step5_title: "Taxa de Participação",
    ug_step5_tripod: "É o percentual do valor de referência que você recebe. Quanto MAIOR a taxa, MAIS dinheiro no seu bolso.",
    ug_step5_ranges: "Faixas de Taxa:",
    ug_step5_veryLow: "Muito baixa",
    ug_step5_minCna: "Mínimo CNA",
    ug_step5_good: "Boa",
    ug_step5_ieaRef: "Referência IEA",
    ug_step5_excellentRate: "Excelente",
    ug_step5_important: "A taxa de 52% é o MÍNIMO recomendado pela CNA. O IEA usa 80% em seus cálculos oficiais!",
    ug_step5_howToGet: "Como conseguir taxas melhores:",
    ug_step5_tip1: "Entregar volume maior",
    ug_step5_tip2: "Manter frequência regular",
    ug_step5_tip3: "Garantir qualidade (DRC alto)",
    ug_step5_tip4: "Fazer contratos de longo prazo",
    ug_step5_tip5: "Negociar em grupo/cooperativa",
    
    // Step 6 - Complete Formula
    ug_step6_title: "A Fórmula Completa",
    ug_step6_formula: "Preço Coágulo = Referência × (DRC/100) × (Taxa/100)",
    ug_step6_compare: "Comparativo com as 3 referências do mercado (DRC 53%):",
    ug_step6_geb10Ref: "Preço de referência bimestral calculado a partir do preço internacional + câmbio + custos de importação.",
    ug_step6_ieaRef: "Custo total para importar borracha beneficiada (GEB-10). Inclui frete, impostos e todos os custos.",
    ug_step6_spRef: "Preço real praticado nas transações do mercado físico de São Paulo.",
    ug_step6_relation: "Relação entre as referências:",
    ug_step6_maxCost: "Custo máximo (se a indústria importasse)",
    ug_step6_refNegotiation: "Referência para negociação entre usinas e produtores",
    ug_step6_realPrice: "Preço real das transações",
    ug_step6_understand: "As usinas adotam o GEB-10 APABOR para negociar com produtores. O Preço Importação IEA serve como referência de \"paridade\" - quanto o coágulo nacional valeria se competisse diretamente com o importado.",
    
    // Step 7 - Production Cost
    ug_step7_title: "Custo de Produção",
    ug_step7_tripod: "Para ter lucro, o preço que você recebe precisa ser MAIOR que seu custo de produção.",
    ug_step7_coe: "Custo Operacional Efetivo",
    ug_step7_coeDesc: "Gastos diretos (COE)",
    ug_step7_cot: "Custo Operacional Total",
    ug_step7_cotDesc: "Inclui pró-labore (COT)",
    ug_step7_marginAnalysis: "Análise de Margem (GEB-10 APABOR vigente):",
    ug_step7_scenario: "Cenário",
    ug_step7_price: "Preço",
    ug_step7_marginVsCot: "Margem (vs COT)",
    ug_step7_analysis: "Compare o preço do coágulo com o custo de produção (COE/COT). Os valores vigentes estão nas abas 💰 Cotações e 📊 Análise, atualizados diariamente.",
    
    // Step 8 - Official Sources
    ug_step8_title: "Fontes Oficiais",
    ug_step8_tripod: "Todos os dados desta calculadora vêm de fontes oficiais que você pode consultar.",
    ug_step8_lateks: "Borracha Natural (Portal Lateks)",
    ug_step8_lateksDesc: "GEB-10 APABOR, Mercado SP, SMR20, Dólar (diário)",
    ug_step8_lateksNote: "Cotações na página inicial - Fonte principal",
    ug_step8_iea: "IEA - Instituto de Economia Agrícola",
    ug_step8_ieaDesc: "Preço de Importação, estudos e análises (mensal)",
    ug_step8_ieaNote: "Buscar por \"borracha natural\" no site",
    ug_step8_apabor: "APABOR",
    ug_step8_apaborDesc: "Boletins técnicos e notícias do setor",
    ug_step8_apaborNote: "Alguns conteúdos para associados",
    ug_step8_noticias: "Notícias Agrícolas",
    ug_step8_noticiasDesc: "Cotação do coágulo (diária)",
    ug_step8_trading: "Trading Economics",
    ug_step8_tradingDesc: "Preço internacional SGX (tempo real)",
    
    // Step 9 - Negotiation Tips
    ug_step9_title: "Dicas para Negociar",
    ug_step9_tripod: "Agora que você entende como o preço é formado, use esse conhecimento para negociar melhor.",
    ug_step9_tip1_title: "Confirme qual referência a usina usa",
    ug_step9_tip1_desc: "A maioria usa GEB-10 APABOR. Compare com os valores desta calculadora.",
    ug_step9_tip2_title: "Peça o cálculo por escrito",
    ug_step9_tip2_desc: "Exija transparência: GEB-10 × DRC × Taxa = seu preço",
    ug_step9_tip3_title: "Melhore seu DRC",
    ug_step9_tip3_desc: "Evite umidade no coágulo. Cada 1% vale R$ 0,10-0,15/kg",
    ug_step9_tip4_title: "Negocie a taxa de participação",
    ug_step9_tip4_desc: "Mínimo 52%, ideal 70-80%. Volume e qualidade justificam taxas melhores",
    ug_step9_tip5_title: "Use esta calculadora",
    ug_step9_tip5_desc: "Confira se o preço oferecido bate com a fórmula oficial",
    ug_step9_congrats: "Parabéns!",
    ug_step9_ready: "Agora você está pronto para negociar de forma informada, com dados oficiais!",

    // Additional keys for UserGuide
    analysis: "Análise",
    importPrice: "Preço de Importação",
    important: "IMPORTANTE",
    knowledgeIsPower: "Conhecimento é poder!",
    marketSP: "Mercado SP",
    officialReferences: "Referências Oficiais",
    priceVsCost: "Seu preço cobre os custos?",
    tip: "Dica",
    understandDifference: "Entenda a diferença",
    verifiableData: "Dados verificáveis",
    whatIsDrc: "O que é DRC?",
    
    // ========== ONBOARDING ==========
    onboardingTitle: "🎯 Primeiros Passos",
    onboardingCompleteTitle: "Primeiros Passos Completos!",
    onboardingCompleteDesc: "Todas as etapas foram concluídas com sucesso",
    onboardingSubtitle: "Complete estas etapas para aproveitar todos os benefícios",
    onboardingStep1Title: "Cadastre sua Propriedade",
    onboardingStep1Desc: "Configure sua fazenda com nome, localização e área de produção",
    onboardingStep2Title: "Configure o Contexto de Produção",
    onboardingStep2Desc: "Defina clone, sistema de sangria e número de árvores para metas justas",
    onboardingStep3Title: "Registre suas Sangrias",
    onboardingStep3Desc: "Use o Calendário para registrar produção diária e acompanhar evolução",
    onboardingStep4Title: "Aceite os Termos LGPD",
    onboardingStep4Desc: "Configure suas preferências de privacidade e apareça no Balcão de Empregos",
    onboardingStep5Title: "Receba sua Primeira Avaliação",
    onboardingStep5Desc: "Convide um tecnico ou proprietario para avaliar seu trabalho. Selo: 100% tecnico (sem calendario) ou 50% tecnico + 50% contextual",
    progress: "Progresso",
    completed: "concluídos",
    start: "Iniciar",
    configure: "Configurar",
    requiresPrevious: "Requer passo anterior",
    done: "Feito",
    nextTip: "Próximo passo",
    dismissChecklist: "Ocultar checklist",
    
    // Welcome Modal
    welcomeModalTitle: "Bem-vindo ao HeveaTalent!",
    welcomeModalSubtitle: "A plataforma completa para heveicultores",
    welcomeModalText: "Estamos felizes em ter você conosco! Preparamos um guia rápido para você aproveitar todos os benefícios da plataforma.",
    welcomeFeature1Title: "Calendário de Sangria",
    welcomeFeature1Desc: "Registre produção, controle equipe e acompanhe evolução",
    welcomeFeature2Title: "Metas Contextuais",
    welcomeFeature2Desc: "Metas justas baseadas no seu clone, sistema e região",
    welcomeFeature3Title: "Sistema de Selos",
    welcomeFeature3Desc: "Conquiste Bronze, Prata ou Ouro e destaque-se",
    welcomeModalButton: "Começar Agora",
    
    // ========== CONTEXTUAL PERFORMANCE ==========
    contextualPerformance: "Desempenho Contextual",
    howEvaluationWorks: "Como funciona o Sistema de Avaliação",
    technicalEvaluation: "Avaliação Técnica",
    configureContext: "Configure o Contexto",
    registerInCalendar: "Registre no Calendário",
    automaticSeal: "Selo Automático",
    sealLevels: "Níveis de Selo",
    yourCurrentSeal: "Seu Selo Atual",
    noSealYet: "Nenhum selo conquistado ainda",
    officialGoalTable: "Tabela de Metas Oficial",
    cloneType: "Tipo de Clone",
    tappingSystems: "Sistemas de Sangria",
    productivityByClone: "Produtividade por Clone",
    totalInProduction: "Total em Produção",
    contextDefinesFairGoal: "O contexto define sua meta justa",
    automatically: "automaticamente",
    targetLine: "Linha da Meta",
    normal: "Normal",
    stop: "Parada",
    year: "Ano",
    month: "Mês",
    cuts: "Cortes",
    totalKg: "kg Total",
    clone: "Clone",
    property: "Propriedade",
    tappingSystem: "Sistema de Sangria",
    technicianWeight3x: "Técnico certificado (peso 3x) ou proprietário (peso 1x) na média",
    groupAScore: "Grupo A - Técnica de Corte",
    groupB1Score: "Grupo B1 - Preparo",
    groupB2Score: "Grupo B2 - Manutenção",
    groupCScore: "Grupo C - Tratamentos",
    bronze70: "🥉 Bronze 60-74 pts",
    silver85: "🥈 Prata 75-89 pts",
    gold100: "🥇 Ouro 90-100 pts",
    
    // ========== PRODUCTION CONTEXT WIZARD ==========
    wizardTitle: "Configurar Contexto de Produção",
    wizardStepOf: "Passo {current} de {total}",
    wizardAllConfigured: "Tudo Configurado!",
    wizardAllConfiguredDesc: "Todas as suas propriedades já têm contexto de produção configurado.",
    wizardClose: "Fechar",
    
    // Wizard Steps
    wizardStepProperty: "Propriedade",
    wizardStepPropertyDesc: "Selecione a propriedade",
    wizardStepClone: "Clone",
    wizardStepCloneDesc: "Tipo de seringueira",
    wizardStepSystem: "Sistema",
    wizardStepSystemDesc: "Frequência de sangria",
    wizardStepTrees: "Árvores",
    wizardStepTreesDesc: "Quantidade e idade",
    wizardStepExtras: "Detalhes",
    wizardStepExtrasDesc: "Região e estimulação",
    wizardStepConfirm: "Confirmar",
    wizardStepConfirmDesc: "Revisar e salvar",
    
    // Property Step
    wizardSelectProperty: "Selecione a Propriedade",
    wizardSelectPropertyDesc: "Escolha a propriedade para configurar o contexto de produção",
    wizardNoPropertiesAvailable: "Nenhuma propriedade disponível para configurar.",
    wizardNoPropertiesHint: "Todas já têm contexto ou você precisa cadastrar uma propriedade primeiro.",
    
    // Clone Step
    wizardWhichClone: "Qual o Clone das Seringueiras?",
    wizardCloneExplain: "O clone determina a produtividade esperada (g/árvore/corte)",
    wizardCloneTip: "Se você não sabe o clone, o RRIM 600 é o mais comum no Brasil e uma boa escolha padrão.",
    wizardGramsPerCut: "g/corte",
    wizardPopular: "Popular",
    
    // System Step
    wizardTappingSystem: "Sistema de Sangria",
    wizardTappingFrequency: "Qual a frequência de sangria utilizada?",
    wizardSystemTip: "D/4 significa sangria a cada 4 dias (4 lotes). Sistemas com mais dias entre sangrias preservam a árvore, mas reduzem a produção total.",
    wizardCutsPerMonth: "cortes/mês",
    
    // Trees Step
    wizardTreesData: "Dados das Árvores",
    wizardTreesDataDesc: "Informe a quantidade e idade do seringal",
    wizardTreesInProduction: "Total de Árvores em Produção",
    wizardTreesInProductionHint: "Quantas árvores estão sendo sangradas atualmente?",
    wizardTreesPerHectare: "Árvores por Hectare",
    wizardTreesDefault: "Padrão: 450",
    wizardSeringalAge: "Idade do Seringal (anos)",
    wizardSeringalAgeHint: "Anos de exploração",
    wizardEstimatedArea: "Área estimada:",
    wizardHectares: "hectares",
    
    // Extras Step
    wizardAdditionalDetails: "Detalhes Adicionais",
    wizardAdditionalDetailsDesc: "Região e uso de estimulação química",
    wizardRegion: "Região",
    wizardRegionExplain: "A região afeta os coeficientes sazonais de produção",
    wizardRegionSP: "São Paulo (Noroeste Paulista)",
    wizardRegionSPDesc: "MAIO é pico (inverno frio)",
    wizardRegionES: "Espírito Santo / Bahia",
    wizardRegionESDesc: "Verão é alta produção",
    wizardRegionMT: "Centro-Oeste (MT/GO/MS)",
    wizardRegionMTDesc: "Seca favorece produção",
    wizardStimulation: "Usa Estimulação (Ethephon)?",
    wizardStimulationHint: "Pode aumentar produção em até 28%",
    wizardStimulationConcentration: "Concentração do Ethephon (%)",
    wizardStimulationLow: "2.5% (Baixo risco, +15-20%)",
    wizardStimulationMedium: "3.3% (Moderado, +20-25%)",
    wizardStimulationHigh: "5.0% (Alto risco, +25-28%)",
    
    // Confirm Step
    wizardConfirmData: "Confirme os Dados",
    wizardConfirmDataDesc: "Revise as informações antes de salvar",
    wizardWhatHappensNext: "O que acontece agora?",
    wizardWhatHappensNextDesc: "Com o contexto configurado, o sistema calculará suas metas justas baseadas nestes dados. Você poderá acompanhar seu desempenho no Dashboard de Desempenho Contextual.",
    wizardYes: "Sim",
    wizardNo: "Não",
    
    // Wizard Navigation
    wizardCancel: "Cancelar",
    wizardBack: "Voltar",
    wizardNext: "Próximo",
    wizardSave: "Salvar Contexto",
    wizardSaving: "Salvando...",
    wizardUseGuided: "Usar Assistente Guiado",
    wizardErrorSaving: "Erro ao salvar contexto",

    // ========== PROPÓSITO PAGE ==========
    purposeLabel: "Nosso Propósito",
    purposeTitle: "Conectando parceiros, produtores e toda a cadeia da heveicultura",
    purposeSubtitle: "A HeveaTalent nasceu da necessidade de valorizar o profissional da heveicultura e criar conexões que fortalecem todo o setor.",
    purposeStatCriteria: "Critérios técnicos de avaliação",
    purposeStatSeals: "Níveis de selo profissional",
    purposeStatOfficial: "Baseado em literatura oficial",
    purposeStatAll: "Toda",
    purposeStatChain: "A cadeia conectada",
    purposeMission: "Missão",
    purposeMissionText: "Conectar parceiros, produtores e toda a cadeia da heveicultura, valorizando o profissional e fortalecendo o setor com tecnologia acessível e certificação técnica baseada em literatura oficial.",
    purposeVision: "Visão",
    purposeVisionText: "Ser a plataforma de referência para o desenvolvimento profissional na heveicultura brasileira, onde cada sangrador tem seu trabalho reconhecido e valorizado.",
    purposeValuesLabel: "Nossos Valores",
    purposeValuesTitle: "Tripé HeveaTalent",
    purposeValuesSubtitle: "Três pilares que orientam cada decisão e funcionalidade da plataforma.",
    purposeJustice: "Justiça",
    purposeJusticeDesc: "Acreditamos que todo profissional merece reconhecimento justo pelo seu trabalho. A certificação HeveaTalent é baseada em critérios técnicos oficiais, garantindo imparcialidade e meritocracia.",
    purposeJustice1: "Certificação técnica baseada em INCAPER e CATI/SP",
    purposeJustice2: "Selos de qualidade (Bronze, Prata, Ouro)",
    purposeJustice3: "Oportunidades iguais para todos os profissionais",
    purposeSecurity: "Segurança",
    purposeSecurityDesc: "Protegemos os dados e as relações profissionais de todos os usuários. Transparência e confiança são a base de cada interação na plataforma.",
    purposeSecurity1: "Dados protegidos em conformidade com a LGPD",
    purposeSecurity2: "Transparência nas relações profissionais",
    purposeSecurity3: "Confiança mútua entre produtor e sangrador",
    purposeSimplicity: "Simplicidade",
    purposeSimplicityDesc: "A tecnologia deve facilitar a vida, não complicar. Cada funcionalidade é pensada para ser intuitiva e acessível, mesmo para quem tem pouca experiência digital.",
    purposeSimplicity1: "Interface acessível para uso no campo",
    purposeSimplicity2: "Informação clara e direta",
    purposeSimplicity3: "Fluxos simples que economizam tempo",
    purposeDiffLabel: "O que nos diferencia",
    purposeDiffTitle: "Diferenciais HeveaTalent",
    purposeDiffCert: "Certificação Profissional",
    purposeDiffCertDesc: "Selos Bronze, Prata e Ouro baseados em 14 critérios técnicos oficiais",
    purposeDiffMarket: "Marketplace",
    purposeDiffMarketDesc: "Compre e venda insumos e equipamentos para heveicultura",
    purposeDiffJobs: "Central de Empregos",
    purposeDiffJobsDesc: "Vagas e ofertas de serviço conectando produtores e sangradores",
    purposeDiffComm: "Comunidade",
    purposeDiffCommDesc: "Troque experiências e dicas com profissionais de todo o Brasil",
    purposeDiffQuotes: "Cotações em Tempo Real",
    purposeDiffQuotesDesc: "Acompanhe preços da borracha e câmbio USD/BRL atualizados",
    purposeDiffRec: "Recomendações",
    purposeDiffRecDesc: "Construa sua reputação com recomendações de empregadores",
    purposeQuote: "Valorizamos cada profissional da heveicultura, do corte à comercialização, construindo pontes que fortalecem toda a cadeia.",
    purposeCTA: "Comece agora — é grátis",
    purposeFooter: "HeveaTalent - Heveicultura Profissional",
    purposeFooterSub: "Baseado no Tripé: Justiça, Segurança e Simplicidade",

    // ========== CONTACT FORM & INSTITUTIONAL FOOTER ==========
    contactTitle: "Fale Conosco",
    contactSubtitle: "Envie sua dúvida, sugestão ou proposta de parceria.",
    contactName: "Nome",
    contactEmail: "E-mail",
    contactSubject: "Assunto",
    contactMessage: "Mensagem",
    contactSend: "Enviar Mensagem",
    contactSuccessTitle: "Mensagem Enviada!",
    contactSuccessMsg: "Retornaremos em breve pelo e-mail informado.",
    contactError: "Erro ao enviar. Tente novamente.",
    sending: "Enviando...",
    footerAbout: "Plataforma de gestão de desempenho e conexão para profissionais e proprietários na heveicultura.",
    footerLinks: "Links",
    footerHome: "Início",
    footerPurpose: "Propósito",
    footerContact: "Contato",
    footerLegal: "Legal",
    footerRights: "Todos os direitos reservados.",
    termsTitle: "Termos de Uso",
    privacyTitle: "Política de Privacidade",
    lastUpdated: "Última atualização",

    // ========== FEATURE GATING ==========
    gateTitle: "Recurso Premium",
    gateCurrentPlan: "Seu plano atual",
    gateUpgradeMsg: "Faça upgrade do seu plano para desbloquear este recurso.",
    gateUpgradeBtn: "Ver Planos e Fazer Upgrade",
    gateCalendar: "Calendário de sangria disponível no plano Plus.",
    gateReports: "Relatórios disponíveis a partir do plano Básico.",
    gateTeam: "Gestão de equipe disponível a partir do plano Básico.",
    gateEvaluations: "Dar avaliações disponível a partir do plano Básico.",
    gateLimitReached: "Limite atingido",
    gateLimitMsg: "Você atingiu o limite do seu plano.",
    gateTrialExpired: "Período de Teste Expirado",
    gateTrialExpiredMsg: "Seu período de teste terminou. Assine um plano para continuar usando este recurso.",
    trialDaysLeft: "Período de teste",
    day: "dia",
    days: "dias",

    // ========== MENSAGENS DE CONTATO ==========
    msgTitle: "Mensagens",
    msgNew: "Nova",
    msgRead: "Lida",
    msgResponded: "Respondida",
    msgEmpty: "Nenhuma mensagem recebida ainda.",
    msgMarkResponded: "Marcar como Respondida",
    msgReplyEmail: "Responder por Email",
    msgDelete: "Excluir",
    msgDeleteConfirm: "Tem certeza que deseja excluir esta mensagem?",

    // ========== ADMIN STATS ==========
    statsTitle: "Estatísticas",
    statsTotal: "Total de Usuários",
    statsActive: "Usuários Ativos",
    statsSubscriptions: "Assinaturas Ativas",
    statsMessages: "Mensagens",
    statsLast30d: "últimos 30 dias",
    statsLast7d: "últimos 7 dias",
    statsTrial: "em teste",
    statsUnread: "não lidas",
    statsUsersByType: "Usuários por Tipo",
    statsGrowth: "Crescimento",
    statsNew7d: "Novos (7 dias)",
    statsNew30d: "Novos (30 dias)",
    statsActive7d: "Ativos (7 dias)",
    statsRecentUsers: "Últimos Cadastros",
    statsNoUsers: "Nenhum usuário cadastrado ainda.",
    usersTitle: "Usuários",
    searchUsers: "Buscar usuário...",
    noSubscription: "Sem assinatura",
    noResults: "Nenhum resultado encontrado",

    // ========== EVALUATION FORM ==========
    evalFormVersion: "Versão",
    evalRoleEngineer: "Engenheiro Agrônomo (peso 3x)",
    evalRoleTechnician: "Técnico Agrícola (peso 3x)",
    evalRoleLeader: "Líder de Equipe (peso 1x)",
    evalRoleOwner: "Proprietário (peso 1x)",
    evalRoleOther: "Outro (peso 1x)",
    evalError: "Erro",
    evalRedirecting: "Redirecionando para o dashboard...",
    evalSelectOption: "Selecione...",
    evalTotalScore: "Pontuação Total",
    evalGroup: "Grupo",

    // ========== CERTIFICATION ==========
    certLoading: "Carregando...",
    certBondType: "Tipo de Vínculo",
    certLGPDTerm: "Termo LGPD",
    certBondQuestion: "Qual é o seu tipo de vínculo?",
    certBondJustice: "Todos os tipos de vínculo têm as mesmas oportunidades no programa de certificação.",
    certLGPDTitle: "Termo de Consentimento LGPD",
    certLGPDSecurity: "Leia atentamente como seus dados serão utilizados.",
    certFooter: "HeveaTalent • Sistema de Certificação",
    certFooterSub: "Baseado no Tripé: Justiça • Segurança • Simplicidade",
    certTitle: "Certificação HeveaTalent",
    certSubtitle: "Participe do programa de certificação e conquiste seu selo de qualidade",
    certVoluntary: "A participação no programa de certificação é opcional. Você pode usar a plataforma normalmente sem aderir.",
    certContinue: "Continuar",
    certBack: "Voltar",
    certAcceptActivate: "Aceitar e Ativar",
    certAcceptTerm: "Li e aceito o termo de consentimento. Entendo que posso revogar a qualquer momento.",
    certDataCollected: "Dados que serão coletados:",
    certPurpose: "Finalidade:",
    certRights: "Seus direitos:",
    certVisible: "O que outras fazendas PODERÃO ver:",
    certVisibleName: "Nome e foto de perfil",
    certVisibleSeal: "Selo de qualidade e nota geral",
    certVisibleExp: "Anos de experiência",
    certVisibleClones: "Clones com que já trabalhou",
    certVisibleTrend: "Tendência de desempenho (Consistente/Em Evolução/Novo)",
    certNeverShared: "O que NUNCA será compartilhado:",
    certNeverHistory: "Histórico detalhado mês a mês",
    certNeverNotes: "Notas individuais por critério técnico",
    certNeverFarms: "Nomes das fazendas anteriores",
    certNeverContact: "Informações de contato (sem sua autorização)",

    // ========== RECOMMENDATIONS ==========
    recExample: "Exemplo",
    recViaInvite: "Via convite",

    // ========== PUBLIC RECOMMEND PAGE ==========
    pubRecLoadingInvite: "Carregando convite...",
    pubRecInvalidTitle: "Convite Inválido",
    pubRecGoHome: "Ir para HeveaTalent",
    pubRecThanks: "Obrigado!",
    pubRecSuccessMsg: "Sua recomendação para",
    pubRecSuccessMsg2: "foi publicada com sucesso.",
    pubRecSuccessVisible: "Ela já está visível no perfil profissional.",
    pubRecKnow: "Conhecer HeveaTalent",
    pubRecPlatform: "Plataforma de Heveicultura Profissional",
    pubRecRequestsRec: "solicita sua recomendação profissional",
    pubRecYourName: "Seu Nome",
    pubRecNamePlaceholder: "Digite seu nome completo",
    pubRecYourRole: "Seu Cargo/Função",
    pubRecSelectRole: "Selecione seu cargo",
    pubRecRoleOwner: "Proprietário",
    pubRecRoleTech: "Técnico Agrícola",
    pubRecRoleManager: "Gerente",
    pubRecRoleEngineer: "Engenheiro Agrônomo",
    pubRecRoleOnly: "Apenas profissionais do setor podem recomendar",
    pubRecFarm: "Fazenda/Empresa",
    pubRecFarmPlaceholder: "Ex: Fazenda São João",
    pubRecPeriod: "Período que trabalharam juntos (opcional)",
    pubRecPeriodPlaceholder: "Ex: 2020 - 2023",
    pubRecYourRec: "Sua Recomendação",
    pubRecPlaceholder: "Descreva as qualidades profissionais e sua experiência trabalhando com esta pessoa...",
    pubRecChars: "caracteres",
    pubRecSending: "Enviando...",
    pubRecSend: "Enviar Recomendação",
    pubRecInfoPrefix: "Sua recomendação será publicada no perfil profissional de",
    pubRecInfoSuffix: "Apenas elogios positivos são permitidos.",
    pubRecErrName: "Por favor, informe seu nome",
    pubRecErrRole: "Por favor, selecione seu cargo/função",
    pubRecErrFarm: "Por favor, informe a fazenda ou empresa",
    pubRecErrMsg: "Por favor, escreva uma recomendação com pelo menos 10 caracteres",
    pubRecErrInvalid: "Convite inválido ou expirado",
    pubRecErrLoad: "Erro ao carregar convite. Tente novamente.",
    pubRecErrSend: "Erro ao enviar recomendação",
    pubRecErrConn: "Erro de conexão. Tente novamente.",

    // ========== NOTIFICATIONS ==========
    notifTitle: "Notificações",
    notifMarkAllRead: "Marcar todas como lidas",
    notifEmpty: "Nenhuma notificação",
    notifNow: "Agora",

    // ========== WORKER DASHBOARD ==========
    wdError: "Erro",
    wdValidUntil: "Válido até",
    wdSealExpired: "Selo Expirado",
    wdCertActive: "Certificação Ativa",
    wdCertPending: "Pendente de Consentimento",
    wdCertJoin: "Participe do Programa de Certificação",
    wdBronze: "Bronze (60-74 pts): Sangrador Certificado",
    wdSilver: "Prata (75-89 pts): Sangrador Profissional",
    wdGold: "Ouro (90-100 pts): Sangrador Expert",
    wdTripod: "Tripé HeveaTalent",

    // ========== WORKERS DATABASE ==========
    wdbTitle: "Banco de Dados Interno - Trabalhadores",
    wdbCurrentMonth: "Mês Atual",
    wdbAllPeriods: "Todos os Períodos",
    wdbSummary: "Resumo do Banco de Dados",
    wdbProperty: "Propriedade",
    wdbTotalRecords: "Total Registros",
    wdbWorkers: "Trabalhadores",
    wdbPeriod: "Período",
    wdbAllPeriodsLabel: "Todos os períodos",
    wdbAverage: "Média",
    wdbImproving: "Melhorando",
    wdbDeclining: "Declínio",
    wdbStable: "Estável",
    wdbDaysWorked: "Dias Trabalhados",
    wdbTotalProd: "Produção Total",
    wdbDailyAvg: "Média Diária",
    wdbEvaluations: "Avaliações",
    wdbNumeric: "numéricas",
    wdbDescriptive: "descritivas",
    wdbNotesObs: "Notas e Observações",
    wdbEvaluation: "Avaliação",
    wdbObservations: "Observações",
    wdbAndMore: "e mais",
    wdbRecords: "registros",
    wdbLastWorks: "Últimos Trabalhos",
    wdbDate: "Data",
    wdbProduction: "Produção",
    wdbActivities: "Atividades",
    wdbNoInternalEval: "Nenhum registro com avaliação interna encontrado",
    wdbMarkInternal: "Marque \"Controle Interno (Privado)\" nos registros diários para criar o banco de dados",
    wdbErrorLoading: "Erro ao carregar banco de dados dos trabalhadores",
    wdbJan: "Janeiro",
    wdbFeb: "Fevereiro",
    wdbMar: "Março",
    wdbApr: "Abril",
    wdbMay: "Maio",
    wdbJun: "Junho",
    wdbJul: "Julho",
    wdbAug: "Agosto",
    wdbSep: "Setembro",
    wdbOct: "Outubro",
    wdbNov: "Novembro",
    wdbDec: "Dezembro",

    // ========== MONTHLY REPORT ==========
    rptPropertyInfo: "Informações da Propriedade",
    rptName: "Nome",
    rptLocation: "Localização",
    rptCultureAge: "Idade da Cultura",
    rptYears: "anos",
    rptExplorationTime: "Tempo de Exploração",
    rptTotalArea: "Área Total",
    rptHectares: "hectares",
    rptMonthYear: "Mês/Ano",
    rptMonthNotInformed: "Mês não informado",
    rptTotalRecords: "Total de Registros",
    rptGeneratedAt: "Gerado em",
    rptGeneralSummary: "Resumo Geral do Mês",
    rptTotalRecordsLabel: "Total Registros",
    rptTotalProduction: "Produção Total",
    rptEvaluatedWorkers: "Trabalhadores Avaliados",
    rptOfMonth: "do mês",
    rptPerRecord: "kg/registro",
    rptNoData: "Sem dados",
    rptWithEval: "Com avaliação",
    rptWithoutEval: "Sem avaliação",
    rptBleedingActivities: "Atividades de Sangria",
    rptDaysPerformed: "Dias Realizados",
    rptLostBleedings: "Sangrias Perdidas",
    rptApprovalRate: "Taxa Aproveitamento",
    rptExcellent: "Excelente!",
    rptAttention: "Atenção",
    rptGreat: "Ótimo!",
    rptCanImprove: "Pode melhorar",
    rptWeatherConditions: "Condições Climáticas",
    rptTotalRain: "Total de Chuva",
    rptPerActiveDay: "mm/dia ativo",
    rptTotalReplacements: "Total Reposições",
    rptNoReplacements: "Sem reposições",
    rptReplacementsDone: "Reposições feitas",
    rptComplementaryAct: "Atividades Complementares",
    rptFungicideApp: "Aplicações Fungicida",
    rptEthrelApp: "Aplicações Ethrel",
    rptApplied: "Aplicado",
    rptNotApplied: "Não aplicado",
    rptWorkerEvals: "Avaliações dos Trabalhadores",
    rptWorker: "Trabalhador",
    rptAverage: "Média",
    rptDays: "Dias",
    rptStatus: "Status",
    rptRecommendation: "Recomendação",
    rptNoWorkerEval: "Nenhuma avaliação de trabalhador registrada neste mês",
    rptActivateInternal: "Ative \"Avaliação Interna\" nos registros diários para gerar relatórios de desempenho",
    rptRecommendations: "Recomendações",
    rptNoRecommendations: "Nenhuma recomendação disponível",
    rptErrorDisplay: "Erro ao exibir mês",
    rptMonthJan: "janeiro",
    rptMonthFeb: "fevereiro",
    rptMonthMar: "março",
    rptMonthApr: "abril",
    rptMonthMay: "maio",
    rptMonthJun: "junho",
    rptMonthJul: "julho",
    rptMonthAug: "agosto",
    rptMonthSep: "setembro",
    rptMonthOct: "outubro",
    rptMonthNov: "novembro",
    rptMonthDec: "dezembro",

    // ========== BLEEDING DAILY TABLE ==========
    bdtTitle: "Tabela Diária de Sangria",
    bdtPropertyLabel: "Propriedade",
    bdtYearsCultivation: "anos de cultivo",
    bdtNoResults: "Nenhum resultado encontrado para",
    bdtDay: "Dia",
    bdtWorkers: "Trabalhadores",
    bdtBleeding: "Sangria",
    bdtReplacement: "Reposição",
    bdtFungicide: "Fungicida",
    bdtEthrel: "Ethrel",
    bdtCollections: "Coletas",
    bdtRainMm: "Chuva (mm)",
    bdtProductionKg: "Produção (kg)",
    bdtActions: "Ações",

    // ========== RECORD FORM ==========
    rfSelectLot: "Selecionar lote...",
    rfCollectionNote: "Marque quando recolher a borracha dos lotes. Pode ser feito mesmo sem sangria no dia (ex: chuva). A pesagem pode ser informada depois.",
    rfAllLotsMarked: "Todos os lotes vêm marcados.",
    rfUncheckNotCollected: "Desmarque",
    rfNotCollectedText: "os que NÃO foram coletados.",
    rfSelectLotOption: "Selecione o lote",
    rfOptionalProductivity: "Opcional - Para controle de produtividade",
    rfOptionalKgPlant: "Opcional - Para cálculo kg/planta",
    rfEvalNote1: "Avalie o desempenho do trabalhador no dia (nota 1 a 10)",
    rfEvalNote2: "Esta avaliação é",
    rfEvalNote2Bold: "privada",
    rfEvalNote2End: "— apenas você vê",
    rfEvalNote3: "Serve para acompanhar a evolução da equipe ao longo do tempo",
    rfEvalNote4: "o selo profissional — o selo é gerado pela Avaliação Técnica (14 critérios)",
    rfEvalNote4Bold: "Não afeta",
    rfPrivacyNote: "Privacidade:",
    rfPrivacyDesc: "Notas visíveis apenas para o empregador",
    rfEvalScale: "Avaliar desempenho de 1 (ruim) a 10 (excelente)",
    rfSelectOption: "Selecionar",
    rfRecordSaved: "Registro salvo com sucesso!",

    // ========== RECOMMENDATIONS SECTION ==========
    recNoRecommendations: "Ainda sem recomendações",
    recIdentifiedRecommender: "Recomendador identificado",
    recVerified: "Verificada",
    recExternal: "Externa",
    recNoRecommendationsYet: "Você ainda não tem recomendações",
    recInviteCreated: "Convite criado!",
    recInviteLink: "Link do convite",
    recHowItWorks: "Como funciona:",
    recAutoPublished: "Sua recomendação será publicada automaticamente",
    recShowsOnProfile: "Aparecerá no perfil público do profissional",
    recNameAsReference: "Seu nome será exibido como referência",
    recOnlyPositive: "Apenas elogios positivos são permitidos",

    // ========== COMMUNITY TIPS ==========
    ctLoadingComments: "Carregando comentários...",
    ctNoComments: "Nenhum comentário ainda.",
    ctBeFirst: "Seja o primeiro a comentar!",
    ctShareKnowledge: "Compartilhe seu conhecimento com a comunidade",
    ctClickAddPhotos: "Clique para adicionar fotos",

    // ========== MARKETPLACE ITEM ==========
    mkiSeller: "Vendedor",
    mkiContact: "Contato",
    mkiDescription: "Descrição",

    // ========== MARKETPLACE DIALOGS ==========
    mkdFullName: "Nome Completo",
    mkdEmail: "Email",
    mkdProduct: "Produto",
    mkdPaymentViaPix: "Pagamento via PIX",
    mkdValue: "Valor",
    mkdStatusLabel: "Status",
    mkdExpiresIn: "Expira em",

    // ========== MONTHLY CHARTS ==========
    mchTotalProduced: "Total Produzido",

    // ========== TEAM REPORT ==========
    trpWorker: "Trabalhador",
    trpAvgScore: "Média",
    trpDaysWorked: "Dias",
    trpStatus: "Status",
    trpRecommendation: "Recomendação",

    // ========== CONTEXTUAL PERFORMANCE ==========
    cpPropertyLabel: "Propriedade",
    cpMonthLabel: "Mês",
    cpYearLabel: "Ano",
    cpYourAvg: "Sua Média",
    cpGoal: "Meta",
    cpGramsPerTreeCut: "g/árvore/corte",
    cpCuts: "Cortes",
    cpAvgPerTreeCut: "Média/Árvore/Corte",
    cpClone: "Clone",
    cpSystem: "Sistema",
    cpStimulation: "Estimulação",
    cpBaseGoal: "Meta Base",
    cpSeasonalCoef: "Coef. Sazonal",
    cpPeriod: "Período",
    cpExcellent: "Excelente (≥110%)",
    cpReachedGoal: "Atingiu Meta (≥100%)",
    cpGood: "Bom (≥85%)",
    cpRegular: "Regular (≥70%)",
    cpGoalLine: "Linha da Meta",
    cpWhyConfigContext: "Por que configurar o contexto?",
    cpAllConfigured: "Todas as suas propriedades já têm contexto configurado!",
    cpCloneType: "Tipo de Clone",
    cpTappingSystem: "Sistema de Sangria",
    cpTreesPerHectare: "Árvores/Hectare",
    cpTotalInProduction: "Total em Produção",
    cpPlantationAge: "Idade do Seringal (anos)",
    cpRegionSP: "São Paulo (Noroeste Paulista)",
    cpRegionES: "Espírito Santo / Bahia",
    cpRegionMT: "Centro-Oeste (MT/GO/MS)",
    cpUsesStimulation: "Usa Estimulação (Ethephon)?",
    cpIncreasesProduction: "Aumenta produção em até 28%",
    cpConcentration: "Concentração (%)",
    cpOfficialGoalsTable: "Tabela de Metas Oficial",
    cpProductivityByClone: "Produtividade por Clone",
    cpConfigureContext: "Configure o Contexto",
    cpConfigContextDesc: "Clone, sistema de sangria, árvores em produção.",
    cpRegisterCalendar: "Registre no Calendário",
    cpRegisterCalendarDesc: "Sangrias, reposições, coletas e produções mensais.",
    cpTechnicalEval: "Avaliação Técnica",
    cpTechnicalEvalDesc: "(mensal): 14 parâmetros avaliados. Técnico certificado (peso 3x) ou proprietário (peso 1x) na média.",
    cpAutoSeal: "Selo Automático",
    cpAutoSealDesc: "50% técnico + 50% contextual (ou 100% técnico sem calendário).",
    cpTechnicalEval14: "Avaliação Técnica (14 itens):",

    // ========== TEAM REPORT ==========
    trpPlants: "Plantas",
    trpDeliveries: "Entregas",
    trpWorkersLabel: "Trabalhadores",
    trpTotalProd: "Produção Total",
    trpTotalPlants: "Total Plantas",
    trpCollections: "Coletas",
    trpCollectionsWithProd: "Entregas com produção registrada",
    trpAccumulated: "Acumulado",
    trpPlants2: "plantas",
    trpLot: "Lote",
    trpCollectionDate: "Data Coleta",
    trpPreviousCollection: "Coleta Anterior",
    trpMonthTotalCuts: "Total de Cortes (Mês)",
    trpTotalThisDelivery: "Total desta entrega",

    // ========== PROFESSIONALS SEARCH ==========
    psSearchTitle: "Buscar Profissionais",
    psSearchPlaceholder: "Buscar por nome ou especialização...",
    psFilterAll: "Todos",
    psFilterSangrador: "Sangrador",
    psFilterGerente: "Gerente",
    psFilterFiscal: "Fiscal",
    psFilterAgronomo: "Agrônomo",
    psNoResults: "Nenhum profissional encontrado",
    psExperience: "Experiência",
    psLocation: "Localização",
    psSpecialization: "Especialização",
    psSealLabel: "Selo",
    psContact: "Contatar",
    psRecommend: "Recomendar",
    psViewProfile: "Ver Perfil",

    // ========== CALENDAR GUIDE MODAL ==========
    cgOverview: "Visão Geral",
    cgDailyRecords: "Registros Diários",
    cgHarvestSummary: "Resumo de Safra",
    cgEthrelControl: "Controle de Ethrel",
    cgTeamManagement: "Gestão de Equipe",
    cgReports: "Relatórios",
    cgTips: "Dicas",
    cgWhatIsCalendar: "O que é o Calendário de Sangria?",
    cgCalendarDesc: "O Calendário de Sangria é uma ferramenta completa para gerenciar todas as atividades da sua propriedade de heveicultura. Registre sangrias, produções, aplicações de produtos e acompanhe o desempenho da sua equipe.",
    cgMainFeatures: "Principais Funcionalidades:",
    cgFeature1: "Registro diário de sangrias e produção",
    cgFeature2: "Controle de aplicações (Fungicida, Ethrel)",
    cgFeature3: "Gestão de equipe e produtividade",
    cgFeature4: "Relatórios mensais e anuais automatizados",
    cgFeature5: "Avaliação interna de trabalhadores",
    cgFeature6: "Coleta e pesagem por lote",
    cgHowToStart: "Como Começar:",
    cgStep1: "Selecione sua propriedade no seletor",
    cgStep2: "Escolha o mês que deseja registrar",
    cgStep3: "Clique no dia para abrir o formulário",
    cgStep4: "Preencha as informações do dia",

    // ========== PROPERTY FORM ==========
    pfPropertyName: "Nome da Propriedade",
    pfLocation: "Localização",
    pfCultureAge: "Idade da Cultura (anos)",
    pfExplorationTime: "Tempo de Exploração (anos)",
    pfTotalArea: "Área Total (hectares)",
    pfSave: "Salvar Propriedade",

    // ========== ETHREL ALERT ==========
    eaEthrelAlert: "Alerta de Ethrel",
    eaDaysRemaining: "dias restantes",
    eaApplied: "Aplicação registrada",
    eaNextApplication: "Próxima aplicação",
    eaConfigure: "Configurar alertas",
    eaLastApplication: "Última aplicação",

    // ========== YEARLY SUMMARY ==========
    ysYearlySummary: "Resumo Anual",
    ysTotalProduction: "Produção Total",
    ysTotalBleedings: "Total Sangrias",
    ysAvgProduction: "Média Produção",
    ysBestMonth: "Melhor Mês",
    ysWorstMonth: "Pior Mês",

    // CalendarGuide feature boxes
    cgProperties: "Propriedades",
    cgPropertiesDesc: "Cadastre múltiplas propriedades com informações de área, idade da cultura e localização.",
    cgVisualCalendar: "Calendário Visual",
    cgVisualCalendarDesc: "Visualize suas atividades em um calendário mensal intuitivo com códigos de cores.",
    cgAutoSummaries: "Resumos Automáticos",
    cgAutoSummariesDesc: "Totais mensais e anuais calculados automaticamente com comparativos.",
    cgTeamMgmt: "Gestão de Equipe",
    cgTeamMgmtDesc: "Acompanhe a produtividade individual de cada seringueiro da sua equipe.",
    cgFirstSteps: "Primeiros Passos:",
    cgFirstStep1: "Crie uma propriedade clicando em \"Nova Propriedade\"",
    cgFirstStep2: "Selecione a propriedade e o mês/ano desejado",
    cgFirstStep3: "Clique em um dia do calendário para adicionar registros",
    cgFirstStep4: "Acompanhe os resumos e relatórios gerados automaticamente",

    // Additional calendar/table labels
    bdtCalendar: "Calendário",
    bdtTable: "Tabela",
    bdtSearchPlaceholder: "Pesquisar por trabalhador ou dia...",
    bdtCollapseAll: "Recolher Todos",
    bdtExpandAll: "Expandir Todos",
    bdtWorkerSingular: "trabalhador",
    bdtWorkerPlural: "trabalhadores",
    bdtShowing: "Mostrando",
    bdtResults: "resultado(s)",

    // App.js calendar guide / legend
    appHowToUse: "Como usar o Calendário de Sangria:",
    appPropertySelected: "Propriedade selecionada",
    appChooseMonth: "Escolher mês/ano acima",
    appClickDayToAdd: "Clicar no dia para adicionar",
    appUseTableToEdit: "Use \"Tabela\" para editar/excluir",
    appLegend: "Legenda:",
    appBleeding: "Sangria",
    appReplacement: "Reposição",
    appFungicide: "Fungicida",
    appRain: "Chuva",
    appProduction: "Produção",
    appDaysWithoutRecord: "dias sem registro este mês",
    appYouHave: "Você tem",

    // YearlySummaryCard
    ysCompare: "Comparar",
    ysExpand: "Expandir",
    ysCollapse: "Recolher",
    ysPreviousHarvest: "Safra anterior",
    ysEthrelApps: "aplicações",
    ysFungicideLabel: "Fungicida",
    ysLosses: "Perdas",
    ysRecords: "Registros",
    ysHarvestPeriod: "Período da safra configurado",
    ysTo: "a",
    ysPlants: "plantas",

    // EthrelAlertBanner
    eaConfigureInterval: "Configure o intervalo entre aplicações e quando deseja receber alertas.",
    eaIntervalDays: "Intervalo entre aplicações (dias)",
    eaViewHistory: "Ver histórico de aplicações",

    // Misc calendar
    calendarGuideTitle: "Guia do Calendário",
    configSafraBtn: "Configurar Safra",
    configSafraTooltip: "Configurar plantas por sangrador, modo de sangria e turnover de equipe por safra",
    tappers: "Seringueiros",
    limitReached: "Limite atingido",
    of: "de",

    // ========== CALENDAR GUIDE MODAL - Full content ==========
    cgModalTitle: "Guia do Calendário de Sangria",
    cgFooterText: "HeveaTalent • Calendário de Sangria",
    cgClose: "Fechar",
    // Records section
    cgRecHowToRegister: "Como Registrar Atividades",
    cgRecClickAnyDay: "Clique em qualquer dia do calendário ou use a tabela para adicionar registros.",
    cgRecAvailableFields: "Campos Disponíveis:",
    cgRecBleeding: "Sangria",
    cgRecBleedingDesc: "Marque se houve sangria neste dia. Acompanhe quantos dias de sangria por mês.",
    cgRecProduction: "Produção (kg)",
    cgRecProductionDesc: "Registre a quantidade de látex/coágulo produzido em quilogramas.",
    cgRecRain: "Chuva (mm)",
    cgRecRainDesc: "Volume de precipitação em milímetros. Importante para análise de produtividade.",
    cgRecReplacement: "Reposição",
    cgRecReplacementDesc: "Número de árvores que receberam reposição de painel ou tigela.",
    cgRecFungicide: "Fungicida",
    cgRecFungicideDesc: "Marque quando houver aplicação de fungicida nas árvores.",
    cgRecEthrelDesc: "Registre aplicações de Ethrel incluindo a proporção/concentração utilizada.",
    cgRecDuplicate: "Duplicar para Outro Seringueiro",
    cgRecDuplicateDesc: "Ao registrar dados, você pode clicar em \"Duplicar para outro seringueiro\" para criar rapidamente um registro similar para outro trabalhador, alterando apenas o nome e ajustando os valores se necessário.",
    // Safra section
    cgSafraTitle: "Resumo Acumulado de Safra",
    cgSafraDesc: "O resumo de safra mostra os totais acumulados do ano agrícola (safra), não do ano calendário. Isso permite uma análise mais precisa da sua produção.",
    cgSafraWhatIs: "O que é Ano de Safra?",
    cgSafraWhatIsDesc: "O ano de safra da borracha geralmente vai de Setembro a Agosto do ano seguinte. Por exemplo: Safra 2024/2025 = Setembro/2024 até Agosto/2025.",
    cgSafraConfigNote: "Você pode configurar o mês de início da safra nas configurações da propriedade.",
    cgSafraMetrics: "Métricas Exibidas:",
    cgSafraTotalProd: "Produção Total (kg)",
    cgSafraTotalRain: "Chuva Total (mm)",
    cgSafraTotalReplacements: "Total Reposições",
    cgSafraEthrelApps: "Aplicações Ethrel",
    cgSafraComparative: "Comparativo com Safra Anterior",
    cgSafraComparativeDesc: "O sistema compara automaticamente com a safra anterior, mostrando:",
    cgSafraIncrease: "Aumento em relação à safra anterior",
    cgSafraDecrease: "Redução em relação à safra anterior",
    cgSafraConfigTitle: "Como Configurar o Início da Safra",
    cgSafraStep1: "Acesse as configurações da propriedade (botão de engrenagem)",
    cgSafraStep2: "Localize o campo \"Mês de Início da Safra\"",
    cgSafraStep3: "Selecione o mês (padrão: Setembro)",
    cgSafraStep4: "Salve as alterações",
    // Ethrel section
    cgEthrelTitle: "Controle de Aplicação de Ethrel",
    cgEthrelDesc: "O sistema monitora as aplicações de Ethrel e alerta quando está próximo da próxima aplicação, ajudando a manter o cronograma ideal.",
    cgEthrelHow: "Como Funciona:",
    cgEthrelStep1: "Configure o Intervalo",
    cgEthrelStep1Desc: "Defina quantos dias entre cada aplicação (ex: 30 dias)",
    cgEthrelStep2: "Configure o Alerta",
    cgEthrelStep2Desc: "Defina com quantos dias de antecedência quer ser alertado (ex: 5 dias)",
    cgEthrelStep3: "Registre as Aplicações",
    cgEthrelStep3Desc: "Ao registrar um dia, marque \"Ethrel\" e informe a proporção usada",
    cgEthrelBanner: "Banner de Alerta",
    cgEthrelBannerDesc: "O banner aparece no topo do calendário mostrando:",
    cgEthrelBannerItem1: "Data da última aplicação",
    cgEthrelBannerItem2: "Dias desde a última aplicação",
    cgEthrelBannerItem3: "Dias restantes para a próxima",
    cgEthrelBannerItem4: "Alerta visual quando estiver próximo ou vencido",
    cgEthrelColors: "Cores do Status:",
    cgEthrelGreen: "Verde: Ethrel em dia",
    cgEthrelYellow: "Amarelo: Próximo da aplicação",
    cgEthrelRed: "Vermelho: Aplicação vencida",
    cgEthrelConcentration: "Proporção/Concentração",
    cgEthrelConcentrationDesc: "Ao registrar uma aplicação de Ethrel, você pode informar a proporção utilizada (ex: \"2,5%\" ou \"1:40\"). Isso fica registrado no histórico para consulta futura.",
    // Team section
    cgTeamTitle: "Gestão de Equipe e Produtividade",
    cgTeamTitleDesc: "Acompanhe o desempenho individual de cada seringueiro da sua equipe com relatórios detalhados de produtividade.",
    cgTeamDatabase: "Banco de Dados de Seringueiros",
    cgTeamDatabaseDesc: "O sistema mantém um cadastro dos seringueiros que aparecem nos seus registros:",
    cgTeamDbItem1: "Nome é automaticamente cadastrado ao criar registros",
    cgTeamDbItem2: "Histórico de produção individual",
    cgTeamDbItem3: "Estatísticas de dias trabalhados",
    cgTeamReport: "Relatório da Equipe",
    cgTeamReportDesc: "O relatório de equipe mostra:",
    cgTeamRanking: "Ranking de Produção",
    cgTeamAvgTapper: "Média por Seringueiro",
    cgTeamDaysWorked: "Dias Trabalhados",
    cgTeamProdPerDay: "Produtividade/Dia",
    cgTeamMultiple: "Como Registrar Múltiplos Seringueiros",
    cgTeamMultipleDesc: "Para facilitar o registro de vários seringueiros no mesmo dia:",
    cgTeamMultiStep1: "Crie o registro do primeiro seringueiro normalmente",
    cgTeamMultiStep2: "Após salvar, clique em \"Duplicar para outro seringueiro\"",
    cgTeamMultiStep3: "O formulário reabre com os mesmos dados - altere o nome e ajuste valores",
    cgTeamMultiStep4: "Repita para todos os seringueiros do dia",
    cgTeamIndTip: "Dica: Produtividade Individual",
    cgTeamIndTipDesc: "Para análises de produtividade individual precisas, sempre registre os dados separadamente por seringueiro, incluindo o nome no campo \"Seringueiro\" do formulário.",
    // Reports section
    cgRptTitle: "Relatórios e Análises",
    cgRptTitleDesc: "O sistema gera automaticamente relatórios detalhados para acompanhamento da sua produção e equipe.",
    cgRptTypes: "Tipos de Relatórios:",
    cgRptMonthlySummary: "Resumo Mensal",
    cgRptMonthlySummaryDesc: "Visão geral do mês com totais de produção, chuva, dias de sangria, reposições e aplicações. Aparece automaticamente no topo do calendário.",
    cgRptHarvestSummary: "Resumo de Safra",
    cgRptHarvestSummaryDesc: "Acumulado do ano agrícola (safra) com comparativo da safra anterior. Inclui detalhamento mês a mês.",
    cgRptTeamReport: "Relatório da Equipe",
    cgRptTeamReportDesc: "Ranking de produtividade individual, médias por seringueiro, dias trabalhados e comparativos de desempenho.",
    cgRptDailyTable: "Tabela Diária",
    cgRptDailyTableDesc: "Lista detalhada de todos os registros do mês em formato de tabela, com opções de editar e excluir registros.",
    cgRptExport: "Exportar Relatórios",
    cgRptExportDesc: "Alguns relatórios podem ser exportados para PDF ou impressos diretamente. Procure pelo botão \"Salvar PDF / Imprimir\" nas seções de relatório.",
    // Tips section
    cgTipTitle: "Dicas para Melhor Uso",
    cgTipTitleDesc: "Aproveite ao máximo o Calendário de Sangria com estas dicas práticas.",
    cgTipDaily: "Registre Diariamente",
    cgTipDailyDesc: "Crie o hábito de registrar as atividades no final de cada dia de trabalho. Dados atualizados garantem relatórios precisos.",
    cgTipMobile: "Acesse pelo Celular",
    cgTipMobileDesc: "O calendário é otimizado para celular. Registre os dados diretamente do campo sem precisar esperar chegar em casa.",
    cgTipIdentify: "Identifique os Seringueiros",
    cgTipIdentifyDesc: "Sempre preencha o campo \"Seringueiro\" nos registros para ter análises de produtividade individual precisas.",
    cgTipEthrelAlerts: "Configure Alertas de Ethrel",
    cgTipEthrelAlertsDesc: "Não perca o timing das aplicações de Ethrel. Configure o intervalo e receba alertas automáticos.",
    cgTipRain: "Registre a Chuva",
    cgTipRainDesc: "Mesmo em dias sem sangria, registre a precipitação. Isso ajuda a entender padrões de produtividade ao longo do tempo.",
    cgTipReports: "Revise os Relatórios",
    cgTipReportsDesc: "Periodicamente, analise os relatórios de safra e equipe para identificar oportunidades de melhoria na produção.",
    cgTipQuestions: "Dúvidas? Compartilhe na aba Comunidade e troque experiências com outros heveicultores!",

    // ========== PROFESSIONALS SEARCH VIEW ==========
    psTitle: "Buscar Profissionais",
    psSubtitle: "Encontre os melhores profissionais da heveicultura",
    psSearchFilters: "Filtros de Busca",
    psSpecialization: "Especialização",
    psAll: "Todas",
    psSangrador: "Sangrador",
    psFieldManager: "Gerente de Campo",
    psAgronomist: "Agrônomo",
    psMachineOperator: "Operador de Máquinas",
    psOthers: "Outros",
    psAllProfs: "Todos",
    psJoinedSystem: "Aderiu ao Sistema de Avaliação",
    psAllProfessionals: "Todos os Profissionais",
    psOnlyRecommended: "Apenas recomendados",
    psSearching: "Buscando profissionais...",
    psNoResults: "Nenhum profissional encontrado com os filtros selecionados.",
    psAchievements: "Conquistas",
    psAvailable: "Disponível",
    psQualitySeal: "Selo de Qualidade",
    psExperience: "Experiência",
    psOnPlatform: "Na plataforma",
    psSince: "Desde",
    psRecommendations: "Recomendações",
    psContactProfessional: "Contatar Profissional",
    psPhoneNotAvailable: "Telefone não disponível. Entre em contato pela plataforma.",
    psTip: "Mencione que encontrou o profissional pelo HeveaTalent para uma melhor experiência.",

    // ContextualPerformance - remaining
    cpTappingSystems: "Sistemas de Sangria",
    cpFactor: "Fator",
    cpSelectRegion: "Selecione a Região:",
    cpHighPeak: "Alta/Pico",
    cpNormal: "Normal",
    cpLowRecovery: "Baixa/Recuperação",
    cpStopped: "Parada",
    cpHowSealsWork: "Como funcionam os selos?",
    cpYourCurrentSeal: "Seu Selo Atual",
    cpLoadingSealInfo: "Carregando informações do selo...",
    cpExpertTapper: "Sangrador Expert",
    cpProfessionalTapper: "Sangrador Profissional",
    cpCertifiedTapper: "Sangrador Certificado",
    cpNoSealYet: "Nenhum selo conquistado ainda",
    cpKeepEvolving: "Continue evoluindo para conquistar badges!",
    cpLast12Seals: "Seus últimos 12 selos conquistados",
    cpSealLevels: "Níveis de Selo:",
    cpScoreCalculation: "Cálculo do Score:",
    cpNoContextData: "Sem dados contextuais? Seu selo será 100% baseado na avaliação técnica.",
    cpRef: "Ref.",

    // ========== MARKET MODULE ==========
    // MarketAnalysis
    maLoadingData: "Carregando dados...",
    maImportPrice: "Preço Importação (IEA)",
    maImportPriceDesc: "Custo TOTAL para importar borracha beneficiada. Inclui: preço internacional + câmbio + frete + seguro + impostos (~10,8%) + custos portuários. Serve como \"teto\" - é o máximo que a indústria pagaria.",
    maAdjustDrc: "Ajuste o DRC e a Taxa de Participação para simular diferentes cenários de preço.",
    maCoaguloDrc: "Coágulo DRC 53%",
    maProdCost: "Custo Produção (COT)",
    maParticipationRate: "Taxa de Participação (%)",
    maReference: "Referência",
    maBaseValue: "Valor Base",
    maWithDrc: "Com DRC",
    maWithRate: "Com Taxa",
    maCurrentCoagulo: "Último pago",
    maOnImportPrice: "Sobre Preço Importação",
    maOnGeb10Apabor: "Sobre GEB-10 APABOR",
    maOnGeb10Market: "Sobre GEB-10 Mercado SP",
    maCotTotal: "Custo Operacional Total (COT)",
    maCotDesc: "Inclui depreciação e remuneração",
    maCoeTotal: "Custo Operacional Efetivo (COE)",
    maCoeDesc: "Custos diretos de produção",
    maCurrentPrice: "Preço Atual do Coágulo",
    maDiffCot: "Diferença sobre COT",
    maDiffCoe: "Diferença sobre COE",
    maDataSources: "Fontes dos Dados",
    maAllReferences: "Todas as referências apresentadas",
    maOfficialSources: "Fontes oficiais verificáveis",
    maClearData: "Dados claros para decisão",
    // ProfitCalculator
    pcImportant: "Importante: Referências de Preço",
    pcImportPriceIEA: "Preço de Importação (IEA/CNA)",
    pcIsCeiling: "é o teto teórico.",
    pcDifference: "Diferença de",
    pcOfficialFormula: "Fórmula Oficial (CNA/FAESP/IEA)",
    pcProducerPrice: "Preço Produtor",
    pcPreview: "Preview",
    pcRealTimePreview: "Preview (tempo real)",
    pcEstimatedPrice: "Preço Estimado por kg",
    pcReferenceLabel: "Referência:",
    pcParticipationRate: "Taxa Participação:",
    pcFinalPrice: "Preço Final:",
    pcMarket: "Mercado (coágulo):",
    pcProductionCost: "Custo produção (COT):",
    pcMargin: "Margem:",
    pcProduction: "Produção",
    pcRevenue: "Receita",
    pcCost: "Custo",
    pcProfitLoss: "Lucro/Prejuízo",
    pcValue: "Valor",
    pcRate: "Taxa",
    // QuotationsPanel
    qpLoadingQuotes: "Carregando cotações do mercado...",
    qpNegotiationRef: "Referência para negociação entre usinas e produtores",
    qpBimonthlyUpdate: "Bimestral",
    qpUpdate: "Atualização",
    qpCoaguloRealPrice: "Coágulo (Preço Real)",
    qpRealPriceDesc: "Preço real pago ao produtor no mercado",
    qpMonthlyUpdate: "Mensal",
    qpDays15to20: "(dias 15-20)",
    qpInternationalSGX: "Internacional (SGX)",
    qpSGXDesc: "Preço da borracha na bolsa de Singapura",
    qpDollarBCB: "Dólar (BCB)",
    qpDollarDesc: "Taxa de câmbio (atualização automática)",
    qpProdCostCONAB: "Custo Produção (CONAB)",
    qpProdCostDesc: "Para calcular margem do produtor",
    qpAutomatic: "Automático:",
    qpManual: "Manual:",
    qpCalculation: "Cálculo:",
    qpProdMargin: "Margem do Produtor",
    // DataStatusDashboard
    dsInternationalSGX: "Internacional (SGX)",
    dsDollarBCB: "Dólar (BCB)",
    dsProdCostCOT: "Custo Produção (COT)",
    // SupplyChain & PriceFactors
    scProductionChain: "Cadeia Produtiva",
    scProducer: "Produtor",
    scProcessor: "Usina",
    scIndustry: "Indústria",
    pfClimateFactors: "Fatores Climáticos",
    pfDemandFactors: "Fatores de Demanda",
    pfPolicyFactors: "Fatores Políticos",

    // EditProductDialog
    edModifyProduct: "Modifique as informações do seu produto",
    edProductTitle: "Título do Produto",
    edPrice: "Preço",
    edFullLocation: "Localização Completa",
    edProductDesc: "Descrição do Produto",
    edContactInfo: "Informações de Contato",
    edPhotosVideos: "Fotos e Vídeos",
    edCondition: "Condição",
    edNew: "Novo",
    edSemiNew: "Seminovo",
    edUsed: "Usado",

    // PropertyFormDialog
    pfNewProperty: "Nova Propriedade",
    pfPropertyName: "Nome da Propriedade",
    pfLocationLabel: "Localização",
    pfCultivationYears: "Anos de Cultivo da Seringueira",
    pfTotalAreaHa: "Área Total (hectares)",
    pfNotes: "Observações",

    // EvaluationForm evaluator types
    evAgronomistWeight: "Engenheiro Agronomo (peso 3x)",
    evTechnicianWeight: "Tecnico Agricola (peso 3x)",
    evTeamLeaderWeight: "Lider de Equipe (peso 1x)",
    evOwnerWeight: "Proprietario (peso 1x)",
    evOtherWeight: "Outro (peso 1x)",

    // TechnicalReferences
    trBack: "Voltar",
    trTitle: "Referências Técnicas",
    trContentCovered: "Conteúdo abordado:",
    trWhySources: "Por que usamos essas fontes?",
    trHowToUse: "Como usar na avaliação?",

    // ========== REMAINING I18N KEYS ==========
    // Week day abbreviations
    weekDaySun: "Dom",
    weekDayMon: "Seg",
    weekDayTue: "Ter",
    weekDayWed: "Qua",
    weekDayThu: "Qui",
    weekDayFri: "Sex",
    weekDaySat: "Sáb",

    // MonthlyCalendarView tooltips
    mcvTooltipDay: "Dia",
    mcvWorkerSingle: "trabalhador",
    mcvWorkerPlural: "trabalhadores",
    mcvBleedingPerformed: "Sangria realizada",
    mcvReplacements: "Reposições",
    mcvActivityRegistered: "Atividade registrada",
    mcvFungicide: "Fungicida",
    mcvEthrel: "Ethrel",

    // MonthlyChartsView
    mchProduction: "Produção",
    mchActivities: "Atividades",
    mchBleedingDays: "Dias de Sangria",
    mchReplacements: "Reposições",
    mchTotalRain: "Chuva Total",
    mchMonthlyGoal: "Meta mensal: 500kg (exemplo)",

    // BleedingDailyTable - dialogs
    bdtDeleteConfirm: "ATENÇÃO: Tem certeza que deseja deletar este registro?\n\nEsta ação não pode ser desfeita.",
    bdtDeleteSuccess: "Registro deletado com sucesso!",
    bdtDeleteError: "Erro ao deletar registro",
    bdtUnknownError: "Erro desconhecido",
    bdtNoName: "Sem nome",

    // EvaluationForm
    evWorkerIdRequired: "ID do trabalhador é obrigatório",
    evCreateError: "Erro ao criar avaliação",
    evConnectionError: "Erro ao conectar com o servidor. Verifique sua conexão.",
    evChange: "Alterar",
    evFungicideApplication: "Aplicação de Fungicida",

    // RecommendationsSection
    recEnterEmployerName: "Informe o nome do ex-empregador",
    recErrorCreatingInvite: "Erro ao criar convite",
    recConnectionError: "Erro de conexão",
    recCancelInvite: "Cancelar este convite?",
    recLinkCopied: "Link copiado!",
    recConfirmRemove: "Tem certeza que deseja remover esta recomendação do seu perfil?",

    // CommunityTipsView
    ctMaxImages: "Máximo de imagens permitidas",
    ctFormatNotSupported: "Formato não suportado. Use JPG, PNG ou WEBP",
    ctImageTooLarge: "Imagem muito grande. Tamanho máximo: 5MB",
    ctErrorUploadImage: "Erro ao enviar imagem. Tente novamente.",
    ctErrorAddComment: "Erro ao adicionar comentário",
    ctFillTitleContent: "Por favor, preencha o título e o conteúdo da dica.",
    ctErrorShareTip: "Erro ao compartilhar dica",
    ctSending: "Enviando...",
    ctAddPhoto: "Adicionar foto",

    // MarketplaceItemCard
    mkConfirmRemoveAd: "Tem certeza que deseja remover este anúncio?",
    mkAdRemoved: "Anúncio removido com sucesso!",
    mkErrorRemoveAd: "Erro ao remover anúncio",
    mkErrorCreatePix: "Erro ao criar pagamento PIX",
    mkPaymentConfirmed: "Pagamento confirmado! Seu item agora está em destaque!",

    // ContextualPerformanceDashboard
    cpContextCreated: "Contexto criado com sucesso!",
    cpErrorCreateContext: "Erro ao criar contexto",
    cpSaveContext: "Salvar Contexto",
    cpSelectPropertyFirst: "Selecione uma propriedade primeiro",

    // WorkerDashboard
    wdErrorLoadData: "Erro ao carregar dados. Tente novamente mais tarde.",

    // CertificationOptIn
    coSelectBondType: "Selecione seu tipo de vínculo",
    coErrorProcessing: "Erro ao processar adesão",
    coAcceptConsent: "Você precisa aceitar o termo de consentimento",
    coErrorConsent: "Erro ao processar consentimento",

    // SubscriptionPlansView
    spErrorSubscription: "Erro ao processar assinatura",

    // RecommendationsSection - additional
    recCopyLink: "Copiar Link",
    recCreateInviteDesc: "Crie um link para seu ex-empregador enviar uma recomendação, mesmo sem ter conta na plataforma.",
    recFormerEmployerName: "Nome do Ex-Empregador",
    recEmailPhone: "Email ou Telefone (opcional)",
    recForControl: "Para seu controle",
    recCreating: "Criando...",
    recCreateInvite: "Criar Convite",
    recSendRecommendation: "Enviar Recomendação",

    // CommunityTipsView - additional
    ctSendComment: "Enviar Comentário",
    ctShareTip: "Compartilhar Dica",

    // MarketplaceItemCard - additional
    mkVideo: "Vídeo",
    mkPhotos: "Fotos",
    mkExample: "Exemplo",
    mkFeatured: "Destaque",
    mkSeeFullDetails: "Ver detalhes completos",
    mkDaysRemaining: "dias restantes",
    mkDayRemaining: "dia restante",
    mkFeature: "Destacar",
    mkRemove: "Remover",
    mkLocation: "Localização",
    mkPublishedOn: "Publicado em",
    mkAdExpiresIn: "Este anúncio expira em",
    mkDays: "dias",
    mkRenewToKeepActive: "Renove para manter ativo!",
    mkSeller: "Vendedor",
    mkThumbnail: "Miniatura",
    mkGoToImage: "Ir para imagem",
    mkPhoto: "Foto",
    mkOf: "de",

    // EthrelAlertBanner - additional
    eaConfigTitle: "Configuração de Ethrel",
    eaConfigTooltip: "Configure aqui o intervalo ideal entre aplicações de Ethrel para sua propriedade. O sistema irá alertá-lo automaticamente quando a próxima aplicação estiver se aproximando.",
    eaIntervalHint: "Quantidade de dias entre cada aplicação de Ethrel",
    eaAlertAdvance: "Alertar com antecedência de (dias)",
    eaAlertAdvanceTooltip: "Defina quantos dias antes do vencimento você quer ser alertado.",
    eaAlertAdvanceHint: "Quantos dias antes da próxima aplicação o alerta deve aparecer",
    eaPreviewSummary: "Você receberá alertas",
    eaPreviewDaysBefore: "dias antes de completar",
    eaPreviewDaysSince: "dias desde a última aplicação.",
    eaAlertLevels: "Níveis de Alerta",
    eaCritical: "Aplicação vencida",
    eaUrgent: "Faltam 3 dias ou menos",
    eaWarning: "Dentro do período de alerta",
    eaOk: "Aplicação em dia",
    eaSaveConfig: "Salvar Configuração",
    eaConfigSaved: "Configuracao de Ethrel salva com sucesso!",
    eaEthrelControl: "Controle de Ethrel",
    eaEthrelTooltip: "O Ethrel é um estimulante de látex aplicado periodicamente. Configure o intervalo entre aplicações para receber alertas automáticos.",
    eaConfigureToReceive: "Configure o intervalo de aplicação para receber alertas",
    eaLot: "Lote",
    eaProportion: "Proporção",
    eaDaysSinceLastApp: "dias desde a última aplicação",
    eaIntervalLabel: "intervalo",
    eaDismiss: "Dispensar",
    eaIntervalTooltip: "Defina quantos dias normalmente você espera entre cada aplicação de Ethrel. Exemplo: se aplica a cada 30 dias, coloque 30.",

    // Payment
    processingPayment: "Processando pagamento...",
    pleaseWait: "Aguarde enquanto confirmamos seu pagamento.",
    paymentConfirmedTitle: "Pagamento confirmado!",
    paymentConfirmedDesc: "Seu plano foi ativado com sucesso.",
    goToDashboard: "Ir para o Dashboard",
    paymentTimeout: "Tempo esgotado",
    paymentTimeoutDesc: "Não foi possível confirmar. Verifique seu email.",
    paymentError: "Erro no pagamento",
    paymentErrorDesc: "Ocorreu um erro. Tente novamente.",
    backToPlans: "Voltar aos Planos",
    paymentCancelled: "Pagamento cancelado",
    paymentCancelledDesc: "Nenhuma cobrança foi feita. Você pode voltar e escolher um plano quando quiser.",
    redirectingToPayment: "Redirecionando para pagamento...",
    plan: "Plano",
    savingLabel: "Salvando...",
    annualTipTitle: "Economia no plano anual",
    annualTipDesc: "Todos os planos pagos oferecem 8% de desconto na assinatura anual. Isso representa aproximadamente 1 mês grátis por ano!",

    // Subscription Management
    mySubscription: "Minha Assinatura",
    active: "Ativo",
    premiumLifetime: "Acesso vitalício a todos os recursos",
    freePlanDesc: "Plano gratuito com recursos limitados",
    expiresAt: "Expira em",
    expiringSoon: "Expira em breve! Renove para não perder acesso.",
    upgradePlan: "Fazer Upgrade",
    changePlan: "Trocar Plano",
    cancelSubscription: "Cancelar Assinatura",
    cancelSubscriptionConfirm: "Tem certeza que deseja cancelar? Seu plano continuará ativo até o vencimento.",
    subscriptionCancelled: "Assinatura cancelada. Permanecerá ativa até o vencimento.",
    planResources: "Recursos do Plano",
    properties: "Propriedades",
    workers: "Trabalhadores",
    paymentHistory: "Histórico de Pagamentos",
    paid: "Pago",
    activeItems: "Itens Ativos",
    upgradeTitle: "Desbloqueie todo o potencial!",
    upgradeDesc: "Faça upgrade para acessar calendário completo, avaliações, gestão de equipe e muito mais.",
    seeAllPlans: "Ver Todos os Planos",
    processing: "Processando...",
    currencyBRL: "Real (R$)",
    currencyUSD: "Dólar (US$)"
  },
  
  en: {
    // ========== HEADER & NAVIGATION ==========
    login: "Login",
    register: "Sign Up",
    logout: "Logout",
    heveicultureProfessional: "Professional Rubber Tapping",
    welcome: "Welcome",
    profile: "Profile",
    settings: "Settings",
    
    // ========== LANDING PAGE ==========
    // Hero Section
    heroTitle: "Connecting Talents in",
    heroSubtitle: "Rubber Cultivation",
    heroDescription: "The specialized platform that connects rural landowners with qualified professionals in the rubber cultivation sector. Find the best tappers, managers, inspectors and agronomist engineers.",
    startFree: "Start Free",
    learnMore: "Learn More",
    
    // Landing Features
    manageHeveiculture: "Manage your rubber cultivation",
    findBestProfessionals: "and find the best professionals",
    completePlatform: "The complete platform for producers and workers in rubber cultivation",
    jobBoard: "Job Board",
    community: "Community",
    bleedingCalendar: "Bleeding Calendar",
    teamManagement: "Team Management",
    workerCertification: "Worker Certification",
    seeHowItWorks: "See how it works",
    
    // Landing Cards
    simplicity: "Simplicity",
    simplicityDesc: "Intuitive interface designed for the field. Easy to use on any device.",
    security: "Security",
    securityDesc: "Your data protected with LGPD. Verified profiles and authentic reviews.",
    fairness: "Transparency",
    fairnessDesc: "Transparent evaluation system. Recognition by merit and experience.",
    
    forEmployers: "For Employers",
    forEmployersDesc: "Post jobs and find qualified professionals with certification system",
    forProfessionals: "For Professionals",
    forProfessionalsDesc: "Offer your services and build your reputation with our badge system",
    marketplaceDesc: "Buy and sell properties, tools, supplies and machinery",
    communityDesc: "Active community to share tips and knowledge",
    
    findIdealProfessional: "How to Find the Ideal Professional",
    
    // ========== MAIN SECTIONS ==========
    jobCenter: "Job Center",
    marketplace: "Marketplace",
    certifiedProfessionals: "Certified Professionals",
    agriculturalMarketplace: "Agricultural Marketplace",
    jobs: "Jobs",
    evaluations: "Evaluations",
    plans: "Plans",
    calendar: "Calendar",
    reports: "Reports",
    performance: "Performance",
    marketAnalysisTab: "Market",
    marketAnalysisDesc: "Quotations, calculator and rubber price analysis",
    professionals: "Professionals",
    communityTips: "Community Tips",
    
    // ========== MARKETPLACE ==========
    properties: "Properties",
    tools: "Tools",
    supplies: "Supplies",
    pesticides: "Pesticides",
    machinery: "Machinery",
    others: "Others",
    sellProduct: "Sell Product",
    myAds: "My Ads",
    browseProducts: "Browse Products",
    announceProduct: "Announce Product",
    publishAd: "Publish Ad",
    productTitle: "Product Title",
    category: "Category",
    selectCategory: "Select category",
    price: "Price (R$)",
    condition: "Condition",
    location: "Location",
    productDescription: "Product Description",
    contactInfo: "Contact Information",
    productImages: "Product Images (URLs)",
    new: "New",
    seminew: "Semi-new",
    used: "Used",
    feature: "Feature",
    featureAd: "🔥 Feature - R$ 9.90",
    remove: "Remove",
    removeAd: "Remove Ad",
    productPublished: "Product published successfully!",
    errorPublishing: "Error creating ad",
    adRemoved: "Ad removed successfully!",
    errorRemoving: "Error removing ad",
    
    // ========== JOBS ==========
    publishJob: "Publish Job",
    searchJobs: "Search Jobs",
    myJobs: "My Jobs",
    jobTitle: "Job Title",
    jobDescription: "Job Description",
    salary: "Salary",
    requirements: "Requirements",
    benefits: "Benefits",
    applyNow: "Apply Now",
    applications: "Applications",
    
    // ========== FORMS ==========
    fullName: "Full Name",
    email: "Email",
    password: "Password",
    userType: "User Type",
    selectType: "Select type",
    employer: "Employer/Landowner",
    professional: "Professional",
    phone: "Phone",
    company: "Company/Property",
    experienceYears: "Years of Experience",
    specialization: "Specialization",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    update: "Update",
    create: "Create",
    record: "Record",
    search: "Search",
    filter: "Filter",
    clear: "Clear",
    
    // ========== SPECIALIZATIONS ==========
    tapper: "Rubber Tapper",
    generalManager: "General Manager",
    inspector: "Inspector",
    agronomist: "Agronomist Engineer",
    
    // ========== TECHNICAL QUALIFICATION (EVALUATION SYSTEM) ==========
    technicalQualification: "Technical Qualification",
    technicalQualificationDesc: "Your qualification determines the weight of evaluations you give",
    qualificationEngineer: "Agronomist Engineer",
    qualificationTechnician: "Agricultural Technician",
    qualificationLeader: "Team Leader",
    qualificationOwner: "Property Owner",
    qualificationOther: "Other",
    selectQualification: "Select your qualification",
    
    // Evaluation Types
    evaluationTypeTechnical: "Technical Evaluation",
    evaluationTypeEmployer: "Employer Evaluation",
    technicalSeal: "Technical Seal",
    technicalSealDesc: "Based on evaluations from certified technical professionals (weight 3x)",
    employerEvaluations: "Employer Evaluations",
    employerEvaluationsDesc: "History of evaluations from property owners (weight 1x)",
    weightedScore: "Weighted Score",
    weightedScoreDesc: "Weighted average: technical evaluations (3x) + employer evaluations (1x)",
    noTechnicalEvaluations: "No technical evaluations yet",
    noEmployerEvaluations: "No employer evaluations yet",
    
    // ========== EVOLUTION CHART ==========
    performanceEvolution: "Performance Evolution",
    last12Months: "Last 12 months",
    currentSeal: "Current Seal",
    trend: "Trend",
    lastThreeMonths: "Last 3 months",
    technicalEvaluations: "Technical Evaluations",
    employerEvaluationsShort: "Employers",
    weight3x: "Weight 3x",
    weight1x: "Weight 1x",
    noEvaluationsYet: "No evaluations yet",
    firstEvaluationMessage: "Data will appear after the first evaluation",
    sealGold: "Gold",
    sealSilver: "Silver",
    sealBronze: "Bronze",
    sealNone: "No seal",
    
    // ========== ACHIEVEMENT SYSTEM ==========
    achievementSystem: "Achievement System",
    allProfessionalsWelcome: "All professionals are welcome! Earn badges as you grow on the platform.",
    firstAccess: "First access",
    firstRating: "First Rating",
    positiveFeedback: "Positive feedback",
    activeProfessional: "Active Professional",
    completedJobs: "5+ completed jobs",
    experienced: "Experienced",
    oneYearPlatform: "1 year on platform",
    
    // ========== TIME ==========
    immediate: "Immediate",
    oneMonth: "1 month",
    twoMonths: "2 months",
    threeMonths: "3 months",
    days: "days",
    hours: "hours",
    minutes: "minutes",
    today: "Today",
    yesterday: "Yesterday",
    
    // ========== PLANS ==========
    plansForEmployers: "Plans for Employers",
    plansForProfessionals: "Plans for Professionals",
    currentPlan: "Current Plan",
    recommended: "Recommended",
    selectPlan: "Select Plan",
    startTrial: "Start Free Trial",
    freeTrial: "free days to try",
    monthly: "month",
    yearly: "year",
    free: "Free",
    unlimited: "Unlimited",
    
    // Plan Features
    propertiesLimit: "properties",
    jobPostings: "job board postings",
    marketplaceAds: "marketplace ads",
    teamManagement: "Team management",
    fullCalendar: "Full calendar",
    basicReports: "Basic reports",
    fullReports: "Full reports",
    freeHighlights: "free highlights/month",
    
    // Trial Messages
    trialExpired: "Trial Period Expired",
    trialExpiredMessage: "Your trial period has ended. Upgrade to continue.",
    trialRemaining: "days remaining in trial period",
    dataPreserved: "Your data is saved and will be recovered after upgrade.",
    
    // ========== AVULSO ITEMS ==========
    avulsoItems: "Individual Items",
    avulsoDescription: "Buy extra resources without changing your plan",
    highlight: "Ad Highlight",
    highlightDesc: "Your ad appears at the top of listings for 7 days",
    extraAdJob: "Extra Ad - Job Board",
    extraAdJobDesc: "1 additional job posting for 30 days",
    extraAdMarketplace: "Extra Ad - Marketplace",
    extraAdMarketplaceDesc: "1 additional marketplace ad for 30 days",
    buyHighlight: "Buy Highlight",
    buyAd: "Buy Ad",
    paymentViaPix: "Payment via PIX • Immediate activation after confirmation",
    
    // ========== BANNER ==========
    growWithHeveaTalent: "Grow with HeveaTalent",
    discoverPlansAndResources: "Discover available plans and resources",
    
    // ========== CALENDAR ==========
    bleedingCalendarTitle: "Bleeding Calendar - Rubber Cultivation",
    newProperty: "New Property",
    propertySelection: "Property Selection",
    noPropertiesRegistered: "No properties registered",
    createFirstProperty: "Create your first property to start using the bleeding calendar",
    createProperty: "Create First Property",
    selectProperty: "Select a property",
    monthlyProduction: "Monthly Production",
    totalProduction: "Total Production",
    averageDaily: "Daily Average",
    activeDays: "Active Days",
    workingDays: "Working Days",
    
    // Calendar Tips
    calendarTipTitle: "How to use the Bleeding Calendar:",
    calendarTip1: "Record daily production for each tapper",
    calendarTip2: "Track monthly and yearly performance",
    calendarTip3: "Compare productivity between workers",
    
    // ========== EVALUATIONS ==========
    evaluationSystem: "Evaluation System",
    giveEvaluation: "Give Evaluation",
    receiveEvaluation: "Receive Evaluation",
    internalEvaluation: "Internal Evaluation",
    privateControl: "Internal Control (Private)",
    evaluationSent: "Evaluation sent successfully!",
    errorSendingEvaluation: "Error sending evaluation",
    
    // ========== COMMUNITY ==========
    communityTipsTitle: "Community Tips",
    shareTip: "Share Tip",
    shareYourTip: "Share your tip or experience:",
    tipCategory: "Category (bleeding, tools, health, weather, others):",
    tipShared: "Tip shared successfully!",
    errorSharingTip: "Error sharing tip. Please try again.",
    writeComment: "Write your comment here...",
    leaveComment: "Leave a comment (optional)",
    send: "Send",
    like: "Like",
    comment: "Comment",
    comments: "comments",
    likes: "likes",
    
    // ========== MESSAGES ==========
    loading: "Loading...",
    searching: "Searching...",
    saving: "Saving...",
    creating: "Creating...",
    sending: "Sending...",
    registering: "Registering...",
    loggingIn: "Logging in...",
    success: "Success!",
    error: "Error",
    warning: "Warning",
    info: "Information",
    
    // Error Messages
    errorLogin: "Login error. Check your credentials.",
    forgotPassword: "Forgot my password",
    forgotPasswordTitle: "Recover password",
    forgotPasswordDesc: "Enter your email and we'll send you a code and a link to reset your password.",
    sendCode: "Send code",
    sending: "Sending...",
    alreadyHaveCode: "I already have a code",
    codeSentInfo: "If the email is registered, you will receive a verification code. Also check your spam folder.",
    verificationCode: "Verification code",
    newPasswordLabel: "New password",
    confirmPasswordLabel: "Confirm new password",
    resetPasswordBtn: "Reset password",
    resetting: "Resetting...",
    passwordsDontMatch: "Passwords don't match",
    passwordMinLength: "Password must be at least 6 characters",
    passwordResetSuccess: "Password reset successfully! Log in with your new password.",
    invalidResetLink: "Invalid or expired link. Request a new recovery email.",
    backToLogin: "Back to home",
    requestNewEmail: "Request a new email",
    freeHighlightAvailablePrefix: "You have",
    freeHighlightAvailableSuffix: "free highlight(s) this month!",
    useFreeHighlight: "Use free highlight",
    freeHighlightUsed: "Free highlight already used this month",
    renewsOn: "Renews on",
    chooseAdToHighlight: "Choose one of your ads to be highlighted for 7 days, at no cost.",
    applyFreeHighlight: "Apply free highlight",
    applying: "Applying...",
    noAdsToHighlight: "You have no active ads to highlight. Create an ad on the Job Board or Marketplace first.",
    freeHighlightSuccess: "Free highlight applied!",
    freeHighlightError: "Could not apply the highlight",
    jobBoardLabel: "Job Board",
    marketplaceLabel: "Marketplace",
    errorRegister: "Registration error",
    errorLoading: "Error loading data",
    errorSaving: "Error saving",
    errorDeleting: "Error deleting",
    errorUnknown: "Unknown error",
    
    // ========== MISC ==========
    all: "All",
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    completed: "Completed",
    yes: "Yes",
    no: "No",
    or: "or",
    and: "and",
    of: "of",
    in: "in",
    for: "for",
    with: "with",
    without: "without",
    more: "more",
    less: "less",
    seeMore: "See more",
    seeLess: "See less",
    viewAll: "View all",
    close: "Close",
    back: "Back",
    next: "Next",
    previous: "Previous",
    finish: "Finish",
    sendComment: "Send Comment",
    sending: "Sending...",
    generating: "Generating...",
    generate: "Generate",
    generateReport: "Generate Report",
    generateTeamReport: "Generate Team Report",
    teamButton: "Team",
    monthlyReport: "Monthly Report",
    teamReport: "Team Report",
    reportPeriod: "Report Period",
    reportMonth: "Report Month",
    closeReport: "Close Report",
    closeDatabase: "Close Database",
    savePdfPrint: "Save PDF / Print",
    printReport: "Print Report",
    consultData: "Consult Data",
    editRecord: "Edit record",
    deleteRecord: "Delete record",
    addDataForDay: "Add data for this day",
    newRecord: "New Record",
    editProduct: "Edit Product",
    saveChanges: "Save Changes",
    addByUrl: "Or Add by URL",
    uploading: "Uploading",
    add: "Add",
    generatePix: "Generate PIX",
    verifiedIdentity: "Verified Identity",
    bleedingPerformed: "Bleeding Performed",
    openChat: "Open Chat",
    mobileFriendlyTip: "Click the button to open the full form.",
    useEditToModify: "Use Edit to modify existing records.",
    
    // Tooltips - How to use
    tooltipJobPosting: "💡 Job Postings: Post a job to find certified professionals with Bronze, Silver or Gold seals. Include title, description, location, salary and requirements.",
    tooltipWorkOffer: "💡 Service Offer: Register your services so employers can find you in the professional search. Describe your skills, experience and availability.",
    tooltipSearchJobs: "💡 Search Jobs: Browse jobs posted by property owners. Click on a job for details and use HeveaTalent chat to get in touch.",
    tooltipMyOffers: "💡 My Offers & Recommendations: Manage your service offers. Below, see your received recommendations and invite former employers to recommend you — even those without a platform account. More recommendations = more visibility. HeveaTalent grows with you!",
    tooltipMarketplace: "💡 Marketplace: Buy and sell products, equipment and supplies related to rubber tapping.",
    tooltipCalendar: "💡 Bleeding Calendar: Record your daily tapping, production in kg, rain and applications. Your records feed into Contextual Performance, contributing 50% of your professional Seal. Every cut counts — build your reputation!",
    tooltipCommunity: "💡 Community: Share tips with photos 📷, ask questions and connect with other professionals. You can attach up to 3 images to your tips and comments!",
    tooltipEvaluations: "💡 Evaluations: Rate and be rated. Build your reputation on the platform.",
    tooltipPlans: "💡 Plans: Your plan defines what you can use — calendar, marketplace, team management and reports. Larger plans unlock more properties, ads and highlights. The more you participate, the more the industry recognizes your value!",
    tooltipProfessionals: "💡 Find Professionals: Find certified workers with Bronze, Silver or Gold seals. View recommendations, evaluations and full profiles. You can recommend professionals who worked with you — your recommendation appears on their public profile. Use HeveaTalent chat for direct contact.",
    tooltipReports: "💡 Reports: View statistics and production reports from your property.",
    tooltipPerformance: "💡 Performance: Track your contextual performance based on local conditions.",
    seeExample: "See Example",
    howToUse: "How to use",
    exampleJobPostings: "Job Posting Examples",
    exampleJobPostingsDesc: "See below examples of how job postings are displayed on the platform. Use as reference when searching for opportunities.",
    example: "Example",
    chatWithEmployer: "Chat with Employer",
    requirements: "Requirements",
    
    // Example Modal - Service Offer (Professional)
    exampleServiceOfferTitle: "Example of a Well-Made Service Offer",
    exampleServiceOfferName: "Experienced Tapper - Available for Work",
    exampleServiceOfferLocation: "Votuporanga, SP and region",
    exampleServiceOfferDesc: "Professional with 5 years of experience in rubber tapping. Specialized in descending and ascending techniques. Immediate availability for work on small to large farms.",
    exampleServiceOfferTip1: "✅ Title with your specialization and availability",
    exampleServiceOfferTip2: "✅ Detailed experience (years, techniques mastered)",
    exampleServiceOfferTip3: "✅ Regions where you can work",
    exampleServiceOfferTip4: "✅ Desired percentage or salary 'negotiable'",
    exampleServiceOfferTip5: "✅ Availability (immediate, in 30 days, etc.)",
    exampleServiceOfferButton: "Got it, I'll create my offer!",
    bestPractices: "Best Practices:",
    
    // Marketplace Tooltips
    tooltipMarketplaceBrowse: "💡 Browse products for sale. Use filters to find equipment, supplies and materials for rubber tapping. Click on a product to see details and contact the seller.",
    tooltipMarketplaceSell: "💡 Advertise your products. Add photos, detailed description, price and location to attract interested buyers.",
    tooltipMarketplaceMyItems: "💡 Manage your ads. Edit, highlight or remove products you have put up for sale.",
    
    // Record Form Tooltips
    tooltipSangria: "Day when you tapped the trees",
    tooltipTalhao: "Section or area where the activity was performed",
    tooltipReposicao: "Recovery of days without tapping (compensation)",
    tooltipSangriaPerdida: "Trees not tapped (rain, TPD, etc)",
    tooltipFungicida: "Application of fungus treatment",
    tooltipChuva: "Rainfall volume of the day",
    tooltipProducao: "Weight of latex/coagulum collected",
    tooltipWorkersDb: "Private history of worker evaluations",
    tooltipKgPlanta: "Average production per tree",
    tooltipTrendUp: "Evaluations trending up",
    tooltipTrendDown: "Evaluations trending down",
    tooltipTrendStable: "Consistent performance",
    tooltipMultiWorkers: "workers on this day",
    tooltipAddRecord: "Add record",
    
    // Multiple Workers Tip - Calendar banner
    multiWorkerTipTitle: "Multiple Workers per Day",
    multiWorkerTipDesc: "Record each worker's production individually on the same day.",
    multiWorkerTipToggle: "See how to do it",
    multiWorkerTipHide: "Hide instructions",
    multiWorkerTipStep1: "Click on the desired day in the calendar",
    multiWorkerTipStep2: "Fill in the",
    multiWorkerTipStep2Bold: "first worker's",
    multiWorkerTipStep2End: "data (name, production, plot)",
    multiWorkerTipStep3: "Click",
    multiWorkerTipStep3Bold: "Save",
    multiWorkerTipStep4: "After saving, the option will appear",
    multiWorkerTipStep4Bold: "Add Another Worker",
    multiWorkerTipStep5: "Repeat the process for each worker of the day",
    multiWorkerTipNote: "Days with multiple workers show a number in the corner",
    multiWorkerTipTooltip: "You can record each worker's production separately on the same day. This allows you to track the individual performance of each team member.",
    multiWorkerTipReshow: "Show tip: Multiple workers",

    // Calendar Events (Absences & Holidays)
    legendBleeding: "Bleeding performed",
    legendLost: "Lost bleeding (rain)",
    legendAbsence: "Worker absence",
    legendHoliday: "Holiday",
    legendHint: "Click a day to record bleeding. To mark absence or holiday, click the small calendar icon in the corner of the cell.",
    celTitle: "Absence or Holiday",
    celExplain: "Absences and holidays are informational labels — they do not alter the bleeding count. They provide context in reports.",
    celExistingTitle: "Events on this day:",
    celAbsence: "Absence",
    celHoliday: "Holiday",
    celCompensated: "compensated",
    celWorker: "Worker",
    celWorkerPlaceholder: "Worker's name",
    celWorkerRequired: "Select or type the worker's name.",
    celFaltaWorkerRequired: "Select or type the worker's name.",
    celReason: "Reason",
    celReasonPlaceholder: "Ex: Medical leave, Personal",
    celHolidayName: "Holiday name",
    celHolidayPlaceholder: "Ex: Christmas, City Anniversary",
    celAbsenceHint: "If this worker later compensates the absence on another date (working on a Saturday for example), you can link that bleeding to this absence in the record form.",
    celHolidayHint: "The holiday is just a label on the calendar. If a worker chooses to work on this day (partnership), the registered bleeding counts normally.",
    celMarkEvent: "Mark absence or holiday",
    celSaveError: "Error saving event.",
    celDeleteError: "Error removing event.",
    celConfirmDelete: "Remove this event?",
    // Compensation in record form
    rfCompensateAbsenceTitle: "This bleeding compensates an absence",
    rfCompensateAbsenceSelect: "Which absence is being compensated?",
    rfCompensateAbsenceHint: "When checked, the selected absence will be marked as compensated in reports.",
    // Monthly report - new sections
    rptWorkerSectionTitle: "By worker",
    rptWorkerName: "Worker",
    rptWorkerBleedings: "Bleedings",
    rptWorkerLost: "Lost",
    rptWorkerAbsences: "Absences",
    rptWorkerCompensated: "Compensated",
    rptWorkerProduction: "Production",
    rptAbsencesTitle: "Absences in the period",
    rptHolidaysTitle: "Holidays",
    rptNoAbsences: "No absences recorded in the period.",
    rptNoHolidays: "No holidays recorded in the period.",
    rptAbsencePattern: "Absence pattern (last 3 months)",
    saving: "Saving...",
    
    // Evaluation System Tooltips - Explanatory based on the Tripod
    tooltipEvaluationOverview: "🏆 **HeveaTalent Certification System**\n\n⚖️ **FAIRNESS**: Evaluation based on 14 official technical criteria (INCAPER, CATI/SP).\n\n📊 **TWO TYPES OF EVALUATION**:\n• **Technical Evaluation** (weight 3x): Made by certified Agronomist Engineers or Agricultural Technicians. Higher credibility.\n• **Employer Evaluation** (weight 1x): Made by property owners. Reflects work experience.\n\n🏅 **SEAL SYSTEM**: Final score is a weighted average. Seals: Bronze (60-74), Silver (75-89), Gold (90+).\n\n📈 **EVOLUTION**: Track your progress in the 'Performance Evolution' tab with charts and trends.\n\n🔒 **SECURITY**: Private evaluations, LGPD compliant.",
    tooltipEvaluationProfile: "📊 **Your Certification Profile**\n\n🏅 **Quality Seals**: Bronze (60-74 pts), Silver (75-89 pts), Gold (90-100 pts).\n\n⚖️ **HOW THE CALCULATION WORKS**:\n• Qualified Evaluations have weight 3x (Agronomist Engineers and Agricultural Technicians)\n• Standard Evaluations have weight 1x (Owners, Team Leaders, Others)\n• Weight is determined by the evaluator's qualification, not account type\n• Your seal is based on the weighted average\n\n📈 **Evolution Chart**: See your progress over time.\n\n🎯 **Educational Feedback**: Receive personalized guidance based on the 14 criteria to improve your techniques.",
    tooltipEvaluationCreate: "✍️ **Create Technical Evaluation**\n\n🎓 **EVALUATION TYPE**: Your evaluation will be classified according to your qualification:\n• **Agronomist Engineer/Agricultural Technician**: Technical Evaluation (weight 3x)\n• **Owner/Team Leader**: Employer Evaluation (weight 1x)\n\n👤 **Who to evaluate**: Professionals who worked on your property.\n\n📋 **14 Criteria**: Tapping Technique (45%), Harvest Preparation (20%), Daily Maintenance (15%), Chemical Applications (20%).\n\n⚖️ **Impact**: Technical evaluations have greater weight on the professional's final seal.",
    tooltipEvaluationEvolution: "📈 **Performance Evolution**\n\n📊 **EVOLUTION CHART**: Visualize your evolution over the last 12 months with:\n• **Green Line**: Weighted score (overall average)\n• **Blue Line**: Qualified Evaluations (weight 3x) — Engineers and Technicians\n• **Purple Line**: Standard Evaluations (weight 1x) — Owners and others\n\n⚖️ **WEIGHT**: Weight is determined by the evaluator's technical qualification, not account type. An owner who is an Agronomist Engineer gets weight 3x.\n\n🏅 **REFERENCE LINES**: Dashed lines show seal thresholds:\n• 🥇 Gold: ≥90 points\n• 🥈 Silver: ≥75 points\n• 🥉 Bronze: ≥60 points\n\n📈 **TREND**: The indicator shows if you're improving (+) or declining (-) in the last 3 months.\n\n💡 **TIP**: Seek evaluations from qualified professionals (Engineers/Technicians) to increase your seal credibility!",
    
    // Seal Levels
    bronzeSeal: "Bronze Seal",
    silverSeal: "Silver Seal",
    goldSeal: "Gold Seal",
    platinumSeal: "Seal removed",
    qualitySeal: "Quality Seal",
    
    // Professional Profile
    yearsExperience: "years of experience",
    evaluationsReceived: "evaluations received",
    jobsCompleted: "jobs completed",
    memberSince: "Member since",
    contactProfessional: "Contact",
    viewProfile: "View Profile",
    
    // Employer/Property
    propertyName: "Property Name",
    propertyLocation: "Property Location",
    numberOfTrees: "Number of Trees",
    cultureAge: "Culture Age (years)",
    
    // Footer
    allRightsReserved: "All rights reserved",
    termsOfUse: "Terms of Use",
    privacyPolicy: "Privacy Policy",
    contact: "Contact",
    help: "Help",
    understood: "Got it",
    
    // ========== PERMISSIONS GUIDE ==========
    permGuideTitle: "Permissions Guide",
    permGuideOverview: "Overview",
    permGuideRoles: "Roles",
    permGuideTransfer: "Transfer",
    permGuidePlans: "Plans",
    permGuideHowWorks: "How does it work?",
    permGuideHowWorksDesc: "Each property can have different people with different access levels. This allows consultants, managers and employees to work together without confusion about who can do what.",
    permGuidePracticalExample: "Practical example:",
    permGuideOwnerExample: "is the owner of Conquista Farm",
    permGuideManagerExample: "(consultant) manages the data",
    permGuideOperatorExample: "(tapper) records daily production",
    permGuideImportantPlans: "Important about Plans:",
    permGuideImportantPlansDesc: "After the trial period, each user will have access according to the chosen plan (Professional or Owner). If you are a consultant/administrator who manages third-party properties, choose the plan that best suits your needs.",
    permGuideManagersOperators: "Managers and Operators:",
    permGuideManagersOperatorsDesc: "When the owner/lessee registers a consultant, operator or technical manager on their property, they access according to the owner's plan limitations. The owner defines who can access their property.",
    permGuideLimitsByPlan: "Limits by Plan:",
    permGuideLimitsByPlanDesc: "Each plan has its limitations (number of properties, team, features). It is not possible to use a single plan to manage multiple properties from different owners - each owner/lessee must have their own active plan.",
    permGuideSummary: "Summary:",
    permGuideSummaryDesc: "The property owner's (owner or lessee) plan defines the limits. Linked consultants and operators use that plan's permissions for that specific property.",
    permGuideOwner: "Owner",
    permGuideOwnerDesc: "Legal owner of the property in the system.",
    permGuideOwnerCan: "Can:",
    permGuideOwnerCanList: "Transfer/sell the property|Define manager and operators|View and edit all data|Deactivate the property (historical data preserved)",
    permGuideOwnerPlanNote: "The owner's plan defines the feature limits",
    permGuideOwnerDataNote: "Historical data is always preserved for analysis and statistics",
    permGuideManager: "Manager",
    permGuideManagerDesc: "Manages the property day to day.",
    permGuideManagerCan: "Can:",
    permGuideManagerCanList: "Insert, edit and delete records|View all reports|Manage tapper team",
    permGuideManagerCannot: "Cannot:",
    permGuideManagerCannotList: "Transfer the property|Add other managers",
    permGuideOperator: "Operator",
    permGuideOperatorDesc: "Inserts daily production records.",
    permGuideOperatorCan: "Can:",
    permGuideOperatorCanList: "Insert new records|Edit/delete own records|View property summaries",
    permGuideOperatorCannot: "Cannot:",
    permGuideOperatorCannotList: "Edit others' records|View detailed team reports",
    permGuideTransferTitle: "Property Transfer",
    permGuideTransferDesc: "Transferring a property means changing who is the official owner on the platform. This directly impacts who pays for the plan and who authorizes collaborator access.",
    permGuideTransferWhatChanges: "What changes in a transfer?",
    permGuideTransferChangeOwner: "The owner changes — the new owner becomes the person legally responsible for the property on the platform.",
    permGuideTransferChangePlan: "The new owner's plan takes effect — all collaborators (manager and operators) will operate under the NEW owner's plan. If the new owner has a lower-tier plan, available features for the team may be reduced.",
    permGuideTransferChangeAuth: "Access authorization changes — the new owner decides who can access, manage, or operate on the property.",
    permGuideTransferWhatStays: "What does NOT change?",
    permGuideTransferStayData: "All data remains intact — tapping records, context configurations, production history, nothing is lost.",
    permGuideTransferStayTeam: "The team stays linked — manager and operators keep their roles, but now under the new owner's management.",
    permGuideTransferStayConfig: "Property settings remain — clone, tapping system, tree density, everything stays the same.",
    permGuideTransferPlanWarningTitle: "Important: About the Plan",
    permGuideTransferPlanWarning: "On HeveaTalent, the OWNER's plan defines the access limits for EVERYONE working on that property. When you transfer a property, the new owner's plan takes over. Example: if the current owner has the Complete plan and transfers to someone with the Free plan, the team loses access to advanced features.",
    permGuideTransferSteps: "How the process works:",
    permGuideTransferStep1: "The transfer is requested through the platform administrator",
    permGuideTransferStep2: "The new owner's email is provided — if they don't have an account, one is created automatically",
    permGuideTransferStep3: "The property immediately transfers to the new owner with all data preserved",
    permGuideTransferStep4: "The new owner's plan now governs access for the entire linked team",
    permGuideTransferWhoCanTitle: "Who can transfer?",
    permGuideTransferWhoCan: "Currently, only the platform administrator can perform transfers. Contact us to request one.",
    permGuideTransferNote: "Summary: transfer = change who owns + who funds the plan for the team. Data and team remain.",
    permGuidePlansTitle: "Plans and Features",
    permGuideFree: "Free",
    permGuideFreeDesc: "90 days calendar access|1 property|1 job posting|No team management",
    permGuideProfessional: "Basic - R$ 30/mo",
    permGuideProfessionalDesc: "1 property|Team up to 5 people|Full calendar|45 days free trial",
    permGuideEnterprise: "Essential - R$ 60/mo",
    permGuideEnterpriseDesc: "3 properties|Team up to 10 people|Complete reports|45 days free trial",
    permGuideComplete: "Complete - R$ 120/mo",
    permGuideCompleteDesc: "Unlimited properties|Unlimited team|Everything unlimited|45 days free trial",
    
    // ========== CALENDAR USER GUIDE ==========
    calGuideTitle: "Bleeding Calendar Guide",
    calGuideQuickStart: "Quick Start",
    calGuideProperty: "Property",
    calGuideRecords: "Records",
    calGuideTeam: "Team",
    calGuideEthrel: "Ethrel",
    calGuideReports: "Reports",
    calGuideTips: "Tips",
    calGuideQuickStartTitle: "Quick Start",
    calGuideQuickStartDesc: "The Bleeding Calendar helps you control all latex production on your property.",
    calGuideFirstSteps: "First Steps:",
    calGuideStep1: "Select the property from the dropdown",
    calGuideStep2: "Choose the month/year you want to view",
    calGuideStep3: "Click on a day in the calendar to add a record",
    calGuideStep4: "Fill in the day's production data",
    calGuideStep5: "Save and repeat for other days",
    calGuideViews: "Available Views:",
    calGuideViewCalendar: "Calendar - Monthly view with visual indicators",
    calGuideViewTable: "Table - Detailed day-by-day list",
    calGuidePropertyTitle: "Setting Up the Property",
    calGuideHarvestMonth: "Important: Harvest Start Month",
    calGuideHarvestMonthDesc: "The rubber tree harvest normally runs from September to August. When registering your property, correctly define the start month so that accumulated reports reflect your actual harvest.",
    calGuidePropertyData: "Property Data:",
    calGuidePropertyName: "Name - Farm identification",
    calGuidePropertyLocation: "Location - City/State",
    calGuidePropertyAge: "Culture Age - Years of rubber trees",
    calGuidePropertyArea: "Total Area - Hectares (optional)",
    calGuidePropertyStartMonth: "Harvest Start Month - Usually September",
    
    // ========== PERMISSIONS MANAGEMENT UI ==========
    permMgmtTitle: "Manage Access",
    permMgmtSubtitle: "Define who can access this property",
    permMgmtOwner: "Owner",
    permMgmtOwnerYou: "(you)",
    permMgmtOwnerDesc: "Legal owner. Can transfer and set permissions.",
    permMgmtManager: "Manager",
    permMgmtManagerDesc: "Manages day-to-day, edits records and views reports.",
    permMgmtOperators: "Operators",
    permMgmtOperatorsDesc: "Insert daily production records.",
    permMgmtNoManager: "No manager assigned",
    permMgmtNoOperators: "No operators registered",
    permMgmtAddManager: "Set Manager",
    permMgmtAddOperator: "Add Operator",
    permMgmtRemove: "Remove",
    permMgmtPromote: "Promote to Manager",
    permMgmtDemote: "Demote to Operator",
    permMgmtEmailPlaceholder: "Enter person's email",
    permMgmtNamePlaceholder: "Name (optional)",
    permMgmtConfirmRemove: "Remove access from",
    permMgmtConfirmRemoveDesc: "This person will lose access to the property.",
    permMgmtSuccessAdded: "Person added successfully",
    permMgmtSuccessRemoved: "Access removed successfully",
    permMgmtSuccessUpdated: "Permissions updated",
    permMgmtErrorInvalidEmail: "Invalid email",
    permMgmtErrorSameUser: "Cannot add yourself",
    permMgmtErrorAlreadyAdded: "This person already has access",
    permMgmtNewAccountCreated: "Account created automatically",
    permMgmtTempPassword: "Temporary password",
    permMgmtShareCredentials: "Share these credentials with the person",
    permMgmtOnlyOwnerCanEdit: "Only the owner can edit permissions",
    permMgmtLoading: "Loading permissions...",
    permMgmtError: "Error loading permissions",
    permMgmtRetry: "Try again",
    
    // ========== LOGIN & REGISTER DIALOGS ==========
    doLogin: "Login",
    enterCredentials: "Enter your credentials",
    createAccount: "Create Account",
    registerOnPlatform: "Sign up on the platform",
    selectSpecialization: "Select specialization",
    other: "Others",
    
    // ========== LANDING PAGE EXTENDED ==========
    professionalsCadastrados: "+500 registered professionals",
    connectingProducersWorkers: "Connecting producers and workers across Brazil",
    whyUseHeveaTalent: "Why use HeveaTalent?",
    everythingYouNeed: "Everything you need to manage your production and team in one place",
    dailyControl: "Daily Control",
    dailyControlDesc: "Record bleedings, rain, fungicides and see automatic monthly summaries",
    evaluateTeam: "Evaluate your Team",
    evaluateTeamDesc: "Track worker performance with private evaluations",
    certifyTeam: "Certify your Team",
    certifyTeamDesc: "Quality seals Bronze, Silver and Gold based on technical evaluation",
    buyAndSell: "Buy and Sell",
    buyAndSellDesc: "Marketplace for supplies, tools and agricultural equipment",
    findWork: "Find Work",
    findWorkDesc: "Post jobs or find opportunities in rubber cultivation",
    shareExperiences: "Share Experiences",
    shareExperiencesDesc: "Active community to share tips and knowledge",
    startIn3Steps: "Start in 3 simple steps",
    freeToStart: "It's free to start and you can test all features",
    createFreeAccount: "Create your free account",
    quickSignup: "Quick signup as producer or professional",
    registerProperty: "Register your property",
    addFarms: "Add your farms and start organizing",
    startUsing: "Start using",
    registerBleedings: "Record bleedings, evaluate team, use marketplace",
    freeToStartBullet: "Free to start",
    noCreditCard: "No credit card required",
    cancelAnytime: "Cancel anytime",
    footerText: "The Brazilian rubber cultivation platform",
    tripeBased: "Based on the Tripod: Fairness • Security • Simplicity",
    
    // ========== DASHBOARD NAVIGATION ==========
    newAd: "New Ad",
    searchProfessionals: "Search Professionals",
    quickActions: "Quick Actions",
    bleedingToday: "Bleeding Today",
    publishJobBtn: "Publish Job",
    myJobsPublished: "My Jobs",
    myPublishedJobs: "My Published Jobs",
    seeExample: "See Example",
    seeExampleTip: "See Example Tip",
    publishing: "Publishing...",
    findQualifiedProfessionals: "Find qualified professionals for your needs",
    noProfessionalsAvailable: "No professional offers available at the moment",
    noJobsPublished: "You haven't published any jobs yet",
    searchJobsBtn: "Search Jobs",
    offerServices: "Offer Services",
    myOffers: "My Offers",
    availableJobs: "Available Jobs",
    findOpportunities: "Find job opportunities in rubber cultivation",
    noJobsAvailable: "No jobs available at the moment",
    myServiceOffers: "My Service Offers",
    noOffersYet: "You haven't published any service offers yet",
    
    // ========== PLANS SECTION ==========
    loadingPlans: "Loading plans...",
    plansDescProfessional: "Affordable plans for rubber cultivation professionals. Full features in the free plan!",
    plansDescEmployer: "Robust plans for property owners and companies. Manage your properties, teams and operations.",
    activateFree: "Activate Free",
    choosePlan: "Choose Plan",
    savingsPercent: "Save",
    perMonth: "/month",
    perYear: "Yearly",
    individualItems: "Individual Items",
    buyExtrasWithoutChangingPlan: "Buy extra resources without changing your plan",
    adHighlight: "Ad Highlight",
    adHighlightDesc: "Your ad appears at the top of listings for 7 days",
    moreVisibility: "More visibility",
    highlightBadge: "Highlight badge",
    validFor7Days: "Valid for 7 days",
    buyHighlightBtn: "Buy Highlight",
    extraAdJobBoard: "Extra Ad - Job Board",
    extraAdJobBoardDesc: "1 additional job posting for 30 days",
    validFor30Days: "Valid for 30 days",
    noChangeToPlan: "No change to your plan",
    immediateUse: "Immediate use",
    buyAdBtn: "Buy Ad",
    extraAdMarketplace: "Extra Ad - Marketplace",
    extraAdMarketplaceDesc: "1 additional marketplace ad for 30 days",
    paymentViaPix: "Payment via PIX • Immediate activation after confirmation",
    tipAnnualSavings: "Tip: Save with the annual plan",
    comingSoon: "Coming soon! Payment integration pending.",
    
    // ========== COMMUNITY SECTION ==========
    loadingCommunityTips: "Loading community tips...",
    communityTipsTitle: "Community Tips",
    communityTipsSubtitle: "Share knowledge and learn from other professionals",
    filterByCategory: "Filter by category",
    allCategories: "All categories",
    categoryBleeding: "Bleeding",
    categoryDiseases: "Diseases",
    categoryIdeas: "Ideas",
    categoryMarket: "Rubber Market",
    categoryNews: "News",
    categoryWeather: "Weather",
    categoryOthers: "Others",
    exampleBadge: "Example",
    likes: "likes",
    comments: "comments",
    by: "By",
    errorLikeTip: "Error liking the tip",
    commentPrompt: "Comment on",
    errorCommentTip: "Error commenting",
    shareATip: "Share a tip",
    noTipsFound: "No tips found for this category",
    
    // ========== MARKETPLACE SECTION ==========
    browseProducts: "Browse Products",
    sellProduct: "Sell Product",
    myAds: "My Ads",
    myAdvertisedProducts: "My Advertised Products",
    noProductsYet: "You don't have any products advertised yet",
    allProducts: "All Products",
    properties: "Properties",
    equipment: "Equipment",
    supplies: "Supplies",
    services: "Services",
    searchInMarketplace: "Search in marketplace...",
    noProductsFound: "No products found",
    
    // ========== CALENDAR SECTION ==========
    trialExpiredTitle: "Trial Period Expired",
    trialExpiredDataSaved: "Your data is saved and will be recovered after the upgrade.",
    viewPlansFrom: "View Plans - Starting from",
    month: "month",
    lastDayOfTrial: "LAST DAY OF TRIAL!",
    lastDayTrialMsg: "Your Calendar access expires tomorrow. Upgrade now to keep access.",
    upgradeNow: "Upgrade Now",
    trialEndingSoon: "Trial ending soon!",
    daysRemaining: "days remaining",
    trialExpiresIn: "Your trial period expires in",
    days: "days",
    seeUpgradeOptions: "See upgrade options",
    trialEnding30Days: "Active trial period",
    trialEnding30DaysMsg: "You still have",
    daysToExplore: "days to explore all features.",
    bleedingCalendar: "Bleeding Calendar",
    calendarSubtitle: "Record and track your daily bleedings",
    selectProperty: "Select Property",
    addProperty: "Add Property",
    newProperty: "New Property",
    propertyName: "Property Name",
    propertyNamePlaceholder: "Ex: São João Farm",
    numberOfTrees: "Number of Trees",
    createProperty: "Create Property",
    loading: "Loading...",
    monthlySummary: "Monthly Summary",
    bleedingDays: "Bleeding Days",
    rainDays: "Rain Days",
    fungicideDays: "Fungicide Applications",
    viewCalendar: "View Calendar",
    viewTable: "View Table",
    addFirstProperty: "Add a Property",
    noPropertyMsg: "Register your first property to start using the bleeding calendar.",
    addPropertyBtn: "Add Property",
    startFreeTrial: "Start Free Trial",
    contentBlocked: "Content blocked. Upgrade to continue.",
    property: "Property",
    years: "years",
    monthYear: "Month/Year",
    previousMonth: "Previous month",
    nextMonth: "Next month",
    location: "Location",
    totalRain: "Total Rain",
    totalProduction: "Total Production",
    totalReplacements: "Total Replacements",
    totalReplacement: "Total Replacement",
    yearlyAccumulatedSummary: "Accumulated Summary",
    ethrelApplications: "Ethrel Applications",
    fungicideApplications: "Fungicide Applications",
    totalLosses: "Total Losses",
    totalRecords: "Total Records",
    monthlyBreakdown: "Monthly Breakdown",
    ethrelControl: "Ethrel Control",
    configureInterval: "Configure application interval",
    todaysActivities: "Today's Activities",
    manageActivitiesDesc: "Manage your daily rubber cultivation activities",
    bleeding: "Bleeding",
    bleedingDesc: "Bleeding performed today",
    production: "Production",
    productionCollection: "Production Collection",
    productionCollectionDesc: "Latex collected/weighed today",
    generalApplications: "General Applications",
    generalApplicationsDesc: "Products applied today (fungicides, ethrel, coagulant, herbicides, fertilizers)",
    management: "Management",
    daily: "Daily",
    periodic: "Periodic",
    sporadic: "Sporadic",
    completed: "Completed!",
    pending: "Pending",
    notNeededToday: "Not needed today",
    dailyGoal: "Daily goal",
    whenNeeded: "When needed",
    noActivitiesYet: "No activities yet. Create your first bleeding activity!",
    addActivity: "Add Activity",
    dayProgress: "Day progress:",
    essentials: "essentials",
    extra: "extra",
    extras: "extras",
    of: "of",
    
    // ========== FORMS ==========
    publishNewJob: "Publish New Job",
    registerNewJobOpp: "Register a new job opportunity",
    jobTitle: "Job Title",
    salaryRange: "Salary Range",
    salaryRangePlaceholder: "Ex: $2,000 - $3,000",
    jobType: "Job Type",
    fullTime: "Full Time",
    partTime: "Part Time",
    contract: "Contract",
    seasonal: "Seasonal",
    jobDescription: "Job Description",
    requirements: "Requirements",
    publishJob: "Publish Job",
    jobPublishedSuccess: "Job published successfully!",
    errorPublishingJob: "Error publishing job",
    needLoginToPublish: "You need to login to publish jobs",
    considerUpgrade: "Consider upgrading your plan in the Plans tab.",
    
    // ========== WORK OFFER FORM ==========
    createWorkOffer: "Create Work Offer",
    offerServicesToEmployers: "Offer your services to employers",
    offerTitle: "Offer Title",
    availableLocations: "Available Locations",
    expectedSalary: "Expected Salary",
    expectedSalaryPlaceholder: "Ex: $2,500",
    availability: "Availability",
    immediate: "Immediate",
    oneMonth: "1 month",
    twoMonths: "2 months",
    threeMonths: "3 months",
    serviceDescription: "Service Description",
    skillsAndExperience: "Skills and Experience",
    createOffer: "Create Offer",
    creating: "Creating...",
    workOfferCreatedSuccess: "Work offer created successfully!",
    errorCreatingOffer: "Error creating offer",
    needLoginToOffer: "You need to login to offer work",
    
    // ========== MARKETPLACE FORM ==========
    advertiseProduct: "Advertise Product",
    registerProductForSale: "Register a product or service for sale",
    productName: "Product Name",
    category: "Category",
    price: "Price",
    pricePlaceholder: "Ex: $150.00",
    condition: "Condition",
    conditionNew: "New",
    conditionUsed: "Used",
    conditionRefurbished: "Refurbished",
    productDescription: "Product Description",
    contactInfo: "Contact Information",
    advertise: "Advertise",
    productRegisteredSuccess: "Product registered successfully!",
    errorRegisteringProduct: "Error registering product",
    needLoginToSell: "You need to login to sell products",
    selectCategory: "Select category",
    pesticides: "Agricultural Pesticides",
    machinery: "Machinery",
    semiNew: "Semi-new",
    fullLocation: "Full Location",
    locationPlaceholder: "Ex: Santa Rita Farm, Km 15, Rural Area",
    
    // ========== EVALUATIONS DASHBOARD ==========
    technicalEvaluationSystem: "Technical Evaluation System",
    heveaTalentCertification: "HeveaTalent Certification based on official technical literature",
    overview: "Overview",
    myProfile: "My Profile",
    createEvaluation: "Create Evaluation",
    myProfessionalProfile: "My Professional Profile",
    viewCertificationSeals: "View certification and seals",
    accessDashboard: "Access Dashboard",
    aboutTheSystem: "About the System",
    howEvaluationWorks: "How the evaluation works",
    bronze: "Bronze",
    silver: "Silver",
    gold: "Gold",
    points: "points",
    technicalCriteria: "Technical Criteria",
    senarEmbrapaIncaperStandards: "Official technical standards (INCAPER/CATI)",
    bleedingTechnique: "Bleeding Technique",
    harvestPreparation: "Harvest Preparation",
    dailyMaintenance: "Daily Maintenance",
    chemicalApplications: "Chemical Applications",
    educationalFeedback: "Educational Feedback",
    improveContinuously: "Improve continuously",
    personalizedRecommendations: "Check the tooltips (ⓘ) on each criterion for practical tips based on official documents.",
    viewTechnicalReferences: "View Technical References",
    viewFullProfile: "View your Full Profile",
    accessDashboardToSee: "Access your dashboard to see certification, score and detailed feedback",
    openMyDashboard: "Open My Dashboard",
    createNewEvaluation: "Create New Evaluation",
    selectWorkerToEvaluate: "Select a worker from your team to evaluate",
    startEvaluation: "Start Evaluation",
    
    // ========== PERFORMANCE DASHBOARD ==========
    contextualPerformance: "Contextual Performance",
    contextualPerformanceSubtitle: "Fair evaluation based on property context",
    selectPropertyToView: "Select a property to view performance",
    performanceHistory: "Performance History",
    monthlyPerformance: "Monthly Performance",
    currentPerformance: "Current Performance",
    qualitySeals: "Quality Seals",
    configureContext: "Configure Context",
    referenceData: "Reference Data",
    cloneTypes: "Clone Types",
    tappingSystems: "Tapping Systems",
    seasonalCoefficients: "Seasonal Coefficients",
    noDataAvailable: "No data available",
    errorLoadingData: "Error loading data",
    
    // ========== COMMON ACTIONS & MESSAGES ==========
    saving: "Saving...",
    save: "Save",
    update: "Update",
    edit: "Edit",
    delete: "Delete",
    remove: "Remove",
    add: "Add",
    send: "Send",
    sending: "Sending...",
    cancel: "Cancel",
    close: "Close",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    previous: "Previous",
    search: "Search",
    filter: "Filter",
    clear: "Clear",
    reset: "Reset",
    submit: "Submit",
    saveChanges: "Save Changes",
    
    // ========== ERROR MESSAGES ==========
    errorSendingEvaluation: "Error sending evaluation",
    errorPublishingJob: "Error publishing job",
    errorCreatingOffer: "Error creating offer",
    errorDeletingJob: "Error deleting job",
    errorDeactivatingJob: "Error deactivating job",
    errorDeletingOffer: "Error deleting offer",
    errorDeactivatingOffer: "Error deactivating offer",
    errorAddingComment: "Error adding comment",
    errorSharingTip: "Error sharing tip. Please try again.",
    errorProcessingSubscription: "Error processing subscription",
    errorSearchingProfessionals: "Error searching professionals",
    errorRemovingAd: "Error removing ad",
    errorCreatingPixPayment: "Error creating PIX payment",
    errorCheckingPaymentStatus: "Error checking payment status",
    errorSavingRecord: "Error saving record",
    errorAddingImage: "Error adding image",
    errorLoadingFile: "Error loading file",
    errorUpdatingProduct: "Error updating product",
    errorDeletingRecord: "Error deleting record",
    
    // ========== CALENDAR SPECIFIC ==========
    newRecord: "New Record",
    editRecord: "Edit Record",
    day: "Day",
    addDataForThisDay: "Add data for this day",
    editRecordTitle: "Edit record",
    deleteRecordTitle: "Delete record",
    onlyNumbers: "Numbers only",
    additionalInfo: "Additional information about the property",
    mobileFriendlyTip: "Mobile-Friendly",
    clickAddButton: "Click the button",
    toOpenFullForm: "to open the full form",
    useEditButton: "Use",
    toModifyRecords: "to modify existing records",
    uploadingFiles: "Uploading",
    addByUrl: "Or Add by URL",
    previousImage: "Previous image",
    nextImage: "Next image",
    
    // ========== MARKETPLACE SPECIFIC ==========
    noProductsAvailableNow: "No products available at the moment",
    noProductsInCategory: "No products in this category",
    publishAd: "Publish Ad",
    editProduct: "Edit Product",
    sendEvaluation: "Send Evaluation",
    
    // ========== PROFESSIONAL RUBBER CULTIVATION ==========
    professionalRubberCultivation: "Professional rubber cultivation",
    
    // ========== CURRENT PLAN BANNER ==========
    growWithHeveaTalent: "Grow with HeveaTalent",
    discoverPlansAndResources: "Discover available plans and resources",
    personalCalendarHistory: "Personal calendar, production history",
    advancedFeaturesUnlocked: "Advanced features unlocked",
    
    // ========== MARKET MODULE ==========
    // Navigation & Headers
    marketModule: "Market",
    marketAnalysis: "Market Analysis",
    quotations: "Quotations",
    calculator: "Calculator",
    sources: "Sources",
    dataStatus: "Status",
    glossary: "Glossary",
    
    // Main Headers
    marketSummary: "Market Summary",
    priceReferences: "Price References",
    scenarioSimulator: "Scenario Simulator",
    valueComparison: "Value Comparison",
    implicitParticipationRate: "Implicit Participation Rate",
    
    // References
    geb10Apabor: "GEB-10 APABOR",
    geb10MarketSP: "GEB-10 SP Market",
    importPriceIEA: "Import Price (IEA)",
    coagulum: "Coagulum",
    coagulumProducer: "Coagulum (Producer)",
    productionCost: "Production Cost",
    exchangeRate: "Exchange Rate",
    dollar: "Dollar",
    international: "International",
    
    // Labels & Tags
    reference: "REFERENCE",
    realPrice: "REAL PRICE",
    adoptedByMills: "ADOPTED BY MILLS",
    importParity: "IMPORT PARITY",
    spotPrice: "SPOT PRICE",
    currentMarket: "Market",
    
    // Units
    perKg: "per kg",
    drc: "DRC",
    participationRate: "Participation Rate",
    
    // Tooltips & Help
    understand: "Understand",
    howItWorks: "How It Works",
    howDataWorks: "How the Data on This Page Works",
    mainData: "The 2 main data points",
    contextData: "Context Data",
    howToUpdate: "How data is updated",
    
    // Data Descriptions
    geb10Description: "Bimonthly reference price calculated from international price + exchange rate + import costs.",
    importPriceDescription: "TOTAL cost to import processed rubber. Includes: international price + exchange rate + freight + insurance + taxes (~10.8%) + port costs.",
    geb10MarketDescription: "Actual price practiced in São Paulo physical market transactions.",
    coagulumDescription: "Actual price paid to producer in the market.",
    
    // Update Frequencies
    bimonthly: "Bimonthly",
    monthly: "Monthly",
    daily: "Daily",
    annual: "Annual",
    automatic: "Automatic",
    manual: "Manual",
    impliedParticipationRate: "Implied Participation Rate",
    timesPerYear: "times/year",
    
    // Status
    current: "Current",
    previousPeriod: "Previous period",
    checkNewPeriod: "Check new period",
    
    // Actions
    update: "Update",
    updateData: "Update Data",
    updateExchangeRate: "Update Exchange Rate",
    save: "Save",
    calculate: "Calculate",
    reset: "Reset",
    expand: "Expand",
    collapse: "Collapse",
    
    // Calculator
    officialFormula: "Official Formula (CNA/FAESP/IEA)",
    producerPrice: "Producer Price",
    preview: "Preview",
    calculatePrice: "Calculate Price",
    calculatedResult: "Calculated Result",
    
    // Margin Analysis
    marginAnalysis: "Margin Analysis",
    marginOnProductionCost: "Margin on Production Cost",
    profit: "Profit",
    loss: "Loss",
    
    // References Comparison
    referencesComparison: "References and Rates Comparison",
    minCNA: "Min CNA",
    refIEA: "Ref IEA",
    
    // Guide Steps
    welcomeToGuide: "Welcome to the Price Guide",
    priceChain: "The Price Chain",
    priceReference: "The Price Reference",
    whatIsDRC: "What is DRC?",
    participationRateExplained: "The Participation Rate",
    completeFormula: "The Complete Formula",
    productionCostAnalysis: "Production Cost",
    negotiationTips: "Negotiation Tips",
    summary: "Summary",
    
    // Guide Content
    guideWelcomeText: "This guide will help you understand how the coagulum price is formed and how to negotiate better.",
    
    // Price Chain
    internationalPrice: "International Price (SGX)",
    conversionAndCosts: "Conversion + Import Costs",
    nationalReferencePrice: "National Reference Price",
    producerFormula: "Producer Formula",
    yourPrice: "Your Price",
    
    // Disclaimers
    officialSourcesDisclaimer: "References from official sources (IEA, APABOR, CONAB). For negotiations, consult your cooperative.",
    dataFromOfficialSources: "Data comes from official sources: IEA, APABOR, CONAB, BCB",
    
    // Footer
    tripodJustice: "JUSTICE: Transparent calculations",
    tripodSecurity: "SECURITY: Official sources",
    tripodSimplicity: "SIMPLICITY: Clear information",
    developedBasedOn: "Content developed based on studies from CNA, FAESP, IEA/SAA-SP and CONAB.",
    lastUpdate: "Last update",
    
    // Publication Calendar
    publicationCalendar: "Publication Calendar",
    nextPublication: "Next publication",
    verify: "Verify",
    
    // Mandatory/Optional
    mandatoryUpdates: "MANDATORY Updates (for calculations)",
    automaticUpdates: "AUTOMATIC Update",
    optionalUpdates: "Optional (context)",
    
    // Analysis
    relationBetweenReferences: "Relationship between references",
    maxCost: "Maximum cost (if industry imported)",
    negotiationReference: "Reference for negotiation between mills and producers",
    realTransactionPrice: "Actual transaction price",
    
    // Why different values
    whyDifferentValues: "Why are the values different?",
    sameFormulaDifferentRef: "The same formula generates different values depending on the reference used.",
    
    // ========== MARKET MODULE INDEX ==========
    understandRubberMarket: "Understand the Rubber Market",
    marketInfoForDecision: "Market information for decision making.",
    viewCompleteGuide: "View Complete Guide",
    new: "NEW",
    yourDataPrivateProtected: "Your data is private and protected",
    importantWarning: "Important Warning",
    educationalContentDisclaimer: "This content is educational, based on official sources (IEA, APABOR, CNA, CONAB). The prices and methodologies presented are references - always consult your cooperative or mill for specific negotiations.",
    viewUserGuide: "View User Guide",
    december: "December",
    
    // Glossary terms
    glossaryGEB10: "Brazilian Dark Granulated - Processed natural rubber, classification 10",
    glossaryDRC: "Dry Rubber Content - Dry rubber content in the coagulum",
    glossaryCoagulum: "Coagulated latex before processing",
    glossaryParticipationRate: "Percentage of the reference price passed to the producer",
    
    // ========== OFFICIAL SOURCES ==========
    heveaTalentQuotations: "HeveaTalent Quotations",
    howPriceIsFormed: "How the Price is Formed",
    understandWhereDataComesFrom: "Understand where each number comes from. Click to verify in official sources.",
    verifySource: "Verify source",
    priceFormulaProducer: "Producer Price Formula",
    priceFormulaExample: "Example (Aug/26): R$ 16.37 × 53% × 70% = R$ 6.07/kg",
    lastVerification: "Last verification",
    importPrice: "Import Price",
    geb10Label: "GEB-10",
    coaguloLabel: "Coagulum",
    internationalLabel: "International",
    geb10ApabarMainRef: "GEB-10 APABOR - Main Reference",
    geb10ApabarDesc: "Internalized price (International + Exchange + Costs). Bimonthly publication.",
    coaguloIeaProducerPrice: "Coagulum IEA - Producer Price",
    coaguloIeaDesc: "Actual value transacted at origin. DRC 53% base.",
    productionCostConab: "Production Cost - CONAB",
    productionCostConabDesc: "Production cost to calculate producer margin.",
    dataVerifiableOfficial: "Data from verifiable official sources",
    youCheckBeforeUsing: "You verify before using",
    onlyWhatMatters: "Only what matters",
    
    // ========== USER GUIDE ==========
    welcomeGuideTitle: "Welcome to the Price Guide",
    guideIntroText: "This guide will teach you how natural rubber pricing works and how to use the calculator to negotiate better.",
    officialDataSources: "Data from official sources (IEA, CNA, APABOR)",
    dataNotShared: "Your data is not shared",
    easyToUnderstandUse: "Easy to understand and use",
    priceFormationChain: "The Price Formation Chain",
    pricePassesThroughSteps: "The price you receive goes through several steps from the international quotation:",
    internationalPriceSGX: "International Price (SGX)",
    sgxQuotation: "Singapore quotation",
    conversionImportCosts: "Conversion + Import Costs",
    exchangeFreightTaxes: "Exchange + freight + taxes + costs",
    nationalRefPrice: "National Reference Price",
    producerFormula: "Producer Formula",
    yourPriceCoagulum: "Your Price (Coagulum)",
    valueYouReceive: "The value you receive",
    priceReferenceTitle: "The Reference Price",
    officialReferencesCalc: "The coagulum price is calculated based on an official reference.",
    mainMarketReferences: "The main market references:",
    adoptedByMills: "ADOPTED BY MILLS",
    internalizedPrice: "Internalized price (International + Exchange + Costs)",
    mostUsedReference: "Most used reference (NB Borracha, São Manoel, Hevea-Tec, etc.)",
    bimonthlyPublication: "Publication: Bimonthly (Dec/Jan, Feb/Mar...)",
    importParity: "IMPORT PARITY",
    totalCostImport: "TOTAL cost to import processed rubber (GEB-10)",
    includesFreightTaxes: "Includes: international price + exchange + freight + taxes (~10.8%) + costs",
    monthlyPublicationDays: "Publication: Monthly (days 15-20)",
    spotPrice: "SPOT PRICE",
    spMarketPracticed: "Price practiced in São Paulo market",
    monthlyPublication: "Publication: Monthly",
    whyGeb10Reference: "Why is GEB-10 APABOR the market reference?",
    geb10MarketExplanation: "It is the reference adopted by the main processing mills (NB Borracha, São Manoel, Hevea-Tec, etc.). It allows you to compare your price directly with what the market practices.",
    whatIsDrcTitle: "DRC - Dry Rubber Content",
    whatIsDrcExplanation: "It's the percentage of dry rubber in your coagulum. The DRIER, the HIGHER the DRC and BETTER the price.",
    howItWorksLabel: "How it works:",
    coagulumMuchWater: "Coagulum with too much water",
    lowDrc: "Low DRC",
    wellDriedCoagulum: "Well-dried coagulum",
    highDrc: "High DRC",
    mayBeRejected: "May be rejected",
    minimumAccepted: "Minimum accepted",
    goodExcellent: "Good / Excellent",
    excellent: "Excellent",
    drcTip: "Each 1% more in DRC can mean R$ 0.10-0.15/kg more in your pocket!",
    participationRateTitle: "Participation Rate",
    participationRateExplanation: "It's the percentage of the reference value you receive. The HIGHER the rate, the MORE money in your pocket.",
    rateBands: "Rate Bands:",
    veryLow: "Very low",
    minCna: "CNA minimum",
    good: "Good",
    ieaReference: "IEA Reference",
    excellentRate: "Excellent",
    minRecommendedCna: "The 52% rate is the MINIMUM recommended by CNA. IEA uses 80% in its official calculations!",
    howToGetBetterRates: "How to get better rates:",
    deliverLargerVolume: "Deliver larger volume",
    maintainRegularFrequency: "Maintain regular frequency",
    guaranteeQuality: "Guarantee quality (high DRC)",
    longTermContracts: "Make long-term contracts",
    negotiateInGroup: "Negotiate in group/cooperative",
    completeFormulaTitle: "The Complete Formula",
    coagulumPriceFormula: "Coagulum Price = Reference × (DRC/100) × (Rate/100)",
    comparativeWithReferences: "Comparison with the 3 market references (DRC 53%):",
    bimonthlyRefPrice: "Bimonthly reference price calculated from international price + exchange + import costs.",
    totalCostImportGeb: "Total cost to import processed rubber (GEB-10). Includes freight, taxes and all costs.",
    realTransactionPriceSP: "Real price practiced in São Paulo physical market transactions.",
    relationBetweenRef: "Relationship between references:",
    maxCostIfImported: "Maximum cost (if industry imported)",
    refNegotiationMills: "Reference for negotiation between mills and producers",
    realTransactionPriceLabel: "Real transaction price",
    understandDifference: "Understand the difference",
    millsAdoptGeb10: "Mills adopt GEB-10 APABOR to negotiate with producers. The IEA Import Price serves as a \"parity\" reference - what the national coagulum would be worth if it competed directly with imported.",
    productionCostTitle: "Production Cost",
    priceCoversCoststQuestion: "Does your price cover costs?",
    profitNeedsHigherPrice: "To make a profit, the price you receive needs to be HIGHER than your production cost.",
    operationalEffectiveCost: "Effective Operational Cost",
    directCostsCOE: "Direct costs (COE)",
    totalOperationalCost: "Total Operational Cost",
    includesProLabore: "Includes pro-labore (COT)",
    marginAnalysisGeb10: "Margin Analysis (GEB-10 APABOR R$ 11.31):",
    scenario: "Scenario",
    marginVsCOT: "Margin (vs COT)",
    marketAnalysis: "Analysis:",
    currentMarketAnalysis: "With current market prices (GEB-10 R$ 11.31 and rate ~72%), the coagulum price (R$ 4.30) is below production cost (R$ 6.07). This is the current market reality.",
    officialSourcesTitle: "Official Sources",
    verifiableData: "Verifiable data",
    allDataFromOfficialSources: "All data from this calculator comes from official sources you can consult.",
    dailyQuotes: "daily",
    searchOnSite: "Search for \"natural rubber\" on the site",
    technicalBulletins: "Technical bulletins and sector news",
    someContentForMembers: "Some content for members only",
    dailyCoagulumQuotation: "Daily coagulum quotation",
    internationalPriceSGXRealTime: "International SGX price (real-time)",
    negotiationTipsTitle: "Negotiation Tips",
    knowledgeIsPower: "Knowledge is power!",
    useKnowledgeToNegotiate: "Now that you understand how the price is formed, use this knowledge to negotiate better.",
    confirmMillReference: "Confirm which reference the mill uses",
    mostUseMills: "Most use GEB-10 APABOR. Compare with this calculator's values.",
    askCalculationInWriting: "Ask for calculation in writing",
    demandTransparency: "Demand transparency: GEB-10 × DRC × Rate = your price",
    improveYourDRC: "Improve your DRC",
    avoidMoisture: "Avoid moisture in coagulum. Each 1% is worth R$ 0.10-0.15/kg",
    negotiateRate: "Negotiate the participation rate",
    minIdealRate: "Minimum 52%, ideal 70-80%. Volume and quality justify better rates",
    useThisCalculator: "Use this calculator",
    checkPriceFormula: "Check if the offered price matches the official formula",
    congratulations: "Congratulations!",
    readyToNegotiate: "Now you're ready to negotiate fairly and informedly!",
    stepOf: "Step {current} of {total}",
    previous: "Previous",
    next: "Next",
    startUsing: "Start using!",
    
    // ========== GLOSSARY ==========
    rubberMarketGlossary: "Rubber Market Glossary",
    understandTechnicalTerms: "Understand the technical terms used in the natural rubber market.",
    starTermsImportant: "Terms with ⭐ are the most important to understand price formation.",
    searchTermPlaceholder: "Search term... (e.g.: geb 10, drc, price)",
    termsFound: "{count} term(s) found",
    forSearch: "for \"{term}\"",
    noTermsFound: "No terms found for \"{term}\"",
    tryOtherWord: "Try searching for another word or clear the filter",
    glossaryTip: "Terms with ⭐ are essential to understand how the price is formed.",
    startWithTerms: "Start with them:",
    categoryProduct: "Product",
    categoryQuality: "Quality",
    categoryProduction: "Production",
    categoryChain: "Chain",
    categoryPrice: "Price",
    categoryInstitution: "Institution",
    categoryTax: "Tax",
    allCategories: "All",
    tip: "Tip",
    
    // ========== ADMIN PANEL ==========
    updateQuotationsTitle: "Update Quotations",
    updateValuesFromSources: "Update values by consulting official sources. Data will be saved in the system.",
    importPriceIEA: "Import Price (IEA)",
    geb10Apabor: "GEB-10 APABOR",
    coaguloDRC53: "Coagulum DRC 53%",
    smr20International: "SMR20 International",
    dollarExchange: "Dollar (Exchange)",
    valueLabel: "Value",
    referenceDateLabel: "Reference Date",
    referenceDatePlaceholder: "E.g.: Dec/2025",
    savingLabel: "Saving...",
    saveLabel: "Save",
    updatedSuccessfully: "updated successfully!",
    errorSavingTryAgain: "Error saving. Please try again.",
    connectionErrorTryAgain: "Connection error. Please try again.",
    consultSourcesLabel: "Consult Sources:",
    loadingLabel: "Loading...",
    
    // ========== SUPPLY CHAIN ==========
    supplyChainTitle: "The Natural Rubber Supply Chain",
    supplyChainDescription: "Understand how rubber goes from the rubber tree to the final consumer. Each link in the chain adds value to the product.",
    detailsOfEachStep: "Details of Each Step",
    importantData: "Important Data",
    referenceLabel: "Reference",
    tapperHeveicultor: "Tapper/Heveicultor",
    tapperDescription: "Extracts latex from the rubber tree through tapping",
    tapperProduct: "Latex / Coagulum",
    tapperDetail1: "Performs tree tapping",
    tapperDetail2: "Collects latex",
    tapperDetail3: "Coagulates latex (adds acid)",
    tapperDetail4: "Sells coagulum to processor",
    coagulumPriceRef: "Coagulum Price (R$/kg)",
    processorMill: "Processor/Mill",
    processorDescription: "Processes coagulum and transforms into processed rubber",
    processorProduct: "GEB-10 (Brazilian Dark Granulated)",
    processorDetail1: "Buys coagulum from producers",
    processorDetail2: "Processes and cleans material",
    processorDetail3: "Dries and granulates rubber",
    processorDetail4: "Produces GEB-10 (100% rubber)",
    geb10PriceRef: "GEB-10 Price (R$/kg)",
    tireIndustry: "Tire Industry",
    tireIndustryDescription: "Manufactures tires and rubber products",
    tireIndustryProduct: "Tires and derivatives",
    tireIndustryDetail1: "Buys GEB-10 from processors",
    tireIndustryDetail2: "Mixes with other components",
    tireIndustryDetail3: "Manufactures tires and products",
    tireIndustryDetail4: "Consumes ~70% of national rubber",
    industrialPriceRef: "Industrial Price",
    finalConsumer: "Final Consumer",
    finalConsumerDescription: "Uses final products",
    finalConsumerProduct: "Vehicles, equipment",
    finalConsumerDetail1: "Buys vehicles with tires",
    finalConsumerDetail2: "Replaces tires periodically",
    finalConsumerDetail3: "Uses rubber products",
    consumerPriceRef: "Consumer Price",
    nationalProductionConsumed: "of national production is consumed by tire industry",
    saoPauloConcentrates: "concentrates ~70% of national coagulum production",
    domesticConsumptionImported: "of domestic consumption is supplied by imports",
    sourceLabel: "Source",
    
    // ========== WHAT IS TBS ==========
    whatIsTbsTitle: "What is TBS (Dry Rubber Content)?",
    tbsExplanation: "is the percentage of dry rubber present in coagulum or latex.",
    tbsExplanation2: "In other words: how much of the material you're selling is actually rubber (not water or impurities).",
    practicalExample: "Practical Example",
    practicalExampleText: "If you have 100 kg of coagulum with 53% TBS:",
    dryRubberValue: "is dry rubber (what has value)",
    waterMoisture: "is water/moisture",
    whyItMatters: "Why does this matter?",
    whyItMattersText: "The price you receive is calculated based on TBS. The higher the TBS, the higher your product's value.",
    standardReference: "Standard reference",
    howTbsAffectsPayment: "How TBS Affects Your Payment",
    priceAdjustedByTbs: "The coagulum price is adjusted proportionally to TBS, using 53% as reference:",
    adjustedPrice: "Adjusted Price",
    basePrice: "Base Price",
    yourTbs: "Your TBS",
    factor: "Factor",
    situation: "Situation",
    aboveReference: "Above reference",
    standardReferenceLabel: "Standard reference",
    belowReference: "Below reference",
    tbsTip: "The drier the coagulum before selling, the higher your TBS and better your price. Avoid excess moisture!",
    tbsCalculator: "TBS Calculator",
    tbsCalculatorDesc: "Calculate your coagulum's TBS. You need to weigh a sample before and after drying.",
    wetWeight: "Wet Weight (kg)",
    wetWeightHint: "Sample weight before drying",
    dryWeight: "Dry Weight (kg)",
    dryWeightHint: "Weight after complete drying",
    calculateTbs: "Calculate TBS",
    clear: "Clear",
    yourCalculatedTbs: "Your calculated TBS:",
    aboveOrEqualReference: "Above or equal to reference (53%)",
    belowReferenceWarning: "Below reference (53%)",
    tbsNote: "This is an estimate. Official TBS is determined in laboratory by the mill/processor at time of purchase.",
    
    // ========== USER GUIDE ==========
    welcomeToPriceGuide: "Welcome to the Price Guide",
    guideIntro: "This guide will teach you how natural rubber pricing works and how to use the calculator to negotiate better.",
    priceFormationChainTitle: "The Price Formation Chain",
    priceChainIntro: "The price you receive goes through several steps from the international quotation:",
    internationalPriceStep: "International Price (SGX)",
    sgxQuotationLabel: "Singapore quotation",
    conversionImportCostsStep: "Conversion + Import Costs",
    exchangeFreightTaxesLabel: "Exchange + freight + taxes + costs",
    nationalReferencePriceStep: "National Reference Price",
    producerFormulaStep: "Producer Formula",
    yourPriceCoagulumStep: "Your Price (Coagulum)",
    valueYouReceiveLabel: "The value you receive",
    priceReferenceGuideTitle: "The Reference Price",
    officialReferencesTitle: "Official References",
    officialReferencesDesc: "The coagulum price is calculated based on an official reference. Learn about the main sources used in the Brazilian market.",
    mainMarketReferencesTitle: "The main market references:",
    adoptedByMillsLabel: "ADOPTED BY MILLS",
    internalizedPriceLabel: "Internalized price (International + Exchange + Costs)",
    mostUsedReferenceLabel: "Most used reference (NB Borracha, São Manoel, Hevea-Tec, etc.)",
    bimonthlyPublicationLabel: "Publication: Bimonthly (Dec/Jan, Feb/Mar...)",
    importParityLabel: "IMPORT PARITY",
    totalCostToImportLabel: "TOTAL cost to import processed rubber (GEB-10)",
    includesFreightTaxesLabel: "Includes: international price + exchange + freight + taxes (~10.8%) + costs",
    monthlyPublicationLabel: "Publication: Monthly (days 15-20)",
    spotPriceLabel: "SPOT PRICE",
    spMarketPracticedLabel: "Price practiced in São Paulo market",
    monthlyPublicationSimpleLabel: "Publication: Monthly",
    whyGeb10ReferenceTitle: "Why is GEB-10 APABOR the market reference?",
    whyGeb10ReferenceExplanation: "It's the reference adopted by major processing mills (NB Borracha, São Manoel, Hevea-Tec, etc.). It allows you to compare your price directly with what the market practices.",
    drcGuideTitle: "DRC - Dry Rubber Content",
    whatIsDrcGuide: "What is DRC?",
    whatIsDrcExplanation: "It's the percentage of dry rubber in your coagulum. The DRIER, the HIGHER the DRC and BETTER the price.",
    howItWorks: "How it works:",
    coagulumMuchWaterLabel: "Coagulum with too much water",
    drcLowLabel: "Low DRC (40-50%)",
    wellDriedCoagulumLabel: "Well-dried coagulum",
    drcHighLabel: "High DRC (60-70%)",
    mayBeRejectedLabel: "May be rejected",
    minimumAcceptedLabel: "Minimum accepted",
    goodExcellentLabel: "Good / Excellent",
    excellentLabel: "Excellent",
    drcTipText: "Each 1% more in DRC can mean R$ 0.10-0.15/kg more in your pocket!",
    participationRateGuideTitle: "Participation Rate",
    whatIsParticipationRate: "What is Participation Rate?",
    participationRateExplanationGuide: "It's the percentage of the reference value you receive. The HIGHER the rate, the MORE money in your pocket.",
    rateBandsTitle: "Rate Bands:",
    veryLowLabel: "Very low",
    cnaMinimumLabel: "CNA minimum",
    goodLabel: "Good",
    ieaReferenceLabel: "IEA Reference",
    excellentRateLabel: "Excellent",
    importantWarningRate: "The 52% rate is the MINIMUM recommended by CNA. IEA uses 80% in its official calculations!",
    howToGetBetterRatesTitle: "How to get better rates:",
    deliverLargerVolumeLabel: "Deliver larger volume",
    maintainRegularFrequencyLabel: "Maintain regular frequency",
    guaranteeQualityLabel: "Guarantee quality (high DRC)",
    longTermContractsLabel: "Make long-term contracts",
    negotiateInGroupLabel: "Negotiate in group/cooperative",
    completeFormulaGuideTitle: "The Complete Formula",
    coagulumPriceFormulaLabel: "Coagulum Price = Reference × (DRC/100) × (Rate/100)",
    comparativeWithReferencesTitle: "Comparison with the 3 market references (DRC 53%):",
    bimonthlyRefPriceDesc: "Bimonthly reference price calculated from international price + exchange + import costs.",
    totalCostToImportDesc: "Total cost to import processed rubber (GEB-10). Includes freight, taxes and all costs.",
    realTransactionPriceDesc: "Real price practiced in São Paulo physical market transactions.",
    relationBetweenReferencesTitle: "Relationship between references:",
    maxCostIfImportedLabel: "Maximum cost (if industry imported)",
    refForNegotiationLabel: "Reference for negotiation between mills and producers",
    realTransactionPriceLabel: "Real transaction price",
    understandDifferenceTitle: "Understand the difference",
    understandDifferenceExplanation: "Mills adopt GEB-10 APABOR to negotiate with producers. The IEA Import Price serves as a \"parity\" reference - what national coagulum would be worth if competing directly with imported.",
    productionCostGuideTitle: "Production Cost",
    priceCoversQuestion: "Does your price cover costs?",
    profitNeedsHigherPriceText: "To profit, the price you receive must be HIGHER than your production cost.",
    effectiveOperationalCost: "Effective Operational Cost",
    directCostsCOE: "Direct costs (COE)",
    totalOperationalCost: "Total Operational Cost",
    includesProLabore: "Includes pro-labore (COT)",
    marginAnalysisTitle: "Margin Analysis (GEB-10 APABOR R$ 11.31):",
    scenarioLabel: "Scenario",
    priceLabel: "Price",
    marginVsCotLabel: "Margin (vs COT)",
    currentMarketLabel: "market",
    marketAnalysisText: "With current market prices (GEB-10 R$ 11.31 and rate ~72%), coagulum price (R$ 4.30) is below production cost (R$ 6.07). This is current market reality.",
    officialSourcesGuideTitle: "Official Sources",
    verifiableDataTitle: "Verifiable data",
    verifiableDataDesc: "All data from this calculator comes from official sources you can consult.",
    naturalRubberPortal: "Natural Rubber (Lateks Portal)",
    dailyLabel: "daily",
    mainSourceLabel: "Quotations on homepage - Main source",
    ieaInstitute: "IEA - Institute of Agricultural Economics",
    studiesAndAnalyses: "Import Price, studies and analyses",
    searchRubberOnSite: "Search for \"natural rubber\" on site",
    technicalBulletinsNews: "Technical bulletins and sector news",
    someContentForMembers: "Some content for members only",
    dailyCoagulumQuotation: "Coagulum quotation",
    internationalPriceSgxRealTime: "International SGX price (real-time)",
    negotiationTipsGuideTitle: "Negotiation Tips",
    knowledgeIsPowerTitle: "Knowledge is power!",
    knowledgeIsPowerDesc: "Now that you understand how price is formed, use this knowledge to negotiate better.",
    confirmMillReference: "Confirm which reference the mill uses",
    confirmMillReferenceDesc: "Most use GEB-10 APABOR. Compare with this calculator's values.",
    askCalculationWritten: "Ask for calculation in writing",
    askCalculationWrittenDesc: "Demand transparency: GEB-10 × DRC × Rate = your price",
    improveYourDrc: "Improve your DRC",
    improveYourDrcDesc: "Avoid moisture in coagulum. Each 1% is worth R$ 0.10-0.15/kg",
    negotiateParticipationRate: "Negotiate participation rate",
    negotiateParticipationRateDesc: "Minimum 52%, ideal 70-80%. Volume and quality justify better rates",
    useThisCalculator: "Use this calculator",
    useThisCalculatorDesc: "Check if offered price matches official formula",
    congratulationsTitle: "Congratulations!",
    congratulationsDesc: "Now you're ready to negotiate fairly and informedly!",
    stepOfTotal: "Step {current} of {total}",
    previousBtn: "Previous",
    nextBtn: "Next",
    startUsingBtn: "Start using!",

    // ========== PHASE 1 - SMALL COMPONENTS ==========
    // AchievementBadge
    noAchievementsYet: "No achievements yet",
    showMore: "more",
    showLess: "Show less",

    // CertificationNav
    navHome: "Home",
    navCertification: "Certification",
    navEvaluation: "Evaluation",
    navDocuments: "Documents",
    joinProgram: "Join the program",
    technicalCriteria: "14 technical criteria",
    officialDocs: "INCAPER, CATI/SP",

    // FeedbackCard
    yourStrengths: "Your Strengths",
    improvementOpportunities: "Improvement Opportunities",
    nextObjective: "Next Objective",
    recommendedCourses: "Recommended Courses",
    potentialGain: "Potential gain",
    pointsFromNextLevel: "points from next level",
    youAreOnly: "You are only",
    seal: "Seal",

    // ScoreBreakdown
    outOf100Points: "out of 100 points",
    privateScore: "Private",
    tappingTechnique: "Tapping Technique",
    harvestPreparation: "Harvest Preparation",
    dailyMaintenance: "Daily Maintenance",
    chemicalApplications: "Chemical Applications",
    maintenanceAndCare: "Maintenance and Care",
    productivity: "Productivity",

    // SealBadge
    sealExpert: "Expert Tapper",
    sealProfessional: "Professional Tapper",
    sealCertified: "Certified Tapper",
    sealInDevelopment: "In Development",
    sealExpired: "Seal Expired",

    // ========== PHASE 2 - DASHBOARDS ==========
    // SimpleDashboard
    hello: "Hello",
    exit: "Exit",
    welcomeUser: "Welcome",
    manageEmployeesProperties: "Manage your employees and properties",
    findWorkOpportunities: "Find work opportunities",
    tappingToday: "Tapping Today",
    viewReports: "View Reports",
    viewPlans: "View Plans",
    jobs: "Jobs",
    mainDashboard: "Main Dashboard",
    welcomeToHeveaTalent: "Welcome to HeveaTalent! Use the tabs above to navigate.",
    jobCenter: "Job Center",
    postJobsOrFindWork: "Post jobs or find work",
    buyAndSellProducts: "Buy and sell products",
    manageBleedingActivities: "Manage bleeding activities",
    jobCenterTitle: "Job Center",
    publishJobsFindProfessionals: "Post jobs and find qualified professionals",
    findHeveicultureOpportunities: "Find job opportunities in rubber cultivation",
    featureInDevelopment: "Feature under development",
    marketplaceBuyAndSell: "Buy and sell rubber cultivation related products",
    manageDailyActivities: "Manage your daily rubber cultivation activities",
    plansAndSubscriptions: "Plans and Subscriptions",
    choosePlanForNeeds: "Choose the ideal plan for your needs",
    basic: "Basic",
    free: "Free",
    publish1Ad: "Publish 1 ad",
    basicCalendar: "Basic calendar",
    featuredAds: "Featured ads",
    popular: "Popular",
    professional: "Professional",
    unlimitedAds: "Unlimited ads",
    advancedCalendar: "Advanced calendar",
    threeFeaturedAds: "3 featured ads",
    allFromProfessional: "All from Professional",
    advancedReports: "Advanced reports",
    prioritySupport: "Priority support",
    perMonth: "/month",

    // ReportsDashboard
    reportsAndManagement: "Reports and Management",
    trackTeamPerformance: "Track your team's performance",
    howToUse: "How to use",
    reportsViewStats: "Reports: View statistics and production reports of your property.",
    month: "Month",
    year: "Year",
    update: "Update",
    teamSummary: "Team Summary",
    anonymousRanking: "Anonymous Ranking",
    withSeal: "With Seal",
    averageScore: "Average Score",
    periodDetails: "Period Details",
    workDays: "Work Days",
    dailyAverage: "Daily Average",
    productionRanking: "Production Ranking",
    anonymousComparisonProtected: "Anonymous comparison - real names protected",
    daysWorked: "days worked",
    noProductionDataPeriod: "No production data for this period",
    dataAppearsWhenWorkersRegister: "Data appears when workers register production in the Bleeding Calendar",
    privacyNotice: "Privacy:",
    realNamesProtected: "Real worker names are replaced with letters (A, B, C...) to protect their identity.",
    productionHistory: "Production History",
    lastMonthsAnalyzed: "Last {months} months",
    noHistoryAvailable: "No history available",
    noPropertiesYet: "You don't have any registered properties yet",
    registerPropertyToSeeReports: "Register a property in the Bleeding Calendar to see reports",
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",

    // ========== PHASE 3 - PRICE FORMATION ==========
    // Section 1 - Transparency Warning
    pf_transparencyTitle: "Transparency About the Current System",
    pf_transparencyText: "There is discussion in the sector about price calculation methodologies. We present here how the system works, including its limitations recognized by official entities such as CNA and FAESP.",
    
    // Section 2 - How Price is Formed
    pf_howPriceFormedTitle: "How Rubber Price is Formed",
    pf_howPriceFormedIntro: "The price paid to Brazilian producers for coagulum is derived from the international rubber price, adjusted by various factors. See the flow:",
    pf_step1Title: "International Price (Singapore)",
    pf_step1Desc: "Singapore exchange quotation - world reference",
    pf_step2Title: "Conversion + Import Costs",
    pf_step2Desc: "Exchange rate (dollar) + freight + insurance + taxes + customs clearance",
    pf_step3Title: "GEB-10 Reference Price",
    pf_step3Desc: "Value of processed rubber in the domestic market",
    pf_step4Title: "TBS and Participation Rate Adjustment",
    pf_step4Desc: "GEB-10 Price × TBS × Participation Rate (~52%)",
    pf_negotiation: "Negotiation",
    pf_finalPriceTitle: "Producer Price (Coagulum)",
    pf_finalPriceDesc: "Final value paid by the mill to the rubber farmer",
    
    // Section 3 - Participation Rate
    pf_participationRateTitle: "What is the Participation Rate?",
    pf_participationRateIntro: "The Participation Rate is the relationship between the price paid to the producer and the international reference price. According to CNA/FAESP studies:",
    pf_minRecommendedRate: "Minimum Recommended Participation Rate",
    pf_rateRelation: "Relationship between producer price and Singapore price",
    pf_factorsTitle: "Factors that influence the rate:",
    pf_factorVolume: "Higher quantity can ensure better negotiation",
    pf_factorFrequency: "Regular deliveries may have better conditions",
    pf_factorQuality: "Higher TBS = better price",
    pf_factorDistance: "Proximity to the mill can reduce costs",
    pf_volume: "Volume",
    pf_frequency: "Frequency",
    pf_qualityTbs: "Quality/TBS",
    pf_distance: "Distance",
    
    // Section 4 - The Problem
    pf_problemTitle: "The Recognized Problem",
    pf_problemSource: "According to official CNA/FAESP study:",
    pf_problemQuote: "The insecurity of rubber producers regarding the mechanism for forming domestic prices must be overcome [...] this only happens with the adoption and disclosure of methodologies recognized by independent institutions.",
    pf_problemsIdentified: "Problems Identified:",
    pf_problem1: "Lack of transparency in methodology",
    pf_problem2: "Absence of formal contracts",
    pf_problem3: "Prices frequently below cost",
    pf_problem4: "Producer without bargaining power",
    pf_problem5: "Discussion about customs value items",
    pf_initiativesTitle: "Ongoing Initiatives:",
    pf_initiative1: "IEA/CNA Index (alternative methodology)",
    pf_initiative2: "Rubber Sector Chamber",
    pf_initiative3: "Studies for public policies",
    pf_initiative4: "Proposal to raise tariff rate",
    
    // Section 5 - Price vs Cost
    pf_priceVsCostTitle: "Price vs Production Cost",
    pf_priceVsCostIntro: "Historical data shows that, in most years, the price paid to the producer does not cover the production cost:",
    pf_tablePeriod: "Period",
    pf_tableProducerPrice: "Producer Price",
    pf_tableProductionCost: "Production Cost",
    pf_tableSituation: "Situation",
    pf_loss: "Loss",
    pf_margin: "Margin",
    pf_sourceNote: "Values are averages and may vary by region and specific conditions of each property.",
    
    // Section 6 - How to Protect
    pf_protectTitle: "How to Protect Yourself",
    pf_beforeSellingTitle: "Before Selling:",
    pf_beforeSelling1: "Check IEA and APABOR quotations",
    pf_beforeSelling2: "Calculate your real TBS",
    pf_beforeSelling3: "Compare prices between mills",
    pf_beforeSelling4: "Know your production cost",
    pf_negotiationTitle: "Negotiation:",
    pf_negotiation1: "Ask for clarity in the calculation methodology",
    pf_negotiation2: "Question the applied participation rate",
    pf_negotiation3: "Consider joining cooperatives",
    pf_negotiation4: "Document all transactions",

    // ========== USER GUIDE STEPS ==========
    // Step 1 - Welcome
    ug_step1_title: "Welcome to the Price Guide",
    ug_step1_intro: "This guide will teach you how natural rubber pricing works and how to use the calculator to negotiate better.",
    ug_step1_tripod1: "Data from official sources (IEA, CNA, APABOR)",
    ug_step1_tripod2: "Your data is not shared",
    ug_step1_tripod3: "Easy to understand and use",
    
    // Step 2 - Price Chain
    ug_step2_title: "The Price Formation Chain",
    ug_step2_intro: "The price you receive goes through several stages from the international quotation:",
    ug_step2_1_title: "1. International Price (SGX)",
    ug_step2_1_desc: "Singapore quotation",
    ug_step2_2_title: "2. Conversion + Import Costs",
    ug_step2_2_desc: "PTAX exchange rate + freight + taxes (10.8%) + costs",
    ug_step2_3_title: "3. National Reference Price",
    ug_step2_3_desc: "GEB-10 APABOR and IEA Import Price",
    ug_step2_4_title: "4. Producer Formula",
    ug_step2_4_desc: "Reference × DRC × Participation Rate",
    ug_step2_5_title: "5. Your Price (Coagulum)",
    ug_step2_5_desc: "The value you receive for coagulum",
    
    // Step 3 - Reference Price
    ug_step3_title: "The Reference Price",
    ug_step3_tripod: "The coagulum price is calculated based on an official reference. Learn about the main sources used in the Brazilian market.",
    ug_step3_mainRefs: "The main market references:",
    ug_step3_adoptedByMills: "ADOPTED BY MILLS",
    ug_step3_geb10Desc: "Internalized price (International + Exchange + Costs)",
    ug_step3_geb10Note: "Most used reference (NB Borracha, São Manoel, Hevea-Tec, etc.)",
    ug_step3_bimonthly: "Publication: Bimonthly (Dec/Jan, Feb/Mar...)",
    ug_step3_importParity: "IMPORT PARITY",
    ug_step3_ieaDesc: "TOTAL cost to import processed rubber (GEB-10)",
    ug_step3_ieaIncl: "Includes: international price + exchange + freight + taxes (~10.8%) + costs",
    ug_step3_monthly: "Publication: Monthly (days 15-20)",
    ug_step3_spotPrice: "SPOT PRICE",
    ug_step3_spDesc: "Price practiced in São Paulo market",
    ug_step3_monthlySimple: "Publication: Monthly",
    ug_step3_whyGeb10: "Why is GEB-10 APABOR the market reference?",
    ug_step3_whyGeb10Desc: "It is the reference adopted by major processing mills (NB Borracha, São Manoel, Hevea-Tec, etc.). It allows you to compare your price directly with market practices.",
    
    // Step 4 - DRC
    ug_step4_title: "DRC - Dry Rubber Content",
    ug_step4_tripod: "It is the percentage of dry rubber in your coagulum. The DRIER it is, the HIGHER the DRC and BETTER the price.",
    ug_step4_howWorks: "How it works:",
    ug_step4_muchWater: "Coagulum with too much water",
    ug_step4_lowDrc: "Low DRC (40-50%)",
    ug_step4_wellDried: "Well-dried coagulum",
    ug_step4_highDrc: "High DRC (60-70%)",
    ug_step4_mayReject: "May be rejected",
    ug_step4_minAccepted: "Minimum accepted",
    ug_step4_goodExcellent: "Good / Excellent",
    ug_step4_excellent: "Excellent",
    ug_step4_tip: "Each 1% more in DRC can mean R$ 0.10-0.15/kg more in your pocket!",
    
    // Step 5 - Participation Rate
    ug_step5_title: "Participation Rate",
    ug_step5_tripod: "It is the percentage of the reference value you receive. The HIGHER the rate, the MORE money in your pocket.",
    ug_step5_ranges: "Rate Ranges:",
    ug_step5_veryLow: "Very low",
    ug_step5_minCna: "CNA Minimum",
    ug_step5_good: "Good",
    ug_step5_ieaRef: "IEA Reference",
    ug_step5_excellentRate: "Excellent",
    ug_step5_important: "The 52% rate is the MINIMUM recommended by CNA. IEA uses 80% in their official calculations!",
    ug_step5_howToGet: "How to get better rates:",
    ug_step5_tip1: "Deliver higher volume",
    ug_step5_tip2: "Maintain regular frequency",
    ug_step5_tip3: "Ensure quality (high DRC)",
    ug_step5_tip4: "Make long-term contracts",
    ug_step5_tip5: "Negotiate as a group/cooperative",
    
    // Step 6 - Complete Formula
    ug_step6_title: "The Complete Formula",
    ug_step6_formula: "Coagulum Price = Reference × (DRC/100) × (Rate/100)",
    ug_step6_compare: "Comparison with the 3 market references (DRC 53%):",
    ug_step6_geb10Ref: "Bimonthly reference price calculated from international price + exchange + import costs.",
    ug_step6_ieaRef: "Total cost to import processed rubber (GEB-10). Includes freight, taxes and all costs.",
    ug_step6_spRef: "Actual price practiced in São Paulo physical market transactions.",
    ug_step6_relation: "Relationship between references:",
    ug_step6_maxCost: "Maximum cost (if industry imported)",
    ug_step6_refNegotiation: "Reference for negotiation between mills and producers",
    ug_step6_realPrice: "Actual transaction price",
    ug_step6_understand: "Mills adopt GEB-10 APABOR to negotiate with producers. The IEA Import Price serves as a \"parity\" reference - what national coagulum would be worth if it competed directly with imported.",
    
    // Step 7 - Production Cost
    ug_step7_title: "Production Cost",
    ug_step7_tripod: "To make a profit, the price you receive must be HIGHER than your production cost.",
    ug_step7_coe: "Effective Operational Cost",
    ug_step7_coeDesc: "Direct expenses (COE)",
    ug_step7_cot: "Total Operational Cost",
    ug_step7_cotDesc: "Includes pro-labore (COT)",
    ug_step7_marginAnalysis: "Margin Analysis (current GEB-10 APABOR):",
    ug_step7_scenario: "Scenario",
    ug_step7_price: "Price",
    ug_step7_marginVsCot: "Margin (vs COT)",
    ug_step7_analysis: "Compare the coagulum price with production costs (COE/COT). Current values are in the 💰 Quotations and 📊 Analysis tabs, updated daily.",
    
    // Step 8 - Official Sources
    ug_step8_title: "Official Sources",
    ug_step8_tripod: "All data in this calculator comes from official sources you can consult.",
    ug_step8_lateks: "Natural Rubber (Portal Lateks)",
    ug_step8_lateksDesc: "GEB-10 APABOR, SP Market, SMR20, Dollar (daily)",
    ug_step8_lateksNote: "Quotations on homepage - Main source",
    ug_step8_iea: "IEA - Agricultural Economics Institute",
    ug_step8_ieaDesc: "Import Price, studies and analyses (monthly)",
    ug_step8_ieaNote: "Search for \"natural rubber\" on the site",
    ug_step8_apabor: "APABOR",
    ug_step8_apaborDesc: "Technical bulletins and sector news",
    ug_step8_apaborNote: "Some content for members only",
    ug_step8_noticias: "Notícias Agrícolas",
    ug_step8_noticiasDesc: "Coagulum quotation (daily)",
    ug_step8_trading: "Trading Economics",
    ug_step8_tradingDesc: "International SGX price (real-time)",
    
    // Step 9 - Negotiation Tips
    ug_step9_title: "Negotiation Tips",
    ug_step9_tripod: "Now that you understand how the price is formed, use this knowledge to negotiate better.",
    ug_step9_tip1_title: "Confirm which reference the mill uses",
    ug_step9_tip1_desc: "Most use GEB-10 APABOR. Compare with this calculator's values.",
    ug_step9_tip2_title: "Ask for calculation in writing",
    ug_step9_tip2_desc: "Demand transparency: GEB-10 × DRC × Rate = your price",
    ug_step9_tip3_title: "Improve your DRC",
    ug_step9_tip3_desc: "Avoid moisture in coagulum. Each 1% is worth R$ 0.10-0.15/kg",
    ug_step9_tip4_title: "Negotiate the participation rate",
    ug_step9_tip4_desc: "Minimum 52%, ideal 70-80%. Volume and quality justify better rates",
    ug_step9_tip5_title: "Use this calculator",
    ug_step9_tip5_desc: "Check if the offered price matches the official formula",
    ug_step9_congrats: "Congratulations!",
    ug_step9_ready: "Now you are ready to negotiate with official, verified data!",

    // Additional keys for UserGuide
    analysis: "Analysis",
    importPrice: "Import Price",
    important: "IMPORTANT",
    knowledgeIsPower: "Knowledge is power!",
    marketSP: "SP Market",
    officialReferences: "Official References",
    priceVsCost: "Does your price cover costs?",
    tip: "Tip",
    understandDifference: "Understand the difference",
    verifiableData: "Verifiable data",
    whatIsDrc: "What is DRC?",
    
    // ========== ONBOARDING ==========
    onboardingTitle: "🎯 Getting Started",
    onboardingCompleteTitle: "Getting Started Complete!",
    onboardingCompleteDesc: "All steps have been completed successfully",
    onboardingSubtitle: "Complete these steps to enjoy all the benefits",
    onboardingStep1Title: "Register your Property",
    onboardingStep1Desc: "Set up your farm with name, location and production area",
    onboardingStep2Title: "Configure Production Context",
    onboardingStep2Desc: "Define clone, tapping system and number of trees for fair goals",
    onboardingStep3Title: "Record your Tappings",
    onboardingStep3Desc: "Use the Calendar to record daily production and track progress",
    onboardingStep4Title: "Accept LGPD Terms",
    onboardingStep4Desc: "Set your privacy preferences and appear on the Job Board",
    onboardingStep5Title: "Get your First Evaluation",
    onboardingStep5Desc: "Invite a technician or owner to evaluate your work. Seal: 100% technical (no calendar) or 50% technical + 50% contextual",
    progress: "Progress",
    completed: "completed",
    start: "Start",
    configure: "Configure",
    requiresPrevious: "Requires previous step",
    done: "Done",
    nextTip: "Next step",
    dismissChecklist: "Hide checklist",
    
    // Welcome Modal
    welcomeModalTitle: "Welcome to HeveaTalent!",
    welcomeModalSubtitle: "The complete platform for rubber farmers",
    welcomeModalText: "We are happy to have you with us! We have prepared a quick guide so you can enjoy all the benefits of the platform.",
    welcomeFeature1Title: "Tapping Calendar",
    welcomeFeature1Desc: "Record production, manage team and track progress",
    welcomeFeature2Title: "Contextual Goals",
    welcomeFeature2Desc: "Fair goals based on your clone, system and region",
    welcomeFeature3Title: "Seal System",
    welcomeFeature3Desc: "Achieve Bronze, Silver or Gold and stand out",
    welcomeModalButton: "Get Started",
    
    // ========== CONTEXTUAL PERFORMANCE ==========
    contextualPerformance: "Contextual Performance",
    howEvaluationWorks: "How the Evaluation System Works",
    technicalEvaluation: "Technical Evaluation",
    configureContext: "Configure Context",
    registerInCalendar: "Register in Calendar",
    automaticSeal: "Automatic Seal",
    sealLevels: "Seal Levels",
    yourCurrentSeal: "Your Current Seal",
    noSealYet: "No seal earned yet",
    officialGoalTable: "Official Goals Table",
    cloneType: "Clone Type",
    tappingSystems: "Tapping Systems",
    productivityByClone: "Productivity by Clone",
    totalInProduction: "Total in Production",
    contextDefinesFairGoal: "Context defines your fair goal",
    automatically: "automatically",
    targetLine: "Target Line",
    normal: "Normal",
    stop: "Stop",
    year: "Year",
    month: "Month",
    cuts: "Cuts",
    totalKg: "Total kg",
    clone: "Clone",
    property: "Property",
    tappingSystem: "Tapping System",
    technicianWeight3x: "Certified technician (weight 3x) or owner (weight 1x) in average",
    groupAScore: "Group A - Cutting Technique",
    groupB1Score: "Group B1 - Preparation",
    groupB2Score: "Group B2 - Maintenance",
    groupCScore: "Group C - Treatments",
    bronze70: "🥉 Bronze 60-74 pts",
    silver85: "🥈 Silver 75-89 pts",
    gold100: "🥇 Gold 90-100 pts",
    
    // ========== PRODUCTION CONTEXT WIZARD ==========
    wizardTitle: "Configure Production Context",
    wizardStepOf: "Step {current} of {total}",
    wizardAllConfigured: "All Configured!",
    wizardAllConfiguredDesc: "All your properties already have production context configured.",
    wizardClose: "Close",
    
    // Wizard Steps
    wizardStepProperty: "Property",
    wizardStepPropertyDesc: "Select the property",
    wizardStepClone: "Clone",
    wizardStepCloneDesc: "Rubber tree type",
    wizardStepSystem: "System",
    wizardStepSystemDesc: "Tapping frequency",
    wizardStepTrees: "Trees",
    wizardStepTreesDesc: "Quantity and age",
    wizardStepExtras: "Details",
    wizardStepExtrasDesc: "Region and stimulation",
    wizardStepConfirm: "Confirm",
    wizardStepConfirmDesc: "Review and save",
    
    // Property Step
    wizardSelectProperty: "Select Property",
    wizardSelectPropertyDesc: "Choose the property to configure production context",
    wizardNoPropertiesAvailable: "No properties available to configure.",
    wizardNoPropertiesHint: "All already have context or you need to register a property first.",
    
    // Clone Step
    wizardWhichClone: "What is the Rubber Tree Clone?",
    wizardCloneExplain: "The clone determines expected productivity (g/tree/cut)",
    wizardCloneTip: "If you don't know the clone, RRIM 600 is the most common in Brazil and a good default choice.",
    wizardGramsPerCut: "g/cut",
    wizardPopular: "Popular",
    
    // System Step
    wizardTappingSystem: "Tapping System",
    wizardTappingFrequency: "What tapping frequency is used?",
    wizardSystemTip: "D/4 means tapping every 4 days (4 lots). Systems with more days between tappings preserve the tree but reduce total production.",
    wizardCutsPerMonth: "cuts/month",
    
    // Trees Step
    wizardTreesData: "Tree Data",
    wizardTreesDataDesc: "Enter quantity and age of rubber plantation",
    wizardTreesInProduction: "Total Trees in Production",
    wizardTreesInProductionHint: "How many trees are currently being tapped?",
    wizardTreesPerHectare: "Trees per Hectare",
    wizardTreesDefault: "Default: 450",
    wizardSeringalAge: "Plantation Age (years)",
    wizardSeringalAgeHint: "Years of exploitation",
    wizardEstimatedArea: "Estimated area:",
    wizardHectares: "hectares",
    
    // Extras Step
    wizardAdditionalDetails: "Additional Details",
    wizardAdditionalDetailsDesc: "Region and chemical stimulation use",
    wizardRegion: "Region",
    wizardRegionExplain: "The region affects seasonal production coefficients",
    wizardRegionSP: "São Paulo (Northwest)",
    wizardRegionSPDesc: "MAY is peak (cold winter)",
    wizardRegionES: "Espírito Santo / Bahia",
    wizardRegionESDesc: "Summer is high production",
    wizardRegionMT: "Central-West (MT/GO/MS)",
    wizardRegionMTDesc: "Dry season favors production",
    wizardStimulation: "Use Stimulation (Ethephon)?",
    wizardStimulationHint: "Can increase production by up to 28%",
    wizardStimulationConcentration: "Ethephon Concentration (%)",
    wizardStimulationLow: "2.5% (Low risk, +15-20%)",
    wizardStimulationMedium: "3.3% (Moderate, +20-25%)",
    wizardStimulationHigh: "5.0% (High risk, +25-28%)",
    
    // Confirm Step
    wizardConfirmData: "Confirm Data",
    wizardConfirmDataDesc: "Review information before saving",
    wizardWhatHappensNext: "What happens now?",
    wizardWhatHappensNextDesc: "With the context configured, the system will calculate your fair goals based on this data. You can track your performance on the Contextual Performance Dashboard.",
    wizardYes: "Yes",
    wizardNo: "No",
    
    // Wizard Navigation
    wizardCancel: "Cancel",
    wizardBack: "Back",
    wizardNext: "Next",
    wizardSave: "Save Context",
    wizardSaving: "Saving...",
    wizardUseGuided: "Use Guided Assistant",
    wizardErrorSaving: "Error saving context",

    // ========== PURPOSE PAGE ==========
    purposeLabel: "Our Purpose",
    purposeTitle: "Connecting partners, producers and the entire rubber cultivation chain",
    purposeSubtitle: "HeveaTalent was born from the need to value rubber tapping professionals and create connections that strengthen the entire sector.",
    purposeStatCriteria: "Technical evaluation criteria",
    purposeStatSeals: "Professional seal levels",
    purposeStatOfficial: "Based on official literature",
    purposeStatAll: "Entire",
    purposeStatChain: "Chain connected",
    purposeMission: "Mission",
    purposeMissionText: "Connect partners, producers and the entire rubber cultivation chain, valuing professionals and strengthening the sector with accessible technology and technical certification based on official literature.",
    purposeVision: "Vision",
    purposeVisionText: "To be the reference platform for professional development in Brazilian rubber cultivation, where every tapper has their work recognized and valued.",
    purposeValuesLabel: "Our Values",
    purposeValuesTitle: "HeveaTalent Tripod",
    purposeValuesSubtitle: "Three pillars that guide every decision and feature of the platform.",
    purposeJustice: "Fairness",
    purposeJusticeDesc: "We believe every professional deserves fair recognition for their work. HeveaTalent certification is based on official technical criteria, ensuring impartiality and meritocracy.",
    purposeJustice1: "Technical certification based on INCAPER and CATI/SP",
    purposeJustice2: "Quality seals (Bronze, Silver, Gold)",
    purposeJustice3: "Equal opportunities for all professionals",
    purposeSecurity: "Security",
    purposeSecurityDesc: "We protect the data and professional relationships of all users. Transparency and trust are the foundation of every interaction on the platform.",
    purposeSecurity1: "Data protected in compliance with LGPD",
    purposeSecurity2: "Transparency in professional relationships",
    purposeSecurity3: "Mutual trust between producer and tapper",
    purposeSimplicity: "Simplicity",
    purposeSimplicityDesc: "Technology should make life easier, not more complicated. Every feature is designed to be intuitive and accessible, even for those with little digital experience.",
    purposeSimplicity1: "Field-accessible interface",
    purposeSimplicity2: "Clear and direct information",
    purposeSimplicity3: "Simple workflows that save time",
    purposeDiffLabel: "What sets us apart",
    purposeDiffTitle: "HeveaTalent Differentials",
    purposeDiffCert: "Professional Certification",
    purposeDiffCertDesc: "Bronze, Silver and Gold seals based on 14 official technical criteria",
    purposeDiffMarket: "Marketplace",
    purposeDiffMarketDesc: "Buy and sell supplies and equipment for rubber cultivation",
    purposeDiffJobs: "Job Center",
    purposeDiffJobsDesc: "Jobs and service offers connecting producers and tappers",
    purposeDiffComm: "Community",
    purposeDiffCommDesc: "Share experiences and tips with professionals from all over Brazil",
    purposeDiffQuotes: "Real-Time Quotes",
    purposeDiffQuotesDesc: "Track rubber prices and USD/BRL exchange rates in real time",
    purposeDiffRec: "Recommendations",
    purposeDiffRecDesc: "Build your reputation with employer recommendations",
    purposeQuote: "We value every rubber cultivation professional, from tapping to trading, building bridges that strengthen the entire chain.",
    purposeCTA: "Start now — it's free",
    purposeFooter: "HeveaTalent - Professional Rubber Cultivation",
    purposeFooterSub: "Based on the Tripod: Fairness, Security and Simplicity",

    // ========== CONTACT FORM & INSTITUTIONAL FOOTER ==========
    contactTitle: "Contact Us",
    contactSubtitle: "Send your question, suggestion or partnership proposal.",
    contactName: "Name",
    contactEmail: "Email",
    contactSubject: "Subject",
    contactMessage: "Message",
    contactSend: "Send Message",
    contactSuccessTitle: "Message Sent!",
    contactSuccessMsg: "We will get back to you soon via the email provided.",
    contactError: "Error sending. Please try again.",
    sending: "Sending...",
    footerAbout: "Performance management and networking platform for professionals and owners in rubber cultivation.",
    footerLinks: "Links",
    footerHome: "Home",
    footerPurpose: "Purpose",
    footerContact: "Contact",
    footerLegal: "Legal",
    footerRights: "All rights reserved.",
    termsTitle: "Terms of Use",
    privacyTitle: "Privacy Policy",
    lastUpdated: "Last updated",

    // ========== FEATURE GATING ==========
    gateTitle: "Premium Feature",
    gateCurrentPlan: "Your current plan",
    gateUpgradeMsg: "Upgrade your plan to unlock this feature.",
    gateUpgradeBtn: "View Plans and Upgrade",
    gateCalendar: "Bleeding calendar available on the Plus plan.",
    gateReports: "Reports available from the Basic plan.",
    gateTeam: "Team management available from the Basic plan.",
    gateEvaluations: "Giving evaluations available from the Basic plan.",
    gateLimitReached: "Limit reached",
    gateLimitMsg: "You have reached the limit of your plan.",
    gateTrialExpired: "Trial Period Expired",
    gateTrialExpiredMsg: "Your trial period has ended. Subscribe to a plan to continue using this feature.",
    trialDaysLeft: "Trial period",
    day: "day",
    days: "days",

    // ========== CONTACT MESSAGES ==========
    msgTitle: "Messages",
    msgNew: "New",
    msgRead: "Read",
    msgResponded: "Responded",
    msgEmpty: "No messages received yet.",
    msgMarkResponded: "Mark as Responded",
    msgReplyEmail: "Reply by Email",
    msgDelete: "Delete",
    msgDeleteConfirm: "Are you sure you want to delete this message?",

    // ========== ADMIN STATS ==========
    statsTitle: "Statistics",
    statsTotal: "Total Users",
    statsActive: "Active Users",
    statsSubscriptions: "Active Subscriptions",
    statsMessages: "Messages",
    statsLast30d: "last 30 days",
    statsLast7d: "last 7 days",
    statsTrial: "in trial",
    statsUnread: "unread",
    statsUsersByType: "Users by Type",
    statsGrowth: "Growth",
    statsNew7d: "New (7 days)",
    statsNew30d: "New (30 days)",
    statsActive7d: "Active (7 days)",
    statsRecentUsers: "Recent Signups",
    statsNoUsers: "No users registered yet.",
    usersTitle: "Users",
    searchUsers: "Search user...",
    noSubscription: "No subscription",
    noResults: "No results found",

    // ========== EVALUATION FORM ==========
    evalFormVersion: "Version",
    evalRoleEngineer: "Agronomist Engineer (weight 3x)",
    evalRoleTechnician: "Agricultural Technician (weight 3x)",
    evalRoleLeader: "Team Leader (weight 1x)",
    evalRoleOwner: "Owner (weight 1x)",
    evalRoleOther: "Other (weight 1x)",
    evalError: "Error",
    evalRedirecting: "Redirecting to dashboard...",
    evalSelectOption: "Select...",
    evalTotalScore: "Total Score",
    evalGroup: "Group",

    // ========== CERTIFICATION ==========
    certLoading: "Loading...",
    certBondType: "Employment Type",
    certLGPDTerm: "LGPD Terms",
    certBondQuestion: "What is your employment type?",
    certBondJustice: "All employment types have the same opportunities in the certification program.",
    certLGPDTitle: "LGPD Consent Agreement",
    certLGPDSecurity: "Please read carefully how your data will be used.",
    certFooter: "HeveaTalent • Certification System",
    certFooterSub: "Based on the Tripod: Fairness • Security • Simplicity",
    certTitle: "HeveaTalent Certification",
    certSubtitle: "Join the certification program and earn your quality seal",
    certVoluntary: "Participation in the certification program is optional. You can use the platform normally without joining.",
    certContinue: "Continue",
    certBack: "Back",
    certAcceptActivate: "Accept and Activate",
    certAcceptTerm: "I have read and accept the consent agreement. I understand I can revoke at any time.",
    certDataCollected: "Data that will be collected:",
    certPurpose: "Purpose:",
    certRights: "Your rights:",
    certVisible: "What other farms CAN see:",
    certVisibleName: "Name and profile photo",
    certVisibleSeal: "Quality seal and overall score",
    certVisibleExp: "Years of experience",
    certVisibleClones: "Clones previously worked with",
    certVisibleTrend: "Performance trend (Consistent/Evolving/New)",
    certNeverShared: "What will NEVER be shared:",
    certNeverHistory: "Detailed month-by-month history",
    certNeverNotes: "Individual scores per technical criteria",
    certNeverFarms: "Names of previous farms",
    certNeverContact: "Contact information (without your authorization)",

    // ========== RECOMMENDATIONS ==========
    recExample: "Example",
    recViaInvite: "Via invitation",

    // ========== PUBLIC RECOMMEND PAGE ==========
    pubRecLoadingInvite: "Loading invitation...",
    pubRecInvalidTitle: "Invalid Invitation",
    pubRecGoHome: "Go to HeveaTalent",
    pubRecThanks: "Thank you!",
    pubRecSuccessMsg: "Your recommendation for",
    pubRecSuccessMsg2: "has been published successfully.",
    pubRecSuccessVisible: "It is now visible on the professional profile.",
    pubRecKnow: "Discover HeveaTalent",
    pubRecPlatform: "Professional Rubber Cultivation Platform",
    pubRecRequestsRec: "requests your professional recommendation",
    pubRecYourName: "Your Name",
    pubRecNamePlaceholder: "Enter your full name",
    pubRecYourRole: "Your Role/Position",
    pubRecSelectRole: "Select your role",
    pubRecRoleOwner: "Owner",
    pubRecRoleTech: "Agricultural Technician",
    pubRecRoleManager: "Manager",
    pubRecRoleEngineer: "Agronomist Engineer",
    pubRecRoleOnly: "Only sector professionals can recommend",
    pubRecFarm: "Farm/Company",
    pubRecFarmPlaceholder: "E.g.: São João Farm",
    pubRecPeriod: "Period working together (optional)",
    pubRecPeriodPlaceholder: "E.g.: 2020 - 2023",
    pubRecYourRec: "Your Recommendation",
    pubRecPlaceholder: "Describe the professional qualities and your experience working with this person...",
    pubRecChars: "characters",
    pubRecSending: "Sending...",
    pubRecSend: "Send Recommendation",
    pubRecInfoPrefix: "Your recommendation will be published on the professional profile of",
    pubRecInfoSuffix: "Only positive compliments are allowed.",
    pubRecErrName: "Please enter your name",
    pubRecErrRole: "Please select your role/position",
    pubRecErrFarm: "Please enter the farm or company",
    pubRecErrMsg: "Please write a recommendation with at least 10 characters",
    pubRecErrInvalid: "Invalid or expired invitation",
    pubRecErrLoad: "Error loading invitation. Try again.",
    pubRecErrSend: "Error sending recommendation",
    pubRecErrConn: "Connection error. Try again.",

    // ========== NOTIFICATIONS ==========
    notifTitle: "Notifications",
    notifMarkAllRead: "Mark all as read",
    notifEmpty: "No notifications",
    notifNow: "Now",

    // ========== WORKER DASHBOARD ==========
    wdError: "Error",
    wdValidUntil: "Valid until",
    wdSealExpired: "Seal Expired",
    wdCertActive: "Certification Active",
    wdCertPending: "Pending Consent",
    wdCertJoin: "Join the Certification Program",
    wdBronze: "Bronze (60-74 pts): Certified Tapper",
    wdSilver: "Silver (75-89 pts): Professional Tapper",
    wdGold: "Gold (90-100 pts): Expert Tapper",
    wdTripod: "HeveaTalent Tripod",

    // ========== WORKERS DATABASE ==========
    wdbTitle: "Internal Database - Workers",
    wdbCurrentMonth: "Current Month",
    wdbAllPeriods: "All Periods",
    wdbSummary: "Database Summary",
    wdbProperty: "Property",
    wdbTotalRecords: "Total Records",
    wdbWorkers: "Workers",
    wdbPeriod: "Period",
    wdbAllPeriodsLabel: "All periods",
    wdbAverage: "Average",
    wdbImproving: "Improving",
    wdbDeclining: "Declining",
    wdbStable: "Stable",
    wdbDaysWorked: "Days Worked",
    wdbTotalProd: "Total Production",
    wdbDailyAvg: "Daily Average",
    wdbEvaluations: "Evaluations",
    wdbNumeric: "numeric",
    wdbDescriptive: "descriptive",
    wdbNotesObs: "Notes & Observations",
    wdbEvaluation: "Evaluation",
    wdbObservations: "Observations",
    wdbAndMore: "and more",
    wdbRecords: "records",
    wdbLastWorks: "Recent Work",
    wdbDate: "Date",
    wdbProduction: "Production",
    wdbActivities: "Activities",
    wdbNoInternalEval: "No records with internal evaluation found",
    wdbMarkInternal: "Mark \"Internal Control (Private)\" in daily records to create the database",
    wdbErrorLoading: "Error loading workers database",
    wdbJan: "January",
    wdbFeb: "February",
    wdbMar: "March",
    wdbApr: "April",
    wdbMay: "May",
    wdbJun: "June",
    wdbJul: "July",
    wdbAug: "August",
    wdbSep: "September",
    wdbOct: "October",
    wdbNov: "November",
    wdbDec: "December",

    // ========== MONTHLY REPORT ==========
    rptPropertyInfo: "Property Information",
    rptName: "Name",
    rptLocation: "Location",
    rptCultureAge: "Culture Age",
    rptYears: "years",
    rptExplorationTime: "Exploration Time",
    rptTotalArea: "Total Area",
    rptHectares: "hectares",
    rptMonthYear: "Month/Year",
    rptMonthNotInformed: "Month not informed",
    rptTotalRecords: "Total Records",
    rptGeneratedAt: "Generated at",
    rptGeneralSummary: "Monthly General Summary",
    rptTotalRecordsLabel: "Total Records",
    rptTotalProduction: "Total Production",
    rptEvaluatedWorkers: "Evaluated Workers",
    rptOfMonth: "of month",
    rptPerRecord: "kg/record",
    rptNoData: "No data",
    rptWithEval: "With evaluation",
    rptWithoutEval: "Without evaluation",
    rptBleedingActivities: "Bleeding Activities",
    rptDaysPerformed: "Days Performed",
    rptLostBleedings: "Lost Bleedings",
    rptApprovalRate: "Approval Rate",
    rptExcellent: "Excellent!",
    rptAttention: "Attention",
    rptGreat: "Great!",
    rptCanImprove: "Can improve",
    rptWeatherConditions: "Weather Conditions",
    rptTotalRain: "Total Rain",
    rptPerActiveDay: "mm/active day",
    rptTotalReplacements: "Total Replacements",
    rptNoReplacements: "No replacements",
    rptReplacementsDone: "Replacements done",
    rptComplementaryAct: "Complementary Activities",
    rptFungicideApp: "Fungicide Applications",
    rptEthrelApp: "Ethrel Applications",
    rptApplied: "Applied",
    rptNotApplied: "Not applied",
    rptWorkerEvals: "Worker Evaluations",
    rptWorker: "Worker",
    rptAverage: "Average",
    rptDays: "Days",
    rptStatus: "Status",
    rptRecommendation: "Recommendation",
    rptNoWorkerEval: "No worker evaluation recorded this month",
    rptActivateInternal: "Enable \"Internal Evaluation\" in daily records to generate performance reports",
    rptRecommendations: "Recommendations",
    rptNoRecommendations: "No recommendations available",
    rptErrorDisplay: "Error displaying month",
    rptMonthJan: "January",
    rptMonthFeb: "February",
    rptMonthMar: "March",
    rptMonthApr: "April",
    rptMonthMay: "May",
    rptMonthJun: "June",
    rptMonthJul: "July",
    rptMonthAug: "August",
    rptMonthSep: "September",
    rptMonthOct: "October",
    rptMonthNov: "November",
    rptMonthDec: "December",

    // ========== BLEEDING DAILY TABLE ==========
    bdtTitle: "Daily Bleeding Table",
    bdtPropertyLabel: "Property",
    bdtYearsCultivation: "years of cultivation",
    bdtNoResults: "No results found for",
    bdtDay: "Day",
    bdtWorkers: "Workers",
    bdtBleeding: "Bleeding",
    bdtReplacement: "Replacement",
    bdtFungicide: "Fungicide",
    bdtEthrel: "Ethrel",
    bdtCollections: "Collections",
    bdtRainMm: "Rain (mm)",
    bdtProductionKg: "Production (kg)",
    bdtActions: "Actions",

    // ========== RECORD FORM ==========
    rfSelectLot: "Select lot...",
    rfCollectionNote: "Mark when collecting rubber from lots. Can be done even without bleeding (e.g., rain). Weight can be informed later.",
    rfAllLotsMarked: "All lots come marked.",
    rfUncheckNotCollected: "Uncheck",
    rfNotCollectedText: "the ones NOT collected.",
    rfSelectLotOption: "Select the lot",
    rfOptionalProductivity: "Optional - For productivity tracking",
    rfOptionalKgPlant: "Optional - For kg/plant calculation",
    rfEvalNote1: "Rate worker performance (1 to 10)",
    rfEvalNote2: "This evaluation is",
    rfEvalNote2Bold: "private",
    rfEvalNote2End: "— only you can see it",
    rfEvalNote3: "Useful for tracking team evolution over time",
    rfEvalNote4: "the professional seal — seal is generated by Technical Evaluation (14 criteria)",
    rfEvalNote4Bold: "Does not affect",
    rfPrivacyNote: "Privacy:",
    rfPrivacyDesc: "Scores visible only to the employer",
    rfEvalScale: "Rate performance from 1 (poor) to 10 (excellent)",
    rfSelectOption: "Select",
    rfRecordSaved: "Record saved successfully!",

    // ========== RECOMMENDATIONS SECTION ==========
    recNoRecommendations: "No recommendations yet",
    recIdentifiedRecommender: "Identified recommender",
    recVerified: "Verified",
    recExternal: "External",
    recNoRecommendationsYet: "You don't have any recommendations yet",
    recInviteCreated: "Invitation created!",
    recInviteLink: "Invitation link",
    recHowItWorks: "How it works:",
    recAutoPublished: "Your recommendation will be published automatically",
    recShowsOnProfile: "Will appear on the professional's public profile",
    recNameAsReference: "Your name will be shown as a reference",
    recOnlyPositive: "Only positive endorsements are allowed",

    // ========== COMMUNITY TIPS ==========
    ctLoadingComments: "Loading comments...",
    ctNoComments: "No comments yet.",
    ctBeFirst: "Be the first to comment!",
    ctShareKnowledge: "Share your knowledge with the community",
    ctClickAddPhotos: "Click to add photos",

    // ========== MARKETPLACE ITEM ==========
    mkiSeller: "Seller",
    mkiContact: "Contact",
    mkiDescription: "Description",

    // ========== MARKETPLACE DIALOGS ==========
    mkdFullName: "Full Name",
    mkdEmail: "Email",
    mkdProduct: "Product",
    mkdPaymentViaPix: "Payment via PIX",
    mkdValue: "Value",
    mkdStatusLabel: "Status",
    mkdExpiresIn: "Expires in",

    // ========== MONTHLY CHARTS ==========
    mchTotalProduced: "Total Produced",

    // ========== TEAM REPORT ==========
    trpWorker: "Worker",
    trpAvgScore: "Average",
    trpDaysWorked: "Days",
    trpStatus: "Status",
    trpRecommendation: "Recommendation",

    // ========== CONTEXTUAL PERFORMANCE ==========
    cpPropertyLabel: "Property",
    cpMonthLabel: "Month",
    cpYearLabel: "Year",
    cpYourAvg: "Your Average",
    cpGoal: "Goal",
    cpGramsPerTreeCut: "g/tree/cut",
    cpCuts: "Cuts",
    cpAvgPerTreeCut: "Avg/Tree/Cut",
    cpClone: "Clone",
    cpSystem: "System",
    cpStimulation: "Stimulation",
    cpBaseGoal: "Base Goal",
    cpSeasonalCoef: "Seasonal Coef.",
    cpPeriod: "Period",
    cpExcellent: "Excellent (≥110%)",
    cpReachedGoal: "Reached Goal (≥100%)",
    cpGood: "Good (≥85%)",
    cpRegular: "Regular (≥70%)",
    cpGoalLine: "Goal Line",
    cpWhyConfigContext: "Why configure context?",
    cpAllConfigured: "All your properties already have context configured!",
    cpCloneType: "Clone Type",
    cpTappingSystem: "Tapping System",
    cpTreesPerHectare: "Trees/Hectare",
    cpTotalInProduction: "Total in Production",
    cpPlantationAge: "Plantation Age (years)",
    cpRegionSP: "São Paulo (Northwest)",
    cpRegionES: "Espírito Santo / Bahia",
    cpRegionMT: "Central-West (MT/GO/MS)",
    cpUsesStimulation: "Uses Stimulation (Ethephon)?",
    cpIncreasesProduction: "Increases production by up to 28%",
    cpConcentration: "Concentration (%)",
    cpOfficialGoalsTable: "Official Goals Table",
    cpProductivityByClone: "Productivity by Clone",
    cpConfigureContext: "Configure Context",
    cpConfigContextDesc: "Clone, tapping system, trees in production.",
    cpRegisterCalendar: "Register in Calendar",
    cpRegisterCalendarDesc: "Bleedings, replacements, collections and monthly production.",
    cpTechnicalEval: "Technical Evaluation",
    cpTechnicalEvalDesc: "(monthly): 14 parameters evaluated. Certified technician (weight 3x) or owner (weight 1x) in the average.",
    cpAutoSeal: "Automatic Seal",
    cpAutoSealDesc: "50% technical + 50% contextual (or 100% technical without calendar).",
    cpTechnicalEval14: "Technical Evaluation (14 items):",

    // ========== TEAM REPORT ==========
    trpPlants: "Plants",
    trpDeliveries: "Deliveries",
    trpWorkersLabel: "Workers",
    trpTotalProd: "Total Production",
    trpTotalPlants: "Total Plants",
    trpCollections: "Collections",
    trpCollectionsWithProd: "Deliveries with recorded production",
    trpAccumulated: "Accumulated",
    trpPlants2: "plants",
    trpLot: "Lot",
    trpCollectionDate: "Collection Date",
    trpPreviousCollection: "Previous Collection",
    trpMonthTotalCuts: "Total Cuts (Month)",
    trpTotalThisDelivery: "Total this delivery",

    // ========== PROFESSIONALS SEARCH ==========
    psSearchTitle: "Search Professionals",
    psSearchPlaceholder: "Search by name or specialization...",
    psFilterAll: "All",
    psFilterSangrador: "Tapper",
    psFilterGerente: "Manager",
    psFilterFiscal: "Inspector",
    psFilterAgronomo: "Agronomist",
    psNoResults: "No professionals found",
    psExperience: "Experience",
    psLocation: "Location",
    psSpecialization: "Specialization",
    psSealLabel: "Seal",
    psContact: "Contact",
    psRecommend: "Recommend",
    psViewProfile: "View Profile",

    // ========== CALENDAR GUIDE MODAL ==========
    cgOverview: "Overview",
    cgDailyRecords: "Daily Records",
    cgHarvestSummary: "Harvest Summary",
    cgEthrelControl: "Ethrel Control",
    cgTeamManagement: "Team Management",
    cgReports: "Reports",
    cgTips: "Tips",
    cgWhatIsCalendar: "What is the Bleeding Calendar?",
    cgCalendarDesc: "The Bleeding Calendar is a complete tool for managing all activities on your rubber plantation property. Record bleedings, productions, product applications and track your team's performance.",
    cgMainFeatures: "Main Features:",
    cgFeature1: "Daily bleeding and production recording",
    cgFeature2: "Application control (Fungicide, Ethrel)",
    cgFeature3: "Team management and productivity",
    cgFeature4: "Automated monthly and yearly reports",
    cgFeature5: "Internal worker evaluations",
    cgFeature6: "Collection and weighing by lot",
    cgHowToStart: "How to Start:",
    cgStep1: "Select your property in the selector",
    cgStep2: "Choose the month you want to record",
    cgStep3: "Click on the day to open the form",
    cgStep4: "Fill in the day's information",

    // ========== PROPERTY FORM ==========
    pfPropertyName: "Property Name",
    pfLocation: "Location",
    pfCultureAge: "Culture Age (years)",
    pfExplorationTime: "Exploration Time (years)",
    pfTotalArea: "Total Area (hectares)",
    pfSave: "Save Property",

    // ========== ETHREL ALERT ==========
    eaEthrelAlert: "Ethrel Alert",
    eaDaysRemaining: "days remaining",
    eaApplied: "Application recorded",
    eaNextApplication: "Next application",
    eaConfigure: "Configure alerts",
    eaLastApplication: "Last application",

    // ========== YEARLY SUMMARY ==========
    ysYearlySummary: "Yearly Summary",
    ysTotalProduction: "Total Production",
    ysTotalBleedings: "Total Bleedings",
    ysAvgProduction: "Average Production",
    ysBestMonth: "Best Month",
    ysWorstMonth: "Worst Month",

    // CalendarGuide feature boxes
    cgProperties: "Properties",
    cgPropertiesDesc: "Register multiple properties with area, culture age and location information.",
    cgVisualCalendar: "Visual Calendar",
    cgVisualCalendarDesc: "View your activities in an intuitive monthly calendar with color codes.",
    cgAutoSummaries: "Automatic Summaries",
    cgAutoSummariesDesc: "Monthly and yearly totals automatically calculated with comparisons.",
    cgTeamMgmt: "Team Management",
    cgTeamMgmtDesc: "Track the individual productivity of each tapper on your team.",
    cgFirstSteps: "First Steps:",
    cgFirstStep1: "Create a property by clicking \"New Property\"",
    cgFirstStep2: "Select the property and desired month/year",
    cgFirstStep3: "Click on a calendar day to add records",
    cgFirstStep4: "Follow the automatically generated summaries and reports",

    // Additional calendar/table labels
    bdtCalendar: "Calendar",
    bdtTable: "Table",
    bdtSearchPlaceholder: "Search by worker or day...",
    bdtCollapseAll: "Collapse All",
    bdtExpandAll: "Expand All",
    bdtWorkerSingular: "worker",
    bdtWorkerPlural: "workers",
    bdtShowing: "Showing",
    bdtResults: "result(s)",

    // App.js calendar guide / legend
    appHowToUse: "How to use the Bleeding Calendar:",
    appPropertySelected: "Property selected",
    appChooseMonth: "Choose month/year above",
    appClickDayToAdd: "Click on the day to add",
    appUseTableToEdit: "Use \"Table\" to edit/delete",
    appLegend: "Legend:",
    appBleeding: "Bleeding",
    appReplacement: "Replacement",
    appFungicide: "Fungicide",
    appRain: "Rain",
    appProduction: "Production",
    appDaysWithoutRecord: "days without record this month",
    appYouHave: "You have",

    // YearlySummaryCard
    ysCompare: "Compare",
    ysExpand: "Expand",
    ysCollapse: "Collapse",
    ysPreviousHarvest: "Previous harvest",
    ysEthrelApps: "applications",
    ysFungicideLabel: "Fungicide",
    ysLosses: "Losses",
    ysRecords: "Records",
    ysHarvestPeriod: "Harvest period configured",
    ysTo: "to",
    ysPlants: "plants",

    // EthrelAlertBanner
    eaConfigureInterval: "Configure the interval between applications and when you want to receive alerts.",
    eaIntervalDays: "Interval between applications (days)",
    eaViewHistory: "View application history",

    // Misc calendar
    calendarGuideTitle: "Calendar Guide",
    configSafraBtn: "Harvest Settings",
    configSafraTooltip: "Configure plants per tapper, bleeding mode and team turnover per harvest season",
    tappers: "Tappers",
    limitReached: "Limit reached",
    of: "of",

    // ========== CALENDAR GUIDE MODAL - Full content ==========
    cgModalTitle: "Bleeding Calendar Guide",
    cgFooterText: "HeveaTalent • Bleeding Calendar",
    cgClose: "Close",
    cgRecHowToRegister: "How to Record Activities",
    cgRecClickAnyDay: "Click on any day in the calendar or use the table to add records.",
    cgRecAvailableFields: "Available Fields:",
    cgRecBleeding: "Bleeding",
    cgRecBleedingDesc: "Mark if bleeding occurred on this day. Track how many bleeding days per month.",
    cgRecProduction: "Production (kg)",
    cgRecProductionDesc: "Record the amount of latex/coagulum produced in kilograms.",
    cgRecRain: "Rain (mm)",
    cgRecRainDesc: "Precipitation volume in millimeters. Important for productivity analysis.",
    cgRecReplacement: "Replacement",
    cgRecReplacementDesc: "Number of trees that received panel or cup replacement.",
    cgRecFungicide: "Fungicide",
    cgRecFungicideDesc: "Mark when fungicide was applied to the trees.",
    cgRecEthrelDesc: "Record Ethrel applications including the proportion/concentration used.",
    cgRecDuplicate: "Duplicate for Another Tapper",
    cgRecDuplicateDesc: "When recording data, you can click \"Duplicate for another tapper\" to quickly create a similar record for another worker, changing only the name and adjusting values if needed.",
    cgSafraTitle: "Accumulated Harvest Summary",
    cgSafraDesc: "The harvest summary shows accumulated totals for the agricultural year (harvest), not the calendar year. This allows a more accurate analysis of your production.",
    cgSafraWhatIs: "What is a Harvest Year?",
    cgSafraWhatIsDesc: "The rubber harvest year usually runs from September to August of the following year. Example: Harvest 2024/2025 = September/2024 to August/2025.",
    cgSafraConfigNote: "You can configure the harvest start month in the property settings.",
    cgSafraMetrics: "Displayed Metrics:",
    cgSafraTotalProd: "Total Production (kg)",
    cgSafraTotalRain: "Total Rain (mm)",
    cgSafraTotalReplacements: "Total Replacements",
    cgSafraEthrelApps: "Ethrel Applications",
    cgSafraComparative: "Comparison with Previous Harvest",
    cgSafraComparativeDesc: "The system automatically compares with the previous harvest, showing:",
    cgSafraIncrease: "Increase compared to previous harvest",
    cgSafraDecrease: "Decrease compared to previous harvest",
    cgSafraConfigTitle: "How to Configure Harvest Start",
    cgSafraStep1: "Access the property settings (gear button)",
    cgSafraStep2: "Find the \"Harvest Start Month\" field",
    cgSafraStep3: "Select the month (default: September)",
    cgSafraStep4: "Save the changes",
    cgEthrelTitle: "Ethrel Application Control",
    cgEthrelDesc: "The system monitors Ethrel applications and alerts when the next application is near, helping maintain the ideal schedule.",
    cgEthrelHow: "How It Works:",
    cgEthrelStep1: "Configure the Interval",
    cgEthrelStep1Desc: "Set how many days between each application (e.g., 30 days)",
    cgEthrelStep2: "Configure the Alert",
    cgEthrelStep2Desc: "Set how many days in advance you want to be alerted (e.g., 5 days)",
    cgEthrelStep3: "Record the Applications",
    cgEthrelStep3Desc: "When recording a day, check \"Ethrel\" and enter the proportion used",
    cgEthrelBanner: "Alert Banner",
    cgEthrelBannerDesc: "The banner appears at the top of the calendar showing:",
    cgEthrelBannerItem1: "Date of last application",
    cgEthrelBannerItem2: "Days since last application",
    cgEthrelBannerItem3: "Days remaining until next",
    cgEthrelBannerItem4: "Visual alert when near or overdue",
    cgEthrelColors: "Status Colors:",
    cgEthrelGreen: "Green: Ethrel up to date",
    cgEthrelYellow: "Yellow: Application approaching",
    cgEthrelRed: "Red: Application overdue",
    cgEthrelConcentration: "Proportion/Concentration",
    cgEthrelConcentrationDesc: "When recording an Ethrel application, you can enter the proportion used (e.g., \"2.5%\" or \"1:40\"). This is saved in history for future reference.",
    cgTeamTitle: "Team Management and Productivity",
    cgTeamTitleDesc: "Track the individual performance of each tapper on your team with detailed productivity reports.",
    cgTeamDatabase: "Tapper Database",
    cgTeamDatabaseDesc: "The system maintains a registry of tappers that appear in your records:",
    cgTeamDbItem1: "Name is automatically registered when creating records",
    cgTeamDbItem2: "Individual production history",
    cgTeamDbItem3: "Days worked statistics",
    cgTeamReport: "Team Report",
    cgTeamReportDesc: "The team report shows:",
    cgTeamRanking: "Production Ranking",
    cgTeamAvgTapper: "Average per Tapper",
    cgTeamDaysWorked: "Days Worked",
    cgTeamProdPerDay: "Productivity/Day",
    cgTeamMultiple: "How to Record Multiple Tappers",
    cgTeamMultipleDesc: "To make it easier to record multiple tappers on the same day:",
    cgTeamMultiStep1: "Create the first tapper's record normally",
    cgTeamMultiStep2: "After saving, click \"Duplicate for another tapper\"",
    cgTeamMultiStep3: "The form reopens with the same data - change the name and adjust values",
    cgTeamMultiStep4: "Repeat for all tappers of the day",
    cgTeamIndTip: "Tip: Individual Productivity",
    cgTeamIndTipDesc: "For accurate individual productivity analysis, always record data separately per tapper, including the name in the \"Tapper\" field of the form.",
    cgRptTitle: "Reports and Analysis",
    cgRptTitleDesc: "The system automatically generates detailed reports to track your production and team.",
    cgRptTypes: "Report Types:",
    cgRptMonthlySummary: "Monthly Summary",
    cgRptMonthlySummaryDesc: "Overview of the month with production totals, rain, bleeding days, replacements and applications. Appears automatically at the top of the calendar.",
    cgRptHarvestSummary: "Harvest Summary",
    cgRptHarvestSummaryDesc: "Agricultural year (harvest) accumulated with previous harvest comparison. Includes month-by-month breakdown.",
    cgRptTeamReport: "Team Report",
    cgRptTeamReportDesc: "Individual productivity ranking, averages per tapper, days worked and performance comparisons.",
    cgRptDailyTable: "Daily Table",
    cgRptDailyTableDesc: "Detailed list of all records for the month in table format, with options to edit and delete records.",
    cgRptExport: "Export Reports",
    cgRptExportDesc: "Some reports can be exported to PDF or printed directly. Look for the \"Save PDF / Print\" button in report sections.",
    cgTipTitle: "Tips for Best Use",
    cgTipTitleDesc: "Make the most of the Bleeding Calendar with these practical tips.",
    cgTipDaily: "Record Daily",
    cgTipDailyDesc: "Build the habit of recording activities at the end of each work day. Updated data ensures accurate reports.",
    cgTipMobile: "Access from Mobile",
    cgTipMobileDesc: "The calendar is optimized for mobile. Record data directly from the field without waiting to get home.",
    cgTipIdentify: "Identify the Tappers",
    cgTipIdentifyDesc: "Always fill in the \"Tapper\" field in records for accurate individual productivity analysis.",
    cgTipEthrelAlerts: "Configure Ethrel Alerts",
    cgTipEthrelAlertsDesc: "Don't miss the timing of Ethrel applications. Set the interval and receive automatic alerts.",
    cgTipRain: "Record Rain",
    cgTipRainDesc: "Even on days without bleeding, record precipitation. This helps understand productivity patterns over time.",
    cgTipReports: "Review Reports",
    cgTipReportsDesc: "Periodically analyze harvest and team reports to identify improvement opportunities in production.",
    cgTipQuestions: "Questions? Share in the Community tab and exchange experiences with other rubber farmers!",

    // ========== PROFESSIONALS SEARCH VIEW ==========
    psTitle: "Search Professionals",
    psSubtitle: "Find the best rubber farming professionals",
    psSearchFilters: "Search Filters",
    psSpecialization: "Specialization",
    psAll: "All",
    psSangrador: "Tapper",
    psFieldManager: "Field Manager",
    psAgronomist: "Agronomist",
    psMachineOperator: "Machine Operator",
    psOthers: "Others",
    psAllProfs: "All",
    psJoinedSystem: "Joined Evaluation System",
    psAllProfessionals: "All Professionals",
    psOnlyRecommended: "Only recommended",
    psSearching: "Searching professionals...",
    psNoResults: "No professionals found with the selected filters.",
    psAchievements: "Achievements",
    psAvailable: "Available",
    psQualitySeal: "Quality Seal",
    psExperience: "Experience",
    psOnPlatform: "On platform",
    psSince: "Since",
    psRecommendations: "Recommendations",
    psContactProfessional: "Contact Professional",
    psPhoneNotAvailable: "Phone not available. Contact through the platform.",
    psTip: "Mention that you found the professional through HeveaTalent for a better experience.",

    // ContextualPerformance - remaining
    cpTappingSystems: "Tapping Systems",
    cpFactor: "Factor",
    cpSelectRegion: "Select Region:",
    cpHighPeak: "High/Peak",
    cpNormal: "Normal",
    cpLowRecovery: "Low/Recovery",
    cpStopped: "Stopped",
    cpHowSealsWork: "How do seals work?",
    cpYourCurrentSeal: "Your Current Seal",
    cpLoadingSealInfo: "Loading seal information...",
    cpExpertTapper: "Expert Tapper",
    cpProfessionalTapper: "Professional Tapper",
    cpCertifiedTapper: "Certified Tapper",
    cpNoSealYet: "No seal achieved yet",
    cpKeepEvolving: "Keep evolving to earn badges!",
    cpLast12Seals: "Your last 12 earned seals",
    cpSealLevels: "Seal Levels:",
    cpScoreCalculation: "Score Calculation:",
    cpNoContextData: "No contextual data? Your seal will be 100% based on the technical evaluation.",
    cpRef: "Ref.",

    // ========== MARKET MODULE ==========
    maLoadingData: "Loading data...",
    maImportPrice: "Import Price (IEA)",
    maImportPriceDesc: "TOTAL cost to import processed rubber. Includes: international price + exchange rate + freight + insurance + taxes (~10.8%) + port costs. Serves as \"ceiling\" - the maximum the industry would pay.",
    maAdjustDrc: "Adjust the DRC and Participation Rate to simulate different price scenarios.",
    maCoaguloDrc: "Coagulum DRC 53%",
    maProdCost: "Production Cost (COT)",
    maParticipationRate: "Participation Rate (%)",
    maReference: "Reference",
    maBaseValue: "Base Value",
    maWithDrc: "With DRC",
    maWithRate: "With Rate",
    maCurrentCoagulo: "Last paid",
    maOnImportPrice: "On Import Price",
    maOnGeb10Apabor: "On GEB-10 APABOR",
    maOnGeb10Market: "On GEB-10 Market SP",
    maCotTotal: "Total Operating Cost (COT)",
    maCotDesc: "Includes depreciation and remuneration",
    maCoeTotal: "Effective Operating Cost (COE)",
    maCoeDesc: "Direct production costs",
    maCurrentPrice: "Current Coagulum Price",
    maDiffCot: "Difference on COT",
    maDiffCoe: "Difference on COE",
    maDataSources: "Data Sources",
    maAllReferences: "All references presented",
    maOfficialSources: "Official verifiable sources",
    maClearData: "Clear data for decision making",
    pcImportant: "Important: Price References",
    pcImportPriceIEA: "Import Price (IEA/CNA)",
    pcIsCeiling: "is the theoretical ceiling.",
    pcDifference: "Difference of",
    pcOfficialFormula: "Official Formula (CNA/FAESP/IEA)",
    pcProducerPrice: "Producer Price",
    pcPreview: "Preview",
    pcRealTimePreview: "Preview (real-time)",
    pcEstimatedPrice: "Estimated Price per kg",
    pcReferenceLabel: "Reference:",
    pcParticipationRate: "Participation Rate:",
    pcFinalPrice: "Final Price:",
    pcMarket: "Market (coagulum):",
    pcProductionCost: "Production cost (COT):",
    pcMargin: "Margin:",
    pcProduction: "Production",
    pcRevenue: "Revenue",
    pcCost: "Cost",
    pcProfitLoss: "Profit/Loss",
    pcValue: "Value",
    pcRate: "Rate",
    qpLoadingQuotes: "Loading market quotes...",
    qpNegotiationRef: "Reference for negotiation between mills and producers",
    qpBimonthlyUpdate: "Bimonthly",
    qpUpdate: "Update",
    qpCoaguloRealPrice: "Coagulum (Real Price)",
    qpRealPriceDesc: "Real price paid to the producer in the market",
    qpMonthlyUpdate: "Monthly",
    qpDays15to20: "(days 15-20)",
    qpInternationalSGX: "International (SGX)",
    qpSGXDesc: "Rubber price on Singapore Exchange",
    qpDollarBCB: "Dollar (BCB)",
    qpDollarDesc: "Exchange rate (automatic update)",
    qpProdCostCONAB: "Production Cost (CONAB)",
    qpProdCostDesc: "To calculate producer margin",
    qpAutomatic: "Automatic:",
    qpManual: "Manual:",
    qpCalculation: "Calculation:",
    qpProdMargin: "Producer Margin",
    dsInternationalSGX: "International (SGX)",
    dsDollarBCB: "Dollar (BCB)",
    dsProdCostCOT: "Production Cost (COT)",
    scProductionChain: "Production Chain",
    scProducer: "Producer",
    scProcessor: "Mill",
    scIndustry: "Industry",
    pfClimateFactors: "Climate Factors",
    pfDemandFactors: "Demand Factors",
    pfPolicyFactors: "Policy Factors",

    // EditProductDialog
    edModifyProduct: "Modify your product information",
    edProductTitle: "Product Title",
    edPrice: "Price",
    edFullLocation: "Full Location",
    edProductDesc: "Product Description",
    edContactInfo: "Contact Information",
    edPhotosVideos: "Photos and Videos",
    edCondition: "Condition",
    edNew: "New",
    edSemiNew: "Like New",
    edUsed: "Used",

    // PropertyFormDialog
    pfNewProperty: "New Property",
    pfPropertyName: "Property Name",
    pfLocationLabel: "Location",
    pfCultivationYears: "Rubber Tree Cultivation Years",
    pfTotalAreaHa: "Total Area (hectares)",
    pfNotes: "Notes",

    // EvaluationForm evaluator types
    evAgronomistWeight: "Agronomist Engineer (weight 3x)",
    evTechnicianWeight: "Agricultural Technician (weight 3x)",
    evTeamLeaderWeight: "Team Leader (weight 1x)",
    evOwnerWeight: "Owner (weight 1x)",
    evOtherWeight: "Other (weight 1x)",

    // TechnicalReferences
    trBack: "Back",
    trTitle: "Technical References",
    trContentCovered: "Content covered:",
    trWhySources: "Why do we use these sources?",
    trHowToUse: "How to use in evaluation?",

    // ========== REMAINING I18N KEYS ==========
    weekDaySun: "Sun",
    weekDayMon: "Mon",
    weekDayTue: "Tue",
    weekDayWed: "Wed",
    weekDayThu: "Thu",
    weekDayFri: "Fri",
    weekDaySat: "Sat",
    mcvTooltipDay: "Day",
    mcvWorkerSingle: "worker",
    mcvWorkerPlural: "workers",
    mcvBleedingPerformed: "Bleeding performed",
    mcvReplacements: "Replacements",
    mcvActivityRegistered: "Activity registered",
    mcvFungicide: "Fungicide",
    mcvEthrel: "Ethrel",
    mchProduction: "Production",
    mchActivities: "Activities",
    mchBleedingDays: "Bleeding Days",
    mchReplacements: "Replacements",
    mchTotalRain: "Total Rain",
    mchMonthlyGoal: "Monthly goal: 500kg (example)",
    bdtDeleteConfirm: "WARNING: Are you sure you want to delete this record?\n\nThis action cannot be undone.",
    bdtDeleteSuccess: "Record deleted successfully!",
    bdtDeleteError: "Error deleting record",
    bdtUnknownError: "Unknown error",
    bdtNoName: "No name",
    evWorkerIdRequired: "Worker ID is required",
    evCreateError: "Error creating evaluation",
    evConnectionError: "Error connecting to server. Check your connection.",
    evChange: "Change",
    evFungicideApplication: "Fungicide Application",
    recEnterEmployerName: "Enter the former employer's name",
    recErrorCreatingInvite: "Error creating invite",
    recConnectionError: "Connection error",
    recCancelInvite: "Cancel this invite?",
    recLinkCopied: "Link copied!",
    recConfirmRemove: "Are you sure you want to remove this recommendation from your profile?",
    ctMaxImages: "Maximum images allowed",
    ctFormatNotSupported: "Format not supported. Use JPG, PNG or WEBP",
    ctImageTooLarge: "Image too large. Maximum size: 5MB",
    ctErrorUploadImage: "Error uploading image. Try again.",
    ctErrorAddComment: "Error adding comment",
    ctFillTitleContent: "Please fill in the title and content of the tip.",
    ctErrorShareTip: "Error sharing tip",
    ctSending: "Sending...",
    ctAddPhoto: "Add photo",
    mkConfirmRemoveAd: "Are you sure you want to remove this ad?",
    mkAdRemoved: "Ad removed successfully!",
    mkErrorRemoveAd: "Error removing ad",
    mkErrorCreatePix: "Error creating PIX payment",
    mkPaymentConfirmed: "Payment confirmed! Your item is now featured!",
    cpContextCreated: "Context created successfully!",
    cpErrorCreateContext: "Error creating context",
    cpSaveContext: "Save Context",
    cpSelectPropertyFirst: "Select a property first",
    wdErrorLoadData: "Error loading data. Please try again later.",
    coSelectBondType: "Select your bond type",
    coErrorProcessing: "Error processing membership",
    coAcceptConsent: "You need to accept the consent terms",
    coErrorConsent: "Error processing consent",
    spErrorSubscription: "Error processing subscription",
    recCopyLink: "Copy Link",
    recCreateInviteDesc: "Create a link for your former employer to send a recommendation, even without having an account on the platform.",
    recFormerEmployerName: "Former Employer's Name",
    recEmailPhone: "Email or Phone (optional)",
    recForControl: "For your records",
    recCreating: "Creating...",
    recCreateInvite: "Create Invite",
    recSendRecommendation: "Send Recommendation",
    ctSendComment: "Send Comment",
    ctShareTip: "Share Tip",
    mkVideo: "Video",
    mkPhotos: "Photos",
    mkExample: "Example",
    mkFeatured: "Featured",
    mkSeeFullDetails: "See full details",
    mkDaysRemaining: "days remaining",
    mkDayRemaining: "day remaining",
    mkFeature: "Feature",
    mkRemove: "Remove",
    mkLocation: "Location",
    mkPublishedOn: "Published on",
    mkAdExpiresIn: "This ad expires in",
    mkDays: "days",
    mkRenewToKeepActive: "Renew to keep active!",
    mkSeller: "Seller",
    mkThumbnail: "Thumbnail",
    mkGoToImage: "Go to image",
    mkPhoto: "Photo",
    mkOf: "of",
    eaConfigTitle: "Ethrel Configuration",
    eaConfigTooltip: "Configure the ideal interval between Ethrel applications for your property. The system will automatically alert you when the next application is approaching.",
    eaIntervalHint: "Number of days between each Ethrel application",
    eaAlertAdvance: "Alert in advance (days)",
    eaAlertAdvanceTooltip: "Set how many days before the deadline you want to be alerted.",
    eaAlertAdvanceHint: "How many days before the next application the alert should appear",
    eaPreviewSummary: "You will receive alerts",
    eaPreviewDaysBefore: "days before completing",
    eaPreviewDaysSince: "days since the last application.",
    eaAlertLevels: "Alert Levels",
    eaCritical: "Application overdue",
    eaUrgent: "3 days or less remaining",
    eaWarning: "Within alert period",
    eaOk: "Application up to date",
    eaSaveConfig: "Save Configuration",
    eaConfigSaved: "Ethrel configuration saved successfully!",
    eaEthrelControl: "Ethrel Control",
    eaEthrelTooltip: "Ethrel is a latex stimulant applied periodically. Configure the interval between applications to receive automatic alerts.",
    eaConfigureToReceive: "Configure the application interval to receive alerts",
    eaLot: "Lot",
    eaProportion: "Proportion",
    eaDaysSinceLastApp: "days since last application",
    eaIntervalLabel: "interval",
    eaDismiss: "Dismiss",
    eaIntervalTooltip: "Set how many days you normally wait between each Ethrel application. Example: if you apply every 30 days, enter 30.",
    processingPayment: "Processing payment...",
    pleaseWait: "Please wait while we confirm your payment.",
    paymentConfirmedTitle: "Payment confirmed!",
    paymentConfirmedDesc: "Your plan has been activated successfully.",
    goToDashboard: "Go to Dashboard",
    paymentTimeout: "Timed out",
    paymentTimeoutDesc: "Could not confirm. Please check your email.",
    paymentError: "Payment error",
    paymentErrorDesc: "An error occurred. Please try again.",
    backToPlans: "Back to Plans",
    paymentCancelled: "Payment cancelled",
    paymentCancelledDesc: "No charges were made. You can come back and choose a plan whenever you want.",
    redirectingToPayment: "Redirecting to payment...",
    plan: "Plan",
    annualTipTitle: "Save with annual plan",
    annualTipDesc: "All paid plans offer 8% discount on annual subscription. That's approximately 1 free month per year!",
    mySubscription: "My Subscription",
    active: "Active",
    premiumLifetime: "Lifetime access to all features",
    freePlanDesc: "Free plan with limited resources",
    expiresAt: "Expires on",
    expiringSoon: "Expiring soon! Renew to keep access.",
    upgradePlan: "Upgrade Plan",
    changePlan: "Change Plan",
    cancelSubscription: "Cancel Subscription",
    cancelSubscriptionConfirm: "Are you sure you want to cancel? Your plan will remain active until expiry.",
    subscriptionCancelled: "Subscription cancelled. Will remain active until expiry.",
    planResources: "Plan Resources",
    properties: "Properties",
    workers: "Workers",
    paymentHistory: "Payment History",
    paid: "Paid",
    activeItems: "Active Items",
    upgradeTitle: "Unlock full potential!",
    upgradeDesc: "Upgrade to access full calendar, evaluations, team management and much more.",
    seeAllPlans: "See All Plans",
    processing: "Processing...",
    currencyBRL: "Real (R$)",
    currencyUSD: "Dollar (US$)"
  },
  
  es: {
    // ========== HEADER & NAVIGATION ==========
    login: "Iniciar Sesión",
    register: "Registrarse",
    logout: "Cerrar Sesión",
    heveicultureProfessional: "Heveicultura Profesional",
    welcome: "Bienvenido",
    profile: "Perfil",
    settings: "Configuración",
    
    // ========== LANDING PAGE ==========
    // Hero Section
    heroTitle: "Conectando Talentos en",
    heroSubtitle: "Cultivo de Caucho",
    heroDescription: "La plataforma especializada que conecta propietarios rurales con profesionales calificados del sector del cultivo de caucho. Encuentra los mejores sangradores, gerentes, inspectores e ingenieros agrónomos.",
    startFree: "Comenzar Gratis",
    learnMore: "Saber Más",
    
    // Landing Features
    manageHeveiculture: "Gestiona tu cultivo de caucho",
    findBestProfessionals: "y encuentra los mejores profesionales",
    completePlatform: "La plataforma completa para productores y trabajadores del cultivo de caucho",
    jobBoard: "Bolsa de Empleo",
    community: "Comunidad",
    bleedingCalendar: "Calendario de Sangría",
    teamManagement: "Gestión de Equipo",
    workerCertification: "Certificación de Trabajadores",
    seeHowItWorks: "Ver cómo funciona",
    
    // Landing Cards
    simplicity: "Simplicidad",
    simplicityDesc: "Interfaz intuitiva diseñada para el campo. Fácil de usar en cualquier dispositivo.",
    security: "Seguridad",
    securityDesc: "Tus datos protegidos con LGPD. Perfiles verificados y evaluaciones auténticas.",
    fairness: "Transparencia",
    fairnessDesc: "Sistema de evaluación transparente. Reconocimiento por mérito y experiencia.",
    
    forEmployers: "Para Empleadores",
    forEmployersDesc: "Publica trabajos y encuentra profesionales calificados con sistema de certificación",
    forProfessionals: "Para Profesionales",
    forProfessionalsDesc: "Ofrece tus servicios y construye tu reputación con nuestro sistema de insignias",
    marketplaceDesc: "Compra y vende propiedades, herramientas, insumos y maquinaria",
    communityDesc: "Comunidad activa para compartir consejos y conocimientos",
    
    findIdealProfessional: "Cómo Encontrar el Profesional Ideal",
    
    // ========== MAIN SECTIONS ==========
    jobCenter: "Centro de Empleos",
    marketplace: "Mercado",
    certifiedProfessionals: "Profesionales Certificados",
    agriculturalMarketplace: "Mercado Agrícola",
    jobs: "Empleos",
    evaluations: "Evaluaciones",
    plans: "Planes",
    calendar: "Calendario",
    reports: "Informes",
    performance: "Desempeño",
    marketAnalysisTab: "Cotações",
    marketAnalysisDesc: "Cotizaciones, calculadora y análisis de precios del caucho",
    professionals: "Profesionales",
    communityTips: "Consejos de la Comunidad",
    
    // ========== MARKETPLACE ==========
    properties: "Propiedades",
    tools: "Herramientas",
    supplies: "Insumos",
    pesticides: "Pesticidas",
    machinery: "Maquinaria",
    others: "Otros",
    sellProduct: "Vender Producto",
    myAds: "Mis Anuncios",
    browseProducts: "Explorar Productos",
    announceProduct: "Anunciar Producto",
    publishAd: "Publicar Anuncio",
    productTitle: "Título del Producto",
    category: "Categoría",
    selectCategory: "Seleccionar categoría",
    price: "Precio (R$)",
    condition: "Condición",
    location: "Ubicación",
    productDescription: "Descripción del Producto",
    contactInfo: "Información de Contacto",
    productImages: "Imágenes del Producto (URLs)",
    new: "Nuevo",
    seminew: "Semi-nuevo",
    used: "Usado",
    feature: "Destacar",
    featureAd: "🔥 Destacar - R$ 9,90",
    remove: "Eliminar",
    removeAd: "Eliminar Anuncio",
    productPublished: "¡Producto publicado exitosamente!",
    errorPublishing: "Error al crear anuncio",
    adRemoved: "¡Anuncio eliminado exitosamente!",
    errorRemoving: "Error al eliminar anuncio",
    
    // ========== JOBS ==========
    publishJob: "Publicar Empleo",
    searchJobs: "Buscar Empleos",
    myJobs: "Mis Empleos",
    jobTitle: "Título del Empleo",
    jobDescription: "Descripción del Empleo",
    salary: "Salario",
    requirements: "Requisitos",
    benefits: "Beneficios",
    applyNow: "Postularse",
    applications: "Postulaciones",
    
    // ========== FORMS ==========
    fullName: "Nombre Completo",
    email: "Email",
    password: "Contraseña",
    userType: "Tipo de Usuario",
    selectType: "Seleccionar tipo",
    employer: "Empleador/Propietario",
    professional: "Profesional",
    phone: "Teléfono",
    company: "Empresa/Propiedad",
    experienceYears: "Años de Experiencia",
    specialization: "Especialización",
    save: "Guardar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    delete: "Eliminar",
    edit: "Editar",
    update: "Actualizar",
    create: "Crear",
    record: "Registro",
    search: "Buscar",
    filter: "Filtrar",
    clear: "Limpiar",
    
    // ========== SPECIALIZATIONS ==========
    tapper: "Sangrador",
    generalManager: "Gerente General",
    inspector: "Inspector",
    agronomist: "Ingeniero Agrónomo",
    
    // ========== TECHNICAL QUALIFICATION (EVALUATION SYSTEM) ==========
    technicalQualification: "Calificación Técnica",
    technicalQualificationDesc: "Su calificación determina el peso de las evaluaciones que realiza",
    qualificationEngineer: "Ingeniero Agrónomo",
    qualificationTechnician: "Técnico Agrícola",
    qualificationLeader: "Líder de Equipo",
    qualificationOwner: "Propietario",
    qualificationOther: "Otro",
    selectQualification: "Seleccione su calificación",
    
    // Evaluation Types
    evaluationTypeTechnical: "Evaluación Técnica",
    evaluationTypeEmployer: "Evaluación de Empleador",
    technicalSeal: "Sello Técnico",
    technicalSealDesc: "Basado en evaluaciones de profesionales técnicos certificados (peso 3x)",
    employerEvaluations: "Evaluaciones de Empleadores",
    employerEvaluationsDesc: "Historial de evaluaciones de propietarios (peso 1x)",
    weightedScore: "Puntuación Ponderada",
    weightedScoreDesc: "Promedio ponderado: evaluaciones técnicas (3x) + evaluaciones de empleadores (1x)",
    noTechnicalEvaluations: "Sin evaluaciones técnicas aún",
    noEmployerEvaluations: "Sin evaluaciones de empleadores aún",
    
    // ========== EVOLUTION CHART ==========
    performanceEvolution: "Evolución del Desempeño",
    last12Months: "Últimos 12 meses",
    currentSeal: "Sello Actual",
    trend: "Tendencia",
    lastThreeMonths: "Últimos 3 meses",
    technicalEvaluations: "Evaluaciones Técnicas",
    employerEvaluationsShort: "Empleadores",
    weight3x: "Peso 3x",
    weight1x: "Peso 1x",
    noEvaluationsYet: "Sin evaluaciones aún",
    firstEvaluationMessage: "Los datos aparecerán después de la primera evaluación",
    sealGold: "Oro",
    sealSilver: "Plata",
    sealBronze: "Bronce",
    sealNone: "Sin sello",
    
    // ========== ACHIEVEMENT SYSTEM ==========
    achievementSystem: "Sistema de Logros",
    allProfessionalsWelcome: "¡Todos los profesionales son bienvenidos! Gana insignias mientras creces en la plataforma.",
    firstAccess: "Primer acceso",
    firstRating: "Primera Calificación",
    positiveFeedback: "Comentarios positivos",
    activeProfessional: "Profesional Activo",
    completedJobs: "5+ trabajos completados",
    experienced: "Experimentado",
    oneYearPlatform: "1 año en la plataforma",
    
    // ========== TIME ==========
    immediate: "Inmediato",
    oneMonth: "1 mes",
    twoMonths: "2 meses",
    threeMonths: "3 meses",
    days: "días",
    hours: "horas",
    minutes: "minutos",
    today: "Hoy",
    yesterday: "Ayer",
    
    // ========== PLANS ==========
    plansForEmployers: "Planes para Empleadores",
    plansForProfessionals: "Planes para Profesionales",
    currentPlan: "Plan Actual",
    recommended: "Recomendado",
    selectPlan: "Seleccionar Plan",
    startTrial: "Iniciar Prueba Gratis",
    freeTrial: "días gratis para probar",
    monthly: "mes",
    yearly: "año",
    free: "Gratis",
    unlimited: "Ilimitado",
    
    // Plan Features
    propertiesLimit: "propiedades",
    jobPostings: "anuncios en bolsa de empleo",
    marketplaceAds: "anuncios en mercado",
    teamManagement: "Gestión de equipo",
    fullCalendar: "Calendario completo",
    basicReports: "Informes básicos",
    fullReports: "Informes completos",
    freeHighlights: "destacados gratis/mes",
    
    // Trial Messages
    trialExpired: "Período de Prueba Expirado",
    trialExpiredMessage: "Tu período de prueba ha terminado. Actualiza para continuar.",
    trialRemaining: "días restantes en el período de prueba",
    dataPreserved: "Tus datos están guardados y se recuperarán después de la actualización.",
    
    // ========== AVULSO ITEMS ==========
    avulsoItems: "Artículos Individuales",
    avulsoDescription: "Compra recursos extras sin cambiar de plan",
    highlight: "Destacar Anuncio",
    highlightDesc: "Tu anuncio aparece en la parte superior de las listas por 7 días",
    extraAdJob: "Anuncio Extra - Bolsa de Empleo",
    extraAdJobDesc: "1 publicación adicional en la bolsa de empleo por 30 días",
    extraAdMarketplace: "Anuncio Extra - Mercado",
    extraAdMarketplaceDesc: "1 anuncio adicional en el mercado por 30 días",
    buyHighlight: "Comprar Destacado",
    buyAd: "Comprar Anuncio",
    paymentViaPix: "Pago vía PIX • Activación inmediata después de la confirmación",
    
    // ========== BANNER ==========
    growWithHeveaTalent: "Crece con HeveaTalent",
    discoverPlansAndResources: "Descubre los planes disponibles y recursos",
    
    // ========== CALENDAR ==========
    bleedingCalendarTitle: "Calendario de Sangría - Cultivo de Caucho",
    newProperty: "Nueva Propiedad",
    propertySelection: "Selección de Propiedad",
    noPropertiesRegistered: "No hay propiedades registradas",
    createFirstProperty: "Crea tu primera propiedad para comenzar a usar el calendario de sangría",
    createProperty: "Crear Primera Propiedad",
    selectProperty: "Selecciona una propiedad",
    monthlyProduction: "Producción Mensual",
    totalProduction: "Producción Total",
    averageDaily: "Promedio Diario",
    activeDays: "Días Activos",
    workingDays: "Días Trabajados",
    
    // Calendar Tips
    calendarTipTitle: "Cómo usar el Calendario de Sangría:",
    calendarTip1: "Registra la producción diaria de cada sangrador",
    calendarTip2: "Sigue el desempeño mensual y anual",
    calendarTip3: "Compara la productividad entre trabajadores",
    
    // ========== EVALUATIONS ==========
    evaluationSystem: "Sistema de Evaluación",
    giveEvaluation: "Dar Evaluación",
    receiveEvaluation: "Recibir Evaluación",
    internalEvaluation: "Evaluación Interna",
    privateControl: "Control Interno (Privado)",
    evaluationSent: "¡Evaluación enviada exitosamente!",
    errorSendingEvaluation: "Error al enviar evaluación",
    
    // ========== COMMUNITY ==========
    communityTipsTitle: "Consejos de la Comunidad",
    shareTip: "Compartir Consejo",
    shareYourTip: "Comparte tu consejo o experiencia:",
    tipCategory: "Categoría (sangría, herramientas, salud, clima, otros):",
    tipShared: "¡Consejo compartido exitosamente!",
    errorSharingTip: "Error al compartir consejo. Inténtalo de nuevo.",
    writeComment: "Escribe tu comentario aquí...",
    leaveComment: "Deja un comentario (opcional)",
    send: "Enviar",
    like: "Me gusta",
    comment: "Comentar",
    comments: "comentarios",
    likes: "me gusta",
    
    // ========== MESSAGES ==========
    loading: "Cargando...",
    searching: "Buscando...",
    saving: "Guardando...",
    creating: "Creando...",
    sending: "Enviando...",
    registering: "Registrando...",
    loggingIn: "Iniciando sesión...",
    success: "¡Éxito!",
    error: "Error",
    warning: "Advertencia",
    info: "Información",
    
    // Error Messages
    errorLogin: "Error de inicio de sesión. Verifica tus credenciales.",
    forgotPassword: "Olvidé mi contraseña",
    forgotPasswordTitle: "Recuperar contraseña",
    forgotPasswordDesc: "Ingresa tu correo y te enviaremos un código y un enlace para restablecer tu contraseña.",
    sendCode: "Enviar código",
    sending: "Enviando...",
    alreadyHaveCode: "Ya tengo un código",
    codeSentInfo: "Si el correo está registrado, recibirás un código de verificación. Revisa también la carpeta de spam.",
    verificationCode: "Código de verificación",
    newPasswordLabel: "Nueva contraseña",
    confirmPasswordLabel: "Confirmar nueva contraseña",
    resetPasswordBtn: "Restablecer contraseña",
    resetting: "Restableciendo...",
    passwordsDontMatch: "Las contraseñas no coinciden",
    passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
    passwordResetSuccess: "¡Contraseña restablecida con éxito! Inicia sesión con tu nueva contraseña.",
    invalidResetLink: "Enlace inválido o expirado. Solicita un nuevo correo de recuperación.",
    backToLogin: "Volver al inicio",
    requestNewEmail: "Solicitar nuevo correo",
    freeHighlightAvailablePrefix: "¡Tienes",
    freeHighlightAvailableSuffix: "destaque(s) gratis este mes!",
    useFreeHighlight: "Usar destaque gratis",
    freeHighlightUsed: "Destaque gratis del mes ya utilizado",
    renewsOn: "Se renueva el",
    chooseAdToHighlight: "Elige uno de tus anuncios para destacarlo por 7 días, sin costo.",
    applyFreeHighlight: "Aplicar destaque gratis",
    applying: "Aplicando...",
    noAdsToHighlight: "No tienes anuncios activos para destacar. Crea un anuncio primero.",
    freeHighlightSuccess: "¡Destaque gratis aplicado!",
    freeHighlightError: "No se pudo aplicar el destaque",
    jobBoardLabel: "Bolsa de empleo",
    marketplaceLabel: "Marketplace",
    errorRegister: "Error de registro",
    errorLoading: "Error al cargar datos",
    errorSaving: "Error al guardar",
    errorDeleting: "Error al eliminar",
    errorUnknown: "Error desconocido",
    
    // ========== MISC ==========
    all: "Todos",
    active: "Activo",
    inactive: "Inactivo",
    pending: "Pendiente",
    completed: "Completado",
    yes: "Sí",
    no: "No",
    or: "o",
    and: "y",
    of: "de",
    in: "en",
    for: "para",
    with: "con",
    without: "sin",
    more: "más",
    less: "menos",
    seeMore: "Ver más",
    seeLess: "Ver menos",
    viewAll: "Ver todos",
    close: "Cerrar",
    back: "Volver",
    next: "Siguiente",
    previous: "Anterior",
    finish: "Finalizar",
    sendComment: "Enviar Comentario",
    sending: "Enviando...",
    generating: "Generando...",
    generate: "Generar",
    generateReport: "Generar Informe",
    generateTeamReport: "Generar Informe del Equipo",
    teamButton: "Equipo",
    monthlyReport: "Informe Mensual",
    teamReport: "Informe del Equipo",
    reportPeriod: "Período del Informe",
    reportMonth: "Mes del Informe",
    closeReport: "Cerrar Informe",
    closeDatabase: "Cerrar Base de Datos",
    savePdfPrint: "Guardar PDF / Imprimir",
    printReport: "Imprimir Informe",
    consultData: "Consultar Datos",
    editRecord: "Editar registro",
    deleteRecord: "Eliminar registro",
    addDataForDay: "Agregar datos para este día",
    newRecord: "Nuevo Registro",
    editProduct: "Editar Producto",
    saveChanges: "Guardar Cambios",
    addByUrl: "O Agregar por URL",
    uploading: "Cargando",
    add: "Agregar",
    generatePix: "Generar PIX",
    verifiedIdentity: "Identidad Verificada",
    bleedingPerformed: "Sangría Realizada",
    openChat: "Abrir Chat",
    mobileFriendlyTip: "Haz clic en el botón para abrir el formulario completo.",
    useEditToModify: "Usa Editar para modificar registros existentes.",
    
    // Tooltips - Cómo usar
    tooltipJobPosting: "💡 Ofertas de Empleo: Publica un trabajo para encontrar profesionales certificados con sellos Bronce, Plata u Oro. Incluye título, descripción, ubicación, salario y requisitos.",
    tooltipWorkOffer: "💡 Oferta de Servicio: Registra tus servicios para que los empleadores te encuentren en la búsqueda de profesionales. Describe tus habilidades, experiencia y disponibilidad.",
    tooltipSearchJobs: "💡 Buscar Trabajos: Navega por los empleos publicados por propietarios. Haz clic en uno para ver detalles y usa el chat HeveaTalent para contactar.",
    tooltipMyOffers: "💡 Mis Ofertas y Recomendaciones: Gestiona tus ofertas de servicio. Abajo, ve tus recomendaciones y invita a ex-empleadores a recomendarte — incluso quienes no tienen cuenta. Más recomendaciones = más visibilidad. HeveaTalent crece contigo!",
    tooltipMarketplace: "💡 Marketplace: Compra y vende productos, equipos e insumos relacionados con la heveicultura.",
    tooltipCalendar: "💡 Calendario de Sangría: Registra sangrado diario, producción en kg, lluvia y aplicaciones. Tus registros alimentan el Rendimiento Contextual, que contribuye al 50% de tu Sello profesional. Cada corte cuenta — construye tu reputación!",
    tooltipCommunity: "💡 Comunidad: Comparte consejos con fotos 📷, haz preguntas y conéctate con otros profesionales. ¡Puedes adjuntar hasta 3 imágenes en tus consejos y comentarios!",
    tooltipEvaluations: "💡 Evaluaciones: Evalúa y sé evaluado. Construye tu reputación en la plataforma.",
    tooltipPlans: "💡 Planes: Tu plan define lo que puedes usar — calendario, marketplace, gestión de equipo e informes. Planes mayores desbloquean más propiedades, anuncios y destacados. Cuanto más participas, más reconoce la industria tu valor!",
    tooltipProfessionals: "💡 Buscar Profesionales: Encuentra trabajadores certificados con sellos Bronce, Plata u Oro. Ve recomendaciones, evaluaciones y perfil completo. Puedes recomendar profesionales que trabajaron contigo — tu recomendación aparece en su perfil público. Usa el chat HeveaTalent para contacto directo.",
    tooltipReports: "💡 Informes: Visualiza estadísticas e informes de producción de tu propiedad.",
    tooltipPerformance: "💡 Rendimiento: Sigue tu rendimiento contextual basado en las condiciones locales.",
    seeExample: "Ver Ejemplo",
    howToUse: "Cómo usar",
    exampleJobPostings: "Ejemplos de Ofertas de Empleo",
    exampleJobPostingsDesc: "Vea a continuación ejemplos de cómo se muestran las ofertas de empleo en la plataforma. Use como referencia al buscar oportunidades.",
    example: "Ejemplo",
    chatWithEmployer: "Conversar con Empleador",
    requirements: "Requisitos",
    
    // Example Modal - Service Offer (Professional)
    exampleServiceOfferTitle: "Ejemplo de Oferta de Servicio Bien Hecha",
    exampleServiceOfferName: "Sangrador Experimentado - Disponible para Trabajo",
    exampleServiceOfferLocation: "Votuporanga, SP y región",
    exampleServiceOfferDesc: "Profesional con 5 años de experiencia en sangría de seringueiras. Especializado en técnicas descendente y ascendente. Disponibilidad inmediata para trabajo en fincas de pequeño a gran porte.",
    exampleServiceOfferTip1: "✅ Título con tu especialización y disponibilidad",
    exampleServiceOfferTip2: "✅ Experiencia detallada (años, técnicas dominadas)",
    exampleServiceOfferTip3: "✅ Regiones donde puedes trabajar",
    exampleServiceOfferTip4: "✅ Porcentaje deseado o salario 'a negociar'",
    exampleServiceOfferTip5: "✅ Disponibilidad (inmediata, en 30 días, etc.)",
    exampleServiceOfferButton: "¡Entendido, voy a crear mi oferta!",
    bestPractices: "Buenas Prácticas:",
    
    // Marketplace Tooltips
    tooltipMarketplaceBrowse: "💡 Navega por los productos en venta. Usa los filtros para encontrar equipos, insumos y materiales para heveicultura. Haz clic en un producto para ver detalles y contactar al vendedor.",
    tooltipMarketplaceSell: "💡 Anuncia tus productos. Agrega fotos, descripción detallada, precio y ubicación para atraer compradores interesados.",
    tooltipMarketplaceMyItems: "💡 Gestiona tus anuncios. Edita, destaca o elimina productos que has puesto a la venta.",
    
    // Record Form Tooltips
    tooltipSangria: "Día en que realizó la sangría de los árboles",
    tooltipTalhao: "Sector o área donde se realizó la actividad",
    tooltipReposicao: "Recuperación de días sin sangría (compensación)",
    tooltipSangriaPerdida: "Árboles no sangrados (lluvia, TPD, etc)",
    tooltipFungicida: "Aplicación de tratamiento contra hongos",
    tooltipChuva: "Volumen de lluvia del día",
    tooltipProducao: "Peso de látex/coágulo recolectado",
    tooltipWorkersDb: "Historial privado de evaluaciones de trabajadores",
    tooltipKgPlanta: "Producción promedio por árbol",
    tooltipTrendUp: "Evaluaciones en alza",
    tooltipTrendDown: "Evaluaciones en baja",
    tooltipTrendStable: "Desempeño consistente",
    tooltipMultiWorkers: "trabajadores en este día",
    tooltipAddRecord: "Agregar registro",
    
    // Multiple Workers Tip - Banner del calendario
    multiWorkerTipTitle: "Múltiples Colaboradores por Día",
    multiWorkerTipDesc: "Registre la producción de cada trabajador individualmente en el mismo día.",
    multiWorkerTipToggle: "Ver cómo hacerlo",
    multiWorkerTipHide: "Ocultar instrucciones",
    multiWorkerTipStep1: "Haga clic en el día deseado en el calendario",
    multiWorkerTipStep2: "Complete los datos del",
    multiWorkerTipStep2Bold: "primer trabajador",
    multiWorkerTipStep2End: "(nombre, producción, parcela)",
    multiWorkerTipStep3: "Haga clic en",
    multiWorkerTipStep3Bold: "Guardar",
    multiWorkerTipStep4: "Después de guardar, aparecerá la opción",
    multiWorkerTipStep4Bold: "Agregar Otro Trabajador",
    multiWorkerTipStep5: "Repita el proceso para cada colaborador del día",
    multiWorkerTipNote: "Los días con múltiples trabajadores muestran un número en la esquina",
    multiWorkerTipTooltip: "Puede registrar la producción de cada trabajador por separado en el mismo día. Esto permite seguir el rendimiento individual de cada miembro del equipo.",
    multiWorkerTipReshow: "Ver consejo: Múltiples trabajadores",

    // Eventos del calendario (Ausencias y Festivos)
    legendBleeding: "Sangría realizada",
    legendLost: "Sangría perdida (lluvia)",
    legendAbsence: "Ausencia del trabajador",
    legendHoliday: "Festivo",
    legendHint: "Haz clic en un día para registrar sangría. Para marcar ausencia o festivo, haz clic en el pequeño icono de calendario en la esquina de la celda.",
    celTitle: "Ausencia o Festivo",
    celExplain: "Las ausencias y los festivos son solo etiquetas informativas — no alteran el conteo de sangrías del sistema. Sirven para dar contexto en los informes.",
    celExistingTitle: "Eventos de este día:",
    celAbsence: "Ausencia",
    celHoliday: "Festivo",
    celCompensated: "compensada",
    celWorker: "Trabajador",
    celWorkerPlaceholder: "Nombre del trabajador",
    celWorkerRequired: "Selecciona o escribe el nombre del trabajador.",
    celFaltaWorkerRequired: "Selecciona o escribe el nombre del trabajador.",
    celReason: "Motivo",
    celReasonPlaceholder: "Ej: Justificante médico, Personal",
    celHolidayName: "Nombre del festivo",
    celHolidayPlaceholder: "Ej: Navidad, Aniversario de la ciudad",
    celAbsenceHint: "Si este trabajador compensa después la ausencia en otra fecha (trabajando un sábado, por ejemplo), podrás vincular esa sangría a esta ausencia en el formulario.",
    celHolidayHint: "El festivo es solo una etiqueta en el calendario. Si algún trabajador decide trabajar este día (en sociedad), la sangría registrada cuenta normalmente.",
    celMarkEvent: "Marcar ausencia o festivo",
    celSaveError: "Error al guardar el evento.",
    celDeleteError: "Error al eliminar el evento.",
    celConfirmDelete: "¿Eliminar este evento?",
    // Compensación en el formulario
    rfCompensateAbsenceTitle: "Esta sangría compensa una ausencia",
    rfCompensateAbsenceSelect: "¿Qué ausencia se está compensando?",
    rfCompensateAbsenceHint: "Al marcar, la ausencia seleccionada se registrará como compensada en los informes.",
    // Informe mensual - nuevas secciones
    rptWorkerSectionTitle: "Por trabajador",
    rptWorkerName: "Trabajador",
    rptWorkerBleedings: "Sangrías",
    rptWorkerLost: "Perdidas",
    rptWorkerAbsences: "Ausencias",
    rptWorkerCompensated: "Compensadas",
    rptWorkerProduction: "Producción",
    rptAbsencesTitle: "Ausencias del periodo",
    rptHolidaysTitle: "Festivos",
    rptNoAbsences: "Ninguna ausencia registrada en el periodo.",
    rptNoHolidays: "Ningún festivo registrado en el periodo.",
    rptAbsencePattern: "Patrón de ausencias (últimos 3 meses)",
    saving: "Guardando...",
    
    // Evaluation System Tooltips - Explicativo basado en el Trípode
    tooltipEvaluationOverview: "🏆 **Sistema de Certificación HeveaTalent**\n\n⚖️ **JUSTICIA**: Evaluación basada en 14 criterios técnicos oficiales (INCAPER, CATI/SP).\n\n📊 **DOS TIPOS DE EVALUACIÓN**:\n• **Evaluación Técnica** (peso 3x): Realizada por Ingenieros Agrónomos o Técnicos Agrícolas certificados. Mayor credibilidad.\n• **Evaluación de Empleador** (peso 1x): Realizada por propietarios. Refleja la experiencia laboral.\n\n🏅 **SISTEMA DE SELLOS**: La puntuación final es un promedio ponderado. Sellos: Bronce (60-74), Plata (75-89), Oro (90+).\n\n📈 **EVOLUCIÓN**: Sigue tu progreso en la pestaña 'Evolución del Desempeño' con gráficos y tendencias.\n\n🔒 **SEGURIDAD**: Evaluaciones privadas, conformidad LGPD.",
    tooltipEvaluationProfile: "📊 **Tu Perfil de Certificación**\n\n🏅 **Sellos de Calidad**: Bronce (60-74 pts), Plata (75-89 pts), Oro (90-100 pts).\n\n⚖️ **CÓMO FUNCIONA EL CÁLCULO**:\n• Evaluaciones Calificadas tienen peso 3x (Ingenieros Agrónomos y Técnicos Agrícolas)\n• Evaluaciones Estándar tienen peso 1x (Propietarios, Líderes, Otros)\n• El peso se determina por la calificación del evaluador, no por tipo de cuenta\n• Tu sello se basa en el promedio ponderado\n\n📈 **Gráfico Evolutivo**: Ve tu progreso a lo largo del tiempo.\n\n🎯 **Feedback Educativo**: Recibe orientaciones personalizadas basadas en los 14 criterios para mejorar tus técnicas.",
    tooltipEvaluationCreate: "✍️ **Crear Evaluación Técnica**\n\n🎓 **TIPO DE EVALUACIÓN**: Tu evaluación será clasificada según tu calificación:\n• **Ingeniero Agrónomo/Técnico Agrícola**: Evaluación Técnica (peso 3x)\n• **Propietario/Líder de Equipo**: Evaluación de Empleador (peso 1x)\n\n👤 **A quién evaluar**: Profesionales que trabajaron en tu propiedad.\n\n📋 **14 Criterios**: Técnica de Sangría (45%), Preparación de Cosecha (20%), Mantenimiento Diario (15%), Aplicaciones Químicas (20%).\n\n⚖️ **Impacto**: Las evaluaciones técnicas tienen mayor peso en el sello final del profesional.",
    tooltipEvaluationEvolution: "📈 **Evolución del Desempeño**\n\n📊 **GRÁFICO EVOLUTIVO**: Visualiza tu evolución en los últimos 12 meses con:\n• **Línea Verde**: Puntuación ponderada (promedio general)\n• **Línea Azul**: Evaluaciones Calificadas (peso 3x) — Ingenieros y Técnicos\n• **Línea Morada**: Evaluaciones Estándar (peso 1x) — Propietarios y otros\n\n⚖️ **PESO**: El peso se determina por la calificación técnica del evaluador, no por tipo de cuenta. Un propietario que es Ingeniero Agrónomo recibe peso 3x.\n\n🏅 **LÍNEAS DE REFERENCIA**: Las líneas punteadas muestran los límites de los sellos:\n• 🥇 Oro: ≥90 puntos\n• 🥈 Plata: ≥75 puntos\n• 🥉 Bronce: ≥60 puntos\n\n📈 **TENDENCIA**: El indicador muestra si estás mejorando (+) o empeorando (-) en los últimos 3 meses.\n\n💡 **CONSEJO**: ¡Busca evaluaciones de profesionales calificados (Ingenieros/Técnicos) para aumentar la credibilidad de tu sello!",
    
    // Seal Levels
    bronzeSeal: "Sello Bronce",
    silverSeal: "Sello Plata",
    goldSeal: "Sello Oro",
    platinumSeal: "Sello removido",
    qualitySeal: "Sello de Calidad",
    
    // Professional Profile
    yearsExperience: "años de experiencia",
    evaluationsReceived: "evaluaciones recibidas",
    jobsCompleted: "trabajos completados",
    memberSince: "Miembro desde",
    contactProfessional: "Contactar",
    viewProfile: "Ver Perfil",
    
    // Employer/Property
    propertyName: "Nombre de la Propiedad",
    propertyLocation: "Ubicación de la Propiedad",
    numberOfTrees: "Número de Árboles",
    cultureAge: "Edad del Cultivo (años)",
    
    // Footer
    allRightsReserved: "Todos los derechos reservados",
    termsOfUse: "Términos de Uso",
    privacyPolicy: "Política de Privacidad",
    contact: "Contacto",
    help: "Ayuda",
    understood: "Entendido",
    
    // ========== PERMISSIONS GUIDE ==========
    permGuideTitle: "Guía de Permisos",
    permGuideOverview: "Visión General",
    permGuideRoles: "Roles",
    permGuideTransfer: "Transferencia",
    permGuidePlans: "Planes",
    permGuideHowWorks: "¿Cómo funciona?",
    permGuideHowWorksDesc: "Cada propiedad puede tener diferentes personas con diferentes niveles de acceso. Esto permite que consultores, gerentes y empleados trabajen juntos sin confusión sobre quién puede hacer qué.",
    permGuidePracticalExample: "Ejemplo práctico:",
    permGuideOwnerExample: "es la dueña de la Finca Conquista",
    permGuideManagerExample: "(consultor) administra los datos",
    permGuideOperatorExample: "(sangrador) registra producción diaria",
    permGuideImportantPlans: "Importante sobre Planes:",
    permGuideImportantPlansDesc: "Después del período de prueba, cada usuario tendrá acceso según el plan elegido (Profesional o Propietario). Si eres un consultor/administrador que gestiona propiedades de terceros, elige el plan que mejor se adapte a tus necesidades.",
    permGuideManagersOperators: "Responsables y Operadores:",
    permGuideManagersOperatorsDesc: "Cuando el propietario/arrendatario registra un consultor, operador o responsable técnico en su propiedad, estos acceden según las limitaciones del plan del propietario. El propietario define quién puede acceder a su propiedad.",
    permGuideLimitsByPlan: "Límites por Plan:",
    permGuideLimitsByPlanDesc: "Cada plan tiene sus limitaciones (cantidad de propiedades, equipo, funcionalidades). No es posible usar un único plan para gestionar múltiples propiedades de diferentes dueños - cada propietario/arrendatario debe tener su propio plan activo.",
    permGuideSummary: "Resumen:",
    permGuideSummaryDesc: "El plan del dueño de la propiedad (propietario o arrendatario) define los límites. Consultores y operadores vinculados usan los permisos de ese plan para esa propiedad específica.",
    permGuideOwner: "Propietario",
    permGuideOwnerDesc: "Dueño legal de la propiedad en el sistema.",
    permGuideOwnerCan: "Puede:",
    permGuideOwnerCanList: "Transferir/vender la propiedad|Definir responsable y operadores|Ver y editar todos los datos|Desactivar la propiedad (datos históricos preservados)",
    permGuideOwnerPlanNote: "El plan del propietario define los límites de funcionalidades",
    permGuideOwnerDataNote: "Los datos históricos siempre se preservan para análisis y estadísticas",
    permGuideManager: "Responsable",
    permGuideManagerDesc: "Gestiona la propiedad en el día a día.",
    permGuideManagerCan: "Puede:",
    permGuideManagerCanList: "Insertar, editar y eliminar registros|Ver todos los informes|Gestionar equipo de sangradores",
    permGuideManagerCannot: "No puede:",
    permGuideManagerCannotList: "Transferir la propiedad|Agregar otros responsables",
    permGuideOperator: "Operador",
    permGuideOperatorDesc: "Inserta registros diarios de producción.",
    permGuideOperatorCan: "Puede:",
    permGuideOperatorCanList: "Insertar nuevos registros|Editar/eliminar sus propios registros|Ver resúmenes de la propiedad",
    permGuideOperatorCannot: "No puede:",
    permGuideOperatorCannotList: "Editar registros de otros|Ver informes detallados del equipo",
    permGuideTransferTitle: "Transferencia de Propiedad",
    permGuideTransferDesc: "Transferir una propiedad significa cambiar quién es el dueño oficial en la plataforma. Esto impacta directamente quién paga el plan y quién autoriza el acceso de los colaboradores.",
    permGuideTransferWhatChanges: "¿Qué cambia en la transferencia?",
    permGuideTransferChangeOwner: "El propietario cambia — el nuevo dueño pasa a ser el responsable legal de la propiedad en la plataforma.",
    permGuideTransferChangePlan: "El plan del nuevo propietario entra en vigor — todos los colaboradores (responsable y operadores) pasan a operar bajo el plan del NUEVO dueño. Si el nuevo dueño tiene un plan inferior, las funcionalidades disponibles para el equipo pueden reducirse.",
    permGuideTransferChangeAuth: "La autorización de acceso cambia — es el nuevo propietario quien decide quién puede acceder, gestionar u operar en la propiedad.",
    permGuideTransferWhatStays: "¿Qué NO cambia?",
    permGuideTransferStayData: "Todos los datos permanecen intactos — registros de sangría, configuraciones de contexto, historial de producción, nada se pierde.",
    permGuideTransferStayTeam: "El equipo continúa vinculado — responsable y operadores mantienen sus roles, pero ahora bajo la gestión del nuevo propietario.",
    permGuideTransferStayConfig: "Las configuraciones de la propiedad permanecen — clon, sistema de sangría, densidad de árboles, todo sigue igual.",
    permGuideTransferPlanWarningTitle: "Atención sobre el Plan",
    permGuideTransferPlanWarning: "En HeveaTalent, el plan del PROPIETARIO define los límites de acceso de TODOS los que trabajan en esa propiedad. Al transferir, el plan del nuevo dueño es el que rige. Ejemplo: si el dueño actual tiene el plan Completo y transfiere a alguien con plan Gratuito, el equipo pierde acceso a funcionalidades avanzadas.",
    permGuideTransferSteps: "¿Cómo funciona el proceso?",
    permGuideTransferStep1: "La transferencia es solicitada por el administrador de la plataforma",
    permGuideTransferStep2: "Se informa el email del nuevo propietario — si no tiene cuenta, se crea automáticamente",
    permGuideTransferStep3: "La propiedad pasa inmediatamente al nuevo dueño con todos los datos preservados",
    permGuideTransferStep4: "El plan del nuevo propietario pasa a gobernar el acceso de todo el equipo vinculado",
    permGuideTransferWhoCanTitle: "¿Quién puede transferir?",
    permGuideTransferWhoCan: "Actualmente, solo el administrador de la plataforma puede realizar transferencias. Contáctenos para solicitarlo.",
    permGuideTransferNote: "Resumen: transferir = cambiar quién es dueño + quién costea el plan para el equipo. Datos y equipo permanecen.",
    permGuidePlansTitle: "Planes y Funcionalidades",
    permGuideFree: "Gratuito",
    permGuideFreeDesc: "90 días de calendario|1 propiedad|1 oferta de empleo|Sin gestión de equipo",
    permGuideProfessional: "Básico - R$ 30/mes",
    permGuideProfessionalDesc: "1 propiedad|Equipo hasta 3 personas|Calendario completo|45 días gratis",
    permGuideEnterprise: "Esencial - R$ 60/mes",
    permGuideEnterpriseDesc: "3 propiedades|Equipo hasta 8 personas|Informes completos|45 días gratis",
    permGuideComplete: "Completo - R$ 120/mes",
    permGuideCompleteDesc: "Propiedades ilimitadas|Equipo ilimitado|Todo ilimitado|45 días gratis",
    
    // ========== CALENDAR USER GUIDE ==========
    calGuideTitle: "Guía del Calendario de Sangría",
    calGuideQuickStart: "Inicio Rápido",
    calGuideProperty: "Propiedad",
    calGuideRecords: "Registros",
    calGuideTeam: "Equipo",
    calGuideEthrel: "Ethrel",
    calGuideReports: "Informes",
    calGuideTips: "Consejos",
    calGuideQuickStartTitle: "Inicio Rápido",
    calGuideQuickStartDesc: "El Calendario de Sangría te ayuda a controlar toda la producción de látex de tu propiedad.",
    calGuideFirstSteps: "Primeros Pasos:",
    calGuideStep1: "Selecciona la propiedad en el menú desplegable",
    calGuideStep2: "Elige el mes/año que deseas visualizar",
    calGuideStep3: "Haz clic en un día del calendario para agregar registro",
    calGuideStep4: "Completa los datos de producción del día",
    calGuideStep5: "Guarda y repite para otros días",
    calGuideViews: "Visualizaciones Disponibles:",
    calGuideViewCalendar: "Calendario - Vista mensual con indicadores visuales",
    calGuideViewTable: "Tabla - Lista detallada día a día",
    calGuidePropertyTitle: "Configurando la Propiedad",
    calGuideHarvestMonth: "Importante: Mes de Inicio de Cosecha",
    calGuideHarvestMonthDesc: "La cosecha de la seringuera normalmente va de Septiembre a Agosto. Al registrar tu propiedad, define correctamente el mes de inicio para que los informes acumulados reflejen tu cosecha real.",
    calGuidePropertyData: "Datos de la Propiedad:",
    calGuidePropertyName: "Nombre - Identificación de la finca",
    calGuidePropertyLocation: "Ubicación - Ciudad/Estado",
    calGuidePropertyAge: "Edad del Cultivo - Años de las seringueras",
    calGuidePropertyArea: "Área Total - Hectáreas (opcional)",
    calGuidePropertyStartMonth: "Mes de Inicio de Cosecha - Generalmente Septiembre",
    
    // ========== PERMISSIONS MANAGEMENT UI ==========
    permMgmtTitle: "Gestionar Acceso",
    permMgmtSubtitle: "Define quién puede acceder a esta propiedad",
    permMgmtOwner: "Propietario",
    permMgmtOwnerYou: "(tú)",
    permMgmtOwnerDesc: "Dueño legal. Puede transferir y definir permisos.",
    permMgmtManager: "Responsable",
    permMgmtManagerDesc: "Gestiona el día a día, edita registros y ve informes.",
    permMgmtOperators: "Operadores",
    permMgmtOperatorsDesc: "Insertan registros diarios de producción.",
    permMgmtNoManager: "Ningún responsable asignado",
    permMgmtNoOperators: "Ningún operador registrado",
    permMgmtAddManager: "Definir Responsable",
    permMgmtAddOperator: "Agregar Operador",
    permMgmtRemove: "Eliminar",
    permMgmtPromote: "Promover a Responsable",
    permMgmtDemote: "Degradar a Operador",
    permMgmtEmailPlaceholder: "Ingresa el email de la persona",
    permMgmtNamePlaceholder: "Nombre (opcional)",
    permMgmtConfirmRemove: "Eliminar acceso de",
    permMgmtConfirmRemoveDesc: "Esta persona perderá acceso a la propiedad.",
    permMgmtSuccessAdded: "Persona agregada exitosamente",
    permMgmtSuccessRemoved: "Acceso eliminado exitosamente",
    permMgmtSuccessUpdated: "Permisos actualizados",
    permMgmtErrorInvalidEmail: "Email inválido",
    permMgmtErrorSameUser: "No puedes agregarte a ti mismo",
    permMgmtErrorAlreadyAdded: "Esta persona ya tiene acceso",
    permMgmtNewAccountCreated: "Cuenta creada automáticamente",
    permMgmtTempPassword: "Contraseña temporal",
    permMgmtShareCredentials: "Comparte estas credenciales con la persona",
    permMgmtOnlyOwnerCanEdit: "Solo el propietario puede editar permisos",
    permMgmtLoading: "Cargando permisos...",
    permMgmtError: "Error al cargar permisos",
    permMgmtRetry: "Intentar de nuevo",
    
    // ========== LOGIN & REGISTER DIALOGS ==========
    doLogin: "Iniciar Sesión",
    enterCredentials: "Ingresa tus credenciales",
    createAccount: "Crear Cuenta",
    registerOnPlatform: "Regístrate en la plataforma",
    selectSpecialization: "Selecciona la especialización",
    other: "Otros",
    
    // ========== LANDING PAGE EXTENDED ==========
    professionalsCadastrados: "+500 profesionales registrados",
    connectingProducersWorkers: "Conectando productores y trabajadores en todo Brasil",
    whyUseHeveaTalent: "¿Por qué usar HeveaTalent?",
    everythingYouNeed: "Todo lo que necesitas para gestionar tu producción y equipo en un solo lugar",
    dailyControl: "Control Diario",
    dailyControlDesc: "Registra sangrías, lluvia, fungicidas y ve resúmenes mensuales automáticos",
    evaluateTeam: "Evalúa tu Equipo",
    evaluateTeamDesc: "Sigue el desempeño de los trabajadores con evaluaciones privadas",
    certifyTeam: "Certifica tu Equipo",
    certifyTeamDesc: "Sellos de calidad Bronce, Plata y Oro basados en evaluación técnica",
    buyAndSell: "Compra y Vende",
    buyAndSellDesc: "Mercado de insumos, herramientas y equipos agrícolas",
    findWork: "Encuentra Trabajo",
    findWorkDesc: "Publica empleos o encuentra oportunidades en el cultivo de caucho",
    shareExperiences: "Comparte Experiencias",
    shareExperiencesDesc: "Comunidad activa para compartir consejos y conocimientos",
    startIn3Steps: "Comienza en 3 pasos simples",
    freeToStart: "Es gratis para comenzar y puedes probar todas las funciones",
    createFreeAccount: "Crea tu cuenta gratis",
    quickSignup: "Registro rápido como productor o profesional",
    registerProperty: "Registra tu propiedad",
    addFarms: "Agrega tus fincas y comienza a organizar",
    startUsing: "Comienza a usar",
    registerBleedings: "Registra sangrías, evalúa equipo, usa el mercado",
    freeToStartBullet: "Gratis para comenzar",
    noCreditCard: "Sin tarjeta de crédito",
    cancelAnytime: "Cancela cuando quieras",
    footerText: "La plataforma del cultivo de caucho brasileño",
    tripeBased: "Basado en el Trípode: Justicia • Seguridad • Simplicidad",
    
    // ========== DASHBOARD NAVIGATION ==========
    newAd: "Nuevo Anuncio",
    searchProfessionals: "Buscar Profesionales",
    quickActions: "Acciones Rápidas",
    bleedingToday: "Sangría Hoy",
    publishJobBtn: "Publicar Empleo",
    myJobsPublished: "Mis Empleos",
    myPublishedJobs: "Mis Empleos Publicados",
    seeExample: "Ver Ejemplo",
    seeExampleTip: "Ver Ejemplo de Consejo",
    publishing: "Publicando...",
    findQualifiedProfessionals: "Encuentra profesionales calificados para tus necesidades",
    noProfessionalsAvailable: "No hay ofertas de profesionales disponibles en este momento",
    noJobsPublished: "Aún no has publicado ningún empleo",
    searchJobsBtn: "Buscar Empleos",
    offerServices: "Ofrecer Servicios",
    myOffers: "Mis Ofertas",
    availableJobs: "Empleos Disponibles",
    findOpportunities: "Encuentra oportunidades de trabajo en el cultivo de caucho",
    noJobsAvailable: "No hay empleos disponibles en este momento",
    myServiceOffers: "Mis Ofertas de Servicio",
    noOffersYet: "Aún no has publicado ninguna oferta de servicio",
    
    // ========== PLANS SECTION ==========
    loadingPlans: "Cargando planes...",
    plansDescProfessional: "Planes accesibles para profesionales del cultivo de caucho. ¡Funciones completas en el plan gratuito!",
    plansDescEmployer: "Planes robustos para propietarios y empresas. Gestiona tus propiedades, equipos y operaciones.",
    activateFree: "Activar Gratis",
    choosePlan: "Elegir Plan",
    savingsPercent: "Ahorro de",
    perMonth: "/mes",
    perYear: "Anual",
    individualItems: "Artículos Individuales",
    buyExtrasWithoutChangingPlan: "Compra recursos extras sin cambiar de plan",
    adHighlight: "Destacar Anuncio",
    adHighlightDesc: "Tu anuncio aparece en la parte superior de las listas por 7 días",
    moreVisibility: "Mayor visibilidad",
    highlightBadge: "Badge de destacado",
    validFor7Days: "Válido por 7 días",
    buyHighlightBtn: "Comprar Destacado",
    extraAdJobBoard: "Anuncio Extra - Bolsa de Empleo",
    extraAdJobBoardDesc: "1 publicación adicional en la bolsa de empleo por 30 días",
    validFor30Days: "Válido por 30 días",
    noChangeToPlan: "Sin cambiar tu plan",
    immediateUse: "Uso inmediato",
    buyAdBtn: "Comprar Anuncio",
    extraAdMarketplace: "Anuncio Extra - Mercado",
    extraAdMarketplaceDesc: "1 anuncio adicional en el mercado por 30 días",
    paymentViaPix: "Pago vía PIX • Activación inmediata después de la confirmación",
    tipAnnualSavings: "Consejo: Ahorra con el plan anual",
    comingSoon: "¡Próximamente! Integración de pago pendiente.",
    
    // ========== COMMUNITY SECTION ==========
    loadingCommunityTips: "Cargando consejos de la comunidad...",
    communityTipsTitle: "Consejos de la Comunidad",
    communityTipsSubtitle: "Comparte conocimiento y aprende de otros profesionales",
    filterByCategory: "Filtrar por categoría",
    allCategories: "Todas las categorías",
    categoryBleeding: "Sangría",
    categoryDiseases: "Enfermedades",
    categoryIdeas: "Ideas",
    categoryMarket: "Mercado del Caucho",
    categoryNews: "Noticias",
    categoryWeather: "Clima",
    categoryOthers: "Otros",
    exampleBadge: "Ejemplo",
    likes: "me gusta",
    comments: "comentarios",
    by: "Por",
    errorLikeTip: "Error al dar me gusta",
    commentPrompt: "Comentar sobre",
    errorCommentTip: "Error al comentar",
    shareATip: "Compartir un consejo",
    noTipsFound: "No se encontraron consejos para esta categoría",
    
    // ========== MARKETPLACE SECTION ==========
    browseProducts: "Explorar Productos",
    sellProduct: "Vender Producto",
    myAds: "Mis Anuncios",
    myAdvertisedProducts: "Mis Productos Anunciados",
    noProductsYet: "Aún no tienes productos anunciados",
    allProducts: "Todos los Productos",
    properties: "Propiedades",
    equipment: "Equipos",
    supplies: "Insumos",
    services: "Servicios",
    searchInMarketplace: "Buscar en el mercado...",
    noProductsFound: "No se encontraron productos",
    
    // ========== CALENDAR SECTION ==========
    trialExpiredTitle: "Período de Prueba Expirado",
    trialExpiredDataSaved: "Tus datos están guardados y se recuperarán después de la actualización.",
    viewPlansFrom: "Ver Planes - Desde",
    month: "mes",
    lastDayOfTrial: "¡ÚLTIMO DÍA DE PRUEBA!",
    lastDayTrialMsg: "Tu acceso al Calendario expira mañana. Actualiza ahora para mantener el acceso.",
    upgradeNow: "Actualizar Ahora",
    trialEndingSoon: "¡Prueba terminando pronto!",
    daysRemaining: "días restantes",
    trialExpiresIn: "Tu período de prueba expira en",
    days: "días",
    seeUpgradeOptions: "Ver opciones de actualización",
    trialEnding30Days: "Período de prueba activo",
    trialEnding30DaysMsg: "Todavía tienes",
    daysToExplore: "días para explorar todas las funciones.",
    bleedingCalendar: "Calendario de Sangría",
    calendarSubtitle: "Registra y sigue tus sangrías diarias",
    selectProperty: "Seleccionar Propiedad",
    addProperty: "Agregar Propiedad",
    newProperty: "Nueva Propiedad",
    propertyName: "Nombre de la Propiedad",
    propertyNamePlaceholder: "Ej: Finca San Juan",
    numberOfTrees: "Número de Árboles",
    createProperty: "Crear Propiedad",
    loading: "Cargando...",
    monthlySummary: "Resumen Mensual",
    bleedingDays: "Días de Sangría",
    rainDays: "Días de Lluvia",
    fungicideDays: "Aplicaciones de Fungicida",
    viewCalendar: "Ver Calendario",
    viewTable: "Ver Tabla",
    addFirstProperty: "Agrega una Propiedad",
    noPropertyMsg: "Registra tu primera propiedad para comenzar a usar el calendario de sangría.",
    addPropertyBtn: "Agregar Propiedad",
    startFreeTrial: "Comenzar Prueba Gratuita",
    contentBlocked: "Contenido bloqueado. Actualiza para continuar.",
    property: "Propiedad",
    years: "años",
    monthYear: "Mes/Año",
    previousMonth: "Mes anterior",
    nextMonth: "Próximo mes",
    location: "Ubicación",
    totalRain: "Total Lluvia",
    totalProduction: "Total Producción",
    totalReplacements: "Total Reposiciones",
    totalReplacement: "Total Reposición",
    yearlyAccumulatedSummary: "Resumen Acumulado",
    ethrelApplications: "Aplicaciones de Ethrel",
    fungicideApplications: "Aplicaciones de Fungicida",
    totalLosses: "Total Pérdidas",
    totalRecords: "Total Registros",
    monthlyBreakdown: "Desglose Mensual",
    ethrelControl: "Control de Ethrel",
    configureInterval: "Configure el intervalo de aplicación",
    todaysActivities: "Actividades de hoy",
    manageActivitiesDesc: "Gestiona tus actividades diarias de cultivo de caucho",
    bleeding: "Sangría",
    bleedingDesc: "Sangría realizada hoy",
    production: "Producción",
    productionCollection: "Recolección de Producción",
    productionCollectionDesc: "Látex recolectado/pesado hoy",
    generalApplications: "Aplicaciones Generales",
    generalApplicationsDesc: "Productos aplicados hoy (fungicidas, ethrel, coagulante, herbicidas, fertilizantes)",
    management: "Manejo",
    daily: "Diaria",
    periodic: "Periódica",
    sporadic: "Esporádica",
    completed: "¡Completado!",
    pending: "Pendiente",
    notNeededToday: "No necesario hoy",
    dailyGoal: "Meta diaria",
    whenNeeded: "Cuando sea necesario",
    noActivitiesYet: "Sin actividades aún. ¡Crea tu primera actividad de sangría!",
    addActivity: "Agregar Actividad",
    dayProgress: "Progreso del día:",
    essentials: "esenciales",
    extra: "extra",
    extras: "extras",
    of: "de",
    
    // ========== FORMS ==========
    publishNewJob: "Publicar Nuevo Empleo",
    registerNewJobOpp: "Registra una nueva oportunidad de empleo",
    jobTitle: "Título del Empleo",
    salaryRange: "Rango Salarial",
    salaryRangePlaceholder: "Ej: $2,000 - $3,000",
    jobType: "Tipo de Trabajo",
    fullTime: "Tiempo Completo",
    partTime: "Medio Tiempo",
    contract: "Contrato",
    seasonal: "Temporal",
    jobDescription: "Descripción del Empleo",
    requirements: "Requisitos",
    publishJob: "Publicar Empleo",
    jobPublishedSuccess: "¡Empleo publicado exitosamente!",
    errorPublishingJob: "Error al publicar empleo",
    needLoginToPublish: "Necesitas iniciar sesión para publicar empleos",
    considerUpgrade: "Considera actualizar tu plan en la pestaña Planes.",
    
    // ========== WORK OFFER FORM ==========
    createWorkOffer: "Crear Oferta de Trabajo",
    offerServicesToEmployers: "Ofrece tus servicios a empleadores",
    offerTitle: "Título de la Oferta",
    availableLocations: "Ubicaciones Disponibles",
    expectedSalary: "Salario Esperado",
    expectedSalaryPlaceholder: "Ej: $2,500",
    availability: "Disponibilidad",
    immediate: "Inmediata",
    oneMonth: "1 mes",
    twoMonths: "2 meses",
    threeMonths: "3 meses",
    serviceDescription: "Descripción de los Servicios",
    skillsAndExperience: "Habilidades y Experiencia",
    createOffer: "Crear Oferta",
    creating: "Creando...",
    workOfferCreatedSuccess: "¡Oferta de trabajo creada exitosamente!",
    errorCreatingOffer: "Error al crear oferta",
    needLoginToOffer: "Necesitas iniciar sesión para ofrecer trabajo",
    
    // ========== MARKETPLACE FORM ==========
    advertiseProduct: "Anunciar Producto",
    registerProductForSale: "Registra un producto o servicio para venta",
    productName: "Nombre del Producto",
    category: "Categoría",
    price: "Precio",
    pricePlaceholder: "Ej: $150.00",
    condition: "Condición",
    conditionNew: "Nuevo",
    conditionUsed: "Usado",
    conditionRefurbished: "Reacondicionado",
    productDescription: "Descripción del Producto",
    contactInfo: "Información de Contacto",
    advertise: "Anunciar",
    productRegisteredSuccess: "¡Producto registrado exitosamente!",
    errorRegisteringProduct: "Error al registrar producto",
    needLoginToSell: "Necesitas iniciar sesión para vender productos",
    selectCategory: "Selecciona la categoría",
    pesticides: "Pesticidas Agrícolas",
    machinery: "Maquinaria",
    semiNew: "Semi-nuevo",
    fullLocation: "Ubicación Completa",
    locationPlaceholder: "Ej: Finca Santa Rita, Km 15, Zona Rural",
    
    // ========== EVALUATIONS DASHBOARD ==========
    technicalEvaluationSystem: "Sistema de Evaluación Técnica",
    heveaTalentCertification: "Certificación HeveaTalent basada en literatura técnica oficial",
    overview: "Visión General",
    myProfile: "Mi Perfil",
    createEvaluation: "Crear Evaluación",
    myProfessionalProfile: "Mi Perfil Profesional",
    viewCertificationSeals: "Ver certificación y sellos",
    accessDashboard: "Acceder al Dashboard",
    aboutTheSystem: "Sobre el Sistema",
    howEvaluationWorks: "Cómo funciona la evaluación",
    bronze: "Bronce",
    silver: "Plata",
    gold: "Oro",
    points: "puntos",
    technicalCriteria: "Criterios Técnicos",
    senarEmbrapaIncaperStandards: "Estándares técnicos oficiales (INCAPER/CATI)",
    bleedingTechnique: "Técnica de Sangría",
    harvestPreparation: "Preparación de Cosecha",
    dailyMaintenance: "Mantenimiento Diario",
    chemicalApplications: "Aplicaciones Químicas",
    educationalFeedback: "Feedback Educativo",
    improveContinuously: "Mejora continuamente",
    personalizedRecommendations: "Consulte los tooltips (ⓘ) en cada criterio para consejos prácticos basados en documentos oficiales.",
    viewTechnicalReferences: "Ver Referencias Técnicas",
    viewFullProfile: "Ver tu Perfil Completo",
    accessDashboardToSee: "Accede a tu dashboard para ver certificación, puntuación y feedback detallado",
    openMyDashboard: "Abrir Mi Dashboard",
    createNewEvaluation: "Crear Nueva Evaluación",
    selectWorkerToEvaluate: "Selecciona un trabajador de tu equipo para evaluar",
    startEvaluation: "Iniciar Evaluación",
    
    // ========== PERFORMANCE DASHBOARD ==========
    contextualPerformance: "Desempeño Contextual",
    contextualPerformanceSubtitle: "Evaluación justa basada en el contexto de la propiedad",
    selectPropertyToView: "Selecciona una propiedad para ver el desempeño",
    performanceHistory: "Historial de Desempeño",
    monthlyPerformance: "Desempeño Mensual",
    currentPerformance: "Desempeño Actual",
    qualitySeals: "Sellos de Calidad",
    configureContext: "Configurar Contexto",
    referenceData: "Datos de Referencia",
    cloneTypes: "Tipos de Clon",
    tappingSystems: "Sistemas de Sangría",
    seasonalCoefficients: "Coeficientes Estacionales",
    noDataAvailable: "No hay datos disponibles",
    errorLoadingData: "Error al cargar datos",
    
    // ========== COMMON ACTIONS & MESSAGES ==========
    saving: "Guardando...",
    save: "Guardar",
    update: "Actualizar",
    edit: "Editar",
    delete: "Eliminar",
    remove: "Remover",
    add: "Agregar",
    send: "Enviar",
    sending: "Enviando...",
    cancel: "Cancelar",
    close: "Cerrar",
    confirm: "Confirmar",
    back: "Volver",
    next: "Siguiente",
    previous: "Anterior",
    search: "Buscar",
    filter: "Filtrar",
    clear: "Limpiar",
    reset: "Resetear",
    submit: "Enviar",
    saveChanges: "Guardar Cambios",
    
    // ========== ERROR MESSAGES ==========
    errorSendingEvaluation: "Error al enviar evaluación",
    errorPublishingJob: "Error al publicar empleo",
    errorCreatingOffer: "Error al crear oferta",
    errorDeletingJob: "Error al eliminar empleo",
    errorDeactivatingJob: "Error al desactivar empleo",
    errorDeletingOffer: "Error al eliminar oferta",
    errorDeactivatingOffer: "Error al desactivar oferta",
    errorAddingComment: "Error al agregar comentario",
    errorSharingTip: "Error al compartir consejo. Inténtalo de nuevo.",
    errorProcessingSubscription: "Error al procesar suscripción",
    errorSearchingProfessionals: "Error al buscar profesionales",
    errorRemovingAd: "Error al remover anuncio",
    errorCreatingPixPayment: "Error al crear pago PIX",
    errorCheckingPaymentStatus: "Error al verificar estado del pago",
    errorSavingRecord: "Error al guardar registro",
    errorAddingImage: "Error al agregar imagen",
    errorLoadingFile: "Error al cargar archivo",
    errorUpdatingProduct: "Error al actualizar producto",
    errorDeletingRecord: "Error al eliminar registro",
    
    // ========== CALENDAR SPECIFIC ==========
    newRecord: "Nuevo Registro",
    editRecord: "Editar Registro",
    day: "Día",
    addDataForThisDay: "Agregar datos para este día",
    editRecordTitle: "Editar registro",
    deleteRecordTitle: "Eliminar registro",
    onlyNumbers: "Solo números",
    additionalInfo: "Información adicional sobre la propiedad",
    mobileFriendlyTip: "Mobile-Friendly",
    clickAddButton: "Haz clic en el botón",
    toOpenFullForm: "para abrir el formulario completo",
    useEditButton: "Usa",
    toModifyRecords: "para modificar registros existentes",
    uploadingFiles: "Cargando",
    addByUrl: "O Agregar por URL",
    previousImage: "Imagen anterior",
    nextImage: "Siguiente imagen",
    
    // ========== MARKETPLACE SPECIFIC ==========
    noProductsAvailableNow: "No hay productos disponibles en este momento",
    noProductsInCategory: "No hay productos en esta categoría",
    publishAd: "Publicar Anuncio",
    editProduct: "Editar Producto",
    sendEvaluation: "Enviar Evaluación",
    
    // ========== PROFESSIONAL RUBBER CULTIVATION ==========
    professionalRubberCultivation: "Cultivo profesional de caucho",
    
    // ========== CURRENT PLAN BANNER ==========
    growWithHeveaTalent: "Crece con HeveaTalent",
    discoverPlansAndResources: "Descubre los planes y recursos disponibles",
    personalCalendarHistory: "Calendario personal, historial de producción",
    advancedFeaturesUnlocked: "Funciones avanzadas desbloqueadas",
    
    // ========== MARKET MODULE ==========
    // Navigation & Headers
    marketModule: "Mercado",
    marketAnalysis: "Análisis de Mercado",
    quotations: "Cotizaciones",
    calculator: "Calculadora",
    sources: "Fuentes",
    dataStatus: "Estado",
    glossary: "Glosario",
    
    // Main Headers
    marketSummary: "Resumen del Mercado",
    priceReferences: "Cotizaciones de Referencia",
    scenarioSimulator: "Simulador de Escenarios",
    valueComparison: "Comparativo de Valores",
    implicitParticipationRate: "Tasa de Participación Implícita",
    
    // References
    geb10Apabor: "GEB-10 APABOR",
    geb10MarketSP: "GEB-10 Mercado SP",
    importPriceIEA: "Precio Importación (IEA)",
    coagulum: "Coágulo",
    coagulumProducer: "Coágulo (Productor)",
    productionCost: "Costo de Producción",
    exchangeRate: "Tipo de Cambio",
    dollar: "Dólar",
    international: "Internacional",
    
    // Labels & Tags
    reference: "REFERENCIA",
    realPrice: "PRECIO REAL",
    adoptedByMills: "ADOPTADO POR LAS USINAS",
    importParity: "PARIDAD IMPORTACIÓN",
    spotPrice: "PRECIO SPOT",
    currentMarket: "Mercado",
    
    // Units
    perKg: "por kg",
    drc: "DRC",
    participationRate: "Tasa de Participación",
    
    // Tooltips & Help
    understand: "Entender",
    howItWorks: "Cómo Funciona",
    howDataWorks: "Cómo Funcionan los Datos de esta Página",
    mainData: "Los 2 datos principales",
    contextData: "Datos de Contexto",
    howToUpdate: "Cómo se actualizan los datos",
    
    // Data Descriptions
    geb10Description: "Precio de referencia bimestral calculado a partir del precio internacional + tipo de cambio + costos de importación.",
    importPriceDescription: "Costo TOTAL para importar caucho procesado. Incluye: precio internacional + tipo de cambio + flete + seguro + impuestos (~10,8%) + costos portuarios.",
    geb10MarketDescription: "Precio real practicado en las transacciones del mercado físico de São Paulo.",
    coagulumDescription: "Precio real pagado al productor en el mercado.",
    
    // Update Frequencies
    bimonthly: "Bimestral",
    monthly: "Mensual",
    daily: "Diario",
    annual: "Anual",
    automatic: "Automático",
    manual: "Manual",
    impliedParticipationRate: "Tasa de Participación Implícita",
    timesPerYear: "veces/año",
    
    // Status
    current: "Vigente",
    previousPeriod: "Período anterior",
    checkNewPeriod: "Verificar nuevo período",
    
    // Actions
    update: "Actualizar",
    updateData: "Actualizar Datos",
    updateExchangeRate: "Actualizar Tipo de Cambio",
    save: "Guardar",
    calculate: "Calcular",
    reset: "Limpiar",
    expand: "Expandir",
    collapse: "Colapsar",
    
    // Calculator
    officialFormula: "Fórmula Oficial (CNA/FAESP/IEA)",
    producerPrice: "Precio Productor",
    preview: "Vista previa",
    calculatePrice: "Calcular Precio",
    calculatedResult: "Resultado del Cálculo",
    
    // Margin Analysis
    marginAnalysis: "Análisis de Margen",
    marginOnProductionCost: "Margen sobre Costo de Producción",
    profit: "Ganancia",
    loss: "Pérdida",
    
    // References Comparison
    referencesComparison: "Comparativo de Referencias y Tasas",
    minCNA: "Mín CNA",
    refIEA: "Ref IEA",
    
    // Guide Steps
    welcomeToGuide: "Bienvenido a la Guía de Precios",
    priceChain: "La Cadena de Formación",
    priceReference: "El Precio de Referencia",
    whatIsDRC: "¿Qué es DRC?",
    participationRateExplained: "La Tasa de Participación",
    completeFormula: "La Fórmula Completa",
    productionCostAnalysis: "Costo de Producción",
    negotiationTips: "Consejos para Negociar",
    summary: "Resumen",
    
    // Guide Content
    guideWelcomeText: "Esta guía te ayudará a entender cómo se forma el precio del coágulo y cómo negociar mejor.",
    
    // Price Chain
    internationalPrice: "Precio Internacional (SGX)",
    conversionAndCosts: "Conversión + Costos de Importación",
    nationalReferencePrice: "Precio de Referencia Nacional",
    producerFormula: "Fórmula del Productor",
    yourPrice: "Tu Precio",
    
    // Disclaimers
    officialSourcesDisclaimer: "Referencias de fuentes oficiales (IEA, APABOR, CONAB). Para negociaciones, consulte su cooperativa.",
    dataFromOfficialSources: "Los datos provienen de fuentes oficiales: IEA, APABOR, CONAB, BCB",
    
    // Footer
    tripodJustice: "JUSTICIA: Cálculos transparentes",
    tripodSecurity: "SEGURIDAD: Fuentes oficiales",
    tripodSimplicity: "SIMPLICIDAD: Información clara",
    developedBasedOn: "Contenido desarrollado con base en estudios de CNA, FAESP, IEA/SAA-SP y CONAB.",
    lastUpdate: "Última actualización",
    
    // Publication Calendar
    publicationCalendar: "Calendario de Publicaciones",
    nextPublication: "Próxima publicación",
    verify: "Verificar",
    
    // Mandatory/Optional
    mandatoryUpdates: "Actualizaciones OBLIGATORIAS (para cálculos)",
    automaticUpdates: "Actualización AUTOMÁTICA",
    optionalUpdates: "Opcionales (contexto)",
    
    // Analysis
    relationBetweenReferences: "Relación entre las referencias",
    maxCost: "Costo máximo (si la industria importara)",
    negotiationReference: "Referencia para negociación entre usinas y productores",
    realTransactionPrice: "Precio real de las transacciones",
    
    // Why different values
    whyDifferentValues: "¿Por qué los valores son diferentes?",
    sameFormulaDifferentRef: "La misma fórmula genera valores diferentes dependiendo de la referencia utilizada.",
    
    // ========== MARKET MODULE INDEX ==========
    understandRubberMarket: "Entiende el Mercado del Caucho",
    marketInfoForDecision: "Información de mercado para la toma de decisiones.",
    viewCompleteGuide: "Ver Guía Completa",
    new: "NUEVO",
    yourDataPrivateProtected: "Tus datos son privados y protegidos",
    importantWarning: "Aviso Importante",
    educationalContentDisclaimer: "Este contenido es educativo, basado en fuentes oficiales (IEA, APABOR, CNA, CONAB). Los precios y metodologías presentados son referencias - consulta siempre tu cooperativa o usina para negociaciones específicas.",
    viewUserGuide: "Ver Guía de Uso",
    december: "Diciembre",
    
    // Glossary terms
    glossaryGEB10: "Granulado Oscuro Brasileño - Caucho natural procesado, clasificación 10",
    glossaryDRC: "Dry Rubber Content - Contenido de caucho seco en el coágulo",
    glossaryCoagulum: "Látex coagulado antes del procesamiento",
    glossaryParticipationRate: "Porcentaje del precio de referencia transferido al productor",
    
    // ========== OFFICIAL SOURCES ==========
    heveaTalentQuotations: "Cotizaciones HeveaTalent",
    howPriceIsFormed: "Cómo se Forma el Precio",
    understandWhereDataComesFrom: "Entiende de dónde viene cada número. Haz clic para verificar en fuentes oficiales.",
    verifySource: "Verificar fuente",
    priceFormulaProducer: "Fórmula del Precio al Productor",
    priceFormulaExample: "Ejemplo (ago/26): R$ 16,37 × 53% × 70% = R$ 6,07/kg",
    lastVerification: "Última verificación",
    importPrice: "Precio Importación",
    geb10Label: "GEB-10",
    coaguloLabel: "Coágulo",
    internationalLabel: "Internacional",
    geb10ApabarMainRef: "GEB-10 APABOR - Referencia Principal",
    geb10ApabarDesc: "Precio internalizado (Internacional + Tipo de Cambio + Costos). Publicación bimestral.",
    coaguloIeaProducerPrice: "Coágulo IEA - Precio al Productor",
    coaguloIeaDesc: "Valor real transaccionado en origen. Base DRC 53%.",
    productionCostConab: "Costo de Producción - CONAB",
    productionCostConabDesc: "Costo de producción para calcular margen del productor.",
    dataVerifiableOfficial: "Datos de fuentes oficiales verificables",
    youCheckBeforeUsing: "Tú verificas antes de usar",
    onlyWhatMatters: "Solo lo que importa",
    
    // ========== USER GUIDE ==========
    welcomeGuideTitle: "Bienvenido a la Guía de Precios",
    guideIntroText: "Esta guía te enseñará cómo funciona la formación de precios del caucho natural y cómo usar la calculadora para negociar mejor.",
    officialDataSources: "Datos de fuentes oficiales (IEA, CNA, APABOR)",
    dataNotShared: "Tus datos no se comparten",
    easyToUnderstandUse: "Fácil de entender y usar",
    priceFormationChain: "La Cadena de Formación de Precios",
    pricePassesThroughSteps: "El precio que recibes pasa por varias etapas desde la cotización internacional:",
    internationalPriceSGX: "Precio Internacional (SGX)",
    sgxQuotation: "Cotización en Singapur",
    conversionImportCosts: "Conversión + Costos de Importación",
    exchangeFreightTaxes: "Tipo de cambio + flete + impuestos + costos",
    nationalRefPrice: "Precio de Referencia Nacional",
    producerFormula: "Fórmula del Productor",
    yourPriceCoagulum: "Tu Precio (Coágulo)",
    valueYouReceive: "El valor que recibes",
    priceReferenceTitle: "El Precio de Referencia",
    officialReferencesCalc: "El precio del coágulo se calcula con base en una referencia oficial.",
    mainMarketReferences: "Las principales referencias del mercado:",
    adoptedByMills: "ADOPTADO POR LAS USINAS",
    internalizedPrice: "Precio internalizado (Internacional + Tipo de Cambio + Costos)",
    mostUsedReference: "Referencia más usada (NB Borracha, São Manoel, Hevea-Tec, etc.)",
    bimonthlyPublication: "Publicación: Bimestral (Dic/Ene, Feb/Mar...)",
    importParity: "PARIDAD DE IMPORTACIÓN",
    totalCostImport: "Costo TOTAL para importar caucho procesado (GEB-10)",
    includesFreightTaxes: "Incluye: precio internacional + tipo de cambio + flete + impuestos (~10,8%) + costos",
    monthlyPublicationDays: "Publicación: Mensual (días 15-20)",
    spotPrice: "PRECIO SPOT",
    spMarketPracticed: "Precio practicado en el mercado de São Paulo",
    monthlyPublication: "Publicación: Mensual",
    whyGeb10Reference: "¿Por qué el GEB-10 APABOR es la referencia del mercado?",
    geb10MarketExplanation: "Es la referencia adoptada por las principales usinas procesadoras (NB Borracha, São Manoel, Hevea-Tec, etc.). Permite comparar tu precio directamente con lo que el mercado practica.",
    whatIsDrcTitle: "DRC - Contenido de Caucho Seco",
    whatIsDrcExplanation: "Es el porcentaje de caucho seco en tu coágulo. Cuanto MÁS seco, MAYOR el DRC y MEJOR el precio.",
    howItWorksLabel: "Cómo funciona:",
    coagulumMuchWater: "Coágulo con mucha agua",
    lowDrc: "DRC bajo",
    wellDriedCoagulum: "Coágulo bien seco",
    highDrc: "DRC alto",
    mayBeRejected: "Puede ser rechazado",
    minimumAccepted: "Mínimo aceptado",
    goodExcellent: "Bueno / Excelente",
    excellent: "Excelente",
    drcTip: "¡Cada 1% más en DRC puede significar R$ 0,10-0,15/kg más en tu bolsillo!",
    participationRateTitle: "Tasa de Participación",
    participationRateExplanation: "Es el porcentaje del valor de referencia que recibes. Cuanto MAYOR la tasa, MÁS dinero en tu bolsillo.",
    rateBands: "Franjas de Tasa:",
    veryLow: "Muy baja",
    minCna: "Mínimo CNA",
    good: "Buena",
    ieaReference: "Referencia IEA",
    excellentRate: "Excelente",
    minRecommendedCna: "¡La tasa del 52% es el MÍNIMO recomendado por CNA. El IEA usa 80% en sus cálculos oficiales!",
    howToGetBetterRates: "Cómo conseguir mejores tasas:",
    deliverLargerVolume: "Entregar mayor volumen",
    maintainRegularFrequency: "Mantener frecuencia regular",
    guaranteeQuality: "Garantizar calidad (DRC alto)",
    longTermContracts: "Hacer contratos a largo plazo",
    negotiateInGroup: "Negociar en grupo/cooperativa",
    completeFormulaTitle: "La Fórmula Completa",
    coagulumPriceFormula: "Precio Coágulo = Referencia × (DRC/100) × (Tasa/100)",
    comparativeWithReferences: "Comparativo con las 3 referencias del mercado (DRC 53%):",
    bimonthlyRefPrice: "Precio de referencia bimestral calculado a partir del precio internacional + tipo de cambio + costos de importación.",
    totalCostImportGeb: "Costo total para importar caucho procesado (GEB-10). Incluye flete, impuestos y todos los costos.",
    realTransactionPriceSP: "Precio real practicado en las transacciones del mercado físico de São Paulo.",
    relationBetweenRef: "Relación entre las referencias:",
    maxCostIfImported: "Costo máximo (si la industria importara)",
    refNegotiationMills: "Referencia para negociación entre usinas y productores",
    realTransactionPriceLabel: "Precio real de las transacciones",
    understandDifference: "Entiende la diferencia",
    millsAdoptGeb10: "Las usinas adoptan el GEB-10 APABOR para negociar con productores. El Precio de Importación IEA sirve como referencia de \"paridad\" - cuánto valdría el coágulo nacional si compitiera directamente con el importado.",
    productionCostTitle: "Costo de Producción",
    priceCoversCoststQuestion: "¿Tu precio cubre los costos?",
    profitNeedsHigherPrice: "Para tener ganancia, el precio que recibes necesita ser MAYOR que tu costo de producción.",
    operationalEffectiveCost: "Costo Operacional Efectivo",
    directCostsCOE: "Gastos directos (COE)",
    totalOperationalCost: "Costo Operacional Total",
    includesProLabore: "Incluye pro-labore (COT)",
    marginAnalysisGeb10: "Análisis de Margen (GEB-10 APABOR R$ 11,31):",
    scenario: "Escenario",
    marginVsCOT: "Margen (vs COT)",
    marketAnalysis: "Análisis:",
    currentMarketAnalysis: "Con los precios actuales del mercado (GEB-10 R$ 11,31 y tasa ~72%), el precio del coágulo (R$ 4,30) está por debajo del costo de producción (R$ 6,07). Esta es la realidad actual del mercado.",
    officialSourcesTitle: "Fuentes Oficiales",
    verifiableData: "Datos verificables",
    allDataFromOfficialSources: "Todos los datos de esta calculadora provienen de fuentes oficiales que puedes consultar.",
    dailyQuotes: "diario",
    searchOnSite: "Buscar \"caucho natural\" en el sitio",
    technicalBulletins: "Boletines técnicos y noticias del sector",
    someContentForMembers: "Algunos contenidos para asociados",
    dailyCoagulumQuotation: "Cotización del coágulo (diaria)",
    internationalPriceSGXRealTime: "Precio internacional SGX (tiempo real)",
    negotiationTipsTitle: "Consejos para Negociar",
    knowledgeIsPower: "¡El conocimiento es poder!",
    useKnowledgeToNegotiate: "Ahora que entiendes cómo se forma el precio, usa este conocimiento para negociar mejor.",
    confirmMillReference: "Confirma qué referencia usa la usina",
    mostUseMills: "La mayoría usa GEB-10 APABOR. Compara con los valores de esta calculadora.",
    askCalculationInWriting: "Pide el cálculo por escrito",
    demandTransparency: "Exige transparencia: GEB-10 × DRC × Tasa = tu precio",
    improveYourDRC: "Mejora tu DRC",
    avoidMoisture: "Evita humedad en el coágulo. Cada 1% vale R$ 0,10-0,15/kg",
    negotiateRate: "Negocia la tasa de participación",
    minIdealRate: "Mínimo 52%, ideal 70-80%. Volumen y calidad justifican mejores tasas",
    useThisCalculator: "Usa esta calculadora",
    checkPriceFormula: "Verifica si el precio ofrecido coincide con la fórmula oficial",
    congratulations: "¡Felicitaciones!",
    readyToNegotiate: "¡Ahora estás listo para negociar de forma justa e informada!",
    stepOf: "Paso {current} de {total}",
    previous: "Anterior",
    next: "Siguiente",
    startUsing: "¡Comenzar a usar!",
    
    // ========== GLOSSARY ==========
    rubberMarketGlossary: "Glosario del Mercado del Caucho",
    understandTechnicalTerms: "Entiende los términos técnicos utilizados en el mercado del caucho natural.",
    starTermsImportant: "Los términos con ⭐ son los más importantes para entender la formación de precio.",
    searchTermPlaceholder: "Buscar término... (ej: geb 10, drc, precio)",
    termsFound: "{count} término(s) encontrado(s)",
    forSearch: "para \"{term}\"",
    noTermsFound: "Ningún término encontrado para \"{term}\"",
    tryOtherWord: "Intenta buscar otra palabra o limpia el filtro",
    glossaryTip: "Los términos con ⭐ son esenciales para entender cómo se forma el precio.",
    startWithTerms: "Comienza por ellos:",
    categoryProduct: "Producto",
    categoryQuality: "Calidad",
    categoryProduction: "Producción",
    categoryChain: "Cadena",
    categoryPrice: "Precio",
    categoryInstitution: "Institución",
    categoryTax: "Impuesto",
    allCategories: "Todos",
    tip: "Consejo",
    
    // ========== ADMIN PANEL ==========
    updateQuotationsTitle: "Actualizar Cotizaciones",
    updateValuesFromSources: "Actualiza los valores consultando fuentes oficiales. Los datos se guardarán en el sistema.",
    importPriceIEA: "Precio Importación (IEA)",
    geb10Apabor: "GEB-10 APABOR",
    coaguloDRC53: "Coágulo DRC 53%",
    smr20International: "SMR20 Internacional",
    dollarExchange: "Dólar (Tipo de Cambio)",
    valueLabel: "Valor",
    referenceDateLabel: "Fecha de Referencia",
    referenceDatePlaceholder: "Ej: Dic/2025",
    savingLabel: "Guardando...",
    saveLabel: "Guardar",
    updatedSuccessfully: "¡actualizado con éxito!",
    errorSavingTryAgain: "Error al guardar. Intenta de nuevo.",
    connectionErrorTryAgain: "Error de conexión. Intenta de nuevo.",
    consultSourcesLabel: "Consultar Fuentes:",
    loadingLabel: "Cargando...",
    
    // ========== SUPPLY CHAIN ==========
    supplyChainTitle: "La Cadena Productiva del Caucho Natural",
    supplyChainDescription: "Entiende cómo el caucho va desde el árbol hasta el consumidor final. Cada eslabón de la cadena agrega valor al producto.",
    detailsOfEachStep: "Detalles de Cada Etapa",
    importantData: "Datos Importantes",
    referenceLabel: "Referencia",
    tapperHeveicultor: "Sangrador/Heveicultor",
    tapperDescription: "Extrae el látex del árbol de caucho mediante sangrado",
    tapperProduct: "Látex / Coágulo",
    tapperDetail1: "Realiza el sangrado de los árboles",
    tapperDetail2: "Recolecta el látex",
    tapperDetail3: "Coagula el látex (agrega ácido)",
    tapperDetail4: "Vende el coágulo a la procesadora",
    coagulumPriceRef: "Precio del Coágulo (R$/kg)",
    processorMill: "Procesadora/Usina",
    processorDescription: "Procesa el coágulo y lo transforma en caucho procesado",
    processorProduct: "GEB-10 (Granulado Oscuro Brasileño)",
    processorDetail1: "Compra coágulo de los productores",
    processorDetail2: "Procesa y limpia el material",
    processorDetail3: "Seca y granula el caucho",
    processorDetail4: "Produce GEB-10 (100% caucho)",
    geb10PriceRef: "Precio GEB-10 (R$/kg)",
    tireIndustry: "Industria Neumática",
    tireIndustryDescription: "Fabrica neumáticos y productos de caucho",
    tireIndustryProduct: "Neumáticos y derivados",
    tireIndustryDetail1: "Compra GEB-10 de las procesadoras",
    tireIndustryDetail2: "Mezcla con otros componentes",
    tireIndustryDetail3: "Fabrica neumáticos y productos",
    tireIndustryDetail4: "Consume ~70% del caucho nacional",
    industrialPriceRef: "Precio Industrial",
    finalConsumer: "Consumidor Final",
    finalConsumerDescription: "Utiliza los productos finales",
    finalConsumerProduct: "Vehículos, equipos",
    finalConsumerDetail1: "Compra vehículos con neumáticos",
    finalConsumerDetail2: "Cambia neumáticos periódicamente",
    finalConsumerDetail3: "Usa productos de caucho",
    consumerPriceRef: "Precio al Consumidor",
    nationalProductionConsumed: "de la producción nacional es consumida por la industria neumática",
    saoPauloConcentrates: "concentra ~70% de la producción nacional de coágulo",
    domesticConsumptionImported: "del consumo interno es abastecido por importaciones",
    sourceLabel: "Fuente",
    
    // ========== WHAT IS TBS ==========
    whatIsTbsTitle: "¿Qué es TBS (Contenido de Caucho Seco)?",
    tbsExplanation: "es el porcentaje de caucho seco presente en el coágulo o látex.",
    tbsExplanation2: "En otras palabras: cuánto del material que estás vendiendo es realmente caucho (y no agua o impurezas).",
    practicalExample: "Ejemplo Práctico",
    practicalExampleText: "Si tienes 100 kg de coágulo con TBS de 53%:",
    dryRubberValue: "es caucho seco (lo que tiene valor)",
    waterMoisture: "es agua/humedad",
    whyItMatters: "¿Por qué importa?",
    whyItMattersText: "El precio que recibes se calcula en base al TBS. Cuanto mayor el TBS, mayor el valor de tu producto.",
    standardReference: "Referencia estándar",
    howTbsAffectsPayment: "Cómo el TBS Afecta Tu Pago",
    priceAdjustedByTbs: "El precio del coágulo se ajusta proporcionalmente al TBS, usando 53% como referencia:",
    adjustedPrice: "Precio Ajustado",
    basePrice: "Precio Base",
    yourTbs: "Tu TBS",
    factor: "Factor",
    situation: "Situación",
    aboveReference: "Por encima de la referencia",
    standardReferenceLabel: "Referencia estándar",
    belowReference: "Por debajo de la referencia",
    tbsTip: "¡Cuanto más seco el coágulo antes de vender, mayor será tu TBS y mejor tu precio. Evita el exceso de humedad!",
    tbsCalculator: "Calculadora de TBS",
    tbsCalculatorDesc: "Calcula el TBS de tu coágulo. Necesitas pesar una muestra antes y después de secar.",
    wetWeight: "Peso Húmedo (kg)",
    wetWeightHint: "Peso de la muestra antes de secar",
    dryWeight: "Peso Seco (kg)",
    dryWeightHint: "Peso después del secado completo",
    calculateTbs: "Calcular TBS",
    clear: "Limpiar",
    yourCalculatedTbs: "Tu TBS calculado:",
    aboveOrEqualReference: "Por encima o igual a la referencia (53%)",
    belowReferenceWarning: "Por debajo de la referencia (53%)",
    tbsNote: "Esta es una estimación. El TBS oficial se determina en laboratorio por la usina/procesadora al momento de la compra.",
    
    // ========== USER GUIDE ==========
    welcomeToPriceGuide: "Bienvenido a la Guía de Precios",
    guideIntro: "Esta guía te enseñará cómo funciona la formación de precios del caucho natural y cómo usar la calculadora para negociar mejor.",
    priceFormationChainTitle: "La Cadena de Formación de Precios",
    priceChainIntro: "El precio que recibes pasa por varias etapas desde la cotización internacional:",
    internationalPriceStep: "Precio Internacional (SGX)",
    sgxQuotationLabel: "Cotización en Singapur",
    conversionImportCostsStep: "Conversión + Costos de Importación",
    exchangeFreightTaxesLabel: "Tipo de cambio + flete + impuestos + costos",
    nationalReferencePriceStep: "Precio de Referencia Nacional",
    producerFormulaStep: "Fórmula del Productor",
    yourPriceCoagulumStep: "Tu Precio (Coágulo)",
    valueYouReceiveLabel: "El valor que recibes",
    priceReferenceGuideTitle: "El Precio de Referencia",
    officialReferencesTitle: "Referencias Oficiales",
    officialReferencesDesc: "El precio del coágulo se calcula con base en una referencia oficial. Conoce las principales fuentes usadas en el mercado brasileño.",
    mainMarketReferencesTitle: "Las principales referencias del mercado:",
    adoptedByMillsLabel: "ADOPTADO POR LAS USINAS",
    internalizedPriceLabel: "Precio internalizado (Internacional + Tipo de Cambio + Costos)",
    mostUsedReferenceLabel: "Referencia más usada (NB Borracha, São Manoel, Hevea-Tec, etc.)",
    bimonthlyPublicationLabel: "Publicación: Bimestral (Dic/Ene, Feb/Mar...)",
    importParityLabel: "PARIDAD DE IMPORTACIÓN",
    totalCostToImportLabel: "Costo TOTAL para importar caucho procesado (GEB-10)",
    includesFreightTaxesLabel: "Incluye: precio internacional + tipo de cambio + flete + impuestos (~10,8%) + costos",
    monthlyPublicationLabel: "Publicación: Mensual (días 15-20)",
    spotPriceLabel: "PRECIO SPOT",
    spMarketPracticedLabel: "Precio practicado en el mercado paulista",
    monthlyPublicationSimpleLabel: "Publicación: Mensual",
    whyGeb10ReferenceTitle: "¿Por qué el GEB-10 APABOR es la referencia del mercado?",
    whyGeb10ReferenceExplanation: "Es la referencia adoptada por las principales usinas procesadoras (NB Borracha, São Manoel, Hevea-Tec, etc.). Permite comparar tu precio directamente con lo que el mercado practica.",
    drcGuideTitle: "DRC - Contenido de Caucho Seco",
    whatIsDrcGuide: "¿Qué es DRC?",
    whatIsDrcExplanation: "Es el porcentaje de caucho seco en tu coágulo. Cuanto MÁS seco, MAYOR el DRC y MEJOR el precio.",
    howItWorks: "Cómo funciona:",
    coagulumMuchWaterLabel: "Coágulo con mucha agua",
    drcLowLabel: "DRC bajo (40-50%)",
    wellDriedCoagulumLabel: "Coágulo bien seco",
    drcHighLabel: "DRC alto (60-70%)",
    mayBeRejectedLabel: "Puede ser rechazado",
    minimumAcceptedLabel: "Mínimo aceptado",
    goodExcellentLabel: "Bueno / Excelente",
    excellentLabel: "Excelente",
    drcTipText: "¡Cada 1% más en DRC puede significar R$ 0,10-0,15/kg más en tu bolsillo!",
    participationRateGuideTitle: "Tasa de Participación",
    whatIsParticipationRate: "¿Qué es la Tasa de Participación?",
    participationRateExplanationGuide: "Es el porcentaje del valor de referencia que recibes. Cuanto MAYOR la tasa, MÁS dinero en tu bolsillo.",
    rateBandsTitle: "Franjas de Tasa:",
    veryLowLabel: "Muy baja",
    cnaMinimumLabel: "Mínimo CNA",
    goodLabel: "Buena",
    ieaReferenceLabel: "Referencia IEA",
    excellentRateLabel: "Excelente",
    importantWarningRate: "¡La tasa del 52% es el MÍNIMO recomendado por CNA. El IEA usa 80% en sus cálculos oficiales!",
    howToGetBetterRatesTitle: "Cómo conseguir mejores tasas:",
    deliverLargerVolumeLabel: "Entregar mayor volumen",
    maintainRegularFrequencyLabel: "Mantener frecuencia regular",
    guaranteeQualityLabel: "Garantizar calidad (DRC alto)",
    longTermContractsLabel: "Hacer contratos a largo plazo",
    negotiateInGroupLabel: "Negociar en grupo/cooperativa",
    completeFormulaGuideTitle: "La Fórmula Completa",
    coagulumPriceFormulaLabel: "Precio Coágulo = Referencia × (DRC/100) × (Tasa/100)",
    comparativeWithReferencesTitle: "Comparativo con las 3 referencias del mercado (DRC 53%):",
    bimonthlyRefPriceDesc: "Precio de referencia bimestral calculado a partir del precio internacional + tipo de cambio + costos de importación.",
    totalCostToImportDesc: "Costo total para importar caucho procesado (GEB-10). Incluye flete, impuestos y todos los costos.",
    realTransactionPriceDesc: "Precio real practicado en las transacciones del mercado físico de São Paulo.",
    relationBetweenReferencesTitle: "Relación entre las referencias:",
    maxCostIfImportedLabel: "Costo máximo (si la industria importara)",
    refForNegotiationLabel: "Referencia para negociación entre usinas y productores",
    realTransactionPriceLabel: "Precio real de las transacciones",
    understandDifferenceTitle: "Entiende la diferencia",
    understandDifferenceExplanation: "Las usinas adoptan el GEB-10 APABOR para negociar con productores. El Precio de Importación IEA sirve como referencia de \"paridad\" - cuánto valdría el coágulo nacional si compitiera directamente con el importado.",
    productionCostGuideTitle: "Costo de Producción",
    priceCoversQuestion: "¿Tu precio cubre los costos?",
    profitNeedsHigherPriceText: "Para tener ganancia, el precio que recibes debe ser MAYOR que tu costo de producción.",
    effectiveOperationalCost: "Costo Operacional Efectivo",
    directCostsCOE: "Gastos directos (COE)",
    totalOperationalCost: "Costo Operacional Total",
    includesProLabore: "Incluye pro-labore (COT)",
    marginAnalysisTitle: "Análisis de Margen (GEB-10 APABOR R$ 11,31):",
    scenarioLabel: "Escenario",
    priceLabel: "Precio",
    marginVsCotLabel: "Margen (vs COT)",
    currentMarketLabel: "mercado",
    marketAnalysisText: "Con los precios actuales del mercado (GEB-10 R$ 11,31 y tasa ~72%), el precio del coágulo (R$ 4,30) está por debajo del costo de producción (R$ 6,07). Esta es la realidad actual del mercado.",
    officialSourcesGuideTitle: "Fuentes Oficiales",
    verifiableDataTitle: "Datos verificables",
    verifiableDataDesc: "Todos los datos de esta calculadora provienen de fuentes oficiales que puedes consultar.",
    naturalRubberPortal: "Caucho Natural (Portal Lateks)",
    dailyLabel: "diario",
    mainSourceLabel: "Cotizaciones en la página principal - Fuente principal",
    ieaInstitute: "IEA - Instituto de Economía Agrícola",
    studiesAndAnalyses: "Precio de Importación, estudios y análisis",
    searchRubberOnSite: "Buscar \"caucho natural\" en el sitio",
    technicalBulletinsNews: "Boletines técnicos y noticias del sector",
    someContentForMembers: "Algunos contenidos para asociados",
    dailyCoagulumQuotation: "Cotización del coágulo",
    internationalPriceSgxRealTime: "Precio internacional SGX (tiempo real)",
    negotiationTipsGuideTitle: "Consejos para Negociar",
    knowledgeIsPowerTitle: "¡El conocimiento es poder!",
    knowledgeIsPowerDesc: "Ahora que entiendes cómo se forma el precio, usa este conocimiento para negociar mejor.",
    confirmMillReference: "Confirma qué referencia usa la usina",
    confirmMillReferenceDesc: "La mayoría usa GEB-10 APABOR. Compara con los valores de esta calculadora.",
    askCalculationWritten: "Pide el cálculo por escrito",
    askCalculationWrittenDesc: "Exige transparencia: GEB-10 × DRC × Tasa = tu precio",
    improveYourDrc: "Mejora tu DRC",
    improveYourDrcDesc: "Evita humedad en el coágulo. Cada 1% vale R$ 0,10-0,15/kg",
    negotiateParticipationRate: "Negocia la tasa de participación",
    negotiateParticipationRateDesc: "Mínimo 52%, ideal 70-80%. Volumen y calidad justifican mejores tasas",
    useThisCalculator: "Usa esta calculadora",
    useThisCalculatorDesc: "Verifica si el precio ofrecido coincide con la fórmula oficial",
    congratulationsTitle: "¡Felicitaciones!",
    congratulationsDesc: "¡Ahora estás listo para negociar de forma justa e informada!",
    stepOfTotal: "Paso {current} de {total}",
    previousBtn: "Anterior",
    nextBtn: "Siguiente",
    startUsingBtn: "¡Comenzar a usar!",

    // ========== PHASE 1 - SMALL COMPONENTS ==========
    // AchievementBadge
    noAchievementsYet: "Ningún logro todavía",
    showMore: "más",
    showLess: "Mostrar menos",

    // CertificationNav
    navHome: "Inicio",
    navCertification: "Certificación",
    navEvaluation: "Evaluación",
    navDocuments: "Documentos",
    joinProgram: "Unirse al programa",
    technicalCriteria: "14 criterios técnicos",
    officialDocs: "INCAPER, CATI/SP",

    // FeedbackCard
    yourStrengths: "Tus Puntos Fuertes",
    improvementOpportunities: "Oportunidades de Mejora",
    nextObjective: "Próximo Objetivo",
    recommendedCourses: "Cursos Recomendados",
    potentialGain: "Ganancia potencial",
    pointsFromNextLevel: "puntos del próximo nivel",
    youAreOnly: "Estás a solo",
    seal: "Sello",

    // ScoreBreakdown
    outOf100Points: "de 100 puntos",
    privateScore: "Privado",
    tappingTechnique: "Técnica de Sangría",
    harvestPreparation: "Preparación de Cosecha",
    dailyMaintenance: "Mantenimiento Diario",
    chemicalApplications: "Aplicaciones Químicas",
    maintenanceAndCare: "Mantenimiento y Cuidado",
    productivity: "Productividad",

    // SealBadge
    sealExpert: "Sangrador Experto",
    sealProfessional: "Sangrador Profesional",
    sealCertified: "Sangrador Certificado",
    sealInDevelopment: "En Desarrollo",
    sealExpired: "Sello Expirado",

    // ========== PHASE 2 - DASHBOARDS ==========
    // SimpleDashboard
    hello: "Hola",
    exit: "Salir",
    welcomeUser: "Bienvenido",
    manageEmployeesProperties: "Gestiona tus empleados y propiedades",
    findWorkOpportunities: "Encuentra oportunidades de trabajo",
    quickActions: "Acciones Rápidas",
    tappingToday: "Sangría Hoy",
    newAd: "Nuevo Anuncio",
    viewReports: "Ver Informes",
    viewPlans: "Ver Planes",
    jobs: "Empleos",
    calendar: "Calendario",
    plans: "Planes",
    mainDashboard: "Panel Principal",
    welcomeToHeveaTalent: "¡Bienvenido a HeveaTalent! Usa las pestañas arriba para navegar.",
    jobCenter: "Centro de Empleos",
    postJobsOrFindWork: "Publica vacantes o encuentra trabajo",
    buyAndSellProducts: "Compra y vende productos",
    manageBleedingActivities: "Gestiona actividades de sangría",
    jobCenterTitle: "Centro de Empleos",
    publishJobsFindProfessionals: "Publica vacantes y encuentra profesionales calificados",
    findHeveicultureOpportunities: "Encuentra oportunidades de trabajo en el sector del caucho",
    featureInDevelopment: "Funcionalidad en desarrollo",
    marketplaceBuyAndSell: "Compra y vende productos relacionados con el cultivo del caucho",
    bleedingCalendar: "Calendario de Sangría",
    manageDailyActivities: "Gestiona tus actividades diarias de cultivo del caucho",
    plansAndSubscriptions: "Planes y Suscripciones",
    choosePlanForNeeds: "Elige el plan ideal para tus necesidades",
    basic: "Básico",
    free: "Gratis",
    publish1Ad: "Publicar 1 anuncio",
    basicCalendar: "Calendario básico",
    featuredAds: "Anuncios destacados",
    popular: "Popular",
    professional: "Profesional",
    unlimitedAds: "Anuncios ilimitados",
    advancedCalendar: "Calendario avanzado",
    threeFeaturedAds: "3 anuncios destacados",
    premium: "Premium",
    allFromProfessional: "Todo del Profesional",
    advancedReports: "Informes avanzados",
    prioritySupport: "Soporte prioritario",
    perMonth: "/mes",

    // ReportsDashboard
    reportsAndManagement: "Informes y Gestión",
    trackTeamPerformance: "Acompaña el desempeño de tu equipo",
    howToUse: "Cómo usar",
    reportsViewStats: "Informes: Visualiza estadísticas e informes de producción de tu propiedad.",
    property: "Propiedad",
    month: "Mes",
    year: "Año",
    update: "Actualizar",
    loading: "Cargando...",
    teamSummary: "Resumen del Equipo",
    anonymousRanking: "Ranking Anónimo",
    history: "Historial",
    workers: "Trabajadores",
    totalProduction: "Producción Total",
    withSeal: "Con Sello",
    averageScore: "Puntuación Promedio",
    periodDetails: "Detalles del Período",
    workDays: "Días de Trabajo",
    dailyAverage: "Promedio Diario",
    certified: "Certificados",
    productionRanking: "Ranking de Producción",
    anonymousComparisonProtected: "Comparación anónima - nombres reales protegidos",
    daysWorked: "días trabajados",
    average: "Promedio",
    noProductionDataPeriod: "No hay datos de producción para este período",
    dataAppearsWhenWorkersRegister: "Los datos aparecen cuando los trabajadores registran producción en el Calendario de Sangría",
    privacyNotice: "Privacidad:",
    realNamesProtected: "Los nombres reales de los trabajadores son reemplazados por letras (A, B, C...) para proteger su identidad.",
    productionHistory: "Historial de Producción",
    lastMonthsAnalyzed: "Últimos {months} meses",
    period: "Período",
    production: "Producción",
    days: "Días",
    noHistoryAvailable: "No hay historial disponible",
    noPropertiesYet: "Aún no tienes propiedades registradas",
    registerPropertyToSeeReports: "Registra una propiedad en el Calendario de Sangría para ver informes",
    january: "Enero",
    february: "Febrero",
    march: "Marzo",
    april: "Abril",
    may: "Mayo",
    june: "Junio",
    july: "Julio",
    august: "Agosto",
    september: "Septiembre",
    october: "Octubre",
    november: "Noviembre",
    december: "Diciembre",

    // ========== PHASE 3 - PRICE FORMATION ==========
    // Section 1 - Transparency Warning
    pf_transparencyTitle: "Transparencia sobre el Sistema Actual",
    pf_transparencyText: "Existe discusión en el sector sobre las metodologías de cálculo de precio. Presentamos aquí cómo funciona el sistema, incluyendo sus limitaciones reconocidas por entidades oficiales como CNA y FAESP.",
    
    // Section 2 - How Price is Formed
    pf_howPriceFormedTitle: "Cómo se Forma el Precio del Caucho",
    pf_howPriceFormedIntro: "El precio pagado al productor brasileño por el coágulo se deriva del precio internacional del caucho, ajustado por varios factores. Vea el flujo:",
    pf_step1Title: "Precio Internacional (Singapur)",
    pf_step1Desc: "Cotización de la bolsa de Singapur - referencia mundial",
    pf_step2Title: "Conversión + Costos de Importación",
    pf_step2Desc: "Tipo de cambio (dólar) + flete + seguro + impuestos + despacho aduanero",
    pf_step3Title: "Precio de Referencia GEB-10",
    pf_step3Desc: "Valor del caucho procesado en el mercado interno",
    pf_step4Title: "Ajuste por TBS y Tasa de Participación",
    pf_step4Desc: "Precio GEB-10 × TBS × Tasa de Participación (~52%)",
    pf_negotiation: "Negociación",
    pf_finalPriceTitle: "Precio al Productor (Coágulo)",
    pf_finalPriceDesc: "Valor final pagado por la usina al productor de caucho",
    
    // Section 3 - Participation Rate
    pf_participationRateTitle: "¿Qué es la Tasa de Participación?",
    pf_participationRateIntro: "La Tasa de Participación es la relación entre el precio pagado al productor y el precio de referencia internacional. Según estudios de CNA/FAESP:",
    pf_minRecommendedRate: "Tasa de Participación Mínima Recomendada",
    pf_rateRelation: "Relación entre precio productor y precio de Singapur",
    pf_factorsTitle: "Factores que influyen en la tasa:",
    pf_factorVolume: "Mayor cantidad puede garantizar mejor negociación",
    pf_factorFrequency: "Entregas regulares pueden tener mejores condiciones",
    pf_factorQuality: "Mayor TBS = mejor precio",
    pf_factorDistance: "Proximidad a la usina puede reducir costos",
    pf_volume: "Volumen",
    pf_frequency: "Frecuencia",
    pf_qualityTbs: "Calidad/TBS",
    pf_distance: "Distancia",
    
    // Section 4 - The Problem
    pf_problemTitle: "El Problema Reconocido",
    pf_problemSource: "Según estudio oficial de CNA/FAESP:",
    pf_problemQuote: "La inseguridad de los productores de caucho en relación al mecanismo de formación de precios internos debe ser superada [...] esto solo se logra con la adopción y divulgación de metodologías reconocidas por instituciones independientes.",
    pf_problemsIdentified: "Problemas Identificados:",
    pf_problem1: "Falta de transparencia en la metodología",
    pf_problem2: "Ausencia de contratos formales",
    pf_problem3: "Precios frecuentemente por debajo del costo",
    pf_problem4: "Productor sin poder de negociación",
    pf_problem5: "Discusión sobre ítems del valor aduanero",
    pf_initiativesTitle: "Iniciativas en Curso:",
    pf_initiative1: "Índice IEA/CNA (metodología alternativa)",
    pf_initiative2: "Cámara Sectorial del Caucho",
    pf_initiative3: "Estudios para políticas públicas",
    pf_initiative4: "Propuesta de aumento de tarifa",
    
    // Section 5 - Price vs Cost
    pf_priceVsCostTitle: "Precio vs Costo de Producción",
    pf_priceVsCostIntro: "Datos históricos muestran que, en la mayoría de los años, el precio pagado al productor no cubre el costo de producción:",
    pf_tablePeriod: "Período",
    pf_tableProducerPrice: "Precio Productor",
    pf_tableProductionCost: "Costo Producción",
    pf_tableSituation: "Situación",
    pf_loss: "Pérdida",
    pf_margin: "Margen",
    pf_sourceNote: "Los valores son promedios y pueden variar por región y condiciones específicas de cada propiedad.",
    
    // Section 6 - How to Protect
    pf_protectTitle: "Cómo Protegerse",
    pf_beforeSellingTitle: "Antes de Vender:",
    pf_beforeSelling1: "Consulte las cotizaciones del IEA y APABOR",
    pf_beforeSelling2: "Calcule su TBS real",
    pf_beforeSelling3: "Compare precios entre usinas",
    pf_beforeSelling4: "Conozca su costo de producción",
    pf_negotiationTitle: "Negociación:",
    pf_negotiation1: "Pida claridad en la metodología de cálculo",
    pf_negotiation2: "Cuestione la tasa de participación aplicada",
    pf_negotiation3: "Considere asociarse a cooperativas",
    pf_negotiation4: "Documente todas las transacciones",

    // ========== USER GUIDE STEPS ==========
    // Step 1 - Welcome
    ug_step1_title: "Bienvenido a la Guía de Precios",
    ug_step1_intro: "Esta guía te enseñará cómo funciona la formación de precios del caucho natural y cómo usar la calculadora para negociar mejor.",
    ug_step1_tripod1: "Datos de fuentes oficiales (IEA, CNA, APABOR)",
    ug_step1_tripod2: "Tus datos no se comparten",
    ug_step1_tripod3: "Fácil de entender y usar",
    
    // Step 2 - Price Chain
    ug_step2_title: "La Cadena de Formación de Precios",
    ug_step2_intro: "El precio que recibes pasa por varias etapas desde la cotización internacional:",
    ug_step2_1_title: "1. Precio Internacional (SGX)",
    ug_step2_1_desc: "Cotización en Singapur",
    ug_step2_2_title: "2. Conversión + Costos de Importación",
    ug_step2_2_desc: "Cambio PTAX + flete + impuestos (10,8%) + costos",
    ug_step2_3_title: "3. Precio de Referencia Nacional",
    ug_step2_3_desc: "GEB-10 APABOR y Precio Importación IEA",
    ug_step2_4_title: "4. Fórmula del Productor",
    ug_step2_4_desc: "Referencia × DRC × Tasa de Participación",
    ug_step2_5_title: "5. Tu Precio (Coágulo)",
    ug_step2_5_desc: "El valor que recibes por el coágulo",
    
    // Step 3 - Reference Price
    ug_step3_title: "El Precio de Referencia",
    ug_step3_tripod: "El precio del coágulo se calcula con base en una referencia oficial. Conoce las principales fuentes usadas en el mercado brasileño.",
    ug_step3_mainRefs: "Las principales referencias del mercado:",
    ug_step3_adoptedByMills: "ADOPTADO POR LAS USINAS",
    ug_step3_geb10Desc: "Precio internalizado (Internacional + Cambio + Costos)",
    ug_step3_geb10Note: "Referencia más usada (NB Borracha, São Manoel, Hevea-Tec, etc.)",
    ug_step3_bimonthly: "Publicación: Bimestral (Dic/Ene, Feb/Mar...)",
    ug_step3_importParity: "PARIDAD DE IMPORTACIÓN",
    ug_step3_ieaDesc: "Costo TOTAL para importar caucho procesado (GEB-10)",
    ug_step3_ieaIncl: "Incluye: precio internacional + cambio + flete + impuestos (~10,8%) + costos",
    ug_step3_monthly: "Publicación: Mensual (días 15-20)",
    ug_step3_spotPrice: "PRECIO SPOT",
    ug_step3_spDesc: "Precio practicado en el mercado paulista",
    ug_step3_monthlySimple: "Publicación: Mensual",
    ug_step3_whyGeb10: "¿Por qué el GEB-10 APABOR es la referencia del mercado?",
    ug_step3_whyGeb10Desc: "Es la referencia adoptada por las principales usinas procesadoras (NB Borracha, São Manoel, Hevea-Tec, etc.). Permite comparar tu precio directamente con lo que practica el mercado.",
    
    // Step 4 - DRC
    ug_step4_title: "DRC - Contenido de Caucho Seco",
    ug_step4_tripod: "Es el porcentaje de caucho seco en tu coágulo. Cuanto MÁS seco, MAYOR el DRC y MEJOR el precio.",
    ug_step4_howWorks: "Cómo funciona:",
    ug_step4_muchWater: "Coágulo con mucha agua",
    ug_step4_lowDrc: "DRC bajo (40-50%)",
    ug_step4_wellDried: "Coágulo bien seco",
    ug_step4_highDrc: "DRC alto (60-70%)",
    ug_step4_mayReject: "Puede ser rechazado",
    ug_step4_minAccepted: "Mínimo aceptado",
    ug_step4_goodExcellent: "Bueno / Óptimo",
    ug_step4_excellent: "Excelente",
    ug_step4_tip: "¡Cada 1% más en el DRC puede significar R$ 0,10-0,15/kg más en tu bolsillo!",
    
    // Step 5 - Participation Rate
    ug_step5_title: "Tasa de Participación",
    ug_step5_tripod: "Es el porcentaje del valor de referencia que recibes. Cuanto MAYOR la tasa, MÁS dinero en tu bolsillo.",
    ug_step5_ranges: "Rangos de Tasa:",
    ug_step5_veryLow: "Muy baja",
    ug_step5_minCna: "Mínimo CNA",
    ug_step5_good: "Buena",
    ug_step5_ieaRef: "Referencia IEA",
    ug_step5_excellentRate: "Excelente",
    ug_step5_important: "¡La tasa del 52% es el MÍNIMO recomendado por CNA. El IEA usa 80% en sus cálculos oficiales!",
    ug_step5_howToGet: "Cómo conseguir mejores tasas:",
    ug_step5_tip1: "Entregar mayor volumen",
    ug_step5_tip2: "Mantener frecuencia regular",
    ug_step5_tip3: "Garantizar calidad (DRC alto)",
    ug_step5_tip4: "Hacer contratos a largo plazo",
    ug_step5_tip5: "Negociar en grupo/cooperativa",
    
    // Step 6 - Complete Formula
    ug_step6_title: "La Fórmula Completa",
    ug_step6_formula: "Precio Coágulo = Referencia × (DRC/100) × (Tasa/100)",
    ug_step6_compare: "Comparativo con las 3 referencias del mercado (DRC 53%):",
    ug_step6_geb10Ref: "Precio de referencia bimestral calculado a partir del precio internacional + cambio + costos de importación.",
    ug_step6_ieaRef: "Costo total para importar caucho procesado (GEB-10). Incluye flete, impuestos y todos los costos.",
    ug_step6_spRef: "Precio real practicado en las transacciones del mercado físico de São Paulo.",
    ug_step6_relation: "Relación entre las referencias:",
    ug_step6_maxCost: "Costo máximo (si la industria importara)",
    ug_step6_refNegotiation: "Referencia para negociación entre usinas y productores",
    ug_step6_realPrice: "Precio real de las transacciones",
    ug_step6_understand: "Las usinas adoptan el GEB-10 APABOR para negociar con productores. El Precio Importación IEA sirve como referencia de \"paridad\" - cuánto valdría el coágulo nacional si compitiera directamente con el importado.",
    
    // Step 7 - Production Cost
    ug_step7_title: "Costo de Producción",
    ug_step7_tripod: "Para tener ganancia, el precio que recibes necesita ser MAYOR que tu costo de producción.",
    ug_step7_coe: "Costo Operacional Efectivo",
    ug_step7_coeDesc: "Gastos directos (COE)",
    ug_step7_cot: "Costo Operacional Total",
    ug_step7_cotDesc: "Incluye pro-labore (COT)",
    ug_step7_marginAnalysis: "Análisis de Margen (GEB-10 APABOR vigente):",
    ug_step7_scenario: "Escenario",
    ug_step7_price: "Precio",
    ug_step7_marginVsCot: "Margen (vs COT)",
    ug_step7_analysis: "Compara el precio del coágulo con el costo de producción (COE/COT). Los valores vigentes están en las pestañas 💰 Cotizaciones y 📊 Análisis, actualizados diariamente.",
    
    // Step 8 - Official Sources
    ug_step8_title: "Fuentes Oficiales",
    ug_step8_tripod: "Todos los datos de esta calculadora provienen de fuentes oficiales que puedes consultar.",
    ug_step8_lateks: "Caucho Natural (Portal Lateks)",
    ug_step8_lateksDesc: "GEB-10 APABOR, Mercado SP, SMR20, Dólar (diario)",
    ug_step8_lateksNote: "Cotizaciones en la página inicial - Fuente principal",
    ug_step8_iea: "IEA - Instituto de Economía Agrícola",
    ug_step8_ieaDesc: "Precio de Importación, estudios y análisis (mensual)",
    ug_step8_ieaNote: "Buscar por \"caucho natural\" en el sitio",
    ug_step8_apabor: "APABOR",
    ug_step8_apaborDesc: "Boletines técnicos y noticias del sector",
    ug_step8_apaborNote: "Algunos contenidos para asociados",
    ug_step8_noticias: "Notícias Agrícolas",
    ug_step8_noticiasDesc: "Cotización del coágulo (diaria)",
    ug_step8_trading: "Trading Economics",
    ug_step8_tradingDesc: "Precio internacional SGX (tiempo real)",
    
    // Step 9 - Negotiation Tips
    ug_step9_title: "Consejos para Negociar",
    ug_step9_tripod: "Ahora que entiendes cómo se forma el precio, usa este conocimiento para negociar mejor.",
    ug_step9_tip1_title: "Confirma qué referencia usa la usina",
    ug_step9_tip1_desc: "La mayoría usa GEB-10 APABOR. Compara con los valores de esta calculadora.",
    ug_step9_tip2_title: "Pide el cálculo por escrito",
    ug_step9_tip2_desc: "Exige transparencia: GEB-10 × DRC × Tasa = tu precio",
    ug_step9_tip3_title: "Mejora tu DRC",
    ug_step9_tip3_desc: "Evita humedad en el coágulo. Cada 1% vale R$ 0,10-0,15/kg",
    ug_step9_tip4_title: "Negocia la tasa de participación",
    ug_step9_tip4_desc: "Mínimo 52%, ideal 70-80%. Volumen y calidad justifican mejores tasas",
    ug_step9_tip5_title: "Usa esta calculadora",
    ug_step9_tip5_desc: "Verifica si el precio ofrecido coincide con la fórmula oficial",
    ug_step9_congrats: "¡Felicitaciones!",
    ug_step9_ready: "¡Ahora estás listo para negociar de forma informada, con datos oficiales!",

    // Additional keys for UserGuide
    analysis: "Análisis",
    importPrice: "Precio de Importación",
    important: "IMPORTANTE",
    knowledgeIsPower: "¡El conocimiento es poder!",
    marketSP: "Mercado SP",
    officialReferences: "Referencias Oficiales",
    priceVsCost: "¿Tu precio cubre los costos?",
    tip: "Consejo",
    understandDifference: "Entiende la diferencia",
    verifiableData: "Datos verificables",
    whatIsDrc: "¿Qué es el DRC?",
    
    // ========== ONBOARDING ==========
    onboardingTitle: "🎯 Primeros Pasos",
    onboardingCompleteTitle: "Primeros Pasos Completos!",
    onboardingCompleteDesc: "Todos los pasos se completaron con éxito",
    onboardingSubtitle: "Complete estos pasos para disfrutar de todos los beneficios",
    onboardingStep1Title: "Registre su Propiedad",
    onboardingStep1Desc: "Configure su finca con nombre, ubicación y área de producción",
    onboardingStep2Title: "Configure el Contexto de Producción",
    onboardingStep2Desc: "Defina clon, sistema de sangría y número de árboles para metas justas",
    onboardingStep3Title: "Registre sus Sangrías",
    onboardingStep3Desc: "Use el Calendario para registrar producción diaria y seguir evolución",
    onboardingStep4Title: "Acepte los Términos LGPD",
    onboardingStep4Desc: "Configure sus preferencias de privacidad y aparezca en la Bolsa de Empleo",
    onboardingStep5Title: "Reciba su Primera Evaluación",
    onboardingStep5Desc: "Invite a un tecnico o propietario para evaluar su trabajo. Sello: 100% tecnico (sin calendario) o 50% tecnico + 50% contextual",
    progress: "Progreso",
    completed: "completados",
    start: "Iniciar",
    configure: "Configurar",
    requiresPrevious: "Requiere paso anterior",
    done: "Hecho",
    nextTip: "Próximo paso",
    dismissChecklist: "Ocultar checklist",
    
    // Welcome Modal
    welcomeModalTitle: "¡Bienvenido a HeveaTalent!",
    welcomeModalSubtitle: "La plataforma completa para heveicultores",
    welcomeModalText: "¡Estamos felices de tenerte con nosotros! Hemos preparado una guía rápida para que disfrutes de todos los beneficios de la plataforma.",
    welcomeFeature1Title: "Calendario de Sangría",
    welcomeFeature1Desc: "Registra producción, controla equipo y sigue evolución",
    welcomeFeature2Title: "Metas Contextuales",
    welcomeFeature2Desc: "Metas justas basadas en tu clon, sistema y región",
    welcomeFeature3Title: "Sistema de Sellos",
    welcomeFeature3Desc: "Conquista Bronce, Plata u Oro y destácate",
    welcomeModalButton: "Comenzar Ahora",
    
    // ========== CONTEXTUAL PERFORMANCE ==========
    contextualPerformance: "Desempeño Contextual",
    howEvaluationWorks: "Cómo funciona el Sistema de Evaluación",
    technicalEvaluation: "Evaluación Técnica",
    configureContext: "Configurar Contexto",
    registerInCalendar: "Registrar en Calendario",
    automaticSeal: "Sello Automático",
    sealLevels: "Niveles de Sello",
    yourCurrentSeal: "Tu Sello Actual",
    noSealYet: "Ningún sello conquistado aún",
    officialGoalTable: "Tabla de Metas Oficial",
    cloneType: "Tipo de Clon",
    tappingSystems: "Sistemas de Sangría",
    productivityByClone: "Productividad por Clon",
    totalInProduction: "Total en Producción",
    contextDefinesFairGoal: "El contexto define tu meta justa",
    automatically: "automáticamente",
    targetLine: "Línea de Meta",
    normal: "Normal",
    stop: "Parada",
    year: "Año",
    month: "Mes",
    cuts: "Cortes",
    totalKg: "kg Total",
    clone: "Clon",
    property: "Propiedad",
    tappingSystem: "Sistema de Sangría",
    technicianWeight3x: "Técnico certificado (peso 3x) o propietario (peso 1x) en el promedio",
    groupAScore: "Grupo A - Técnica de Corte",
    groupB1Score: "Grupo B1 - Preparación",
    groupB2Score: "Grupo B2 - Mantenimiento",
    groupCScore: "Grupo C - Tratamientos",
    bronze70: "🥉 Bronce 60-74 pts",
    silver85: "🥈 Plata 75-89 pts",
    gold100: "🥇 Oro 90-100 pts",
    
    // ========== PRODUCTION CONTEXT WIZARD ==========
    wizardTitle: "Configurar Contexto de Producción",
    wizardStepOf: "Paso {current} de {total}",
    wizardAllConfigured: "¡Todo Configurado!",
    wizardAllConfiguredDesc: "Todas sus propiedades ya tienen contexto de producción configurado.",
    wizardClose: "Cerrar",
    
    // Wizard Steps
    wizardStepProperty: "Propiedad",
    wizardStepPropertyDesc: "Seleccione la propiedad",
    wizardStepClone: "Clon",
    wizardStepCloneDesc: "Tipo de árbol de caucho",
    wizardStepSystem: "Sistema",
    wizardStepSystemDesc: "Frecuencia de sangría",
    wizardStepTrees: "Árboles",
    wizardStepTreesDesc: "Cantidad y edad",
    wizardStepExtras: "Detalles",
    wizardStepExtrasDesc: "Región y estimulación",
    wizardStepConfirm: "Confirmar",
    wizardStepConfirmDesc: "Revisar y guardar",
    
    // Property Step
    wizardSelectProperty: "Seleccionar Propiedad",
    wizardSelectPropertyDesc: "Elija la propiedad para configurar el contexto de producción",
    wizardNoPropertiesAvailable: "No hay propiedades disponibles para configurar.",
    wizardNoPropertiesHint: "Todas ya tienen contexto o necesita registrar una propiedad primero.",
    
    // Clone Step
    wizardWhichClone: "¿Cuál es el Clon de los Árboles de Caucho?",
    wizardCloneExplain: "El clon determina la productividad esperada (g/árbol/corte)",
    wizardCloneTip: "Si no conoce el clon, RRIM 600 es el más común en Brasil y una buena opción predeterminada.",
    wizardGramsPerCut: "g/corte",
    wizardPopular: "Popular",
    
    // System Step
    wizardTappingSystem: "Sistema de Sangría",
    wizardTappingFrequency: "¿Qué frecuencia de sangría se utiliza?",
    wizardSystemTip: "D/4 significa sangría cada 4 días (4 lotes). Los sistemas con más días entre sangrías preservan el árbol pero reducen la producción total.",
    wizardCutsPerMonth: "cortes/mes",
    
    // Trees Step
    wizardTreesData: "Datos de Árboles",
    wizardTreesDataDesc: "Ingrese cantidad y edad del cultivo de caucho",
    wizardTreesInProduction: "Total de Árboles en Producción",
    wizardTreesInProductionHint: "¿Cuántos árboles se están sangrando actualmente?",
    wizardTreesPerHectare: "Árboles por Hectárea",
    wizardTreesDefault: "Predeterminado: 450",
    wizardSeringalAge: "Edad del Cultivo (años)",
    wizardSeringalAgeHint: "Años de explotación",
    wizardEstimatedArea: "Área estimada:",
    wizardHectares: "hectáreas",
    
    // Extras Step
    wizardAdditionalDetails: "Detalles Adicionales",
    wizardAdditionalDetailsDesc: "Región y uso de estimulación química",
    wizardRegion: "Región",
    wizardRegionExplain: "La región afecta los coeficientes estacionales de producción",
    wizardRegionSP: "São Paulo (Noroeste)",
    wizardRegionSPDesc: "MAYO es pico (invierno frío)",
    wizardRegionES: "Espírito Santo / Bahia",
    wizardRegionESDesc: "Verano es alta producción",
    wizardRegionMT: "Centro-Oeste (MT/GO/MS)",
    wizardRegionMTDesc: "La sequía favorece la producción",
    wizardStimulation: "¿Usa Estimulación (Ethephon)?",
    wizardStimulationHint: "Puede aumentar la producción hasta un 28%",
    wizardStimulationConcentration: "Concentración de Ethephon (%)",
    wizardStimulationLow: "2.5% (Bajo riesgo, +15-20%)",
    wizardStimulationMedium: "3.3% (Moderado, +20-25%)",
    wizardStimulationHigh: "5.0% (Alto riesgo, +25-28%)",
    
    // Confirm Step
    wizardConfirmData: "Confirmar Datos",
    wizardConfirmDataDesc: "Revise la información antes de guardar",
    wizardWhatHappensNext: "¿Qué pasa ahora?",
    wizardWhatHappensNextDesc: "Con el contexto configurado, el sistema calculará sus metas justas basadas en estos datos. Puede seguir su desempeño en el Panel de Desempeño Contextual.",
    wizardYes: "Sí",
    wizardNo: "No",
    
    // Wizard Navigation
    wizardCancel: "Cancelar",
    wizardBack: "Volver",
    wizardNext: "Siguiente",
    wizardSave: "Guardar Contexto",
    wizardSaving: "Guardando...",
    wizardUseGuided: "Usar Asistente Guiado",
    wizardErrorSaving: "Error al guardar contexto",

    // ========== PÁGINA PROPÓSITO ==========
    purposeLabel: "Nuestro Propósito",
    purposeTitle: "Conectando socios, productores y toda la cadena de heveicultura",
    purposeSubtitle: "HeveaTalent nació de la necesidad de valorar al profesional de la heveicultura y crear conexiones que fortalezcan todo el sector.",
    purposeStatCriteria: "Criterios técnicos de evaluación",
    purposeStatSeals: "Niveles de sello profesional",
    purposeStatOfficial: "Basado en literatura oficial",
    purposeStatAll: "Toda",
    purposeStatChain: "La cadena conectada",
    purposeMission: "Misión",
    purposeMissionText: "Conectar socios, productores y toda la cadena de la heveicultura, valorando al profesional y fortaleciendo el sector con tecnología accesible y certificación técnica basada en literatura oficial.",
    purposeVision: "Visión",
    purposeVisionText: "Ser la plataforma de referencia para el desarrollo profesional en la heveicultura brasileña, donde cada sangrador tiene su trabajo reconocido y valorado.",
    purposeValuesLabel: "Nuestros Valores",
    purposeValuesTitle: "Trípode HeveaTalent",
    purposeValuesSubtitle: "Tres pilares que orientan cada decisión y funcionalidad de la plataforma.",
    purposeJustice: "Justicia",
    purposeJusticeDesc: "Creemos que todo profesional merece un reconocimiento justo por su trabajo. La certificación HeveaTalent se basa en criterios técnicos oficiales, garantizando imparcialidad y meritocracia.",
    purposeJustice1: "Certificación técnica basada en INCAPER y CATI/SP",
    purposeJustice2: "Sellos de calidad (Bronce, Plata, Oro)",
    purposeJustice3: "Oportunidades iguales para todos los profesionales",
    purposeSecurity: "Seguridad",
    purposeSecurityDesc: "Protegemos los datos y las relaciones profesionales de todos los usuarios. La transparencia y la confianza son la base de cada interacción en la plataforma.",
    purposeSecurity1: "Datos protegidos en cumplimiento con la LGPD",
    purposeSecurity2: "Transparencia en las relaciones profesionales",
    purposeSecurity3: "Confianza mutua entre productor y sangrador",
    purposeSimplicity: "Simplicidad",
    purposeSimplicityDesc: "La tecnología debe facilitar la vida, no complicarla. Cada funcionalidad está pensada para ser intuitiva y accesible, incluso para quienes tienen poca experiencia digital.",
    purposeSimplicity1: "Interfaz accesible para uso en el campo",
    purposeSimplicity2: "Información clara y directa",
    purposeSimplicity3: "Flujos simples que ahorran tiempo",
    purposeDiffLabel: "Lo que nos diferencia",
    purposeDiffTitle: "Diferenciales HeveaTalent",
    purposeDiffCert: "Certificación Profesional",
    purposeDiffCertDesc: "Sellos Bronce, Plata y Oro basados en 14 criterios técnicos oficiales",
    purposeDiffMarket: "Marketplace",
    purposeDiffMarketDesc: "Compre y venda insumos y equipos para heveicultura",
    purposeDiffJobs: "Central de Empleos",
    purposeDiffJobsDesc: "Vacantes y ofertas de servicio conectando productores y sangradores",
    purposeDiffComm: "Comunidad",
    purposeDiffCommDesc: "Comparta experiencias y consejos con profesionales de todo Brasil",
    purposeDiffQuotes: "Cotizaciones en Tiempo Real",
    purposeDiffQuotesDesc: "Acompañe precios del caucho y tipo de cambio USD/BRL actualizados",
    purposeDiffRec: "Recomendaciones",
    purposeDiffRecDesc: "Construya su reputación con recomendaciones de empleadores",
    purposeQuote: "Valoramos a cada profesional de la heveicultura, del corte a la comercialización, construyendo puentes que fortalecen toda la cadena.",
    purposeCTA: "Comience ahora — es gratis",
    purposeFooter: "HeveaTalent - Heveicultura Profesional",
    purposeFooterSub: "Basado en el Trípode: Justicia, Seguridad y Simplicidad",

    // ========== FORMULARIO DE CONTACTO & PIE INSTITUCIONAL ==========
    contactTitle: "Contáctenos",
    contactSubtitle: "Envíe su duda, sugerencia o propuesta de asociación.",
    contactName: "Nombre",
    contactEmail: "Correo electrónico",
    contactSubject: "Asunto",
    contactMessage: "Mensaje",
    contactSend: "Enviar Mensaje",
    contactSuccessTitle: "¡Mensaje Enviado!",
    contactSuccessMsg: "Le responderemos pronto por el correo informado.",
    contactError: "Error al enviar. Intente nuevamente.",
    sending: "Enviando...",
    footerAbout: "Plataforma de gestión de desempeño y conexión para profesionales y propietarios en la heveicultura.",
    footerLinks: "Enlaces",
    footerHome: "Inicio",
    footerPurpose: "Propósito",
    footerContact: "Contacto",
    footerLegal: "Legal",
    footerRights: "Todos los derechos reservados.",
    termsTitle: "Términos de Uso",
    privacyTitle: "Política de Privacidad",
    lastUpdated: "Última actualización",

    // ========== FEATURE GATING ==========
    gateTitle: "Recurso Premium",
    gateCurrentPlan: "Su plan actual",
    gateUpgradeMsg: "Actualice su plan para desbloquear este recurso.",
    gateUpgradeBtn: "Ver Planes y Actualizar",
    gateCalendar: "Calendario de sangría disponible en el plan Plus.",
    gateReports: "Informes disponibles desde el plan Básico.",
    gateTeam: "Gestión de equipo disponible desde el plan Básico.",
    gateEvaluations: "Dar evaluaciones disponible desde el plan Básico.",
    gateLimitReached: "Límite alcanzado",
    gateLimitMsg: "Has alcanzado el límite de tu plan.",
    gateTrialExpired: "Período de Prueba Expirado",
    gateTrialExpiredMsg: "Su período de prueba ha terminado. Suscríbase a un plan para seguir usando este recurso.",
    trialDaysLeft: "Período de prueba",
    day: "día",
    days: "días",

    // ========== MENSAJES DE CONTACTO ==========
    msgTitle: "Mensajes",
    msgNew: "Nueva",
    msgRead: "Leída",
    msgResponded: "Respondida",
    msgEmpty: "Ningún mensaje recibido aún.",
    msgMarkResponded: "Marcar como Respondida",
    msgReplyEmail: "Responder por Email",
    msgDelete: "Eliminar",
    msgDeleteConfirm: "¿Estás seguro de que deseas eliminar este mensaje?",

    // ========== ADMIN STATS ==========
    statsTitle: "Estadísticas",
    statsTotal: "Total de Usuarios",
    statsActive: "Usuarios Activos",
    statsSubscriptions: "Suscripciones Activas",
    statsMessages: "Mensajes",
    statsLast30d: "últimos 30 días",
    statsLast7d: "últimos 7 días",
    statsTrial: "en prueba",
    statsUnread: "no leídos",
    statsUsersByType: "Usuarios por Tipo",
    statsGrowth: "Crecimiento",
    statsNew7d: "Nuevos (7 días)",
    statsNew30d: "Nuevos (30 días)",
    statsActive7d: "Activos (7 días)",
    statsRecentUsers: "Últimos Registros",
    statsNoUsers: "Ningún usuario registrado aún.",
    usersTitle: "Usuarios",
    searchUsers: "Buscar usuario...",
    noSubscription: "Sin suscripción",
    noResults: "Ningún resultado encontrado",

    // ========== FORMULARIO DE EVALUACIÓN ==========
    evalFormVersion: "Versión",
    evalRoleEngineer: "Ingeniero Agrónomo (peso 3x)",
    evalRoleTechnician: "Técnico Agrícola (peso 3x)",
    evalRoleLeader: "Líder de Equipo (peso 1x)",
    evalRoleOwner: "Propietario (peso 1x)",
    evalRoleOther: "Otro (peso 1x)",
    evalError: "Error",
    evalRedirecting: "Redirigiendo al panel...",
    evalSelectOption: "Seleccione...",
    evalTotalScore: "Puntuación Total",
    evalGroup: "Grupo",

    // ========== CERTIFICACIÓN ==========
    certLoading: "Cargando...",
    certBondType: "Tipo de Vínculo",
    certLGPDTerm: "Término LGPD",
    certBondQuestion: "¿Cuál es su tipo de vínculo?",
    certBondJustice: "Todos los tipos de vínculo tienen las mismas oportunidades en el programa de certificación.",
    certLGPDTitle: "Término de Consentimiento LGPD",
    certLGPDSecurity: "Lea atentamente cómo se utilizarán sus datos.",
    certFooter: "HeveaTalent • Sistema de Certificación",
    certFooterSub: "Basado en el Trípode: Justicia • Seguridad • Simplicidad",
    certTitle: "Certificación HeveaTalent",
    certSubtitle: "Participe del programa de certificación y obtenga su sello de calidad",
    certVoluntary: "La participación en el programa de certificación es opcional. Puede usar la plataforma normalmente sin adherirse.",
    certContinue: "Continuar",
    certBack: "Volver",
    certAcceptActivate: "Aceptar y Activar",
    certAcceptTerm: "He leído y acepto el término de consentimiento. Entiendo que puedo revocar en cualquier momento.",
    certDataCollected: "Datos que serán recopilados:",
    certPurpose: "Finalidad:",
    certRights: "Sus derechos:",
    certVisible: "Lo que otras fincas PODRÁN ver:",
    certVisibleName: "Nombre y foto de perfil",
    certVisibleSeal: "Sello de calidad y nota general",
    certVisibleExp: "Años de experiencia",
    certVisibleClones: "Clones con los que ya trabajó",
    certVisibleTrend: "Tendencia de rendimiento (Consistente/En Evolución/Nuevo)",
    certNeverShared: "Lo que NUNCA será compartido:",
    certNeverHistory: "Historial detallado mes a mes",
    certNeverNotes: "Notas individuales por criterio técnico",
    certNeverFarms: "Nombres de las fincas anteriores",
    certNeverContact: "Información de contacto (sin su autorización)",

    // ========== RECOMENDACIONES ==========
    recExample: "Ejemplo",
    recViaInvite: "Por invitación",

    // ========== PÁGINA PÚBLICA DE RECOMENDACIÓN ==========
    pubRecLoadingInvite: "Cargando invitación...",
    pubRecInvalidTitle: "Invitación Inválida",
    pubRecGoHome: "Ir a HeveaTalent",
    pubRecThanks: "¡Gracias!",
    pubRecSuccessMsg: "Su recomendación para",
    pubRecSuccessMsg2: "fue publicada con éxito.",
    pubRecSuccessVisible: "Ya es visible en el perfil profesional.",
    pubRecKnow: "Conocer HeveaTalent",
    pubRecPlatform: "Plataforma de Heveicultura Profesional",
    pubRecRequestsRec: "solicita su recomendación profesional",
    pubRecYourName: "Su Nombre",
    pubRecNamePlaceholder: "Ingrese su nombre completo",
    pubRecYourRole: "Su Cargo/Función",
    pubRecSelectRole: "Seleccione su cargo",
    pubRecRoleOwner: "Propietario",
    pubRecRoleTech: "Técnico Agrícola",
    pubRecRoleManager: "Gerente",
    pubRecRoleEngineer: "Ingeniero Agrónomo",
    pubRecRoleOnly: "Solo profesionales del sector pueden recomendar",
    pubRecFarm: "Finca/Empresa",
    pubRecFarmPlaceholder: "Ej: Finca São João",
    pubRecPeriod: "Período que trabajaron juntos (opcional)",
    pubRecPeriodPlaceholder: "Ej: 2020 - 2023",
    pubRecYourRec: "Su Recomendación",
    pubRecPlaceholder: "Describa las cualidades profesionales y su experiencia trabajando con esta persona...",
    pubRecChars: "caracteres",
    pubRecSending: "Enviando...",
    pubRecSend: "Enviar Recomendación",
    pubRecInfoPrefix: "Su recomendación será publicada en el perfil profesional de",
    pubRecInfoSuffix: "Solo se permiten elogios positivos.",
    pubRecErrName: "Por favor, ingrese su nombre",
    pubRecErrRole: "Por favor, seleccione su cargo/función",
    pubRecErrFarm: "Por favor, ingrese la finca o empresa",
    pubRecErrMsg: "Por favor, escriba una recomendación con al menos 10 caracteres",
    pubRecErrInvalid: "Invitación inválida o expirada",
    pubRecErrLoad: "Error al cargar invitación. Inténtelo de nuevo.",
    pubRecErrSend: "Error al enviar recomendación",
    pubRecErrConn: "Error de conexión. Inténtelo de nuevo.",

    // ========== NOTIFICACIONES ==========
    notifTitle: "Notificaciones",
    notifMarkAllRead: "Marcar todas como leídas",
    notifEmpty: "Ninguna notificación",
    notifNow: "Ahora",

    // ========== PANEL DEL TRABAJADOR ==========
    wdError: "Error",
    wdValidUntil: "Válido hasta",
    wdSealExpired: "Sello Expirado",
    wdCertActive: "Certificación Activa",
    wdCertPending: "Pendiente de Consentimiento",
    wdCertJoin: "Participe del Programa de Certificación",
    wdBronze: "Bronce (60-74 pts): Sangrador Certificado",
    wdSilver: "Plata (75-89 pts): Sangrador Profesional",
    wdGold: "Oro (90-100 pts): Sangrador Experto",
    wdTripod: "Trípode HeveaTalent",

    // ========== WORKERS DATABASE ==========
    wdbTitle: "Base de Datos Interna - Trabajadores",
    wdbCurrentMonth: "Mes Actual",
    wdbAllPeriods: "Todos los Períodos",
    wdbSummary: "Resumen de la Base de Datos",
    wdbProperty: "Propiedad",
    wdbTotalRecords: "Total Registros",
    wdbWorkers: "Trabajadores",
    wdbPeriod: "Período",
    wdbAllPeriodsLabel: "Todos los períodos",
    wdbAverage: "Promedio",
    wdbImproving: "Mejorando",
    wdbDeclining: "En declive",
    wdbStable: "Estable",
    wdbDaysWorked: "Días Trabajados",
    wdbTotalProd: "Producción Total",
    wdbDailyAvg: "Promedio Diario",
    wdbEvaluations: "Evaluaciones",
    wdbNumeric: "numéricas",
    wdbDescriptive: "descriptivas",
    wdbNotesObs: "Notas y Observaciones",
    wdbEvaluation: "Evaluación",
    wdbObservations: "Observaciones",
    wdbAndMore: "y más",
    wdbRecords: "registros",
    wdbLastWorks: "Últimos Trabajos",
    wdbDate: "Fecha",
    wdbProduction: "Producción",
    wdbActivities: "Actividades",
    wdbNoInternalEval: "Ningún registro con evaluación interna encontrado",
    wdbMarkInternal: "Marque \"Control Interno (Privado)\" en los registros diarios para crear la base de datos",
    wdbErrorLoading: "Error al cargar base de datos de trabajadores",
    wdbJan: "Enero",
    wdbFeb: "Febrero",
    wdbMar: "Marzo",
    wdbApr: "Abril",
    wdbMay: "Mayo",
    wdbJun: "Junio",
    wdbJul: "Julio",
    wdbAug: "Agosto",
    wdbSep: "Septiembre",
    wdbOct: "Octubre",
    wdbNov: "Noviembre",
    wdbDec: "Diciembre",

    // ========== MONTHLY REPORT ==========
    rptPropertyInfo: "Información de la Propiedad",
    rptName: "Nombre",
    rptLocation: "Ubicación",
    rptCultureAge: "Edad del Cultivo",
    rptYears: "años",
    rptExplorationTime: "Tiempo de Explotación",
    rptTotalArea: "Área Total",
    rptHectares: "hectáreas",
    rptMonthYear: "Mes/Año",
    rptMonthNotInformed: "Mes no informado",
    rptTotalRecords: "Total de Registros",
    rptGeneratedAt: "Generado en",
    rptGeneralSummary: "Resumen General del Mes",
    rptTotalRecordsLabel: "Total Registros",
    rptTotalProduction: "Producción Total",
    rptEvaluatedWorkers: "Trabajadores Evaluados",
    rptOfMonth: "del mes",
    rptPerRecord: "kg/registro",
    rptNoData: "Sin datos",
    rptWithEval: "Con evaluación",
    rptWithoutEval: "Sin evaluación",
    rptBleedingActivities: "Actividades de Sangría",
    rptDaysPerformed: "Días Realizados",
    rptLostBleedings: "Sangrías Perdidas",
    rptApprovalRate: "Tasa de Aprovechamiento",
    rptExcellent: "¡Excelente!",
    rptAttention: "Atención",
    rptGreat: "¡Óptimo!",
    rptCanImprove: "Puede mejorar",
    rptWeatherConditions: "Condiciones Climáticas",
    rptTotalRain: "Total de Lluvia",
    rptPerActiveDay: "mm/día activo",
    rptTotalReplacements: "Total Reposiciones",
    rptNoReplacements: "Sin reposiciones",
    rptReplacementsDone: "Reposiciones hechas",
    rptComplementaryAct: "Actividades Complementarias",
    rptFungicideApp: "Aplicaciones de Fungicida",
    rptEthrelApp: "Aplicaciones de Ethrel",
    rptApplied: "Aplicado",
    rptNotApplied: "No aplicado",
    rptWorkerEvals: "Evaluaciones de Trabajadores",
    rptWorker: "Trabajador",
    rptAverage: "Promedio",
    rptDays: "Días",
    rptStatus: "Estado",
    rptRecommendation: "Recomendación",
    rptNoWorkerEval: "Ninguna evaluación de trabajador registrada este mes",
    rptActivateInternal: "Active \"Evaluación Interna\" en los registros diarios para generar informes de rendimiento",
    rptRecommendations: "Recomendaciones",
    rptNoRecommendations: "Ninguna recomendación disponible",
    rptErrorDisplay: "Error al mostrar mes",
    rptMonthJan: "enero",
    rptMonthFeb: "febrero",
    rptMonthMar: "marzo",
    rptMonthApr: "abril",
    rptMonthMay: "mayo",
    rptMonthJun: "junio",
    rptMonthJul: "julio",
    rptMonthAug: "agosto",
    rptMonthSep: "septiembre",
    rptMonthOct: "octubre",
    rptMonthNov: "noviembre",
    rptMonthDec: "diciembre",

    // ========== BLEEDING DAILY TABLE ==========
    bdtTitle: "Tabla Diaria de Sangría",
    bdtPropertyLabel: "Propiedad",
    bdtYearsCultivation: "años de cultivo",
    bdtNoResults: "Ningún resultado encontrado para",
    bdtDay: "Día",
    bdtWorkers: "Trabajadores",
    bdtBleeding: "Sangría",
    bdtReplacement: "Reposición",
    bdtFungicide: "Fungicida",
    bdtEthrel: "Ethrel",
    bdtCollections: "Colectas",
    bdtRainMm: "Lluvia (mm)",
    bdtProductionKg: "Producción (kg)",
    bdtActions: "Acciones",

    // ========== RECORD FORM ==========
    rfSelectLot: "Seleccionar lote...",
    rfCollectionNote: "Marque al recoger la goma de los lotes. Puede hacerse incluso sin sangría (ej: lluvia). El peso puede informarse después.",
    rfAllLotsMarked: "Todos los lotes vienen marcados.",
    rfUncheckNotCollected: "Desmarque",
    rfNotCollectedText: "los que NO fueron recolectados.",
    rfSelectLotOption: "Seleccione el lote",
    rfOptionalProductivity: "Opcional - Para control de productividad",
    rfOptionalKgPlant: "Opcional - Para cálculo kg/planta",
    rfEvalNote1: "Evalúe el desempeño del trabajador (1 a 10)",
    rfEvalNote2: "Esta evaluación es",
    rfEvalNote2Bold: "privada",
    rfEvalNote2End: "— solo usted la ve",
    rfEvalNote3: "Sirve para acompañar la evolución del equipo a lo largo del tiempo",
    rfEvalNote4: "el sello profesional — el sello es generado por la Evaluación Técnica (14 criterios)",
    rfEvalNote4Bold: "No afecta",
    rfPrivacyNote: "Privacidad:",
    rfPrivacyDesc: "Notas visibles solo para el empleador",
    rfEvalScale: "Evaluar desempeño de 1 (malo) a 10 (excelente)",
    rfSelectOption: "Seleccionar",
    rfRecordSaved: "¡Registro guardado con éxito!",

    // ========== RECOMMENDATIONS SECTION ==========
    recNoRecommendations: "Aún sin recomendaciones",
    recIdentifiedRecommender: "Recomendador identificado",
    recVerified: "Verificada",
    recExternal: "Externa",
    recNoRecommendationsYet: "Aún no tienes recomendaciones",
    recInviteCreated: "¡Invitación creada!",
    recInviteLink: "Enlace de invitación",
    recHowItWorks: "Cómo funciona:",
    recAutoPublished: "Su recomendación será publicada automáticamente",
    recShowsOnProfile: "Aparecerá en el perfil público del profesional",
    recNameAsReference: "Su nombre será mostrado como referencia",
    recOnlyPositive: "Solo se permiten elogios positivos",

    // ========== COMMUNITY TIPS ==========
    ctLoadingComments: "Cargando comentarios...",
    ctNoComments: "Ningún comentario aún.",
    ctBeFirst: "¡Sé el primero en comentar!",
    ctShareKnowledge: "Comparta su conocimiento con la comunidad",
    ctClickAddPhotos: "Clic para agregar fotos",

    // ========== MARKETPLACE ITEM ==========
    mkiSeller: "Vendedor",
    mkiContact: "Contacto",
    mkiDescription: "Descripción",

    // ========== MARKETPLACE DIALOGS ==========
    mkdFullName: "Nombre Completo",
    mkdEmail: "Correo",
    mkdProduct: "Producto",
    mkdPaymentViaPix: "Pago via PIX",
    mkdValue: "Valor",
    mkdStatusLabel: "Estado",
    mkdExpiresIn: "Expira en",

    // ========== MONTHLY CHARTS ==========
    mchTotalProduced: "Total Producido",

    // ========== TEAM REPORT ==========
    trpWorker: "Trabajador",
    trpAvgScore: "Promedio",
    trpDaysWorked: "Días",
    trpStatus: "Estado",
    trpRecommendation: "Recomendación",

    // ========== CONTEXTUAL PERFORMANCE ==========
    cpPropertyLabel: "Propiedad",
    cpMonthLabel: "Mes",
    cpYearLabel: "Año",
    cpYourAvg: "Su Promedio",
    cpGoal: "Meta",
    cpGramsPerTreeCut: "g/árbol/corte",
    cpCuts: "Cortes",
    cpAvgPerTreeCut: "Prom/Árbol/Corte",
    cpClone: "Clon",
    cpSystem: "Sistema",
    cpStimulation: "Estimulación",
    cpBaseGoal: "Meta Base",
    cpSeasonalCoef: "Coef. Estacional",
    cpPeriod: "Período",
    cpExcellent: "Excelente (≥110%)",
    cpReachedGoal: "Meta Alcanzada (≥100%)",
    cpGood: "Bueno (≥85%)",
    cpRegular: "Regular (≥70%)",
    cpGoalLine: "Línea de Meta",
    cpWhyConfigContext: "¿Por qué configurar el contexto?",
    cpAllConfigured: "¡Todas sus propiedades ya tienen contexto configurado!",
    cpCloneType: "Tipo de Clon",
    cpTappingSystem: "Sistema de Sangría",
    cpTreesPerHectare: "Árboles/Hectárea",
    cpTotalInProduction: "Total en Producción",
    cpPlantationAge: "Edad del Seringal (años)",
    cpRegionSP: "São Paulo (Noroeste)",
    cpRegionES: "Espírito Santo / Bahia",
    cpRegionMT: "Centro-Oeste (MT/GO/MS)",
    cpUsesStimulation: "¿Usa Estimulación (Ethephon)?",
    cpIncreasesProduction: "Aumenta producción hasta 28%",
    cpConcentration: "Concentración (%)",
    cpOfficialGoalsTable: "Tabla de Metas Oficial",
    cpProductivityByClone: "Productividad por Clon",
    cpConfigureContext: "Configure el Contexto",
    cpConfigContextDesc: "Clon, sistema de sangría, árboles en producción.",
    cpRegisterCalendar: "Registre en el Calendario",
    cpRegisterCalendarDesc: "Sangrías, reposiciones, colectas y producciones mensuales.",
    cpTechnicalEval: "Evaluación Técnica",
    cpTechnicalEvalDesc: "(mensual): 14 parámetros evaluados. Técnico certificado (peso 3x) o propietario (peso 1x) en el promedio.",
    cpAutoSeal: "Sello Automático",
    cpAutoSealDesc: "50% técnico + 50% contextual (o 100% técnico sin calendario).",
    cpTechnicalEval14: "Evaluación Técnica (14 ítems):",

    // ========== TEAM REPORT ==========
    trpPlants: "Plantas",
    trpDeliveries: "Entregas",
    trpWorkersLabel: "Trabajadores",
    trpTotalProd: "Producción Total",
    trpTotalPlants: "Total Plantas",
    trpCollections: "Colectas",
    trpCollectionsWithProd: "Entregas con producción registrada",
    trpAccumulated: "Acumulado",
    trpPlants2: "plantas",
    trpLot: "Lote",
    trpCollectionDate: "Fecha Colecta",
    trpPreviousCollection: "Colecta Anterior",
    trpMonthTotalCuts: "Total de Cortes (Mes)",
    trpTotalThisDelivery: "Total esta entrega",

    // ========== PROFESSIONALS SEARCH ==========
    psSearchTitle: "Buscar Profesionales",
    psSearchPlaceholder: "Buscar por nombre o especialización...",
    psFilterAll: "Todos",
    psFilterSangrador: "Sangrador",
    psFilterGerente: "Gerente",
    psFilterFiscal: "Fiscal",
    psFilterAgronomo: "Agrónomo",
    psNoResults: "Ningún profesional encontrado",
    psExperience: "Experiencia",
    psLocation: "Ubicación",
    psSpecialization: "Especialización",
    psSealLabel: "Sello",
    psContact: "Contactar",
    psRecommend: "Recomendar",
    psViewProfile: "Ver Perfil",

    // ========== CALENDAR GUIDE MODAL ==========
    cgOverview: "Visión General",
    cgDailyRecords: "Registros Diarios",
    cgHarvestSummary: "Resumen de Zafra",
    cgEthrelControl: "Control de Ethrel",
    cgTeamManagement: "Gestión de Equipo",
    cgReports: "Informes",
    cgTips: "Consejos",
    cgWhatIsCalendar: "¿Qué es el Calendario de Sangría?",
    cgCalendarDesc: "El Calendario de Sangría es una herramienta completa para gestionar todas las actividades de su propiedad de heveicultura. Registre sangrías, producciones, aplicaciones de productos y acompañe el rendimiento de su equipo.",
    cgMainFeatures: "Funcionalidades Principales:",
    cgFeature1: "Registro diario de sangrías y producción",
    cgFeature2: "Control de aplicaciones (Fungicida, Ethrel)",
    cgFeature3: "Gestión de equipo y productividad",
    cgFeature4: "Informes mensuales y anuales automatizados",
    cgFeature5: "Evaluación interna de trabajadores",
    cgFeature6: "Colecta y pesaje por lote",
    cgHowToStart: "Cómo Empezar:",
    cgStep1: "Seleccione su propiedad en el selector",
    cgStep2: "Elija el mes que desea registrar",
    cgStep3: "Haga clic en el día para abrir el formulario",
    cgStep4: "Complete la información del día",

    // ========== PROPERTY FORM ==========
    pfPropertyName: "Nombre de la Propiedad",
    pfLocation: "Ubicación",
    pfCultureAge: "Edad del Cultivo (años)",
    pfExplorationTime: "Tiempo de Explotación (años)",
    pfTotalArea: "Área Total (hectáreas)",
    pfSave: "Guardar Propiedad",

    // ========== ETHREL ALERT ==========
    eaEthrelAlert: "Alerta de Ethrel",
    eaDaysRemaining: "días restantes",
    eaApplied: "Aplicación registrada",
    eaNextApplication: "Próxima aplicación",
    eaConfigure: "Configurar alertas",
    eaLastApplication: "Última aplicación",

    // ========== YEARLY SUMMARY ==========
    ysYearlySummary: "Resumen Anual",
    ysTotalProduction: "Producción Total",
    ysTotalBleedings: "Total Sangrías",
    ysAvgProduction: "Producción Promedio",
    ysBestMonth: "Mejor Mes",
    ysWorstMonth: "Peor Mes",

    // CalendarGuide feature boxes
    cgProperties: "Propiedades",
    cgPropertiesDesc: "Registre múltiples propiedades con información de área, edad del cultivo y ubicación.",
    cgVisualCalendar: "Calendario Visual",
    cgVisualCalendarDesc: "Visualice sus actividades en un calendario mensual intuitivo con códigos de colores.",
    cgAutoSummaries: "Resúmenes Automáticos",
    cgAutoSummariesDesc: "Totales mensuales y anuales calculados automáticamente con comparativos.",
    cgTeamMgmt: "Gestión de Equipo",
    cgTeamMgmtDesc: "Acompañe la productividad individual de cada sangrador de su equipo.",
    cgFirstSteps: "Primeros Pasos:",
    cgFirstStep1: "Cree una propiedad haciendo clic en \"Nueva Propiedad\"",
    cgFirstStep2: "Seleccione la propiedad y el mes/año deseado",
    cgFirstStep3: "Haga clic en un día del calendario para agregar registros",
    cgFirstStep4: "Acompañe los resúmenes e informes generados automáticamente",

    // Additional calendar/table labels
    bdtCalendar: "Calendario",
    bdtTable: "Tabla",
    bdtSearchPlaceholder: "Buscar por trabajador o día...",
    bdtCollapseAll: "Contraer Todos",
    bdtExpandAll: "Expandir Todos",
    bdtWorkerSingular: "trabajador",
    bdtWorkerPlural: "trabajadores",
    bdtShowing: "Mostrando",
    bdtResults: "resultado(s)",

    // App.js calendar guide / legend
    appHowToUse: "Cómo usar el Calendario de Sangría:",
    appPropertySelected: "Propiedad seleccionada",
    appChooseMonth: "Elegir mes/año arriba",
    appClickDayToAdd: "Haga clic en el día para agregar",
    appUseTableToEdit: "Use \"Tabla\" para editar/eliminar",
    appLegend: "Leyenda:",
    appBleeding: "Sangría",
    appReplacement: "Reposición",
    appFungicide: "Fungicida",
    appRain: "Lluvia",
    appProduction: "Producción",
    appDaysWithoutRecord: "días sin registro este mes",
    appYouHave: "Usted tiene",

    // YearlySummaryCard
    ysCompare: "Comparar",
    ysExpand: "Expandir",
    ysCollapse: "Contraer",
    ysPreviousHarvest: "Zafra anterior",
    ysEthrelApps: "aplicaciones",
    ysFungicideLabel: "Fungicida",
    ysLosses: "Pérdidas",
    ysRecords: "Registros",
    ysHarvestPeriod: "Período de zafra configurado",
    ysTo: "a",
    ysPlants: "plantas",

    // EthrelAlertBanner
    eaConfigureInterval: "Configure el intervalo entre aplicaciones y cuándo desea recibir alertas.",
    eaIntervalDays: "Intervalo entre aplicaciones (días)",
    eaViewHistory: "Ver historial de aplicaciones",

    // Misc calendar
    calendarGuideTitle: "Guía del Calendario",
    configSafraBtn: "Configurar Zafra",
    configSafraTooltip: "Configurar plantas por sangrador, modo de sangrado y rotación de equipo por zafra",
    tappers: "Sangradores",
    limitReached: "Límite alcanzado",
    of: "de",

    // ========== CALENDAR GUIDE MODAL - Full content ==========
    cgModalTitle: "Guía del Calendario de Sangría",
    cgFooterText: "HeveaTalent • Calendario de Sangría",
    cgClose: "Cerrar",
    cgRecHowToRegister: "Cómo Registrar Actividades",
    cgRecClickAnyDay: "Haga clic en cualquier día del calendario o use la tabla para agregar registros.",
    cgRecAvailableFields: "Campos Disponibles:",
    cgRecBleeding: "Sangría",
    cgRecBleedingDesc: "Marque si hubo sangría este día. Acompañe cuántos días de sangría por mes.",
    cgRecProduction: "Producción (kg)",
    cgRecProductionDesc: "Registre la cantidad de látex/coágulo producido en kilogramos.",
    cgRecRain: "Lluvia (mm)",
    cgRecRainDesc: "Volumen de precipitación en milímetros. Importante para análisis de productividad.",
    cgRecReplacement: "Reposición",
    cgRecReplacementDesc: "Número de árboles que recibieron reposición de panel o taza.",
    cgRecFungicide: "Fungicida",
    cgRecFungicideDesc: "Marque cuando haya aplicación de fungicida en los árboles.",
    cgRecEthrelDesc: "Registre aplicaciones de Ethrel incluyendo la proporción/concentración utilizada.",
    cgRecDuplicate: "Duplicar para Otro Sangrador",
    cgRecDuplicateDesc: "Al registrar datos, puede hacer clic en \"Duplicar para otro sangrador\" para crear rápidamente un registro similar para otro trabajador, cambiando solo el nombre y ajustando los valores si es necesario.",
    cgSafraTitle: "Resumen Acumulado de Zafra",
    cgSafraDesc: "El resumen de zafra muestra los totales acumulados del año agrícola (zafra), no del año calendario. Esto permite un análisis más preciso de su producción.",
    cgSafraWhatIs: "¿Qué es el Año de Zafra?",
    cgSafraWhatIsDesc: "El año de zafra del caucho generalmente va de Septiembre a Agosto del año siguiente. Ejemplo: Zafra 2024/2025 = Septiembre/2024 hasta Agosto/2025.",
    cgSafraConfigNote: "Puede configurar el mes de inicio de la zafra en las configuraciones de la propiedad.",
    cgSafraMetrics: "Métricas Mostradas:",
    cgSafraTotalProd: "Producción Total (kg)",
    cgSafraTotalRain: "Lluvia Total (mm)",
    cgSafraTotalReplacements: "Total Reposiciones",
    cgSafraEthrelApps: "Aplicaciones Ethrel",
    cgSafraComparative: "Comparativo con Zafra Anterior",
    cgSafraComparativeDesc: "El sistema compara automáticamente con la zafra anterior, mostrando:",
    cgSafraIncrease: "Aumento respecto a la zafra anterior",
    cgSafraDecrease: "Reducción respecto a la zafra anterior",
    cgSafraConfigTitle: "Cómo Configurar el Inicio de la Zafra",
    cgSafraStep1: "Acceda a las configuraciones de la propiedad (botón de engranaje)",
    cgSafraStep2: "Localice el campo \"Mes de Inicio de la Zafra\"",
    cgSafraStep3: "Seleccione el mes (predeterminado: Septiembre)",
    cgSafraStep4: "Guarde los cambios",
    cgEthrelTitle: "Control de Aplicación de Ethrel",
    cgEthrelDesc: "El sistema monitorea las aplicaciones de Ethrel y alerta cuando se acerca la próxima aplicación, ayudando a mantener el cronograma ideal.",
    cgEthrelHow: "Cómo Funciona:",
    cgEthrelStep1: "Configure el Intervalo",
    cgEthrelStep1Desc: "Defina cuántos días entre cada aplicación (ej: 30 días)",
    cgEthrelStep2: "Configure la Alerta",
    cgEthrelStep2Desc: "Defina con cuántos días de anticipación quiere ser alertado (ej: 5 días)",
    cgEthrelStep3: "Registre las Aplicaciones",
    cgEthrelStep3Desc: "Al registrar un día, marque \"Ethrel\" e informe la proporción usada",
    cgEthrelBanner: "Banner de Alerta",
    cgEthrelBannerDesc: "El banner aparece en la parte superior del calendario mostrando:",
    cgEthrelBannerItem1: "Fecha de la última aplicación",
    cgEthrelBannerItem2: "Días desde la última aplicación",
    cgEthrelBannerItem3: "Días restantes para la próxima",
    cgEthrelBannerItem4: "Alerta visual cuando esté próximo o vencido",
    cgEthrelColors: "Colores del Estado:",
    cgEthrelGreen: "Verde: Ethrel al día",
    cgEthrelYellow: "Amarillo: Próximo a la aplicación",
    cgEthrelRed: "Rojo: Aplicación vencida",
    cgEthrelConcentration: "Proporción/Concentración",
    cgEthrelConcentrationDesc: "Al registrar una aplicación de Ethrel, puede informar la proporción utilizada (ej: \"2,5%\" o \"1:40\"). Esto queda registrado en el historial para consulta futura.",
    cgTeamTitle: "Gestión de Equipo y Productividad",
    cgTeamTitleDesc: "Acompañe el desempeño individual de cada sangrador de su equipo con informes detallados de productividad.",
    cgTeamDatabase: "Base de Datos de Sangradores",
    cgTeamDatabaseDesc: "El sistema mantiene un registro de los sangradores que aparecen en sus registros:",
    cgTeamDbItem1: "Nombre registrado automáticamente al crear registros",
    cgTeamDbItem2: "Historial de producción individual",
    cgTeamDbItem3: "Estadísticas de días trabajados",
    cgTeamReport: "Informe del Equipo",
    cgTeamReportDesc: "El informe del equipo muestra:",
    cgTeamRanking: "Ranking de Producción",
    cgTeamAvgTapper: "Promedio por Sangrador",
    cgTeamDaysWorked: "Días Trabajados",
    cgTeamProdPerDay: "Productividad/Día",
    cgTeamMultiple: "Cómo Registrar Múltiples Sangradores",
    cgTeamMultipleDesc: "Para facilitar el registro de varios sangradores el mismo día:",
    cgTeamMultiStep1: "Cree el registro del primer sangrador normalmente",
    cgTeamMultiStep2: "Después de guardar, haga clic en \"Duplicar para otro sangrador\"",
    cgTeamMultiStep3: "El formulario reabre con los mismos datos - cambie el nombre y ajuste valores",
    cgTeamMultiStep4: "Repita para todos los sangradores del día",
    cgTeamIndTip: "Consejo: Productividad Individual",
    cgTeamIndTipDesc: "Para análisis de productividad individual precisos, siempre registre los datos por separado por sangrador, incluyendo el nombre en el campo \"Sangrador\" del formulario.",
    cgRptTitle: "Informes y Análisis",
    cgRptTitleDesc: "El sistema genera automáticamente informes detallados para acompañamiento de su producción y equipo.",
    cgRptTypes: "Tipos de Informes:",
    cgRptMonthlySummary: "Resumen Mensual",
    cgRptMonthlySummaryDesc: "Visión general del mes con totales de producción, lluvia, días de sangría, reposiciones y aplicaciones. Aparece automáticamente en la parte superior del calendario.",
    cgRptHarvestSummary: "Resumen de Zafra",
    cgRptHarvestSummaryDesc: "Acumulado del año agrícola (zafra) con comparativo de la zafra anterior. Incluye detalle mes a mes.",
    cgRptTeamReport: "Informe del Equipo",
    cgRptTeamReportDesc: "Ranking de productividad individual, promedios por sangrador, días trabajados y comparativos de rendimiento.",
    cgRptDailyTable: "Tabla Diaria",
    cgRptDailyTableDesc: "Lista detallada de todos los registros del mes en formato de tabla, con opciones de editar y eliminar registros.",
    cgRptExport: "Exportar Informes",
    cgRptExportDesc: "Algunos informes pueden exportarse a PDF o imprimirse directamente. Busque el botón \"Guardar PDF / Imprimir\" en las secciones de informes.",
    cgTipTitle: "Consejos para Mejor Uso",
    cgTipTitleDesc: "Aproveche al máximo el Calendario de Sangría con estos consejos prácticos.",
    cgTipDaily: "Registre Diariamente",
    cgTipDailyDesc: "Cree el hábito de registrar las actividades al final de cada día de trabajo. Datos actualizados garantizan informes precisos.",
    cgTipMobile: "Acceda desde el Celular",
    cgTipMobileDesc: "El calendario está optimizado para celular. Registre los datos directamente desde el campo sin esperar llegar a casa.",
    cgTipIdentify: "Identifique los Sangradores",
    cgTipIdentifyDesc: "Siempre complete el campo \"Sangrador\" en los registros para tener análisis de productividad individual precisos.",
    cgTipEthrelAlerts: "Configure Alertas de Ethrel",
    cgTipEthrelAlertsDesc: "No pierda el momento de las aplicaciones de Ethrel. Configure el intervalo y reciba alertas automáticas.",
    cgTipRain: "Registre la Lluvia",
    cgTipRainDesc: "Incluso en días sin sangría, registre la precipitación. Esto ayuda a entender patrones de productividad a lo largo del tiempo.",
    cgTipReports: "Revise los Informes",
    cgTipReportsDesc: "Periódicamente, analice los informes de zafra y equipo para identificar oportunidades de mejora en la producción.",
    cgTipQuestions: "¿Dudas? Comparta en la pestaña Comunidad e intercambie experiencias con otros heveicultores!",

    // ========== PROFESSIONALS SEARCH VIEW ==========
    psTitle: "Buscar Profesionales",
    psSubtitle: "Encuentre los mejores profesionales de la heveicultura",
    psSearchFilters: "Filtros de Búsqueda",
    psSpecialization: "Especialización",
    psAll: "Todas",
    psSangrador: "Sangrador",
    psFieldManager: "Gerente de Campo",
    psAgronomist: "Agrónomo",
    psMachineOperator: "Operador de Máquinas",
    psOthers: "Otros",
    psAllProfs: "Todos",
    psJoinedSystem: "Se unió al Sistema de Evaluación",
    psAllProfessionals: "Todos los Profesionales",
    psOnlyRecommended: "Solo recomendados",
    psSearching: "Buscando profesionales...",
    psNoResults: "Ningún profesional encontrado con los filtros seleccionados.",
    psAchievements: "Logros",
    psAvailable: "Disponible",
    psQualitySeal: "Sello de Calidad",
    psExperience: "Experiencia",
    psOnPlatform: "En la plataforma",
    psSince: "Desde",
    psRecommendations: "Recomendaciones",
    psContactProfessional: "Contactar Profesional",
    psPhoneNotAvailable: "Teléfono no disponible. Contacte por la plataforma.",
    psTip: "Mencione que encontró al profesional por HeveaTalent para una mejor experiencia.",

    // ContextualPerformance - remaining
    cpTappingSystems: "Sistemas de Sangría",
    cpFactor: "Factor",
    cpSelectRegion: "Seleccione la Región:",
    cpHighPeak: "Alta/Pico",
    cpNormal: "Normal",
    cpLowRecovery: "Baja/Recuperación",
    cpStopped: "Parada",
    cpHowSealsWork: "¿Cómo funcionan los sellos?",
    cpYourCurrentSeal: "Su Sello Actual",
    cpLoadingSealInfo: "Cargando información del sello...",
    cpExpertTapper: "Sangrador Experto",
    cpProfessionalTapper: "Sangrador Profesional",
    cpCertifiedTapper: "Sangrador Certificado",
    cpNoSealYet: "Ningún sello conquistado aún",
    cpKeepEvolving: "¡Siga evolucionando para conquistar badges!",
    cpLast12Seals: "Sus últimos 12 sellos conquistados",
    cpSealLevels: "Niveles de Sello:",
    cpScoreCalculation: "Cálculo del Score:",
    cpNoContextData: "¿Sin datos contextuales? Su sello será 100% basado en la evaluación técnica.",
    cpRef: "Ref.",

    // ========== MARKET MODULE ==========
    maLoadingData: "Cargando datos...",
    maImportPrice: "Precio Importación (IEA)",
    maImportPriceDesc: "Costo TOTAL para importar caucho procesado. Incluye: precio internacional + tipo de cambio + flete + seguro + impuestos (~10,8%) + costos portuarios. Sirve como \"techo\" - lo máximo que la industria pagaría.",
    maAdjustDrc: "Ajuste el DRC y la Tasa de Participación para simular diferentes escenarios de precio.",
    maCoaguloDrc: "Coágulo DRC 53%",
    maProdCost: "Costo Producción (COT)",
    maParticipationRate: "Tasa de Participación (%)",
    maReference: "Referencia",
    maBaseValue: "Valor Base",
    maWithDrc: "Con DRC",
    maWithRate: "Con Tasa",
    maCurrentCoagulo: "Último pagado",
    maOnImportPrice: "Sobre Precio Importación",
    maOnGeb10Apabor: "Sobre GEB-10 APABOR",
    maOnGeb10Market: "Sobre GEB-10 Mercado SP",
    maCotTotal: "Costo Operacional Total (COT)",
    maCotDesc: "Incluye depreciación y remuneración",
    maCoeTotal: "Costo Operacional Efectivo (COE)",
    maCoeDesc: "Costos directos de producción",
    maCurrentPrice: "Precio Actual del Coágulo",
    maDiffCot: "Diferencia sobre COT",
    maDiffCoe: "Diferencia sobre COE",
    maDataSources: "Fuentes de Datos",
    maAllReferences: "Todas las referencias presentadas",
    maOfficialSources: "Fuentes oficiales verificables",
    maClearData: "Datos claros para decisión",
    pcImportant: "Importante: Referencias de Precio",
    pcImportPriceIEA: "Precio de Importación (IEA/CNA)",
    pcIsCeiling: "es el techo teórico.",
    pcDifference: "Diferencia de",
    pcOfficialFormula: "Fórmula Oficial (CNA/FAESP/IEA)",
    pcProducerPrice: "Precio Productor",
    pcPreview: "Vista previa",
    pcRealTimePreview: "Vista previa (tiempo real)",
    pcEstimatedPrice: "Precio Estimado por kg",
    pcReferenceLabel: "Referencia:",
    pcParticipationRate: "Tasa Participación:",
    pcFinalPrice: "Precio Final:",
    pcMarket: "Mercado (coágulo):",
    pcProductionCost: "Costo producción (COT):",
    pcMargin: "Margen:",
    pcProduction: "Producción",
    pcRevenue: "Ingresos",
    pcCost: "Costo",
    pcProfitLoss: "Ganancia/Pérdida",
    pcValue: "Valor",
    pcRate: "Tasa",
    qpLoadingQuotes: "Cargando cotizaciones del mercado...",
    qpNegotiationRef: "Referencia para negociación entre usinas y productores",
    qpBimonthlyUpdate: "Bimestral",
    qpUpdate: "Actualización",
    qpCoaguloRealPrice: "Coágulo (Precio Real)",
    qpRealPriceDesc: "Precio real pagado al productor en el mercado",
    qpMonthlyUpdate: "Mensual",
    qpDays15to20: "(días 15-20)",
    qpInternationalSGX: "Internacional (SGX)",
    qpSGXDesc: "Precio del caucho en la bolsa de Singapur",
    qpDollarBCB: "Dólar (BCB)",
    qpDollarDesc: "Tipo de cambio (actualización automática)",
    qpProdCostCONAB: "Costo Producción (CONAB)",
    qpProdCostDesc: "Para calcular margen del productor",
    qpAutomatic: "Automático:",
    qpManual: "Manual:",
    qpCalculation: "Cálculo:",
    qpProdMargin: "Margen del Productor",
    dsInternationalSGX: "Internacional (SGX)",
    dsDollarBCB: "Dólar (BCB)",
    dsProdCostCOT: "Costo Producción (COT)",
    scProductionChain: "Cadena Productiva",
    scProducer: "Productor",
    scProcessor: "Usina",
    scIndustry: "Industria",
    pfClimateFactors: "Factores Climáticos",
    pfDemandFactors: "Factores de Demanda",
    pfPolicyFactors: "Factores Políticos",

    // EditProductDialog
    edModifyProduct: "Modifique la información de su producto",
    edProductTitle: "Título del Producto",
    edPrice: "Precio",
    edFullLocation: "Ubicación Completa",
    edProductDesc: "Descripción del Producto",
    edContactInfo: "Información de Contacto",
    edPhotosVideos: "Fotos y Videos",
    edCondition: "Condición",
    edNew: "Nuevo",
    edSemiNew: "Seminuevo",
    edUsed: "Usado",

    // PropertyFormDialog
    pfNewProperty: "Nueva Propiedad",
    pfPropertyName: "Nombre de la Propiedad",
    pfLocationLabel: "Ubicación",
    pfCultivationYears: "Años de Cultivo del Seringal",
    pfTotalAreaHa: "Área Total (hectáreas)",
    pfNotes: "Observaciones",

    // EvaluationForm evaluator types
    evAgronomistWeight: "Ingeniero Agrónomo (peso 3x)",
    evTechnicianWeight: "Técnico Agrícola (peso 3x)",
    evTeamLeaderWeight: "Líder de Equipo (peso 1x)",
    evOwnerWeight: "Propietario (peso 1x)",
    evOtherWeight: "Otro (peso 1x)",

    // TechnicalReferences
    trBack: "Volver",
    trTitle: "Referencias Técnicas",
    trContentCovered: "Contenido abordado:",
    trWhySources: "¿Por qué usamos estas fuentes?",
    trHowToUse: "¿Cómo usar en la evaluación?",

    // ========== REMAINING I18N KEYS ==========
    weekDaySun: "Dom",
    weekDayMon: "Lun",
    weekDayTue: "Mar",
    weekDayWed: "Mié",
    weekDayThu: "Jue",
    weekDayFri: "Vie",
    weekDaySat: "Sáb",
    mcvTooltipDay: "Día",
    mcvWorkerSingle: "trabajador",
    mcvWorkerPlural: "trabajadores",
    mcvBleedingPerformed: "Sangría realizada",
    mcvReplacements: "Reposiciones",
    mcvActivityRegistered: "Actividad registrada",
    mcvFungicide: "Fungicida",
    mcvEthrel: "Ethrel",
    mchProduction: "Producción",
    mchActivities: "Actividades",
    mchBleedingDays: "Días de Sangría",
    mchReplacements: "Reposiciones",
    mchTotalRain: "Lluvia Total",
    mchMonthlyGoal: "Meta mensual: 500kg (ejemplo)",
    bdtDeleteConfirm: "ATENCIÓN: ¿Está seguro que desea eliminar este registro?\n\nEsta acción no se puede deshacer.",
    bdtDeleteSuccess: "¡Registro eliminado exitosamente!",
    bdtDeleteError: "Error al eliminar registro",
    bdtUnknownError: "Error desconocido",
    bdtNoName: "Sin nombre",
    evWorkerIdRequired: "El ID del trabajador es obligatorio",
    evCreateError: "Error al crear evaluación",
    evConnectionError: "Error al conectar con el servidor. Verifique su conexión.",
    evChange: "Cambiar",
    evFungicideApplication: "Aplicación de Fungicida",
    recEnterEmployerName: "Ingrese el nombre del ex-empleador",
    recErrorCreatingInvite: "Error al crear invitación",
    recConnectionError: "Error de conexión",
    recCancelInvite: "¿Cancelar esta invitación?",
    recLinkCopied: "¡Enlace copiado!",
    recConfirmRemove: "¿Está seguro que desea eliminar esta recomendación de su perfil?",
    ctMaxImages: "Máximo de imágenes permitidas",
    ctFormatNotSupported: "Formato no soportado. Use JPG, PNG o WEBP",
    ctImageTooLarge: "Imagen demasiado grande. Tamaño máximo: 5MB",
    ctErrorUploadImage: "Error al enviar imagen. Intente de nuevo.",
    ctErrorAddComment: "Error al agregar comentario",
    ctFillTitleContent: "Por favor, complete el título y el contenido del consejo.",
    ctErrorShareTip: "Error al compartir consejo",
    ctSending: "Enviando...",
    ctAddPhoto: "Agregar foto",
    mkConfirmRemoveAd: "¿Está seguro que desea eliminar este anuncio?",
    mkAdRemoved: "¡Anuncio eliminado exitosamente!",
    mkErrorRemoveAd: "Error al eliminar anuncio",
    mkErrorCreatePix: "Error al crear pago PIX",
    mkPaymentConfirmed: "¡Pago confirmado! Su artículo ahora está destacado!",
    cpContextCreated: "¡Contexto creado exitosamente!",
    cpErrorCreateContext: "Error al crear contexto",
    cpSaveContext: "Guardar Contexto",
    cpSelectPropertyFirst: "Seleccione una propiedad primero",
    wdErrorLoadData: "Error al cargar datos. Intente de nuevo más tarde.",
    coSelectBondType: "Seleccione su tipo de vínculo",
    coErrorProcessing: "Error al procesar adhesión",
    coAcceptConsent: "Necesita aceptar los términos de consentimiento",
    coErrorConsent: "Error al procesar consentimiento",
    spErrorSubscription: "Error al procesar suscripción",
    recCopyLink: "Copiar Enlace",
    recCreateInviteDesc: "Crea un enlace para que tu ex-empleador envíe una recomendación, incluso sin tener cuenta en la plataforma.",
    recFormerEmployerName: "Nombre del Ex-Empleador",
    recEmailPhone: "Email o Teléfono (opcional)",
    recForControl: "Para su control",
    recCreating: "Creando...",
    recCreateInvite: "Crear Invitación",
    recSendRecommendation: "Enviar Recomendación",
    ctSendComment: "Enviar Comentario",
    ctShareTip: "Compartir Consejo",
    mkVideo: "Video",
    mkPhotos: "Fotos",
    mkExample: "Ejemplo",
    mkFeatured: "Destacado",
    mkSeeFullDetails: "Ver detalles completos",
    mkDaysRemaining: "días restantes",
    mkDayRemaining: "día restante",
    mkFeature: "Destacar",
    mkRemove: "Eliminar",
    mkLocation: "Ubicación",
    mkPublishedOn: "Publicado el",
    mkAdExpiresIn: "Este anuncio expira en",
    mkDays: "días",
    mkRenewToKeepActive: "¡Renueve para mantener activo!",
    mkSeller: "Vendedor",
    mkThumbnail: "Miniatura",
    mkGoToImage: "Ir a imagen",
    mkPhoto: "Foto",
    mkOf: "de",
    eaConfigTitle: "Configuración de Ethrel",
    eaConfigTooltip: "Configure el intervalo ideal entre aplicaciones de Ethrel para su propiedad. El sistema le alertará automáticamente cuando se acerque la próxima aplicación.",
    eaIntervalHint: "Cantidad de días entre cada aplicación de Ethrel",
    eaAlertAdvance: "Alertar con anticipación de (días)",
    eaAlertAdvanceTooltip: "Defina cuántos días antes del vencimiento quiere ser alertado.",
    eaAlertAdvanceHint: "Cuántos días antes de la próxima aplicación debe aparecer la alerta",
    eaPreviewSummary: "Recibirá alertas",
    eaPreviewDaysBefore: "días antes de completar",
    eaPreviewDaysSince: "días desde la última aplicación.",
    eaAlertLevels: "Niveles de Alerta",
    eaCritical: "Aplicación vencida",
    eaUrgent: "Faltan 3 días o menos",
    eaWarning: "Dentro del período de alerta",
    eaOk: "Aplicación al día",
    eaSaveConfig: "Guardar Configuración",
    eaConfigSaved: "Configuracion de Ethrel guardada con exito!",
    eaEthrelControl: "Control de Ethrel",
    eaEthrelTooltip: "El Ethrel es un estimulante de látex aplicado periódicamente. Configure el intervalo entre aplicaciones para recibir alertas automáticas.",
    eaConfigureToReceive: "Configure el intervalo de aplicación para recibir alertas",
    eaLot: "Lote",
    eaProportion: "Proporción",
    eaDaysSinceLastApp: "días desde la última aplicación",
    eaIntervalLabel: "intervalo",
    eaDismiss: "Descartar",
    eaIntervalTooltip: "Defina cuántos días normalmente espera entre cada aplicación de Ethrel. Ejemplo: si aplica cada 30 días, ponga 30.",
    processingPayment: "Procesando pago...",
    pleaseWait: "Espere mientras confirmamos su pago.",
    paymentConfirmedTitle: "¡Pago confirmado!",
    paymentConfirmedDesc: "Su plan ha sido activado exitosamente.",
    goToDashboard: "Ir al Dashboard",
    paymentTimeout: "Tiempo agotado",
    paymentTimeoutDesc: "No se pudo confirmar. Verifique su email.",
    paymentError: "Error en el pago",
    paymentErrorDesc: "Ocurrió un error. Intente de nuevo.",
    backToPlans: "Volver a los Planes",
    paymentCancelled: "Pago cancelado",
    paymentCancelledDesc: "No se realizó ningún cargo. Puede volver y elegir un plan cuando desee.",
    redirectingToPayment: "Redirigiendo al pago...",
    plan: "Plan",
    annualTipTitle: "Ahorro en el plan anual",
    annualTipDesc: "¡Todos los planes pagos ofrecen 8% de descuento en la suscripción anual. Eso es aproximadamente 1 mes gratis por año!",
    mySubscription: "Mi Suscripción",
    active: "Activo",
    premiumLifetime: "Acceso vitalicio a todos los recursos",
    freePlanDesc: "Plan gratuito con recursos limitados",
    expiresAt: "Expira el",
    expiringSoon: "¡Expira pronto! Renueve para mantener el acceso.",
    upgradePlan: "Mejorar Plan",
    changePlan: "Cambiar Plan",
    cancelSubscription: "Cancelar Suscripción",
    cancelSubscriptionConfirm: "¿Está seguro que desea cancelar? Su plan continuará activo hasta el vencimiento.",
    subscriptionCancelled: "Suscripción cancelada. Permanecerá activa hasta el vencimiento.",
    planResources: "Recursos del Plan",
    properties: "Propiedades",
    workers: "Trabajadores",
    paymentHistory: "Historial de Pagos",
    paid: "Pagado",
    activeItems: "Artículos Activos",
    upgradeTitle: "¡Desbloquee todo el potencial!",
    upgradeDesc: "Mejore para acceder al calendario completo, evaluaciones, gestión de equipo y mucho más.",
    seeAllPlans: "Ver Todos los Planes",
    processing: "Procesando...",
    currencyBRL: "Real (R$)",
    currencyUSD: "Dólar (US$)"
  }
};

// Translation hook
import React, { useState, useContext, createContext, useEffect } from 'react';

const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('pt');
  
  const t = (key) => {
    return translations[currentLanguage]?.[key] || translations.pt[key] || key;
  };
  
  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setCurrentLanguage(lang);
      localStorage.setItem('language', lang);
    }
  };
  
  // Load saved language on init
  useEffect(() => {
    const savedLang = localStorage.getItem('language');
    if (savedLang && translations[savedLang]) {
      setCurrentLanguage(savedLang);
    }
  }, []);
  
  return (
    <TranslationContext.Provider value={{ t, currentLanguage, changeLanguage }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation must be used within TranslationProvider');
  }
  return context;
};
